import bs from "react";
import ys from "react-dom";
var cs = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ls;
function zs() {
  if (Ls)
    return cs;
  Ls = 1;
  var yc = bs, Uu = ys;
  function Q(i) {
    var o = "https://react.dev/errors/" + i;
    if (1 < arguments.length) {
      o += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var f = 2; f < arguments.length; f++)
        o += "&args[]=" + encodeURIComponent(arguments[f]);
    }
    return "Minified React error #" + i + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var ko = Symbol.for("react.transitional.element"), Nl = Symbol.for("react.portal"), Ut = Symbol.for("react.fragment"), Xr = Symbol.for("react.strict_mode"), Co = Symbol.for("react.profiler"), za = Symbol.for("react.provider"), Ba = Symbol.for("react.consumer"), z = Symbol.for("react.context"), Ce = Symbol.for("react.forward_ref"), ul = Symbol.for("react.suspense"), q = Symbol.for("react.suspense_list"), U = Symbol.for("react.memo"), sl = Symbol.for("react.lazy"), wc = Symbol.for("react.scope"), Na = Symbol.for("react.activity"), Po = Symbol.for("react.legacy_hidden"), qt = Symbol.for("react.memo_cache_sentinel"), Cu = Symbol.for("react.view_transition"), xe = Symbol.iterator, Zr = Array.isArray;
  function Ua(i, o) {
    var f = i.length & 3, g = i.length - f, T = o;
    for (o = 0; o < g; ) {
      var x = i.charCodeAt(o) & 255 | (i.charCodeAt(++o) & 255) << 8 | (i.charCodeAt(++o) & 255) << 16 | (i.charCodeAt(++o) & 255) << 24;
      ++o, x = 3432918353 * (x & 65535) + ((3432918353 * (x >>> 16) & 65535) << 16) & 4294967295, x = x << 15 | x >>> 17, x = 461845907 * (x & 65535) + ((461845907 * (x >>> 16) & 65535) << 16) & 4294967295, T ^= x, T = T << 13 | T >>> 19, T = 5 * (T & 65535) + ((5 * (T >>> 16) & 65535) << 16) & 4294967295, T = (T & 65535) + 27492 + (((T >>> 16) + 58964 & 65535) << 16);
    }
    switch (x = 0, f) {
      case 3:
        x ^= (i.charCodeAt(o + 2) & 255) << 16;
      case 2:
        x ^= (i.charCodeAt(o + 1) & 255) << 8;
      case 1:
        x ^= i.charCodeAt(o) & 255, x = 3432918353 * (x & 65535) + ((3432918353 * (x >>> 16) & 65535) << 16) & 4294967295, x = x << 15 | x >>> 17, T ^= 461845907 * (x & 65535) + ((461845907 * (x >>> 16) & 65535) << 16) & 4294967295;
    }
    return T ^= i.length, T ^= T >>> 16, T = 2246822507 * (T & 65535) + ((2246822507 * (T >>> 16) & 65535) << 16) & 4294967295, T ^= T >>> 13, T = 3266489909 * (T & 65535) + ((3266489909 * (T >>> 16) & 65535) << 16) & 4294967295, (T ^ T >>> 16) >>> 0;
  }
  var mt = Object.assign, je = Object.prototype.hasOwnProperty, Mt = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), jc = {}, $c = {};
  function Pe(i) {
    return je.call($c, i) ? !0 : je.call(jc, i) ? !1 : Mt.test(i) ? $c[i] = !0 : (jc[i] = !0, !1);
  }
  var Xe = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), dt = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), X = /["'&<>]/;
  function ce(i) {
    if (typeof i == "boolean" || typeof i == "number" || typeof i == "bigint")
      return "" + i;
    i = "" + i;
    var o = X.exec(i);
    if (o) {
      var f = "", g, T = 0;
      for (g = o.index; g < i.length; g++) {
        switch (i.charCodeAt(g)) {
          case 34:
            o = "&quot;";
            break;
          case 38:
            o = "&amp;";
            break;
          case 39:
            o = "&#x27;";
            break;
          case 60:
            o = "&lt;";
            break;
          case 62:
            o = "&gt;";
            break;
          default:
            continue;
        }
        T !== g && (f += i.slice(T, g)), T = g + 1, f += o;
      }
      i = T !== g ? f + i.slice(T, g) : f;
    }
    return i;
  }
  var si = /([A-Z])/g, pe = /^ms-/, j = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function m(i) {
    return j.test("" + i) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : i;
  }
  var fi = yc.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, gt = Uu.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ie = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, hn = gt.d;
  gt.d = {
    f: hn.f,
    r: hn.r,
    D: fl,
    C: Pu,
    L: la,
    m: Su,
    X: bt,
    S: hl,
    M: Sc
  };
  var zn = [], So = /(<\/|<)(s)(cript)/gi;
  function hi(i, o, f, g) {
    return "" + o + (f === "s" ? "\\u0073" : "\\u0053") + g;
  }
  function Tc(i, o, f, g, T) {
    return {
      idPrefix: i === void 0 ? "" : i,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: f,
      bootstrapScripts: g,
      bootstrapModules: T,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function ze() {
    return {
      htmlChunks: null,
      headChunks: null,
      bodyChunks: null,
      contribution: 0
    };
  }
  function Ae(i, o, f) {
    return {
      insertionMode: i,
      selectedValue: o,
      tagScope: f
    };
  }
  function De(i, o, f) {
    switch (o) {
      case "noscript":
        return Ae(2, null, i.tagScope | 1);
      case "select":
        return Ae(
          2,
          f.value != null ? f.value : f.defaultValue,
          i.tagScope
        );
      case "svg":
        return Ae(4, null, i.tagScope);
      case "picture":
        return Ae(2, null, i.tagScope | 2);
      case "math":
        return Ae(5, null, i.tagScope);
      case "foreignObject":
        return Ae(2, null, i.tagScope);
      case "table":
        return Ae(6, null, i.tagScope);
      case "thead":
      case "tbody":
      case "tfoot":
        return Ae(7, null, i.tagScope);
      case "colgroup":
        return Ae(9, null, i.tagScope);
      case "tr":
        return Ae(8, null, i.tagScope);
      case "head":
        if (2 > i.insertionMode)
          return Ae(3, null, i.tagScope);
        break;
      case "html":
        if (i.insertionMode === 0)
          return Ae(1, null, i.tagScope);
    }
    return 6 <= i.insertionMode || 2 > i.insertionMode ? Ae(2, null, i.tagScope) : i;
  }
  var di = /* @__PURE__ */ new Map();
  function Ec(i, o) {
    if (typeof o != "object")
      throw Error(Q(62));
    var f = !0, g;
    for (g in o)
      if (je.call(o, g)) {
        var T = o[g];
        if (T != null && typeof T != "boolean" && T !== "") {
          if (g.indexOf("--") === 0) {
            var x = ce(g);
            T = ce(("" + T).trim());
          } else
            x = di.get(g), x === void 0 && (x = ce(
              g.replace(si, "-$1").toLowerCase().replace(pe, "-ms-")
            ), di.set(g, x)), T = typeof T == "number" ? T === 0 || Xe.has(g) ? "" + T : T + "px" : ce(("" + T).trim());
          f ? (f = !1, i.push(' style="', x, ":", T)) : i.push(";", x, ":", T);
        }
      }
    f || i.push('"');
  }
  function tt(i, o, f) {
    f && typeof f != "function" && typeof f != "symbol" && i.push(" ", o, '=""');
  }
  function Cn(i, o, f) {
    typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" && i.push(" ", o, '="', ce(f), '"');
  }
  var gr = ce(
    "javascript:throw new Error('React form unexpectedly submitted.')"
  );
  function Fo(i, o) {
    this.push('<input type="hidden"'), Ao(i), Cn(this, "name", o), Cn(this, "value", i), this.push("/>");
  }
  function Ao(i) {
    if (typeof i != "string")
      throw Error(Q(480));
  }
  function Yt(i, o) {
    if (typeof o.$$FORM_ACTION == "function") {
      var f = i.nextFormID++;
      i = i.idPrefix + f;
      try {
        var g = o.$$FORM_ACTION(i);
        if (g) {
          var T = g.data;
          T != null && T.forEach(Ao);
        }
        return g;
      } catch (x) {
        if (typeof x == "object" && x !== null && typeof x.then == "function")
          throw x;
      }
    }
    return null;
  }
  function Bn(i, o, f, g, T, x, C, H) {
    var L = null;
    if (typeof g == "function") {
      var B = Yt(o, g);
      B !== null ? (H = B.name, g = B.action || "", T = B.encType, x = B.method, C = B.target, L = B.data) : (i.push(" ", "formAction", '="', gr, '"'), C = x = T = g = H = null, vr(o, f));
    }
    return H != null && ke(i, "name", H), g != null && ke(i, "formAction", g), T != null && ke(i, "formEncType", T), x != null && ke(i, "formMethod", x), C != null && ke(i, "formTarget", C), L;
  }
  function ke(i, o, f) {
    switch (o) {
      case "className":
        Cn(i, "class", f);
        break;
      case "tabIndex":
        Cn(i, "tabindex", f);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Cn(i, o, f);
        break;
      case "style":
        Ec(i, f);
        break;
      case "src":
      case "href":
        if (f === "")
          break;
      case "action":
      case "formAction":
        if (f == null || typeof f == "function" || typeof f == "symbol" || typeof f == "boolean")
          break;
        f = m("" + f), i.push(" ", o, '="', ce(f), '"');
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        tt(i, o.toLowerCase(), f);
        break;
      case "xlinkHref":
        if (typeof f == "function" || typeof f == "symbol" || typeof f == "boolean")
          break;
        f = m("" + f), i.push(" ", "xlink:href", '="', ce(f), '"');
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof f != "function" && typeof f != "symbol" && i.push(" ", o, '="', ce(f), '"');
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        f && typeof f != "function" && typeof f != "symbol" && i.push(" ", o, '=""');
        break;
      case "capture":
      case "download":
        f === !0 ? i.push(" ", o, '=""') : f !== !1 && typeof f != "function" && typeof f != "symbol" && i.push(" ", o, '="', ce(f), '"');
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof f != "function" && typeof f != "symbol" && !isNaN(f) && 1 <= f && i.push(" ", o, '="', ce(f), '"');
        break;
      case "rowSpan":
      case "start":
        typeof f == "function" || typeof f == "symbol" || isNaN(f) || i.push(" ", o, '="', ce(f), '"');
        break;
      case "xlinkActuate":
        Cn(i, "xlink:actuate", f);
        break;
      case "xlinkArcrole":
        Cn(i, "xlink:arcrole", f);
        break;
      case "xlinkRole":
        Cn(i, "xlink:role", f);
        break;
      case "xlinkShow":
        Cn(i, "xlink:show", f);
        break;
      case "xlinkTitle":
        Cn(i, "xlink:title", f);
        break;
      case "xlinkType":
        Cn(i, "xlink:type", f);
        break;
      case "xmlBase":
        Cn(i, "xml:base", f);
        break;
      case "xmlLang":
        Cn(i, "xml:lang", f);
        break;
      case "xmlSpace":
        Cn(i, "xml:space", f);
        break;
      default:
        if ((!(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (o = dt.get(o) || o, Pe(o))) {
          switch (typeof f) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var g = o.toLowerCase().slice(0, 5);
              if (g !== "data-" && g !== "aria-")
                return;
          }
          i.push(" ", o, '="', ce(f), '"');
        }
    }
  }
  function jt(i, o, f) {
    if (o != null) {
      if (f != null)
        throw Error(Q(60));
      if (typeof o != "object" || !("__html" in o))
        throw Error(Q(61));
      o = o.__html, o != null && i.push("" + o);
    }
  }
  function gi(i) {
    var o = "";
    return yc.Children.forEach(i, function(f) {
      f != null && (o += f);
    }), o;
  }
  function vr(i, o) {
    !(i.instructions & 16) && (i.instructions |= 16, o.bootstrapChunks.unshift(
      o.startInlineScript,
      `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
      "<\/script>"
    ));
  }
  function rt(i, o) {
    i.push(me("link"));
    for (var f in o)
      if (je.call(o, f)) {
        var g = o[f];
        if (g != null)
          switch (f) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(Q(399, "link"));
            default:
              ke(i, f, g);
          }
      }
    return i.push("/>"), null;
  }
  var Rc = /(<\/|<)(s)(tyle)/gi;
  function xc(i, o, f, g) {
    return "" + o + (f === "s" ? "\\73 " : "\\53 ") + g;
  }
  function $i(i, o, f) {
    i.push(me(f));
    for (var g in o)
      if (je.call(o, g)) {
        var T = o[g];
        if (T != null)
          switch (g) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(Q(399, f));
            default:
              ke(i, g, T);
          }
      }
    return i.push("/>"), null;
  }
  function kc(i, o) {
    i.push(me("title"));
    var f = null, g = null, T;
    for (T in o)
      if (je.call(o, T)) {
        var x = o[T];
        if (x != null)
          switch (T) {
            case "children":
              f = x;
              break;
            case "dangerouslySetInnerHTML":
              g = x;
              break;
            default:
              ke(i, T, x);
          }
      }
    return i.push(">"), o = Array.isArray(f) ? 2 > f.length ? f[0] : null : f, typeof o != "function" && typeof o != "symbol" && o !== null && o !== void 0 && i.push(ce("" + o)), jt(i, g, f), i.push(bi("title")), null;
  }
  function Ul(i, o) {
    i.push(me("script"));
    var f = null, g = null, T;
    for (T in o)
      if (je.call(o, T)) {
        var x = o[T];
        if (x != null)
          switch (T) {
            case "children":
              f = x;
              break;
            case "dangerouslySetInnerHTML":
              g = x;
              break;
            default:
              ke(i, T, x);
          }
      }
    return i.push(">"), jt(i, g, f), typeof f == "string" && i.push(("" + f).replace(So, hi)), i.push(bi("script")), null;
  }
  function vi(i, o, f) {
    i.push(me(f));
    var g = f = null, T;
    for (T in o)
      if (je.call(o, T)) {
        var x = o[T];
        if (x != null)
          switch (T) {
            case "children":
              f = x;
              break;
            case "dangerouslySetInnerHTML":
              g = x;
              break;
            default:
              ke(i, T, x);
          }
      }
    return i.push(">"), jt(i, g, f), f;
  }
  function po(i, o, f) {
    i.push(me(f));
    var g = f = null, T;
    for (T in o)
      if (je.call(o, T)) {
        var x = o[T];
        if (x != null)
          switch (T) {
            case "children":
              f = x;
              break;
            case "dangerouslySetInnerHTML":
              g = x;
              break;
            default:
              ke(i, T, x);
          }
      }
    return i.push(">"), jt(i, g, f), typeof f == "string" ? (i.push(ce(f)), null) : f;
  }
  var ma = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ea = /* @__PURE__ */ new Map();
  function me(i) {
    var o = ea.get(i);
    if (o === void 0) {
      if (!ma.test(i))
        throw Error(Q(65, i));
      o = "<" + i, ea.set(i, o);
    }
    return o;
  }
  function $t(i, o, f, g, T, x, C, H, L, B) {
    switch (o) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        i.push(me("a"));
        var oe = null, $ = null, ae;
        for (ae in f)
          if (je.call(f, ae)) {
            var se = f[ae];
            if (se != null)
              switch (ae) {
                case "children":
                  oe = se;
                  break;
                case "dangerouslySetInnerHTML":
                  $ = se;
                  break;
                case "href":
                  se === "" ? Cn(i, "href", "") : ke(i, ae, se);
                  break;
                default:
                  ke(i, ae, se);
              }
          }
        if (i.push(">"), jt(i, $, oe), typeof oe == "string") {
          i.push(ce(oe));
          var Ee = null;
        } else
          Ee = oe;
        return Ee;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        i.push(me("select"));
        var he = null, Ne = null, Ve;
        for (Ve in f)
          if (je.call(f, Ve)) {
            var Ge = f[Ve];
            if (Ge != null)
              switch (Ve) {
                case "children":
                  he = Ge;
                  break;
                case "dangerouslySetInnerHTML":
                  Ne = Ge;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  ke(
                    i,
                    Ve,
                    Ge
                  );
              }
          }
        return i.push(">"), jt(i, Ne, he), he;
      case "option":
        var cn = H.selectedValue;
        i.push(me("option"));
        var de = null, _e = null, Re = null, Kn = null, xt;
        for (xt in f)
          if (je.call(f, xt)) {
            var ve = f[xt];
            if (ve != null)
              switch (xt) {
                case "children":
                  de = ve;
                  break;
                case "selected":
                  Re = ve;
                  break;
                case "dangerouslySetInnerHTML":
                  Kn = ve;
                  break;
                case "value":
                  _e = ve;
                default:
                  ke(
                    i,
                    xt,
                    ve
                  );
              }
          }
        if (cn != null) {
          var $e = _e !== null ? "" + _e : gi(de);
          if (Zr(cn)) {
            for (var On = 0; On < cn.length; On++)
              if ("" + cn[On] === $e) {
                i.push(' selected=""');
                break;
              }
          } else
            "" + cn === $e && i.push(' selected=""');
        } else
          Re && i.push(' selected=""');
        return i.push(">"), jt(i, Kn, de), de;
      case "textarea":
        i.push(me("textarea"));
        var mn = null, $r = null, tn = null, Mn;
        for (Mn in f)
          if (je.call(f, Mn)) {
            var _t = f[Mn];
            if (_t != null)
              switch (Mn) {
                case "children":
                  tn = _t;
                  break;
                case "value":
                  mn = _t;
                  break;
                case "defaultValue":
                  $r = _t;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(Q(91));
                default:
                  ke(
                    i,
                    Mn,
                    _t
                  );
              }
          }
        if (mn === null && $r !== null && (mn = $r), i.push(">"), tn != null) {
          if (mn != null)
            throw Error(Q(92));
          if (Zr(tn)) {
            if (1 < tn.length)
              throw Error(Q(93));
            mn = "" + tn[0];
          }
          mn = "" + tn;
        }
        return typeof mn == "string" && mn[0] === `
` && i.push(`
`), mn !== null && i.push(ce("" + mn)), null;
      case "input":
        i.push(me("input"));
        var kt = null, el = null, Ct = null, Dr = null, ir = null, In = null, xr = null, ar = null, nl = null, Lr;
        for (Lr in f)
          if (je.call(f, Lr)) {
            var kr = f[Lr];
            if (kr != null)
              switch (Lr) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(Q(399, "input"));
                case "name":
                  kt = kr;
                  break;
                case "formAction":
                  el = kr;
                  break;
                case "formEncType":
                  Ct = kr;
                  break;
                case "formMethod":
                  Dr = kr;
                  break;
                case "formTarget":
                  ir = kr;
                  break;
                case "defaultChecked":
                  nl = kr;
                  break;
                case "defaultValue":
                  xr = kr;
                  break;
                case "checked":
                  ar = kr;
                  break;
                case "value":
                  In = kr;
                  break;
                default:
                  ke(
                    i,
                    Lr,
                    kr
                  );
              }
          }
        var _c = Bn(
          i,
          g,
          T,
          el,
          Ct,
          Dr,
          ir,
          kt
        );
        return ar !== null ? tt(i, "checked", ar) : nl !== null && tt(i, "checked", nl), In !== null ? ke(i, "value", In) : xr !== null && ke(i, "value", xr), i.push("/>"), _c != null && _c.forEach(Fo, i), null;
      case "button":
        i.push(me("button"));
        var Kl = null, tl = null, Xo = null, uu = null, va = null, su = null, qn = null, Ht;
        for (Ht in f)
          if (je.call(f, Ht)) {
            var Tn = f[Ht];
            if (Tn != null)
              switch (Ht) {
                case "children":
                  Kl = Tn;
                  break;
                case "dangerouslySetInnerHTML":
                  tl = Tn;
                  break;
                case "name":
                  Xo = Tn;
                  break;
                case "formAction":
                  uu = Tn;
                  break;
                case "formEncType":
                  va = Tn;
                  break;
                case "formMethod":
                  su = Tn;
                  break;
                case "formTarget":
                  qn = Tn;
                  break;
                default:
                  ke(
                    i,
                    Ht,
                    Tn
                  );
              }
          }
        var Zo = Bn(
          i,
          g,
          T,
          uu,
          va,
          su,
          qn,
          Xo
        );
        if (i.push(">"), Zo != null && Zo.forEach(Fo, i), jt(i, tl, Kl), typeof Kl == "string") {
          i.push(ce(Kl));
          var rl = null;
        } else
          rl = Kl;
        return rl;
      case "form":
        i.push(me("form"));
        var _i = null, En = null, _r = null, no = null, ll = null, to = null, ba;
        for (ba in f)
          if (je.call(f, ba)) {
            var ql = f[ba];
            if (ql != null)
              switch (ba) {
                case "children":
                  _i = ql;
                  break;
                case "dangerouslySetInnerHTML":
                  En = ql;
                  break;
                case "action":
                  _r = ql;
                  break;
                case "encType":
                  no = ql;
                  break;
                case "method":
                  ll = ql;
                  break;
                case "target":
                  to = ql;
                  break;
                default:
                  ke(
                    i,
                    ba,
                    ql
                  );
              }
          }
        var Yn = null, Qo = null;
        if (typeof _r == "function") {
          var or = Yt(
            g,
            _r
          );
          or !== null ? (_r = or.action || "", no = or.encType, ll = or.method, to = or.target, Yn = or.data, Qo = or.name) : (i.push(
            " ",
            "action",
            '="',
            gr,
            '"'
          ), to = ll = no = _r = null, vr(g, T));
        }
        if (_r != null && ke(i, "action", _r), no != null && ke(i, "encType", no), ll != null && ke(i, "method", ll), to != null && ke(i, "target", to), i.push(">"), Qo !== null && (i.push('<input type="hidden"'), Cn(i, "name", Qo), i.push("/>"), Yn != null && Yn.forEach(Fo, i)), jt(i, En, _i), typeof _i == "string") {
          i.push(ce(_i));
          var ya = null;
        } else
          ya = _i;
        return ya;
      case "menuitem":
        i.push(me("menuitem"));
        for (var Hi in f)
          if (je.call(f, Hi)) {
            var kl = f[Hi];
            if (kl != null)
              switch (Hi) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(Q(400));
                default:
                  ke(
                    i,
                    Hi,
                    kl
                  );
              }
          }
        return i.push(">"), null;
      case "object":
        i.push(me("object"));
        var Hr = null, Wi = null, Pt;
        for (Pt in f)
          if (je.call(f, Pt)) {
            var jl = f[Pt];
            if (jl != null)
              switch (Pt) {
                case "children":
                  Hr = jl;
                  break;
                case "dangerouslySetInnerHTML":
                  Wi = jl;
                  break;
                case "data":
                  var fu = m("" + jl);
                  if (fu === "")
                    break;
                  i.push(
                    " ",
                    "data",
                    '="',
                    ce(fu),
                    '"'
                  );
                  break;
                default:
                  ke(
                    i,
                    Pt,
                    jl
                  );
              }
          }
        if (i.push(">"), jt(i, Wi, Hr), typeof Hr == "string") {
          i.push(ce(Hr));
          var Jo = null;
        } else
          Jo = Hr;
        return Jo;
      case "title":
        if (H.insertionMode === 4 || H.tagScope & 1 || f.itemProp != null)
          var ro = kc(
            i,
            f
          );
        else
          B ? ro = null : (kc(T.hoistableChunks, f), ro = void 0);
        return ro;
      case "link":
        var Hc = f.rel, jn = f.href, wa = f.precedence;
        if (H.insertionMode === 4 || H.tagScope & 1 || f.itemProp != null || typeof Hc != "string" || typeof jn != "string" || jn === "") {
          rt(i, f);
          var Ta = null;
        } else if (f.rel === "stylesheet")
          if (typeof wa != "string" || f.disabled != null || f.onLoad || f.onError)
            Ta = rt(
              i,
              f
            );
          else {
            var zi = T.styles.get(wa), Vo = g.styleResources.hasOwnProperty(jn) ? g.styleResources[jn] : void 0;
            if (Vo !== null) {
              g.styleResources[jn] = null, zi || (zi = {
                precedence: ce(wa),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, T.styles.set(wa, zi));
              var Ko = {
                state: 0,
                props: mt({}, f, {
                  "data-precedence": f.precedence,
                  precedence: null
                })
              };
              if (Vo) {
                Vo.length === 2 && Jr(Ko.props, Vo);
                var Cr = T.preloads.stylesheets.get(jn);
                Cr && 0 < Cr.length ? Cr.length = 0 : Ko.state = 1;
              }
              zi.sheets.set(jn, Ko), C && C.stylesheets.add(Ko);
            } else if (zi) {
              var Ou = zi.sheets.get(jn);
              Ou && C && C.stylesheets.add(Ou);
            }
            L && i.push("<!-- -->"), Ta = null;
          }
        else
          f.onLoad || f.onError ? Ta = rt(
            i,
            f
          ) : (L && i.push("<!-- -->"), Ta = B ? null : rt(T.hoistableChunks, f));
        return Ta;
      case "script":
        var Cl = f.async;
        if (typeof f.src != "string" || !f.src || !Cl || typeof Cl == "function" || typeof Cl == "symbol" || f.onLoad || f.onError || H.insertionMode === 4 || H.tagScope & 1 || f.itemProp != null)
          var hu = Ul(
            i,
            f
          );
        else {
          var $l = f.src;
          if (f.type === "module")
            var lo = g.moduleScriptResources, qo = T.preloads.moduleScripts;
          else
            lo = g.scriptResources, qo = T.preloads.scripts;
          var Bi = lo.hasOwnProperty($l) ? lo[$l] : void 0;
          if (Bi !== null) {
            lo[$l] = null;
            var jo = f;
            if (Bi) {
              Bi.length === 2 && (jo = mt({}, f), Jr(jo, Bi));
              var Wc = qo.get($l);
              Wc && (Wc.length = 0);
            }
            var zc = [];
            T.scripts.add(zc), Ul(zc, jo);
          }
          L && i.push("<!-- -->"), hu = null;
        }
        return hu;
      case "style":
        var $o = f.precedence, il = f.href;
        if (H.insertionMode === 4 || H.tagScope & 1 || f.itemProp != null || typeof $o != "string" || typeof il != "string" || il === "") {
          i.push(me("style"));
          var ei = null, io = null, Ea;
          for (Ea in f)
            if (je.call(f, Ea)) {
              var ec = f[Ea];
              if (ec != null)
                switch (Ea) {
                  case "children":
                    ei = ec;
                    break;
                  case "dangerouslySetInnerHTML":
                    io = ec;
                    break;
                  default:
                    ke(
                      i,
                      Ea,
                      ec
                    );
                }
            }
          i.push(">");
          var ao = Array.isArray(ei) ? 2 > ei.length ? ei[0] : null : ei;
          typeof ao != "function" && typeof ao != "symbol" && ao !== null && ao !== void 0 && i.push(("" + ao).replace(Rc, xc)), jt(i, io, ei), i.push(bi("style"));
          var Ni = null;
        } else {
          var Ui = T.styles.get($o);
          if ((g.styleResources.hasOwnProperty(il) ? g.styleResources[il] : void 0) !== null) {
            g.styleResources[il] = null, Ui ? Ui.hrefs.push(
              ce(il)
            ) : (Ui = {
              precedence: ce($o),
              rules: [],
              hrefs: [ce(il)],
              sheets: /* @__PURE__ */ new Map()
            }, T.styles.set($o, Ui));
            var mi = Ui.rules, Ra = null, xa = null, nc;
            for (nc in f)
              if (je.call(f, nc)) {
                var l = f[nc];
                if (l != null)
                  switch (nc) {
                    case "children":
                      Ra = l;
                      break;
                    case "dangerouslySetInnerHTML":
                      xa = l;
                  }
              }
            var a = Array.isArray(Ra) ? 2 > Ra.length ? Ra[0] : null : Ra;
            typeof a != "function" && typeof a != "symbol" && a !== null && a !== void 0 && mi.push(
              ("" + a).replace(Rc, xc)
            ), jt(mi, xa, Ra);
          }
          Ui && C && C.styles.add(Ui), L && i.push("<!-- -->"), Ni = void 0;
        }
        return Ni;
      case "meta":
        if (H.insertionMode === 4 || H.tagScope & 1 || f.itemProp != null)
          var s = $i(
            i,
            f,
            "meta"
          );
        else
          L && i.push("<!-- -->"), s = B ? null : typeof f.charSet == "string" ? $i(T.charsetChunks, f, "meta") : f.name === "viewport" ? $i(T.viewportChunks, f, "meta") : $i(T.hoistableChunks, f, "meta");
        return s;
      case "listing":
      case "pre":
        i.push(me(o));
        var v = null, w = null, k;
        for (k in f)
          if (je.call(f, k)) {
            var P = f[k];
            if (P != null)
              switch (k) {
                case "children":
                  v = P;
                  break;
                case "dangerouslySetInnerHTML":
                  w = P;
                  break;
                default:
                  ke(
                    i,
                    k,
                    P
                  );
              }
          }
        if (i.push(">"), w != null) {
          if (v != null)
            throw Error(Q(60));
          if (typeof w != "object" || !("__html" in w))
            throw Error(Q(61));
          var _ = w.__html;
          _ != null && (typeof _ == "string" && 0 < _.length && _[0] === `
` ? i.push(`
`, _) : i.push("" + _));
        }
        return typeof v == "string" && v[0] === `
` && i.push(`
`), v;
      case "img":
        var A = f.src, D = f.srcSet;
        if (!(f.loading === "lazy" || !A && !D || typeof A != "string" && A != null || typeof D != "string" && D != null) && f.fetchPriority !== "low" && !(H.tagScope & 3) && (typeof A != "string" || A[4] !== ":" || A[0] !== "d" && A[0] !== "D" || A[1] !== "a" && A[1] !== "A" || A[2] !== "t" && A[2] !== "T" || A[3] !== "a" && A[3] !== "A") && (typeof D != "string" || D[4] !== ":" || D[0] !== "d" && D[0] !== "D" || D[1] !== "a" && D[1] !== "A" || D[2] !== "t" && D[2] !== "T" || D[3] !== "a" && D[3] !== "A")) {
          var ee = typeof f.sizes == "string" ? f.sizes : void 0, Y = D ? D + `
` + (ee || "") : A, ue = T.preloads.images, ge = ue.get(Y);
          if (ge)
            (f.fetchPriority === "high" || 10 > T.highImagePreloads.size) && (ue.delete(Y), T.highImagePreloads.add(ge));
          else if (!g.imageResources.hasOwnProperty(Y)) {
            g.imageResources[Y] = zn;
            var ye = f.crossOrigin, Se = typeof ye == "string" ? ye === "use-credentials" ? ye : "" : void 0, rn = T.headers, Dn;
            rn && 0 < rn.remainingCapacity && typeof f.srcSet != "string" && (f.fetchPriority === "high" || 500 > rn.highImagePreloads.length) && (Dn = nr(A, "image", {
              imageSrcSet: f.srcSet,
              imageSizes: f.sizes,
              crossOrigin: Se,
              integrity: f.integrity,
              nonce: f.nonce,
              type: f.type,
              fetchPriority: f.fetchPriority,
              referrerPolicy: f.refererPolicy
            }), 0 <= (rn.remainingCapacity -= Dn.length + 2)) ? (T.resets.image[Y] = zn, rn.highImagePreloads && (rn.highImagePreloads += ", "), rn.highImagePreloads += Dn) : (ge = [], rt(ge, {
              rel: "preload",
              as: "image",
              href: D ? void 0 : A,
              imageSrcSet: D,
              imageSizes: ee,
              crossOrigin: Se,
              integrity: f.integrity,
              type: f.type,
              fetchPriority: f.fetchPriority,
              referrerPolicy: f.referrerPolicy
            }), f.fetchPriority === "high" || 10 > T.highImagePreloads.size ? T.highImagePreloads.add(ge) : (T.bulkPreloads.add(ge), ue.set(Y, ge)));
          }
        }
        return $i(i, f, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return $i(i, f, o);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > H.insertionMode) {
          var Ye = x || T.preamble;
          if (Ye.headChunks)
            throw Error(Q(545, "`<head>`"));
          Ye.headChunks = [];
          var Wt = vi(
            Ye.headChunks,
            f,
            "head"
          );
        } else
          Wt = po(
            i,
            f,
            "head"
          );
        return Wt;
      case "body":
        if (2 > H.insertionMode) {
          var Ln = x || T.preamble;
          if (Ln.bodyChunks)
            throw Error(Q(545, "`<body>`"));
          Ln.bodyChunks = [];
          var cr = vi(
            Ln.bodyChunks,
            f,
            "body"
          );
        } else
          cr = po(
            i,
            f,
            "body"
          );
        return cr;
      case "html":
        if (H.insertionMode === 0) {
          var St = x || T.preamble;
          if (St.htmlChunks)
            throw Error(Q(545, "`<html>`"));
          St.htmlChunks = [""];
          var ot = vi(
            St.htmlChunks,
            f,
            "html"
          );
        } else
          ot = po(
            i,
            f,
            "html"
          );
        return ot;
      default:
        if (o.indexOf("-") !== -1) {
          i.push(me(o));
          var Zt = null, ln = null, Gn;
          for (Gn in f)
            if (je.call(f, Gn)) {
              var Rn = f[Gn];
              if (Rn != null) {
                var Ft = Gn;
                switch (Gn) {
                  case "children":
                    Zt = Rn;
                    break;
                  case "dangerouslySetInnerHTML":
                    ln = Rn;
                    break;
                  case "style":
                    Ec(i, Rn);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    Ft = "class";
                  default:
                    if (Pe(Gn) && typeof Rn != "function" && typeof Rn != "symbol" && Rn !== !1) {
                      if (Rn === !0)
                        Rn = "";
                      else if (typeof Rn == "object")
                        continue;
                      i.push(
                        " ",
                        Ft,
                        '="',
                        ce(Rn),
                        '"'
                      );
                    }
                }
              }
            }
          return i.push(">"), jt(i, ln, Zt), Zt;
        }
    }
    return po(i, f, o);
  }
  var Oo = /* @__PURE__ */ new Map();
  function bi(i) {
    var o = Oo.get(i);
    return o === void 0 && (o = "</" + i + ">", Oo.set(i, o)), o;
  }
  function Qr(i, o) {
    i = i.preamble, i.htmlChunks === null && o.htmlChunks && (i.htmlChunks = o.htmlChunks, o.contribution |= 1), i.headChunks === null && o.headChunks && (i.headChunks = o.headChunks, o.contribution |= 4), i.bodyChunks === null && o.bodyChunks && (i.bodyChunks = o.bodyChunks, o.contribution |= 2);
  }
  function Cc(i, o) {
    o = o.bootstrapChunks;
    for (var f = 0; f < o.length - 1; f++)
      i.push(o[f]);
    return f < o.length ? (f = o[f], o.length = 0, i.push(f)) : !0;
  }
  function eu(i, o, f) {
    if (i.push('<!--$?--><template id="'), f === null)
      throw Error(Q(395));
    return i.push(o.boundaryPrefix), o = f.toString(16), i.push(o), i.push('"></template>');
  }
  function Pc(i, o) {
    o = o.contribution, o !== 0 && (i.push("<!--"), i.push("" + o), i.push("-->"));
  }
  function Mo(i, o, f, g) {
    switch (f.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return i.push('<div hidden id="'), i.push(o.segmentPrefix), o = g.toString(16), i.push(o), i.push('">');
      case 4:
        return i.push('<svg aria-hidden="true" style="display:none" id="'), i.push(o.segmentPrefix), o = g.toString(16), i.push(o), i.push('">');
      case 5:
        return i.push('<math aria-hidden="true" style="display:none" id="'), i.push(o.segmentPrefix), o = g.toString(16), i.push(o), i.push('">');
      case 6:
        return i.push('<table hidden id="'), i.push(o.segmentPrefix), o = g.toString(16), i.push(o), i.push('">');
      case 7:
        return i.push('<table hidden><tbody id="'), i.push(o.segmentPrefix), o = g.toString(16), i.push(o), i.push('">');
      case 8:
        return i.push('<table hidden><tr id="'), i.push(o.segmentPrefix), o = g.toString(16), i.push(o), i.push('">');
      case 9:
        return i.push('<table hidden><colgroup id="'), i.push(o.segmentPrefix), o = g.toString(16), i.push(o), i.push('">');
      default:
        throw Error(Q(397));
    }
  }
  function on(i, o) {
    switch (o.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return i.push("</div>");
      case 4:
        return i.push("</svg>");
      case 5:
        return i.push("</math>");
      case 6:
        return i.push("</table>");
      case 7:
        return i.push("</tbody></table>");
      case 8:
        return i.push("</tr></table>");
      case 9:
        return i.push("</colgroup></table>");
      default:
        throw Error(Q(397));
    }
  }
  var yi = /[<\u2028\u2029]/g;
  function lt(i) {
    return JSON.stringify(i).replace(
      yi,
      function(o) {
        switch (o) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var br = /[&><\u2028\u2029]/g;
  function Nn(i) {
    return JSON.stringify(i).replace(
      br,
      function(o) {
        switch (o) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var na = !1, yr = !0;
  function Jn(i) {
    var o = i.rules, f = i.hrefs, g = 0;
    if (f.length) {
      for (this.push('<style media="not all" data-precedence="'), this.push(i.precedence), this.push('" data-href="'); g < f.length - 1; g++)
        this.push(f[g]), this.push(" ");
      for (this.push(f[g]), this.push('">'), g = 0; g < o.length; g++)
        this.push(o[g]);
      yr = this.push("</style>"), na = !0, o.length = 0, f.length = 0;
    }
  }
  function dn(i) {
    return i.state !== 2 ? na = !0 : !1;
  }
  function wi(i, o, f) {
    return na = !1, yr = !0, o.styles.forEach(Jn, i), o.stylesheets.forEach(dn), na && (f.stylesToHoist = !0), yr;
  }
  function er(i) {
    for (var o = 0; o < i.length; o++)
      this.push(i[o]);
    i.length = 0;
  }
  var wr = [];
  function nu(i) {
    rt(wr, i.props);
    for (var o = 0; o < wr.length; o++)
      this.push(wr[o]);
    wr.length = 0, i.state = 2;
  }
  function Ya(i) {
    var o = 0 < i.sheets.size;
    i.sheets.forEach(nu, this), i.sheets.clear();
    var f = i.rules, g = i.hrefs;
    if (!o || g.length) {
      if (this.push('<style data-precedence="'), this.push(i.precedence), i = 0, g.length) {
        for (this.push('" data-href="'); i < g.length - 1; i++)
          this.push(g[i]), this.push(" ");
        this.push(g[i]);
      }
      for (this.push('">'), i = 0; i < f.length; i++)
        this.push(f[i]);
      this.push("</style>"), f.length = 0, g.length = 0;
    }
  }
  function Be(i) {
    if (i.state === 0) {
      i.state = 1;
      var o = i.props;
      for (rt(wr, {
        rel: "preload",
        as: "style",
        href: i.props.href,
        crossOrigin: o.crossOrigin,
        fetchPriority: o.fetchPriority,
        integrity: o.integrity,
        media: o.media,
        hrefLang: o.hrefLang,
        referrerPolicy: o.referrerPolicy
      }), i = 0; i < wr.length; i++)
        this.push(wr[i]);
      wr.length = 0;
    }
  }
  function sn(i) {
    i.sheets.forEach(Be, this), i.sheets.clear();
  }
  function ta(i, o) {
    i.push("[");
    var f = "[";
    o.stylesheets.forEach(function(g) {
      if (g.state !== 2)
        if (g.state === 3)
          i.push(f), g = Nn(
            "" + g.props.href
          ), i.push(g), i.push("]"), f = ",[";
        else {
          i.push(f);
          var T = g.props["data-precedence"], x = g.props, C = m("" + g.props.href);
          C = Nn(C), i.push(C), T = "" + T, i.push(","), T = Nn(T), i.push(T);
          for (var H in x)
            if (je.call(x, H) && (T = x[H], T != null))
              switch (H) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(Q(399, "link"));
                default:
                  vt(
                    i,
                    H,
                    T
                  );
              }
          i.push("]"), f = ",[", g.state = 3;
        }
    }), i.push("]");
  }
  function vt(i, o, f) {
    var g = o.toLowerCase();
    switch (typeof f) {
      case "function":
      case "symbol":
        return;
    }
    switch (o) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        g = "class", o = "" + f;
        break;
      case "hidden":
        if (f === !1)
          return;
        o = "";
        break;
      case "src":
      case "href":
        f = m(f), o = "" + f;
        break;
      default:
        if (2 < o.length && (o[0] === "o" || o[0] === "O") && (o[1] === "n" || o[1] === "N") || !Pe(o))
          return;
        o = "" + f;
    }
    i.push(","), g = Nn(g), i.push(g), i.push(","), g = Nn(o), i.push(g);
  }
  function ra() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set() };
  }
  function fl(i) {
    var o = Rt || null;
    if (o) {
      var f = o.resumableState, g = o.renderState;
      if (typeof i == "string" && i) {
        if (!f.dnsResources.hasOwnProperty(i)) {
          f.dnsResources[i] = null, f = g.headers;
          var T, x;
          (x = f && 0 < f.remainingCapacity) && (x = (T = "<" + ("" + i).replace(
            Ga,
            Ti
          ) + ">; rel=dns-prefetch", 0 <= (f.remainingCapacity -= T.length + 2))), x ? (g.resets.dns[i] = null, f.preconnects && (f.preconnects += ", "), f.preconnects += T) : (T = [], rt(T, { href: i, rel: "dns-prefetch" }), g.preconnects.add(T));
        }
        pn(o);
      }
    } else
      hn.D(i);
  }
  function Pu(i, o) {
    var f = Rt || null;
    if (f) {
      var g = f.resumableState, T = f.renderState;
      if (typeof i == "string" && i) {
        var x = o === "use-credentials" ? "credentials" : typeof o == "string" ? "anonymous" : "default";
        if (!g.connectResources[x].hasOwnProperty(i)) {
          g.connectResources[x][i] = null, g = T.headers;
          var C, H;
          if (H = g && 0 < g.remainingCapacity) {
            if (H = "<" + ("" + i).replace(
              Ga,
              Ti
            ) + ">; rel=preconnect", typeof o == "string") {
              var L = ("" + o).replace(
                dl,
                Ei
              );
              H += '; crossorigin="' + L + '"';
            }
            H = (C = H, 0 <= (g.remainingCapacity -= C.length + 2));
          }
          H ? (T.resets.connect[x][i] = null, g.preconnects && (g.preconnects += ", "), g.preconnects += C) : (x = [], rt(x, {
            rel: "preconnect",
            href: i,
            crossOrigin: o
          }), T.preconnects.add(x));
        }
        pn(f);
      }
    } else
      hn.C(i, o);
  }
  function la(i, o, f) {
    var g = Rt || null;
    if (g) {
      var T = g.resumableState, x = g.renderState;
      if (o && i) {
        switch (o) {
          case "image":
            if (f)
              var C = f.imageSrcSet, H = f.imageSizes, L = f.fetchPriority;
            var B = C ? C + `
` + (H || "") : i;
            if (T.imageResources.hasOwnProperty(B))
              return;
            T.imageResources[B] = zn, T = x.headers;
            var oe;
            T && 0 < T.remainingCapacity && typeof C != "string" && L === "high" && (oe = nr(i, o, f), 0 <= (T.remainingCapacity -= oe.length + 2)) ? (x.resets.image[B] = zn, T.highImagePreloads && (T.highImagePreloads += ", "), T.highImagePreloads += oe) : (T = [], rt(
              T,
              mt(
                { rel: "preload", href: C ? void 0 : i, as: o },
                f
              )
            ), L === "high" ? x.highImagePreloads.add(T) : (x.bulkPreloads.add(T), x.preloads.images.set(B, T)));
            break;
          case "style":
            if (T.styleResources.hasOwnProperty(i))
              return;
            C = [], rt(
              C,
              mt({ rel: "preload", href: i, as: o }, f)
            ), T.styleResources[i] = !f || typeof f.crossOrigin != "string" && typeof f.integrity != "string" ? zn : [f.crossOrigin, f.integrity], x.preloads.stylesheets.set(i, C), x.bulkPreloads.add(C);
            break;
          case "script":
            if (T.scriptResources.hasOwnProperty(i))
              return;
            C = [], x.preloads.scripts.set(i, C), x.bulkPreloads.add(C), rt(
              C,
              mt({ rel: "preload", href: i, as: o }, f)
            ), T.scriptResources[i] = !f || typeof f.crossOrigin != "string" && typeof f.integrity != "string" ? zn : [f.crossOrigin, f.integrity];
            break;
          default:
            if (T.unknownResources.hasOwnProperty(o)) {
              if (C = T.unknownResources[o], C.hasOwnProperty(i))
                return;
            } else
              C = {}, T.unknownResources[o] = C;
            if (C[i] = zn, (T = x.headers) && 0 < T.remainingCapacity && o === "font" && (B = nr(i, o, f), 0 <= (T.remainingCapacity -= B.length + 2)))
              x.resets.font[i] = zn, T.fontPreloads && (T.fontPreloads += ", "), T.fontPreloads += B;
            else
              switch (T = [], i = mt({ rel: "preload", href: i, as: o }, f), rt(T, i), o) {
                case "font":
                  x.fontPreloads.add(T);
                  break;
                default:
                  x.bulkPreloads.add(T);
              }
        }
        pn(g);
      }
    } else
      hn.L(i, o, f);
  }
  function Su(i, o) {
    var f = Rt || null;
    if (f) {
      var g = f.resumableState, T = f.renderState;
      if (i) {
        var x = o && typeof o.as == "string" ? o.as : "script";
        switch (x) {
          case "script":
            if (g.moduleScriptResources.hasOwnProperty(i))
              return;
            x = [], g.moduleScriptResources[i] = !o || typeof o.crossOrigin != "string" && typeof o.integrity != "string" ? zn : [o.crossOrigin, o.integrity], T.preloads.moduleScripts.set(i, x);
            break;
          default:
            if (g.moduleUnknownResources.hasOwnProperty(x)) {
              var C = g.unknownResources[x];
              if (C.hasOwnProperty(i))
                return;
            } else
              C = {}, g.moduleUnknownResources[x] = C;
            x = [], C[i] = zn;
        }
        rt(x, mt({ rel: "modulepreload", href: i }, o)), T.bulkPreloads.add(x), pn(f);
      }
    } else
      hn.m(i, o);
  }
  function hl(i, o, f) {
    var g = Rt || null;
    if (g) {
      var T = g.resumableState, x = g.renderState;
      if (i) {
        o = o || "default";
        var C = x.styles.get(o), H = T.styleResources.hasOwnProperty(i) ? T.styleResources[i] : void 0;
        H !== null && (T.styleResources[i] = null, C || (C = {
          precedence: ce(o),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, x.styles.set(o, C)), o = {
          state: 0,
          props: mt(
            { rel: "stylesheet", href: i, "data-precedence": o },
            f
          )
        }, H && (H.length === 2 && Jr(o.props, H), (x = x.preloads.stylesheets.get(i)) && 0 < x.length ? x.length = 0 : o.state = 1), C.sheets.set(i, o), pn(g));
      }
    } else
      hn.S(i, o, f);
  }
  function bt(i, o) {
    var f = Rt || null;
    if (f) {
      var g = f.resumableState, T = f.renderState;
      if (i) {
        var x = g.scriptResources.hasOwnProperty(i) ? g.scriptResources[i] : void 0;
        x !== null && (g.scriptResources[i] = null, o = mt({ src: i, async: !0 }, o), x && (x.length === 2 && Jr(o, x), i = T.preloads.scripts.get(i)) && (i.length = 0), i = [], T.scripts.add(i), Ul(i, o), pn(f));
      }
    } else
      hn.X(i, o);
  }
  function Sc(i, o) {
    var f = Rt || null;
    if (f) {
      var g = f.resumableState, T = f.renderState;
      if (i) {
        var x = g.moduleScriptResources.hasOwnProperty(
          i
        ) ? g.moduleScriptResources[i] : void 0;
        x !== null && (g.moduleScriptResources[i] = null, o = mt({ src: i, type: "module", async: !0 }, o), x && (x.length === 2 && Jr(o, x), i = T.preloads.moduleScripts.get(i)) && (i.length = 0), i = [], T.scripts.add(i), Ul(i, o), pn(f));
      }
    } else
      hn.M(i, o);
  }
  function Jr(i, o) {
    i.crossOrigin == null && (i.crossOrigin = o[0]), i.integrity == null && (i.integrity = o[1]);
  }
  function nr(i, o, f) {
    i = ("" + i).replace(
      Ga,
      Ti
    ), o = ("" + o).replace(
      dl,
      Ei
    ), o = "<" + i + '>; rel=preload; as="' + o + '"';
    for (var g in f)
      je.call(f, g) && (i = f[g], typeof i == "string" && (o += "; " + g.toLowerCase() + '="' + ("" + i).replace(
        dl,
        Ei
      ) + '"'));
    return o;
  }
  var Ga = /[<>\r\n]/g;
  function Ti(i) {
    switch (i) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var dl = /["';,\r\n]/g;
  function Ei(i) {
    switch (i) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function Fc(i) {
    this.styles.add(i);
  }
  function Fu(i) {
    this.stylesheets.add(i);
  }
  function ml(i, o) {
    var f = i.idPrefix, g = [], T = i.bootstrapScriptContent, x = i.bootstrapScripts, C = i.bootstrapModules;
    T !== void 0 && g.push(
      "<script>",
      ("" + T).replace(So, hi),
      "<\/script>"
    ), T = f + "P:";
    var H = f + "S:";
    f += "B:";
    var L = ze(), B = /* @__PURE__ */ new Set(), oe = /* @__PURE__ */ new Set(), $ = /* @__PURE__ */ new Set(), ae = /* @__PURE__ */ new Map(), se = /* @__PURE__ */ new Set(), Ee = /* @__PURE__ */ new Set(), he = /* @__PURE__ */ new Set(), Ne = {
      images: /* @__PURE__ */ new Map(),
      stylesheets: /* @__PURE__ */ new Map(),
      scripts: /* @__PURE__ */ new Map(),
      moduleScripts: /* @__PURE__ */ new Map()
    };
    if (x !== void 0)
      for (var Ve = 0; Ve < x.length; Ve++) {
        var Ge = x[Ve], cn, de = void 0, _e = void 0, Re = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: void 0
        };
        typeof Ge == "string" ? Re.href = cn = Ge : (Re.href = cn = Ge.src, Re.integrity = _e = typeof Ge.integrity == "string" ? Ge.integrity : void 0, Re.crossOrigin = de = typeof Ge == "string" || Ge.crossOrigin == null ? void 0 : Ge.crossOrigin === "use-credentials" ? "use-credentials" : ""), Ge = i;
        var Kn = cn;
        Ge.scriptResources[Kn] = null, Ge.moduleScriptResources[Kn] = null, Ge = [], rt(Ge, Re), se.add(Ge), g.push('<script src="', ce(cn)), typeof _e == "string" && g.push('" integrity="', ce(_e)), typeof de == "string" && g.push(
          '" crossorigin="',
          ce(de)
        ), g.push('" async=""><\/script>');
      }
    if (C !== void 0)
      for (x = 0; x < C.length; x++)
        Re = C[x], de = cn = void 0, _e = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: void 0
        }, typeof Re == "string" ? _e.href = Ve = Re : (_e.href = Ve = Re.src, _e.integrity = de = typeof Re.integrity == "string" ? Re.integrity : void 0, _e.crossOrigin = cn = typeof Re == "string" || Re.crossOrigin == null ? void 0 : Re.crossOrigin === "use-credentials" ? "use-credentials" : ""), Re = i, Ge = Ve, Re.scriptResources[Ge] = null, Re.moduleScriptResources[Ge] = null, Re = [], rt(Re, _e), se.add(Re), g.push(
          '<script type="module" src="',
          ce(Ve)
        ), typeof de == "string" && g.push(
          '" integrity="',
          ce(de)
        ), typeof cn == "string" && g.push('" crossorigin="', ce(cn)), g.push('" async=""><\/script>');
    return {
      placeholderPrefix: T,
      segmentPrefix: H,
      boundaryPrefix: f,
      startInlineScript: "<script>",
      preamble: L,
      externalRuntimeScript: null,
      bootstrapChunks: g,
      importMapChunks: [],
      onHeaders: void 0,
      headers: null,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: B,
      fontPreloads: oe,
      highImagePreloads: $,
      styles: ae,
      bootstrapScripts: se,
      scripts: Ee,
      bulkPreloads: he,
      preloads: Ne,
      stylesToHoist: !1,
      generateStaticMarkup: o
    };
  }
  function bn(i, o, f, g) {
    return f.generateStaticMarkup ? (i.push(ce(o)), !1) : (o === "" ? i = g : (g && i.push("<!-- -->"), i.push(ce(o)), i = !0), i);
  }
  function Io(i, o, f, g) {
    o.generateStaticMarkup || f && g && i.push("<!-- -->");
  }
  var tu = Function.prototype.bind, Xa = Symbol.for("react.client.reference");
  function It(i) {
    if (i == null)
      return null;
    if (typeof i == "function")
      return i.$$typeof === Xa ? null : i.displayName || i.name || null;
    if (typeof i == "string")
      return i;
    switch (i) {
      case Ut:
        return "Fragment";
      case Co:
        return "Profiler";
      case Xr:
        return "StrictMode";
      case ul:
        return "Suspense";
      case q:
        return "SuspenseList";
      case Na:
        return "Activity";
    }
    if (typeof i == "object")
      switch (i.$$typeof) {
        case Nl:
          return "Portal";
        case z:
          return (i.displayName || "Context") + ".Provider";
        case Ba:
          return (i._context.displayName || "Context") + ".Consumer";
        case Ce:
          var o = i.render;
          return i = i.displayName, i || (i = o.displayName || o.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
        case U:
          return o = i.displayName || null, o !== null ? o : It(i.type) || "Memo";
        case sl:
          o = i._payload, i = i._init;
          try {
            return It(i(o));
          } catch {
          }
      }
    return null;
  }
  var ru = {}, Ri = null;
  function Mr(i, o) {
    if (i !== o) {
      i.context._currentValue2 = i.parentValue, i = i.parent;
      var f = o.parent;
      if (i === null) {
        if (f !== null)
          throw Error(Q(401));
      } else {
        if (f === null)
          throw Error(Q(401));
        Mr(i, f);
      }
      o.context._currentValue2 = o.value;
    }
  }
  function Yl(i) {
    i.context._currentValue2 = i.parentValue, i = i.parent, i !== null && Yl(i);
  }
  function ia(i) {
    var o = i.parent;
    o !== null && ia(o), i.context._currentValue2 = i.value;
  }
  function Do(i, o) {
    if (i.context._currentValue2 = i.parentValue, i = i.parent, i === null)
      throw Error(Q(402));
    i.depth === o.depth ? Mr(i, o) : Do(i, o);
  }
  function aa(i, o) {
    var f = o.parent;
    if (f === null)
      throw Error(Q(402));
    i.depth === f.depth ? Mr(i, f) : aa(i, f), o.context._currentValue2 = o.value;
  }
  function Tr(i) {
    var o = Ri;
    o !== i && (o === null ? ia(i) : i === null ? Yl(o) : o.depth === i.depth ? Mr(o, i) : o.depth > i.depth ? Do(o, i) : aa(o, i), Ri = i);
  }
  var xi = {
    enqueueSetState: function(i, o) {
      i = i._reactInternals, i.queue !== null && i.queue.push(o);
    },
    enqueueReplaceState: function(i, o) {
      i = i._reactInternals, i.replace = !0, i.queue = [o];
    },
    enqueueForceUpdate: function() {
    }
  }, oa = { id: 1, overflow: "" };
  function Gl(i, o, f) {
    var g = i.id;
    i = i.overflow;
    var T = 32 - gl(g) - 1;
    g &= ~(1 << T), f += 1;
    var x = 32 - gl(o) + T;
    if (30 < x) {
      var C = T - T % 5;
      return x = (g & (1 << C) - 1).toString(32), g >>= C, T -= C, {
        id: 1 << 32 - gl(o) + T | f << T | g,
        overflow: x + i
      };
    }
    return {
      id: 1 << x | f << T | g,
      overflow: i
    };
  }
  var gl = Math.clz32 ? Math.clz32 : lu, yt = Math.log, vl = Math.LN2;
  function lu(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (yt(i) / vl | 0) | 0;
  }
  var Er = Error(Q(460));
  function Xl() {
  }
  function Za(i, o, f) {
    switch (f = i[f], f === void 0 ? i.push(o) : f !== o && (o.then(Xl, Xl), o = f), o.status) {
      case "fulfilled":
        return o.value;
      case "rejected":
        throw o.reason;
      default:
        switch (typeof o.status == "string" ? o.then(Xl, Xl) : (i = o, i.status = "pending", i.then(
          function(g) {
            if (o.status === "pending") {
              var T = o;
              T.status = "fulfilled", T.value = g;
            }
          },
          function(g) {
            if (o.status === "pending") {
              var T = o;
              T.status = "rejected", T.reason = g;
            }
          }
        )), o.status) {
          case "fulfilled":
            return o.value;
          case "rejected":
            throw o.reason;
        }
        throw bl = o, Er;
    }
  }
  var bl = null;
  function An() {
    if (bl === null)
      throw Error(Q(459));
    var i = bl;
    return bl = null, i;
  }
  function ki(i, o) {
    return i === o && (i !== 0 || 1 / i === 1 / o) || i !== i && o !== o;
  }
  var Gt = typeof Object.is == "function" ? Object.is : ki, Xt = null, Lo = null, _o = null, wt = null, Qa = null, Qe = null, Tt = !1, Ci = !1, Zl = 0, yl = 0, wl = -1, ca = 0, Et = null, Tl = null, Ql = 0;
  function tr() {
    if (Xt === null)
      throw Error(Q(321));
    return Xt;
  }
  function ua() {
    if (0 < Ql)
      throw Error(Q(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Jl() {
    return Qe === null ? Qa === null ? (Tt = !1, Qa = Qe = ua()) : (Tt = !0, Qe = Qa) : Qe.next === null ? (Tt = !1, Qe = Qe.next = ua()) : (Tt = !0, Qe = Qe.next), Qe;
  }
  function Vr() {
    var i = Et;
    return Et = null, i;
  }
  function El() {
    wt = _o = Lo = Xt = null, Ci = !1, Qa = null, Ql = 0, Qe = Tl = null;
  }
  function Ho(i, o) {
    return typeof o == "function" ? o(i) : o;
  }
  function sa(i, o, f) {
    if (Xt = tr(), Qe = Jl(), Tt) {
      var g = Qe.queue;
      if (o = g.dispatch, Tl !== null && (f = Tl.get(g), f !== void 0)) {
        Tl.delete(g), g = Qe.memoizedState;
        do
          g = i(g, f.action), f = f.next;
        while (f !== null);
        return Qe.memoizedState = g, [g, o];
      }
      return [Qe.memoizedState, o];
    }
    return i = i === Ho ? typeof o == "function" ? o() : o : f !== void 0 ? f(o) : o, Qe.memoizedState = i, i = Qe.queue = { last: null, dispatch: null }, i = i.dispatch = Pi.bind(
      null,
      Xt,
      i
    ), [Qe.memoizedState, i];
  }
  function Ac(i, o) {
    if (Xt = tr(), Qe = Jl(), o = o === void 0 ? null : o, Qe !== null) {
      var f = Qe.memoizedState;
      if (f !== null && o !== null) {
        var g = f[1];
        e:
          if (g === null)
            g = !1;
          else {
            for (var T = 0; T < g.length && T < o.length; T++)
              if (!Gt(o[T], g[T])) {
                g = !1;
                break e;
              }
            g = !0;
          }
        if (g)
          return f[0];
      }
    }
    return i = i(), Qe.memoizedState = [i, o], i;
  }
  function Pi(i, o, f) {
    if (25 <= Ql)
      throw Error(Q(301));
    if (i === Xt)
      if (Ci = !0, i = { action: f, next: null }, Tl === null && (Tl = /* @__PURE__ */ new Map()), f = Tl.get(o), f === void 0)
        Tl.set(o, i);
      else {
        for (o = f; o.next !== null; )
          o = o.next;
        o.next = i;
      }
  }
  function Wo() {
    throw Error(Q(394));
  }
  function pc() {
    throw Error(Q(479));
  }
  function Ja(i, o, f) {
    tr();
    var g = yl++, T = _o;
    if (typeof i.$$FORM_ACTION == "function") {
      var x = null, C = wt;
      T = T.formState;
      var H = i.$$IS_SIGNATURE_EQUAL;
      if (T !== null && typeof H == "function") {
        var L = T[1];
        H.call(i, T[2], T[3]) && (x = f !== void 0 ? "p" + f : "k" + Ua(
          JSON.stringify([C, null, g]),
          0
        ), L === x && (wl = g, o = T[0]));
      }
      var B = i.bind(null, o);
      return i = function($) {
        B($);
      }, typeof B.$$FORM_ACTION == "function" && (i.$$FORM_ACTION = function($) {
        $ = B.$$FORM_ACTION($), f !== void 0 && (f += "", $.action = f);
        var ae = $.data;
        return ae && (x === null && (x = f !== void 0 ? "p" + f : "k" + Ua(
          JSON.stringify([
            C,
            null,
            g
          ]),
          0
        )), ae.append("$ACTION_KEY", x)), $;
      }), [o, i, !1];
    }
    var oe = i.bind(null, o);
    return [
      o,
      function($) {
        oe($);
      },
      !1
    ];
  }
  function zo(i) {
    var o = ca;
    return ca += 1, Et === null && (Et = []), Za(Et, i, o);
  }
  function iu() {
    throw Error(Q(393));
  }
  function Va() {
  }
  var Si = {
    readContext: function(i) {
      return i._currentValue2;
    },
    use: function(i) {
      if (i !== null && typeof i == "object") {
        if (typeof i.then == "function")
          return zo(i);
        if (i.$$typeof === z)
          return i._currentValue2;
      }
      throw Error(Q(438, String(i)));
    },
    useContext: function(i) {
      return tr(), i._currentValue2;
    },
    useMemo: Ac,
    useReducer: sa,
    useRef: function(i) {
      Xt = tr(), Qe = Jl();
      var o = Qe.memoizedState;
      return o === null ? (i = { current: i }, Qe.memoizedState = i) : o;
    },
    useState: function(i) {
      return sa(Ho, i);
    },
    useInsertionEffect: Va,
    useLayoutEffect: Va,
    useCallback: function(i, o) {
      return Ac(function() {
        return i;
      }, o);
    },
    useImperativeHandle: Va,
    useEffect: Va,
    useDebugValue: Va,
    useDeferredValue: function(i, o) {
      return tr(), o !== void 0 ? o : i;
    },
    useTransition: function() {
      return tr(), [!1, Wo];
    },
    useId: function() {
      var i = Lo.treeContext, o = i.overflow;
      i = i.id, i = (i & ~(1 << 32 - gl(i) - 1)).toString(32) + o;
      var f = fa;
      if (f === null)
        throw Error(Q(404));
      return o = Zl++, i = "«" + f.idPrefix + "R" + i, 0 < o && (i += "H" + o.toString(32)), i + "»";
    },
    useSyncExternalStore: function(i, o, f) {
      if (f === void 0)
        throw Error(Q(407));
      return f();
    },
    useOptimistic: function(i) {
      return tr(), [i, pc];
    },
    useActionState: Ja,
    useFormState: Ja,
    useHostTransitionStatus: function() {
      return tr(), Ie;
    },
    useMemoCache: function(i) {
      for (var o = Array(i), f = 0; f < i; f++)
        o[f] = qt;
      return o;
    },
    useCacheRefresh: function() {
      return iu;
    }
  }, fa = null, Fi = {
    getCacheForType: function() {
      throw Error(Q(248));
    }
  }, Bo, Ai;
  function ha(i) {
    if (Bo === void 0)
      try {
        throw Error();
      } catch (f) {
        var o = f.stack.trim().match(/\n( *(at )?)/);
        Bo = o && o[1] || "", Ai = -1 < f.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < f.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Bo + i + Ai;
  }
  var da = !1;
  function pi(i, o) {
    if (!i || da)
      return "";
    da = !0;
    var f = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var g = {
        DetermineComponentFrameRoot: function() {
          try {
            if (o) {
              var $ = function() {
                throw Error();
              };
              if (Object.defineProperty($.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct($, []);
                } catch (se) {
                  var ae = se;
                }
                Reflect.construct(i, [], $);
              } else {
                try {
                  $.call();
                } catch (se) {
                  ae = se;
                }
                i.call($.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (se) {
                ae = se;
              }
              ($ = i()) && typeof $.catch == "function" && $.catch(function() {
              });
            }
          } catch (se) {
            if (se && ae && typeof se.stack == "string")
              return [se.stack, ae.stack];
          }
          return [null, null];
        }
      };
      g.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var T = Object.getOwnPropertyDescriptor(
        g.DetermineComponentFrameRoot,
        "name"
      );
      T && T.configurable && Object.defineProperty(
        g.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var x = g.DetermineComponentFrameRoot(), C = x[0], H = x[1];
      if (C && H) {
        var L = C.split(`
`), B = H.split(`
`);
        for (T = g = 0; g < L.length && !L[g].includes("DetermineComponentFrameRoot"); )
          g++;
        for (; T < B.length && !B[T].includes(
          "DetermineComponentFrameRoot"
        ); )
          T++;
        if (g === L.length || T === B.length)
          for (g = L.length - 1, T = B.length - 1; 1 <= g && 0 <= T && L[g] !== B[T]; )
            T--;
        for (; 1 <= g && 0 <= T; g--, T--)
          if (L[g] !== B[T]) {
            if (g !== 1 || T !== 1)
              do
                if (g--, T--, 0 > T || L[g] !== B[T]) {
                  var oe = `
` + L[g].replace(" at new ", " at ");
                  return i.displayName && oe.includes("<anonymous>") && (oe = oe.replace("<anonymous>", i.displayName)), oe;
                }
              while (1 <= g && 0 <= T);
            break;
          }
      }
    } finally {
      da = !1, Error.prepareStackTrace = f;
    }
    return (f = i ? i.displayName || i.name : "") ? ha(f) : "";
  }
  function Oi(i) {
    if (typeof i == "string")
      return ha(i);
    if (typeof i == "function")
      return i.prototype && i.prototype.isReactComponent ? pi(i, !0) : pi(i, !1);
    if (typeof i == "object" && i !== null) {
      switch (i.$$typeof) {
        case Ce:
          return pi(i.render, !1);
        case U:
          return pi(i.type, !1);
        case sl:
          var o = i, f = o._payload;
          o = o._init;
          try {
            i = o(f);
          } catch {
            return ha("Lazy");
          }
          return Oi(i);
      }
      if (typeof i.name == "string")
        return f = i.env, ha(
          i.name + (f ? " [" + f + "]" : "")
        );
    }
    switch (i) {
      case q:
        return ha("SuspenseList");
      case ul:
        return ha("Suspense");
    }
    return "";
  }
  function Kr(i) {
    if (typeof i == "object" && i !== null && typeof i.environmentName == "string") {
      var o = i.environmentName;
      i = [i].slice(0), typeof i[0] == "string" ? i.splice(
        0,
        1,
        "[%s] " + i[0],
        " " + o + " "
      ) : i.splice(0, 0, "[%s] ", " " + o + " "), i.unshift(console), o = tu.apply(console.error, i), o();
    } else
      console.error(i);
    return null;
  }
  function Rl() {
  }
  function No(i, o, f, g, T, x, C, H, L, B, oe) {
    var $ = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = i, this.renderState = o, this.rootFormatContext = f, this.progressiveChunkSize = g === void 0 ? 12800 : g, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.abortableTasks = $, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = T === void 0 ? Kr : T, this.onPostpone = B === void 0 ? Rl : B, this.onAllReady = x === void 0 ? Rl : x, this.onShellReady = C === void 0 ? Rl : C, this.onShellError = H === void 0 ? Rl : H, this.onFatalError = L === void 0 ? Rl : L, this.formState = oe === void 0 ? null : oe;
  }
  function ga(i, o, f, g, T, x, C, H, L, B, oe, $) {
    return o = new No(
      o,
      f,
      g,
      T,
      x,
      C,
      H,
      L,
      B,
      oe,
      $
    ), f = jr(
      o,
      0,
      null,
      g,
      !1,
      !1
    ), f.parentFlushed = !0, i = Ii(
      o,
      null,
      i,
      -1,
      null,
      f,
      null,
      null,
      o.abortableTasks,
      null,
      g,
      null,
      oa,
      null,
      !1
    ), gn(i), o.pingedTasks.push(i), o;
  }
  var Rt = null;
  function Mi(i, o) {
    i.pingedTasks.push(o), i.pingedTasks.length === 1 && (i.flushScheduled = i.destination !== null, au(i));
  }
  function qr(i, o, f, g) {
    return {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: o,
      errorDigest: null,
      contentState: ra(),
      fallbackState: ra(),
      contentPreamble: f,
      fallbackPreamble: g,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    };
  }
  function Ii(i, o, f, g, T, x, C, H, L, B, oe, $, ae, se, Ee) {
    i.allPendingTasks++, T === null ? i.pendingRootTasks++ : T.pendingTasks++;
    var he = {
      replay: null,
      node: f,
      childIndex: g,
      ping: function() {
        return Mi(i, he);
      },
      blockedBoundary: T,
      blockedSegment: x,
      blockedPreamble: C,
      hoistableState: H,
      abortSet: L,
      keyPath: B,
      formatContext: oe,
      context: $,
      treeContext: ae,
      componentStack: se,
      thenableState: o,
      isFallback: Ee
    };
    return L.add(he), he;
  }
  function Ka(i, o, f, g, T, x, C, H, L, B, oe, $, ae, se) {
    i.allPendingTasks++, x === null ? i.pendingRootTasks++ : x.pendingTasks++, f.pendingTasks++;
    var Ee = {
      replay: f,
      node: g,
      childIndex: T,
      ping: function() {
        return Mi(i, Ee);
      },
      blockedBoundary: x,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: C,
      abortSet: H,
      keyPath: L,
      formatContext: B,
      context: oe,
      treeContext: $,
      componentStack: ae,
      thenableState: o,
      isFallback: se
    };
    return H.add(Ee), Ee;
  }
  function jr(i, o, f, g, T, x) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: o,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: g,
      boundary: f,
      lastPushedText: T,
      textEmbedded: x
    };
  }
  function gn(i) {
    var o = i.node;
    if (typeof o == "object" && o !== null)
      switch (o.$$typeof) {
        case ko:
          i.componentStack = { parent: i.componentStack, type: o.type };
      }
  }
  function Un(i) {
    var o = {};
    return i && Object.defineProperty(o, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var f = "", g = i;
          do
            f += Oi(g.type), g = g.parent;
          while (g);
          var T = f;
        } catch (x) {
          T = `
Error generating stack: ` + x.message + `
` + x.stack;
        }
        return Object.defineProperty(o, "componentStack", {
          value: T
        }), T;
      }
    }), o;
  }
  function rr(i, o, f) {
    if (i = i.onError, o = i(o, f), o == null || typeof o == "string")
      return o;
  }
  function Di(i, o) {
    var f = i.onShellError, g = i.onFatalError;
    f(o), g(o), i.destination !== null ? (i.status = 14, i.destination.destroy(o)) : (i.status = 13, i.fatalError = o);
  }
  function Pn(i, o, f, g, T, x) {
    var C = o.thenableState;
    for (o.thenableState = null, Xt = {}, Lo = o, _o = i, wt = f, yl = Zl = 0, wl = -1, ca = 0, Et = C, i = g(T, x); Ci; )
      Ci = !1, yl = Zl = 0, wl = -1, ca = 0, Ql += 1, Qe = null, i = g(T, x);
    return El(), i;
  }
  function Ke(i, o, f, g, T, x, C) {
    var H = !1;
    if (x !== 0 && i.formState !== null) {
      var L = o.blockedSegment;
      if (L !== null) {
        H = !0, L = L.chunks;
        for (var B = 0; B < x; B++)
          B === C ? L.push("<!--F!-->") : L.push("<!--F-->");
      }
    }
    x = o.keyPath, o.keyPath = f, T ? (f = o.treeContext, o.treeContext = Gl(f, 1, 0), Rr(i, o, g, -1), o.treeContext = f) : H ? Rr(i, o, g, -1) : Vn(i, o, g, -1), o.keyPath = x;
  }
  function Oc(i, o, f, g, T, x) {
    if (typeof g == "function")
      if (g.prototype && g.prototype.isReactComponent) {
        var C = T;
        if ("ref" in T) {
          C = {};
          for (var H in T)
            H !== "ref" && (C[H] = T[H]);
        }
        var L = g.defaultProps;
        if (L) {
          C === T && (C = mt({}, C, T));
          for (var B in L)
            C[B] === void 0 && (C[B] = L[B]);
        }
        T = C, C = ru, L = g.contextType, typeof L == "object" && L !== null && (C = L._currentValue2), C = new g(T, C);
        var oe = C.state !== void 0 ? C.state : null;
        if (C.updater = xi, C.props = T, C.state = oe, L = { queue: [], replace: !1 }, C._reactInternals = L, x = g.contextType, C.context = typeof x == "object" && x !== null ? x._currentValue2 : ru, x = g.getDerivedStateFromProps, typeof x == "function" && (x = x(T, oe), oe = x == null ? oe : mt({}, oe, x), C.state = oe), typeof g.getDerivedStateFromProps != "function" && typeof C.getSnapshotBeforeUpdate != "function" && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function"))
          if (g = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), g !== C.state && xi.enqueueReplaceState(
            C,
            C.state,
            null
          ), L.queue !== null && 0 < L.queue.length)
            if (g = L.queue, x = L.replace, L.queue = null, L.replace = !1, x && g.length === 1)
              C.state = g[0];
            else {
              for (L = x ? g[0] : C.state, oe = !0, x = x ? 1 : 0; x < g.length; x++)
                B = g[x], B = typeof B == "function" ? B.call(C, L, T, void 0) : B, B != null && (oe ? (oe = !1, L = mt({}, L, B)) : mt(L, B));
              C.state = L;
            }
          else
            L.queue = null;
        if (g = C.render(), i.status === 12)
          throw null;
        T = o.keyPath, o.keyPath = f, Vn(i, o, g, -1), o.keyPath = T;
      } else {
        if (g = Pn(i, o, f, g, T, void 0), i.status === 12)
          throw null;
        Ke(
          i,
          o,
          f,
          g,
          Zl !== 0,
          yl,
          wl
        );
      }
    else if (typeof g == "string")
      if (C = o.blockedSegment, C === null)
        C = T.children, L = o.formatContext, oe = o.keyPath, o.formatContext = De(L, g, T), o.keyPath = f, Rr(i, o, C, -1), o.formatContext = L, o.keyPath = oe;
      else {
        x = $t(
          C.chunks,
          g,
          T,
          i.resumableState,
          i.renderState,
          o.blockedPreamble,
          o.hoistableState,
          o.formatContext,
          C.lastPushedText,
          o.isFallback
        ), C.lastPushedText = !1, L = o.formatContext, oe = o.keyPath, o.keyPath = f, (o.formatContext = De(L, g, T)).insertionMode === 3 ? (f = jr(
          i,
          0,
          null,
          o.formatContext,
          !1,
          !1
        ), C.preambleChildren.push(f), f = Ii(
          i,
          null,
          x,
          -1,
          o.blockedBoundary,
          f,
          o.blockedPreamble,
          o.hoistableState,
          i.abortableTasks,
          o.keyPath,
          o.formatContext,
          o.context,
          o.treeContext,
          o.componentStack,
          o.isFallback
        ), gn(f), i.pingedTasks.push(f)) : Rr(i, o, x, -1), o.formatContext = L, o.keyPath = oe;
        e: {
          switch (o = C.chunks, i = i.resumableState, g) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break e;
            case "body":
              if (1 >= L.insertionMode) {
                i.hasBody = !0;
                break e;
              }
              break;
            case "html":
              if (L.insertionMode === 0) {
                i.hasHtml = !0;
                break e;
              }
              break;
            case "head":
              if (1 >= L.insertionMode)
                break e;
          }
          o.push(bi(g));
        }
        C.lastPushedText = !1;
      }
    else {
      switch (g) {
        case Po:
        case Xr:
        case Co:
        case Ut:
          g = o.keyPath, o.keyPath = f, Vn(i, o, T.children, -1), o.keyPath = g;
          return;
        case Na:
          T.mode !== "hidden" && (g = o.keyPath, o.keyPath = f, Vn(i, o, T.children, -1), o.keyPath = g);
          return;
        case q:
          g = o.keyPath, o.keyPath = f, Vn(i, o, T.children, -1), o.keyPath = g;
          return;
        case Cu:
        case wc:
          throw Error(Q(343));
        case ul:
          e:
            if (o.replay !== null) {
              g = o.keyPath, o.keyPath = f, f = T.children;
              try {
                Rr(i, o, f, -1);
              } finally {
                o.keyPath = g;
              }
            } else {
              g = o.keyPath;
              var $ = o.blockedBoundary;
              x = o.blockedPreamble;
              var ae = o.hoistableState;
              B = o.blockedSegment, H = T.fallback, T = T.children;
              var se = /* @__PURE__ */ new Set(), Ee = 2 > o.formatContext.insertionMode ? qr(
                i,
                se,
                ze(),
                ze()
              ) : qr(i, se, null, null);
              i.trackedPostpones !== null && (Ee.trackedContentKeyPath = f);
              var he = jr(
                i,
                B.chunks.length,
                Ee,
                o.formatContext,
                !1,
                !1
              );
              B.children.push(he), B.lastPushedText = !1;
              var Ne = jr(
                i,
                0,
                null,
                o.formatContext,
                !1,
                !1
              );
              if (Ne.parentFlushed = !0, i.trackedPostpones !== null) {
                C = [f[0], "Suspense Fallback", f[2]], L = [C[1], C[2], [], null], i.trackedPostpones.workingMap.set(C, L), Ee.trackedFallbackNode = L, o.blockedSegment = he, o.blockedPreamble = Ee.fallbackPreamble, o.keyPath = C, he.status = 6;
                try {
                  Rr(i, o, H, -1), Io(
                    he.chunks,
                    i.renderState,
                    he.lastPushedText,
                    he.textEmbedded
                  ), he.status = 1;
                } catch (Ve) {
                  throw he.status = i.status === 12 ? 3 : 4, Ve;
                } finally {
                  o.blockedSegment = B, o.blockedPreamble = x, o.keyPath = g;
                }
                o = Ii(
                  i,
                  null,
                  T,
                  -1,
                  Ee,
                  Ne,
                  Ee.contentPreamble,
                  Ee.contentState,
                  o.abortSet,
                  f,
                  o.formatContext,
                  o.context,
                  o.treeContext,
                  o.componentStack,
                  o.isFallback
                ), gn(o), i.pingedTasks.push(o);
              } else {
                o.blockedBoundary = Ee, o.blockedPreamble = Ee.contentPreamble, o.hoistableState = Ee.contentState, o.blockedSegment = Ne, o.keyPath = f, Ne.status = 6;
                try {
                  if (Rr(i, o, T, -1), Io(
                    Ne.chunks,
                    i.renderState,
                    Ne.lastPushedText,
                    Ne.textEmbedded
                  ), Ne.status = 1, Yo(Ee, Ne), Ee.pendingTasks === 0 && Ee.status === 0) {
                    Ee.status = 1, i.pendingRootTasks === 0 && o.blockedPreamble && Vl(i);
                    break e;
                  }
                } catch (Ve) {
                  Ee.status = 4, i.status === 12 ? (Ne.status = 3, C = i.fatalError) : (Ne.status = 4, C = Ve), L = Un(o.componentStack), oe = rr(
                    i,
                    C,
                    L
                  ), Ee.errorDigest = oe, qa(i, Ee);
                } finally {
                  o.blockedBoundary = $, o.blockedPreamble = x, o.hoistableState = ae, o.blockedSegment = B, o.keyPath = g;
                }
                o = Ii(
                  i,
                  null,
                  H,
                  -1,
                  $,
                  he,
                  Ee.fallbackPreamble,
                  Ee.fallbackState,
                  se,
                  [f[0], "Suspense Fallback", f[2]],
                  o.formatContext,
                  o.context,
                  o.treeContext,
                  o.componentStack,
                  !0
                ), gn(o), i.pingedTasks.push(o);
              }
            }
          return;
      }
      if (typeof g == "object" && g !== null)
        switch (g.$$typeof) {
          case Ce:
            if ("ref" in T)
              for (Ee in C = {}, T)
                Ee !== "ref" && (C[Ee] = T[Ee]);
            else
              C = T;
            g = Pn(
              i,
              o,
              f,
              g.render,
              C,
              x
            ), Ke(
              i,
              o,
              f,
              g,
              Zl !== 0,
              yl,
              wl
            );
            return;
          case U:
            Oc(i, o, f, g.type, T, x);
            return;
          case za:
          case z:
            if (L = T.children, C = o.keyPath, T = T.value, oe = g._currentValue2, g._currentValue2 = T, x = Ri, Ri = g = {
              parent: x,
              depth: x === null ? 0 : x.depth + 1,
              context: g,
              parentValue: oe,
              value: T
            }, o.context = g, o.keyPath = f, Vn(i, o, L, -1), i = Ri, i === null)
              throw Error(Q(403));
            i.context._currentValue2 = i.parentValue, i = Ri = i.parent, o.context = i, o.keyPath = C;
            return;
          case Ba:
            T = T.children, g = T(g._context._currentValue2), T = o.keyPath, o.keyPath = f, Vn(i, o, g, -1), o.keyPath = T;
            return;
          case sl:
            if (C = g._init, g = C(g._payload), i.status === 12)
              throw null;
            Oc(i, o, f, g, T, x);
            return;
        }
      throw Error(
        Q(130, g == null ? g : typeof g, "")
      );
    }
  }
  function Uo(i, o, f, g, T) {
    var x = o.replay, C = o.blockedBoundary, H = jr(
      i,
      0,
      null,
      o.formatContext,
      !1,
      !1
    );
    H.id = f, H.parentFlushed = !0;
    try {
      o.replay = null, o.blockedSegment = H, Rr(i, o, g, T), H.status = 1, C === null ? i.completedRootSegment = H : (Yo(C, H), C.parentFlushed && i.partialBoundaries.push(C));
    } finally {
      o.replay = x, o.blockedSegment = null;
    }
  }
  function Vn(i, o, f, g) {
    o.replay !== null && typeof o.replay.slots == "number" ? Uo(i, o, o.replay.slots, f, g) : (o.node = f, o.childIndex = g, f = o.componentStack, gn(o), Mc(i, o), o.componentStack = f);
  }
  function Mc(i, o) {
    var f = o.node, g = o.childIndex;
    if (f !== null) {
      if (typeof f == "object") {
        switch (f.$$typeof) {
          case ko:
            var T = f.type, x = f.key, C = f.props;
            f = C.ref;
            var H = f !== void 0 ? f : null, L = It(T), B = x ?? (g === -1 ? 0 : g);
            if (x = [o.keyPath, L, B], o.replay !== null)
              e: {
                var oe = o.replay;
                for (g = oe.nodes, f = 0; f < g.length; f++) {
                  var $ = g[f];
                  if (B === $[1]) {
                    if ($.length === 4) {
                      if (L !== null && L !== $[0])
                        throw Error(
                          Q(490, $[0], L)
                        );
                      var ae = $[2];
                      L = $[3], B = o.node, o.replay = {
                        nodes: ae,
                        slots: L,
                        pendingTasks: 1
                      };
                      try {
                        if (Oc(i, o, x, T, C, H), o.replay.pendingTasks === 1 && 0 < o.replay.nodes.length)
                          throw Error(Q(488));
                        o.replay.pendingTasks--;
                      } catch (de) {
                        if (typeof de == "object" && de !== null && (de === Er || typeof de.then == "function"))
                          throw o.node === B && (o.replay = oe), de;
                        o.replay.pendingTasks--, C = Un(o.componentStack), x = o.blockedBoundary, T = de, C = rr(i, T, C), it(
                          i,
                          x,
                          ae,
                          L,
                          T,
                          C
                        );
                      }
                      o.replay = oe;
                    } else {
                      if (T !== ul)
                        throw Error(
                          Q(
                            490,
                            "Suspense",
                            It(T) || "Unknown"
                          )
                        );
                      n: {
                        oe = void 0, T = $[5], H = $[2], L = $[3], B = $[4] === null ? [] : $[4][2], $ = $[4] === null ? null : $[4][3];
                        var se = o.keyPath, Ee = o.replay, he = o.blockedBoundary, Ne = o.hoistableState, Ve = C.children, Ge = C.fallback, cn = /* @__PURE__ */ new Set();
                        C = 2 > o.formatContext.insertionMode ? qr(
                          i,
                          cn,
                          ze(),
                          ze()
                        ) : qr(
                          i,
                          cn,
                          null,
                          null
                        ), C.parentFlushed = !0, C.rootSegmentID = T, o.blockedBoundary = C, o.hoistableState = C.contentState, o.keyPath = x, o.replay = {
                          nodes: H,
                          slots: L,
                          pendingTasks: 1
                        };
                        try {
                          if (Rr(i, o, Ve, -1), o.replay.pendingTasks === 1 && 0 < o.replay.nodes.length)
                            throw Error(Q(488));
                          if (o.replay.pendingTasks--, C.pendingTasks === 0 && C.status === 0) {
                            C.status = 1, i.completedBoundaries.push(C);
                            break n;
                          }
                        } catch (de) {
                          C.status = 4, ae = Un(o.componentStack), oe = rr(
                            i,
                            de,
                            ae
                          ), C.errorDigest = oe, o.replay.pendingTasks--, i.clientRenderedBoundaries.push(C);
                        } finally {
                          o.blockedBoundary = he, o.hoistableState = Ne, o.replay = Ee, o.keyPath = se;
                        }
                        o = Ka(
                          i,
                          null,
                          {
                            nodes: B,
                            slots: $,
                            pendingTasks: 0
                          },
                          Ge,
                          -1,
                          he,
                          C.fallbackState,
                          cn,
                          [x[0], "Suspense Fallback", x[2]],
                          o.formatContext,
                          o.context,
                          o.treeContext,
                          o.componentStack,
                          !0
                        ), gn(o), i.pingedTasks.push(o);
                      }
                    }
                    g.splice(f, 1);
                    break e;
                  }
                }
              }
            else
              Oc(i, o, x, T, C, H);
            return;
          case Nl:
            throw Error(Q(257));
          case sl:
            if (ae = f._init, f = ae(f._payload), i.status === 12)
              throw null;
            Vn(i, o, f, g);
            return;
        }
        if (Zr(f)) {
          Ic(i, o, f, g);
          return;
        }
        if (f === null || typeof f != "object" ? ae = null : (ae = xe && f[xe] || f["@@iterator"], ae = typeof ae == "function" ? ae : null), ae && (ae = ae.call(f))) {
          if (f = ae.next(), !f.done) {
            C = [];
            do
              C.push(f.value), f = ae.next();
            while (!f.done);
            Ic(i, o, C, g);
          }
          return;
        }
        if (typeof f.then == "function")
          return o.thenableState = null, Vn(i, o, zo(f), g);
        if (f.$$typeof === z)
          return Vn(
            i,
            o,
            f._currentValue2,
            g
          );
        throw g = Object.prototype.toString.call(f), Error(
          Q(
            31,
            g === "[object Object]" ? "object with keys {" + Object.keys(f).join(", ") + "}" : g
          )
        );
      }
      typeof f == "string" ? (g = o.blockedSegment, g !== null && (g.lastPushedText = bn(
        g.chunks,
        f,
        i.renderState,
        g.lastPushedText
      ))) : (typeof f == "number" || typeof f == "bigint") && (g = o.blockedSegment, g !== null && (g.lastPushedText = bn(
        g.chunks,
        "" + f,
        i.renderState,
        g.lastPushedText
      )));
    }
  }
  function Ic(i, o, f, g) {
    var T = o.keyPath;
    if (g !== -1 && (o.keyPath = [o.keyPath, "Fragment", g], o.replay !== null)) {
      for (var x = o.replay, C = x.nodes, H = 0; H < C.length; H++) {
        var L = C[H];
        if (L[1] === g) {
          g = L[2], L = L[3], o.replay = { nodes: g, slots: L, pendingTasks: 1 };
          try {
            if (Ic(i, o, f, -1), o.replay.pendingTasks === 1 && 0 < o.replay.nodes.length)
              throw Error(Q(488));
            o.replay.pendingTasks--;
          } catch ($) {
            if (typeof $ == "object" && $ !== null && ($ === Er || typeof $.then == "function"))
              throw $;
            o.replay.pendingTasks--, f = Un(o.componentStack);
            var B = o.blockedBoundary, oe = $;
            f = rr(i, oe, f), it(
              i,
              B,
              g,
              L,
              oe,
              f
            );
          }
          o.replay = x, C.splice(H, 1);
          break;
        }
      }
      o.keyPath = T;
      return;
    }
    if (x = o.treeContext, C = f.length, o.replay !== null && (H = o.replay.slots, H !== null && typeof H == "object")) {
      for (g = 0; g < C; g++)
        L = f[g], o.treeContext = Gl(x, C, g), B = H[g], typeof B == "number" ? (Uo(i, o, B, L, g), delete H[g]) : Rr(i, o, L, g);
      o.treeContext = x, o.keyPath = T;
      return;
    }
    for (H = 0; H < C; H++)
      g = f[H], o.treeContext = Gl(x, C, H), Rr(i, o, g, H);
    o.treeContext = x, o.keyPath = T;
  }
  function qa(i, o) {
    i = i.trackedPostpones, i !== null && (o = o.trackedContentKeyPath, o !== null && (o = i.workingMap.get(o), o !== void 0 && (o.length = 4, o[2] = [], o[3] = null)));
  }
  function mo(i, o, f) {
    return Ka(
      i,
      f,
      o.replay,
      o.node,
      o.childIndex,
      o.blockedBoundary,
      o.hoistableState,
      o.abortSet,
      o.keyPath,
      o.formatContext,
      o.context,
      o.treeContext,
      o.componentStack,
      o.isFallback
    );
  }
  function xl(i, o, f) {
    var g = o.blockedSegment, T = jr(
      i,
      g.chunks.length,
      null,
      o.formatContext,
      g.lastPushedText,
      !0
    );
    return g.children.push(T), g.lastPushedText = !1, Ii(
      i,
      f,
      o.node,
      o.childIndex,
      o.blockedBoundary,
      T,
      o.blockedPreamble,
      o.hoistableState,
      o.abortSet,
      o.keyPath,
      o.formatContext,
      o.context,
      o.treeContext,
      o.componentStack,
      o.isFallback
    );
  }
  function Rr(i, o, f, g) {
    var T = o.formatContext, x = o.context, C = o.keyPath, H = o.treeContext, L = o.componentStack, B = o.blockedSegment;
    if (B === null)
      try {
        return Vn(i, o, f, g);
      } catch (ae) {
        if (El(), f = ae === Er ? An() : ae, typeof f == "object" && f !== null) {
          if (typeof f.then == "function") {
            g = Vr(), i = mo(i, o, g).ping, f.then(i, i), o.formatContext = T, o.context = x, o.keyPath = C, o.treeContext = H, o.componentStack = L, Tr(x);
            return;
          }
          if (f.message === "Maximum call stack size exceeded") {
            f = Vr(), f = mo(i, o, f), i.pingedTasks.push(f), o.formatContext = T, o.context = x, o.keyPath = C, o.treeContext = H, o.componentStack = L, Tr(x);
            return;
          }
        }
      }
    else {
      var oe = B.children.length, $ = B.chunks.length;
      try {
        return Vn(i, o, f, g);
      } catch (ae) {
        if (El(), B.children.length = oe, B.chunks.length = $, f = ae === Er ? An() : ae, typeof f == "object" && f !== null) {
          if (typeof f.then == "function") {
            g = Vr(), i = xl(i, o, g).ping, f.then(i, i), o.formatContext = T, o.context = x, o.keyPath = C, o.treeContext = H, o.componentStack = L, Tr(x);
            return;
          }
          if (f.message === "Maximum call stack size exceeded") {
            f = Vr(), f = xl(i, o, f), i.pingedTasks.push(f), o.formatContext = T, o.context = x, o.keyPath = C, o.treeContext = H, o.componentStack = L, Tr(x);
            return;
          }
        }
      }
    }
    throw o.formatContext = T, o.context = x, o.keyPath = C, o.treeContext = H, Tr(x), f;
  }
  function Au(i) {
    var o = i.blockedBoundary;
    i = i.blockedSegment, i !== null && (i.status = 3, Dc(this, o, i));
  }
  function it(i, o, f, g, T, x) {
    for (var C = 0; C < f.length; C++) {
      var H = f[C];
      if (H.length === 4)
        it(
          i,
          o,
          H[2],
          H[3],
          T,
          x
        );
      else {
        H = H[5];
        var L = i, B = x, oe = qr(
          L,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        oe.parentFlushed = !0, oe.rootSegmentID = H, oe.status = 4, oe.errorDigest = B, oe.parentFlushed && L.clientRenderedBoundaries.push(oe);
      }
    }
    if (f.length = 0, g !== null) {
      if (o === null)
        throw Error(Q(487));
      if (o.status !== 4 && (o.status = 4, o.errorDigest = x, o.parentFlushed && i.clientRenderedBoundaries.push(o)), typeof g == "object")
        for (var $ in g)
          delete g[$];
    }
  }
  function Dt(i, o, f) {
    var g = i.blockedBoundary, T = i.blockedSegment;
    if (T !== null) {
      if (T.status === 6)
        return;
      T.status = 3;
    }
    if (T = Un(i.componentStack), g === null) {
      if (o.status !== 13 && o.status !== 14) {
        if (g = i.replay, g === null) {
          rr(o, f, T), Di(o, f);
          return;
        }
        g.pendingTasks--, g.pendingTasks === 0 && 0 < g.nodes.length && (i = rr(o, f, T), it(
          o,
          null,
          g.nodes,
          g.slots,
          f,
          i
        )), o.pendingRootTasks--, o.pendingRootTasks === 0 && yn(o);
      }
    } else
      g.pendingTasks--, g.status !== 4 && (g.status = 4, i = rr(o, f, T), g.status = 4, g.errorDigest = i, qa(o, g), g.parentFlushed && o.clientRenderedBoundaries.push(g)), g.fallbackAbortableTasks.forEach(function(x) {
        return Dt(x, o, f);
      }), g.fallbackAbortableTasks.clear();
    o.allPendingTasks--, o.allPendingTasks === 0 && Je(o);
  }
  function at(i, o) {
    try {
      var f = i.renderState, g = f.onHeaders;
      if (g) {
        var T = f.headers;
        if (T) {
          f.headers = null;
          var x = T.preconnects;
          if (T.fontPreloads && (x && (x += ", "), x += T.fontPreloads), T.highImagePreloads && (x && (x += ", "), x += T.highImagePreloads), !o) {
            var C = f.styles.values(), H = C.next();
            e:
              for (; 0 < T.remainingCapacity && !H.done; H = C.next())
                for (var L = H.value.sheets.values(), B = L.next(); 0 < T.remainingCapacity && !B.done; B = L.next()) {
                  var oe = B.value, $ = oe.props, ae = $.href, se = oe.props, Ee = nr(se.href, "style", {
                    crossOrigin: se.crossOrigin,
                    integrity: se.integrity,
                    nonce: se.nonce,
                    type: se.type,
                    fetchPriority: se.fetchPriority,
                    referrerPolicy: se.referrerPolicy,
                    media: se.media
                  });
                  if (0 <= (T.remainingCapacity -= Ee.length + 2))
                    f.resets.style[ae] = zn, x && (x += ", "), x += Ee, f.resets.style[ae] = typeof $.crossOrigin == "string" || typeof $.integrity == "string" ? [$.crossOrigin, $.integrity] : zn;
                  else
                    break e;
                }
          }
          g(x ? { Link: x } : {});
        }
      }
    } catch (he) {
      rr(i, he, {});
    }
  }
  function yn(i) {
    i.trackedPostpones === null && at(i, !0), i.trackedPostpones === null && Vl(i), i.onShellError = Rl, i = i.onShellReady, i();
  }
  function Je(i) {
    at(
      i,
      i.trackedPostpones === null ? !0 : i.completedRootSegment === null || i.completedRootSegment.status !== 5
    ), Vl(i), i = i.onAllReady, i();
  }
  function Yo(i, o) {
    if (o.chunks.length === 0 && o.children.length === 1 && o.children[0].boundary === null && o.children[0].id === -1) {
      var f = o.children[0];
      f.id = o.id, f.parentFlushed = !0, f.status === 1 && Yo(i, f);
    } else
      i.completedSegments.push(o);
  }
  function Dc(i, o, f) {
    if (o === null) {
      if (f !== null && f.parentFlushed) {
        if (i.completedRootSegment !== null)
          throw Error(Q(389));
        i.completedRootSegment = f;
      }
      i.pendingRootTasks--, i.pendingRootTasks === 0 && yn(i);
    } else
      o.pendingTasks--, o.status !== 4 && (o.pendingTasks === 0 ? (o.status === 0 && (o.status = 1), f !== null && f.parentFlushed && f.status === 1 && Yo(o, f), o.parentFlushed && i.completedBoundaries.push(o), o.status === 1 && (o.fallbackAbortableTasks.forEach(Au, i), o.fallbackAbortableTasks.clear(), i.pendingRootTasks === 0 && i.trackedPostpones === null && o.contentPreamble !== null && Vl(i))) : f !== null && f.parentFlushed && f.status === 1 && (Yo(o, f), o.completedSegments.length === 1 && o.parentFlushed && i.partialBoundaries.push(o)));
    i.allPendingTasks--, i.allPendingTasks === 0 && Je(i);
  }
  function au(i) {
    if (i.status !== 14 && i.status !== 13) {
      var o = Ri, f = fi.H;
      fi.H = Si;
      var g = fi.A;
      fi.A = Fi;
      var T = Rt;
      Rt = i;
      var x = fa;
      fa = i.resumableState;
      try {
        var C = i.pingedTasks, H;
        for (H = 0; H < C.length; H++) {
          var L = C[H], B = i, oe = L.blockedSegment;
          if (oe === null) {
            var $ = B;
            if (L.replay.pendingTasks !== 0) {
              Tr(L.context);
              try {
                if (typeof L.replay.slots == "number" ? Uo(
                  $,
                  L,
                  L.replay.slots,
                  L.node,
                  L.childIndex
                ) : Mc($, L), L.replay.pendingTasks === 1 && 0 < L.replay.nodes.length)
                  throw Error(Q(488));
                L.replay.pendingTasks--, L.abortSet.delete(L), Dc($, L.blockedBoundary, null);
              } catch ($e) {
                El();
                var ae = $e === Er ? An() : $e;
                if (typeof ae == "object" && ae !== null && typeof ae.then == "function") {
                  var se = L.ping;
                  ae.then(se, se), L.thenableState = Vr();
                } else {
                  L.replay.pendingTasks--, L.abortSet.delete(L);
                  var Ee = Un(L.componentStack);
                  B = void 0;
                  var he = $, Ne = L.blockedBoundary, Ve = $.status === 12 ? $.fatalError : ae, Ge = L.replay.nodes, cn = L.replay.slots;
                  B = rr(
                    he,
                    Ve,
                    Ee
                  ), it(
                    he,
                    Ne,
                    Ge,
                    cn,
                    Ve,
                    B
                  ), $.pendingRootTasks--, $.pendingRootTasks === 0 && yn($), $.allPendingTasks--, $.allPendingTasks === 0 && Je($);
                }
              } finally {
              }
            }
          } else if ($ = void 0, he = oe, he.status === 0) {
            he.status = 6, Tr(L.context);
            var de = he.children.length, _e = he.chunks.length;
            try {
              Mc(B, L), Io(
                he.chunks,
                B.renderState,
                he.lastPushedText,
                he.textEmbedded
              ), L.abortSet.delete(L), he.status = 1, Dc(B, L.blockedBoundary, he);
            } catch ($e) {
              El(), he.children.length = de, he.chunks.length = _e;
              var Re = $e === Er ? An() : B.status === 12 ? B.fatalError : $e;
              if (typeof Re == "object" && Re !== null && typeof Re.then == "function") {
                he.status = 0, L.thenableState = Vr();
                var Kn = L.ping;
                Re.then(Kn, Kn);
              } else {
                var xt = Un(L.componentStack);
                L.abortSet.delete(L), he.status = 4;
                var ve = L.blockedBoundary;
                $ = rr(
                  B,
                  Re,
                  xt
                ), ve === null ? Di(B, Re) : (ve.pendingTasks--, ve.status !== 4 && (ve.status = 4, ve.errorDigest = $, qa(B, ve), ve.parentFlushed && B.clientRenderedBoundaries.push(ve), B.pendingRootTasks === 0 && B.trackedPostpones === null && ve.contentPreamble !== null && Vl(B))), B.allPendingTasks--, B.allPendingTasks === 0 && Je(B);
              }
            } finally {
            }
          }
        }
        C.splice(0, H), i.destination !== null && eo(i, i.destination);
      } catch ($e) {
        rr(i, $e, {}), Di(i, $e);
      } finally {
        fa = x, fi.H = f, fi.A = g, f === Si && Tr(o), Rt = T;
      }
    }
  }
  function ou(i, o, f) {
    o.preambleChildren.length && f.push(o.preambleChildren);
    for (var g = !1, T = 0; T < o.children.length; T++)
      g = ja(
        i,
        o.children[T],
        f
      ) || g;
    return g;
  }
  function ja(i, o, f) {
    var g = o.boundary;
    if (g === null)
      return ou(
        i,
        o,
        f
      );
    var T = g.contentPreamble, x = g.fallbackPreamble;
    if (T === null || x === null)
      return !1;
    switch (g.status) {
      case 1:
        if (Qr(i.renderState, T), o = g.completedSegments[0], !o)
          throw Error(Q(391));
        return ou(
          i,
          o,
          f
        );
      case 5:
        if (i.trackedPostpones !== null)
          return !0;
      case 4:
        if (o.status === 1)
          return Qr(i.renderState, x), ou(
            i,
            o,
            f
          );
      default:
        return !0;
    }
  }
  function Vl(i) {
    if (i.completedRootSegment && i.completedPreambleSegments === null) {
      var o = [], f = ja(
        i,
        i.completedRootSegment,
        o
      ), g = i.renderState.preamble;
      (f === !1 || g.headChunks && g.bodyChunks) && (i.completedPreambleSegments = o);
    }
  }
  function Ir(i, o, f, g) {
    switch (f.parentFlushed = !0, f.status) {
      case 0:
        f.id = i.nextSegmentId++;
      case 5:
        return g = f.id, f.lastPushedText = !1, f.textEmbedded = !1, i = i.renderState, o.push('<template id="'), o.push(i.placeholderPrefix), i = g.toString(16), o.push(i), o.push('"></template>');
      case 1:
        f.status = 2;
        var T = !0, x = f.chunks, C = 0;
        f = f.children;
        for (var H = 0; H < f.length; H++) {
          for (T = f[H]; C < T.index; C++)
            o.push(x[C]);
          T = lr(i, o, T, g);
        }
        for (; C < x.length - 1; C++)
          o.push(x[C]);
        return C < x.length && (T = o.push(x[C])), T;
      default:
        throw Error(Q(390));
    }
  }
  function lr(i, o, f, g) {
    var T = f.boundary;
    if (T === null)
      return Ir(i, o, f, g);
    if (T.parentFlushed = !0, T.status === 4) {
      if (!i.renderState.generateStaticMarkup) {
        var x = T.errorDigest;
        o.push("<!--$!-->"), o.push("<template"), x && (o.push(' data-dgst="'), x = ce(x), o.push(x), o.push('"')), o.push("></template>");
      }
      return Ir(i, o, f, g), i.renderState.generateStaticMarkup ? o = !0 : ((i = T.fallbackPreamble) && Pc(o, i), o = o.push("<!--/$-->")), o;
    }
    if (T.status !== 1)
      return T.status === 0 && (T.rootSegmentID = i.nextSegmentId++), 0 < T.completedSegments.length && i.partialBoundaries.push(T), eu(
        o,
        i.renderState,
        T.rootSegmentID
      ), g && (T = T.fallbackState, T.styles.forEach(Fc, g), T.stylesheets.forEach(
        Fu,
        g
      )), Ir(i, o, f, g), o.push("<!--/$-->");
    if (T.byteSize > i.progressiveChunkSize)
      return T.rootSegmentID = i.nextSegmentId++, i.completedBoundaries.push(T), eu(
        o,
        i.renderState,
        T.rootSegmentID
      ), Ir(i, o, f, g), o.push("<!--/$-->");
    if (g && (f = T.contentState, f.styles.forEach(Fc, g), f.stylesheets.forEach(Fu, g)), i.renderState.generateStaticMarkup || o.push("<!--$-->"), f = T.completedSegments, f.length !== 1)
      throw Error(Q(391));
    return lr(i, o, f[0], g), i.renderState.generateStaticMarkup ? o = !0 : ((i = T.contentPreamble) && Pc(o, i), o = o.push("<!--/$-->")), o;
  }
  function $a(i, o, f, g) {
    return Mo(
      o,
      i.renderState,
      f.parentFormatContext,
      f.id
    ), lr(i, o, f, g), on(o, f.parentFormatContext);
  }
  function Go(i, o, f) {
    for (var g = f.completedSegments, T = 0; T < g.length; T++)
      Lc(
        i,
        o,
        f,
        g[T]
      );
    g.length = 0, wi(
      o,
      f.contentState,
      i.renderState
    ), g = i.resumableState, i = i.renderState, T = f.rootSegmentID, f = f.contentState;
    var x = i.stylesToHoist;
    return i.stylesToHoist = !1, o.push(i.startInlineScript), x ? g.instructions & 2 ? g.instructions & 8 ? o.push('$RR("') : (g.instructions |= 8, o.push(
      `$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`
    )) : (g.instructions |= 10, o.push(
      `$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`
    )) : g.instructions & 2 ? o.push('$RC("') : (g.instructions |= 2, o.push(
      '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("'
    )), g = T.toString(16), o.push(i.boundaryPrefix), o.push(g), o.push('","'), o.push(i.segmentPrefix), o.push(g), x ? (o.push('",'), ta(o, f)) : o.push('"'), f = o.push(")<\/script>"), Cc(o, i) && f;
  }
  function Lc(i, o, f, g) {
    if (g.status === 2)
      return !0;
    var T = f.contentState, x = g.id;
    if (x === -1) {
      if ((g.id = f.rootSegmentID) === -1)
        throw Error(Q(392));
      return $a(i, o, g, T);
    }
    return x === f.rootSegmentID ? $a(i, o, g, T) : ($a(i, o, g, T), f = i.resumableState, i = i.renderState, o.push(i.startInlineScript), f.instructions & 1 ? o.push('$RS("') : (f.instructions |= 1, o.push(
      '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
    )), o.push(i.segmentPrefix), x = x.toString(16), o.push(x), o.push('","'), o.push(i.placeholderPrefix), o.push(x), o = o.push('")<\/script>'), o);
  }
  function eo(i, o) {
    try {
      if (!(0 < i.pendingRootTasks)) {
        var f, g = i.completedRootSegment;
        if (g !== null) {
          if (g.status === 5)
            return;
          var T = i.completedPreambleSegments;
          if (T === null)
            return;
          var x = i.renderState, C = x.preamble, H = C.htmlChunks, L = C.headChunks, B;
          if (H) {
            for (B = 0; B < H.length; B++)
              o.push(H[B]);
            if (L)
              for (B = 0; B < L.length; B++)
                o.push(L[B]);
            else {
              var oe = me("head");
              o.push(oe), o.push(">");
            }
          } else if (L)
            for (B = 0; B < L.length; B++)
              o.push(L[B]);
          var $ = x.charsetChunks;
          for (B = 0; B < $.length; B++)
            o.push($[B]);
          $.length = 0, x.preconnects.forEach(er, o), x.preconnects.clear();
          var ae = x.viewportChunks;
          for (B = 0; B < ae.length; B++)
            o.push(ae[B]);
          ae.length = 0, x.fontPreloads.forEach(er, o), x.fontPreloads.clear(), x.highImagePreloads.forEach(er, o), x.highImagePreloads.clear(), x.styles.forEach(Ya, o);
          var se = x.importMapChunks;
          for (B = 0; B < se.length; B++)
            o.push(se[B]);
          se.length = 0, x.bootstrapScripts.forEach(er, o), x.scripts.forEach(er, o), x.scripts.clear(), x.bulkPreloads.forEach(er, o), x.bulkPreloads.clear();
          var Ee = x.hoistableChunks;
          for (B = 0; B < Ee.length; B++)
            o.push(Ee[B]);
          for (x = Ee.length = 0; x < T.length; x++) {
            var he = T[x];
            for (C = 0; C < he.length; C++)
              lr(i, o, he[C], null);
          }
          var Ne = i.renderState.preamble, Ve = Ne.headChunks;
          if (Ne.htmlChunks || Ve) {
            var Ge = bi("head");
            o.push(Ge);
          }
          var cn = Ne.bodyChunks;
          if (cn)
            for (T = 0; T < cn.length; T++)
              o.push(cn[T]);
          lr(i, o, g, null), i.completedRootSegment = null, Cc(o, i.renderState);
        }
        var de = i.renderState;
        g = 0;
        var _e = de.viewportChunks;
        for (g = 0; g < _e.length; g++)
          o.push(_e[g]);
        _e.length = 0, de.preconnects.forEach(er, o), de.preconnects.clear(), de.fontPreloads.forEach(er, o), de.fontPreloads.clear(), de.highImagePreloads.forEach(
          er,
          o
        ), de.highImagePreloads.clear(), de.styles.forEach(sn, o), de.scripts.forEach(er, o), de.scripts.clear(), de.bulkPreloads.forEach(er, o), de.bulkPreloads.clear();
        var Re = de.hoistableChunks;
        for (g = 0; g < Re.length; g++)
          o.push(Re[g]);
        Re.length = 0;
        var Kn = i.clientRenderedBoundaries;
        for (f = 0; f < Kn.length; f++) {
          var xt = Kn[f];
          de = o;
          var ve = i.resumableState, $e = i.renderState, On = xt.rootSegmentID, mn = xt.errorDigest;
          de.push($e.startInlineScript), ve.instructions & 4 ? de.push('$RX("') : (ve.instructions |= 4, de.push(
            '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
          )), de.push($e.boundaryPrefix);
          var $r = On.toString(16);
          if (de.push($r), de.push('"'), mn) {
            de.push(",");
            var tn = lt(
              mn || ""
            );
            de.push(tn);
          }
          var Mn = de.push(")<\/script>");
          if (!Mn) {
            i.destination = null, f++, Kn.splice(0, f);
            return;
          }
        }
        Kn.splice(0, f);
        var _t = i.completedBoundaries;
        for (f = 0; f < _t.length; f++)
          if (!Go(i, o, _t[f])) {
            i.destination = null, f++, _t.splice(0, f);
            return;
          }
        _t.splice(0, f);
        var kt = i.partialBoundaries;
        for (f = 0; f < kt.length; f++) {
          var el = kt[f];
          e: {
            Kn = i, xt = o;
            var Ct = el.completedSegments;
            for (Mn = 0; Mn < Ct.length; Mn++)
              if (!Lc(
                Kn,
                xt,
                el,
                Ct[Mn]
              )) {
                Mn++, Ct.splice(0, Mn);
                var Dr = !1;
                break e;
              }
            Ct.splice(0, Mn), Dr = wi(
              xt,
              el.contentState,
              Kn.renderState
            );
          }
          if (!Dr) {
            i.destination = null, f++, kt.splice(0, f);
            return;
          }
        }
        kt.splice(0, f);
        var ir = i.completedBoundaries;
        for (f = 0; f < ir.length; f++)
          if (!Go(i, o, ir[f])) {
            i.destination = null, f++, ir.splice(0, f);
            return;
          }
        ir.splice(0, f);
      }
    } finally {
      i.allPendingTasks === 0 && i.pingedTasks.length === 0 && i.clientRenderedBoundaries.length === 0 && i.completedBoundaries.length === 0 && (i.flushScheduled = !1, f = i.resumableState, f.hasBody && (kt = bi("body"), o.push(kt)), f.hasHtml && (f = bi("html"), o.push(f)), i.status = 14, o.push(null), i.destination = null);
    }
  }
  function pn(i) {
    if (i.flushScheduled === !1 && i.pingedTasks.length === 0 && i.destination !== null) {
      i.flushScheduled = !0;
      var o = i.destination;
      o ? eo(i, o) : i.flushScheduled = !1;
    }
  }
  function pu(i, o) {
    if (i.status === 13)
      i.status = 14, o.destroy(i.fatalError);
    else if (i.status !== 14 && i.destination === null) {
      i.destination = o;
      try {
        eo(i, o);
      } catch (f) {
        rr(i, f, {}), Di(i, f);
      }
    }
  }
  function Lt(i, o) {
    (i.status === 11 || i.status === 10) && (i.status = 12);
    try {
      var f = i.abortableTasks;
      if (0 < f.size) {
        var g = o === void 0 ? Error(Q(432)) : typeof o == "object" && o !== null && typeof o.then == "function" ? Error(Q(530)) : o;
        i.fatalError = g, f.forEach(function(T) {
          return Dt(T, i, g);
        }), f.clear();
      }
      i.destination !== null && eo(i, i.destination);
    } catch (T) {
      rr(i, T, {}), Di(i, T);
    }
  }
  function cu() {
  }
  function Li(i, o, f, g) {
    var T = !1, x = null, C = "", H = !1;
    if (o = Tc(o ? o.identifierPrefix : void 0), i = ga(
      i,
      o,
      ml(o, f),
      Ae(0, null, 0),
      1 / 0,
      cu,
      void 0,
      function() {
        H = !0;
      },
      void 0,
      void 0,
      void 0
    ), i.flushScheduled = i.destination !== null, au(i), i.status === 10 && (i.status = 11), i.trackedPostpones === null && at(i, i.pendingRootTasks === 0), Lt(i, g), pu(i, {
      push: function(L) {
        return L !== null && (C += L), !0;
      },
      destroy: function(L) {
        T = !0, x = L;
      }
    }), T && x !== g)
      throw x;
    if (!H)
      throw Error(Q(426));
    return C;
  }
  return cs.renderToStaticMarkup = function(i, o) {
    return Li(
      i,
      o,
      !0,
      'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, cs.renderToString = function(i, o) {
    return Li(
      i,
      o,
      !1,
      'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, cs.version = "19.1.0", cs;
}
var us = {};
/**
 * @license React
 * react-dom-server.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _s;
function Bs() {
  if (_s)
    return us;
  _s = 1;
  var yc = bs, Uu = ys;
  function Q(l) {
    var a = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      a += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var s = 2; s < arguments.length; s++)
        a += "&args[]=" + encodeURIComponent(arguments[s]);
    }
    return "Minified React error #" + l + "; visit " + a + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var ko = Symbol.for("react.transitional.element"), Nl = Symbol.for("react.portal"), Ut = Symbol.for("react.fragment"), Xr = Symbol.for("react.strict_mode"), Co = Symbol.for("react.profiler"), za = Symbol.for("react.provider"), Ba = Symbol.for("react.consumer"), z = Symbol.for("react.context"), Ce = Symbol.for("react.forward_ref"), ul = Symbol.for("react.suspense"), q = Symbol.for("react.suspense_list"), U = Symbol.for("react.memo"), sl = Symbol.for("react.lazy"), wc = Symbol.for("react.scope"), Na = Symbol.for("react.activity"), Po = Symbol.for("react.legacy_hidden"), qt = Symbol.for("react.memo_cache_sentinel"), Cu = Symbol.for("react.view_transition"), xe = Symbol.iterator, Zr = Array.isArray;
  function Ua(l, a) {
    var s = l.length & 3, v = l.length - s, w = a;
    for (a = 0; a < v; ) {
      var k = l.charCodeAt(a) & 255 | (l.charCodeAt(++a) & 255) << 8 | (l.charCodeAt(++a) & 255) << 16 | (l.charCodeAt(++a) & 255) << 24;
      ++a, k = 3432918353 * (k & 65535) + ((3432918353 * (k >>> 16) & 65535) << 16) & 4294967295, k = k << 15 | k >>> 17, k = 461845907 * (k & 65535) + ((461845907 * (k >>> 16) & 65535) << 16) & 4294967295, w ^= k, w = w << 13 | w >>> 19, w = 5 * (w & 65535) + ((5 * (w >>> 16) & 65535) << 16) & 4294967295, w = (w & 65535) + 27492 + (((w >>> 16) + 58964 & 65535) << 16);
    }
    switch (k = 0, s) {
      case 3:
        k ^= (l.charCodeAt(a + 2) & 255) << 16;
      case 2:
        k ^= (l.charCodeAt(a + 1) & 255) << 8;
      case 1:
        k ^= l.charCodeAt(a) & 255, k = 3432918353 * (k & 65535) + ((3432918353 * (k >>> 16) & 65535) << 16) & 4294967295, k = k << 15 | k >>> 17, w ^= 461845907 * (k & 65535) + ((461845907 * (k >>> 16) & 65535) << 16) & 4294967295;
    }
    return w ^= l.length, w ^= w >>> 16, w = 2246822507 * (w & 65535) + ((2246822507 * (w >>> 16) & 65535) << 16) & 4294967295, w ^= w >>> 13, w = 3266489909 * (w & 65535) + ((3266489909 * (w >>> 16) & 65535) << 16) & 4294967295, (w ^ w >>> 16) >>> 0;
  }
  var mt = new MessageChannel(), je = [];
  mt.port1.onmessage = function() {
    var l = je.shift();
    l && l();
  };
  function Mt(l) {
    je.push(l), mt.port2.postMessage(null);
  }
  function jc(l) {
    setTimeout(function() {
      throw l;
    });
  }
  var $c = Promise, Pe = typeof queueMicrotask == "function" ? queueMicrotask : function(l) {
    $c.resolve(null).then(l).catch(jc);
  }, Xe = null, dt = 0;
  function X(l, a) {
    if (a.byteLength !== 0)
      if (2048 < a.byteLength)
        0 < dt && (l.enqueue(
          new Uint8Array(Xe.buffer, 0, dt)
        ), Xe = new Uint8Array(2048), dt = 0), l.enqueue(a);
      else {
        var s = Xe.length - dt;
        s < a.byteLength && (s === 0 ? l.enqueue(Xe) : (Xe.set(a.subarray(0, s), dt), l.enqueue(Xe), a = a.subarray(s)), Xe = new Uint8Array(2048), dt = 0), Xe.set(a, dt), dt += a.byteLength;
      }
  }
  function ce(l, a) {
    return X(l, a), !0;
  }
  function si(l) {
    Xe && 0 < dt && (l.enqueue(new Uint8Array(Xe.buffer, 0, dt)), Xe = null, dt = 0);
  }
  var pe = new TextEncoder();
  function j(l) {
    return pe.encode(l);
  }
  function m(l) {
    return pe.encode(l);
  }
  function fi(l, a) {
    typeof l.error == "function" ? l.error(a) : l.close();
  }
  var gt = Object.assign, Ie = Object.prototype.hasOwnProperty, hn = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), zn = {}, So = {};
  function hi(l) {
    return Ie.call(So, l) ? !0 : Ie.call(zn, l) ? !1 : hn.test(l) ? So[l] = !0 : (zn[l] = !0, !1);
  }
  var Tc = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), ze = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Ae = /["'&<>]/;
  function De(l) {
    if (typeof l == "boolean" || typeof l == "number" || typeof l == "bigint")
      return "" + l;
    l = "" + l;
    var a = Ae.exec(l);
    if (a) {
      var s = "", v, w = 0;
      for (v = a.index; v < l.length; v++) {
        switch (l.charCodeAt(v)) {
          case 34:
            a = "&quot;";
            break;
          case 38:
            a = "&amp;";
            break;
          case 39:
            a = "&#x27;";
            break;
          case 60:
            a = "&lt;";
            break;
          case 62:
            a = "&gt;";
            break;
          default:
            continue;
        }
        w !== v && (s += l.slice(w, v)), w = v + 1, s += a;
      }
      l = w !== v ? s + l.slice(w, v) : s;
    }
    return l;
  }
  var di = /([A-Z])/g, Ec = /^ms-/, tt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Cn(l) {
    return tt.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  var gr = yc.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Fo = Uu.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ao = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, Yt = Fo.d;
  Fo.d = {
    f: Yt.f,
    r: Yt.r,
    D: at,
    C: yn,
    L: Je,
    m: Yo,
    X: au,
    S: Dc,
    M: ou
  };
  var Bn = [];
  m('"></template>');
  var ke = m("<script>"), jt = m("<\/script>"), gi = m('<script src="'), vr = m('<script type="module" src="'), rt = m('" nonce="'), Rc = m('" integrity="'), xc = m('" crossorigin="'), $i = m('" async=""><\/script>'), kc = /(<\/|<)(s)(cript)/gi;
  function Ul(l, a, s, v) {
    return "" + a + (s === "s" ? "\\u0073" : "\\u0053") + v;
  }
  var vi = m(
    '<script type="importmap">'
  ), po = m("<\/script>");
  function ma(l, a, s, v, w, k) {
    var P = a === void 0 ? ke : m(
      '<script nonce="' + De(a) + '">'
    ), _ = l.idPrefix;
    s = [];
    var A = l.bootstrapScriptContent, D = l.bootstrapScripts, ee = l.bootstrapModules;
    if (A !== void 0 && s.push(
      P,
      j(
        ("" + A).replace(kc, Ul)
      ),
      jt
    ), A = [], v !== void 0 && (A.push(vi), A.push(
      j(
        ("" + JSON.stringify(v)).replace(kc, Ul)
      )
    ), A.push(po)), v = w ? {
      preconnects: "",
      fontPreloads: "",
      highImagePreloads: "",
      remainingCapacity: 2 + (typeof k == "number" ? k : 2e3)
    } : null, w = {
      placeholderPrefix: m(_ + "P:"),
      segmentPrefix: m(_ + "S:"),
      boundaryPrefix: m(_ + "B:"),
      startInlineScript: P,
      preamble: me(),
      externalRuntimeScript: null,
      bootstrapChunks: s,
      importMapChunks: A,
      onHeaders: w,
      headers: v,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: /* @__PURE__ */ new Set(),
      fontPreloads: /* @__PURE__ */ new Set(),
      highImagePreloads: /* @__PURE__ */ new Set(),
      styles: /* @__PURE__ */ new Map(),
      bootstrapScripts: /* @__PURE__ */ new Set(),
      scripts: /* @__PURE__ */ new Set(),
      bulkPreloads: /* @__PURE__ */ new Set(),
      preloads: {
        images: /* @__PURE__ */ new Map(),
        stylesheets: /* @__PURE__ */ new Map(),
        scripts: /* @__PURE__ */ new Map(),
        moduleScripts: /* @__PURE__ */ new Map()
      },
      nonce: a,
      hoistableState: null,
      stylesToHoist: !1
    }, D !== void 0)
      for (v = 0; v < D.length; v++) {
        var Y = D[v];
        _ = P = void 0, A = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: a
        }, typeof Y == "string" ? A.href = k = Y : (A.href = k = Y.src, A.integrity = _ = typeof Y.integrity == "string" ? Y.integrity : void 0, A.crossOrigin = P = typeof Y == "string" || Y.crossOrigin == null ? void 0 : Y.crossOrigin === "use-credentials" ? "use-credentials" : ""), Y = l;
        var ue = k;
        Y.scriptResources[ue] = null, Y.moduleScriptResources[ue] = null, Y = [], bt(Y, A), w.bootstrapScripts.add(Y), s.push(
          gi,
          j(De(k))
        ), a && s.push(
          rt,
          j(De(a))
        ), typeof _ == "string" && s.push(
          Rc,
          j(De(_))
        ), typeof P == "string" && s.push(
          xc,
          j(De(P))
        ), s.push($i);
      }
    if (ee !== void 0)
      for (D = 0; D < ee.length; D++)
        A = ee[D], P = k = void 0, _ = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: a
        }, typeof A == "string" ? _.href = v = A : (_.href = v = A.src, _.integrity = P = typeof A.integrity == "string" ? A.integrity : void 0, _.crossOrigin = k = typeof A == "string" || A.crossOrigin == null ? void 0 : A.crossOrigin === "use-credentials" ? "use-credentials" : ""), A = l, Y = v, A.scriptResources[Y] = null, A.moduleScriptResources[Y] = null, A = [], bt(A, _), w.bootstrapScripts.add(A), s.push(
          vr,
          j(De(v))
        ), a && s.push(
          rt,
          j(De(a))
        ), typeof P == "string" && s.push(
          Rc,
          j(De(P))
        ), typeof k == "string" && s.push(
          xc,
          j(De(k))
        ), s.push($i);
    return w;
  }
  function ea(l, a, s, v, w) {
    return {
      idPrefix: l === void 0 ? "" : l,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: s,
      bootstrapScripts: v,
      bootstrapModules: w,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function me() {
    return {
      htmlChunks: null,
      headChunks: null,
      bodyChunks: null,
      contribution: 0
    };
  }
  function $t(l, a, s) {
    return {
      insertionMode: l,
      selectedValue: a,
      tagScope: s
    };
  }
  function Oo(l) {
    return $t(
      l === "http://www.w3.org/2000/svg" ? 4 : l === "http://www.w3.org/1998/Math/MathML" ? 5 : 0,
      null,
      0
    );
  }
  function bi(l, a, s) {
    switch (a) {
      case "noscript":
        return $t(2, null, l.tagScope | 1);
      case "select":
        return $t(
          2,
          s.value != null ? s.value : s.defaultValue,
          l.tagScope
        );
      case "svg":
        return $t(4, null, l.tagScope);
      case "picture":
        return $t(2, null, l.tagScope | 2);
      case "math":
        return $t(5, null, l.tagScope);
      case "foreignObject":
        return $t(2, null, l.tagScope);
      case "table":
        return $t(6, null, l.tagScope);
      case "thead":
      case "tbody":
      case "tfoot":
        return $t(7, null, l.tagScope);
      case "colgroup":
        return $t(9, null, l.tagScope);
      case "tr":
        return $t(8, null, l.tagScope);
      case "head":
        if (2 > l.insertionMode)
          return $t(3, null, l.tagScope);
        break;
      case "html":
        if (l.insertionMode === 0)
          return $t(1, null, l.tagScope);
    }
    return 6 <= l.insertionMode || 2 > l.insertionMode ? $t(2, null, l.tagScope) : l;
  }
  var Qr = m("<!-- -->");
  function Cc(l, a, s, v) {
    return a === "" ? v : (v && l.push(Qr), l.push(j(De(a))), !0);
  }
  var eu = /* @__PURE__ */ new Map(), Pc = m(' style="'), Mo = m(":"), on = m(";");
  function yi(l, a) {
    if (typeof a != "object")
      throw Error(Q(62));
    var s = !0, v;
    for (v in a)
      if (Ie.call(a, v)) {
        var w = a[v];
        if (w != null && typeof w != "boolean" && w !== "") {
          if (v.indexOf("--") === 0) {
            var k = j(De(v));
            w = j(
              De(("" + w).trim())
            );
          } else
            k = eu.get(v), k === void 0 && (k = m(
              De(
                v.replace(di, "-$1").toLowerCase().replace(Ec, "-ms-")
              )
            ), eu.set(v, k)), w = typeof w == "number" ? w === 0 || Tc.has(v) ? j("" + w) : j(w + "px") : j(
              De(("" + w).trim())
            );
          s ? (s = !1, l.push(
            Pc,
            k,
            Mo,
            w
          )) : l.push(on, k, Mo, w);
        }
      }
    s || l.push(Nn);
  }
  var lt = m(" "), br = m('="'), Nn = m('"'), na = m('=""');
  function yr(l, a, s) {
    s && typeof s != "function" && typeof s != "symbol" && l.push(lt, j(a), na);
  }
  function Jn(l, a, s) {
    typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" && l.push(
      lt,
      j(a),
      br,
      j(De(s)),
      Nn
    );
  }
  var dn = m(
    De(
      "javascript:throw new Error('React form unexpectedly submitted.')"
    )
  ), wi = m('<input type="hidden"');
  function er(l, a) {
    this.push(wi), wr(l), Jn(this, "name", a), Jn(this, "value", l), this.push(ta);
  }
  function wr(l) {
    if (typeof l != "string")
      throw Error(Q(480));
  }
  function nu(l, a) {
    if (typeof a.$$FORM_ACTION == "function") {
      var s = l.nextFormID++;
      l = l.idPrefix + s;
      try {
        var v = a.$$FORM_ACTION(l);
        if (v) {
          var w = v.data;
          w != null && w.forEach(wr);
        }
        return v;
      } catch (k) {
        if (typeof k == "object" && k !== null && typeof k.then == "function")
          throw k;
      }
    }
    return null;
  }
  function Ya(l, a, s, v, w, k, P, _) {
    var A = null;
    if (typeof v == "function") {
      var D = nu(a, v);
      D !== null ? (_ = D.name, v = D.action || "", w = D.encType, k = D.method, P = D.target, A = D.data) : (l.push(
        lt,
        j("formAction"),
        br,
        dn,
        Nn
      ), P = k = w = v = _ = null, la(a, s));
    }
    return _ != null && Be(l, "name", _), v != null && Be(l, "formAction", v), w != null && Be(l, "formEncType", w), k != null && Be(l, "formMethod", k), P != null && Be(l, "formTarget", P), A;
  }
  function Be(l, a, s) {
    switch (a) {
      case "className":
        Jn(l, "class", s);
        break;
      case "tabIndex":
        Jn(l, "tabindex", s);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Jn(l, a, s);
        break;
      case "style":
        yi(l, s);
        break;
      case "src":
      case "href":
        if (s === "")
          break;
      case "action":
      case "formAction":
        if (s == null || typeof s == "function" || typeof s == "symbol" || typeof s == "boolean")
          break;
        s = Cn("" + s), l.push(
          lt,
          j(a),
          br,
          j(De(s)),
          Nn
        );
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        yr(l, a.toLowerCase(), s);
        break;
      case "xlinkHref":
        if (typeof s == "function" || typeof s == "symbol" || typeof s == "boolean")
          break;
        s = Cn("" + s), l.push(
          lt,
          j("xlink:href"),
          br,
          j(De(s)),
          Nn
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof s != "function" && typeof s != "symbol" && l.push(
          lt,
          j(a),
          br,
          j(De(s)),
          Nn
        );
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        s && typeof s != "function" && typeof s != "symbol" && l.push(
          lt,
          j(a),
          na
        );
        break;
      case "capture":
      case "download":
        s === !0 ? l.push(
          lt,
          j(a),
          na
        ) : s !== !1 && typeof s != "function" && typeof s != "symbol" && l.push(
          lt,
          j(a),
          br,
          j(De(s)),
          Nn
        );
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof s != "function" && typeof s != "symbol" && !isNaN(s) && 1 <= s && l.push(
          lt,
          j(a),
          br,
          j(De(s)),
          Nn
        );
        break;
      case "rowSpan":
      case "start":
        typeof s == "function" || typeof s == "symbol" || isNaN(s) || l.push(
          lt,
          j(a),
          br,
          j(De(s)),
          Nn
        );
        break;
      case "xlinkActuate":
        Jn(l, "xlink:actuate", s);
        break;
      case "xlinkArcrole":
        Jn(l, "xlink:arcrole", s);
        break;
      case "xlinkRole":
        Jn(l, "xlink:role", s);
        break;
      case "xlinkShow":
        Jn(l, "xlink:show", s);
        break;
      case "xlinkTitle":
        Jn(l, "xlink:title", s);
        break;
      case "xlinkType":
        Jn(l, "xlink:type", s);
        break;
      case "xmlBase":
        Jn(l, "xml:base", s);
        break;
      case "xmlLang":
        Jn(l, "xml:lang", s);
        break;
      case "xmlSpace":
        Jn(l, "xml:space", s);
        break;
      default:
        if ((!(2 < a.length) || a[0] !== "o" && a[0] !== "O" || a[1] !== "n" && a[1] !== "N") && (a = ze.get(a) || a, hi(a))) {
          switch (typeof s) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var v = a.toLowerCase().slice(0, 5);
              if (v !== "data-" && v !== "aria-")
                return;
          }
          l.push(
            lt,
            j(a),
            br,
            j(De(s)),
            Nn
          );
        }
    }
  }
  var sn = m(">"), ta = m("/>");
  function vt(l, a, s) {
    if (a != null) {
      if (s != null)
        throw Error(Q(60));
      if (typeof a != "object" || !("__html" in a))
        throw Error(Q(61));
      a = a.__html, a != null && l.push(j("" + a));
    }
  }
  function ra(l) {
    var a = "";
    return yc.Children.forEach(l, function(s) {
      s != null && (a += s);
    }), a;
  }
  var fl = m(' selected=""'), Pu = m(
    `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`
  );
  function la(l, a) {
    !(l.instructions & 16) && (l.instructions |= 16, a.bootstrapChunks.unshift(
      a.startInlineScript,
      Pu,
      jt
    ));
  }
  var Su = m("<!--F!-->"), hl = m("<!--F-->");
  function bt(l, a) {
    l.push(bn("link"));
    for (var s in a)
      if (Ie.call(a, s)) {
        var v = a[s];
        if (v != null)
          switch (s) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(Q(399, "link"));
            default:
              Be(l, s, v);
          }
      }
    return l.push(ta), null;
  }
  var Sc = /(<\/|<)(s)(tyle)/gi;
  function Jr(l, a, s, v) {
    return "" + a + (s === "s" ? "\\73 " : "\\53 ") + v;
  }
  function nr(l, a, s) {
    l.push(bn(s));
    for (var v in a)
      if (Ie.call(a, v)) {
        var w = a[v];
        if (w != null)
          switch (v) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(Q(399, s));
            default:
              Be(l, v, w);
          }
      }
    return l.push(ta), null;
  }
  function Ga(l, a) {
    l.push(bn("title"));
    var s = null, v = null, w;
    for (w in a)
      if (Ie.call(a, w)) {
        var k = a[w];
        if (k != null)
          switch (w) {
            case "children":
              s = k;
              break;
            case "dangerouslySetInnerHTML":
              v = k;
              break;
            default:
              Be(l, w, k);
          }
      }
    return l.push(sn), a = Array.isArray(s) ? 2 > s.length ? s[0] : null : s, typeof a != "function" && typeof a != "symbol" && a !== null && a !== void 0 && l.push(j(De("" + a))), vt(l, v, s), l.push(It("title")), null;
  }
  function Ti(l, a) {
    l.push(bn("script"));
    var s = null, v = null, w;
    for (w in a)
      if (Ie.call(a, w)) {
        var k = a[w];
        if (k != null)
          switch (w) {
            case "children":
              s = k;
              break;
            case "dangerouslySetInnerHTML":
              v = k;
              break;
            default:
              Be(l, w, k);
          }
      }
    return l.push(sn), vt(l, v, s), typeof s == "string" && l.push(
      j(("" + s).replace(kc, Ul))
    ), l.push(It("script")), null;
  }
  function dl(l, a, s) {
    l.push(bn(s));
    var v = s = null, w;
    for (w in a)
      if (Ie.call(a, w)) {
        var k = a[w];
        if (k != null)
          switch (w) {
            case "children":
              s = k;
              break;
            case "dangerouslySetInnerHTML":
              v = k;
              break;
            default:
              Be(l, w, k);
          }
      }
    return l.push(sn), vt(l, v, s), s;
  }
  function Ei(l, a, s) {
    l.push(bn(s));
    var v = s = null, w;
    for (w in a)
      if (Ie.call(a, w)) {
        var k = a[w];
        if (k != null)
          switch (w) {
            case "children":
              s = k;
              break;
            case "dangerouslySetInnerHTML":
              v = k;
              break;
            default:
              Be(l, w, k);
          }
      }
    return l.push(sn), vt(l, v, s), typeof s == "string" ? (l.push(j(De(s))), null) : s;
  }
  var Fc = m(`
`), Fu = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ml = /* @__PURE__ */ new Map();
  function bn(l) {
    var a = ml.get(l);
    if (a === void 0) {
      if (!Fu.test(l))
        throw Error(Q(65, l));
      a = m("<" + l), ml.set(l, a);
    }
    return a;
  }
  var Io = m("<!DOCTYPE html>");
  function tu(l, a, s, v, w, k, P, _, A, D) {
    switch (a) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        l.push(bn("a"));
        var ee = null, Y = null, ue;
        for (ue in s)
          if (Ie.call(s, ue)) {
            var ge = s[ue];
            if (ge != null)
              switch (ue) {
                case "children":
                  ee = ge;
                  break;
                case "dangerouslySetInnerHTML":
                  Y = ge;
                  break;
                case "href":
                  ge === "" ? Jn(l, "href", "") : Be(l, ue, ge);
                  break;
                default:
                  Be(l, ue, ge);
              }
          }
        if (l.push(sn), vt(l, Y, ee), typeof ee == "string") {
          l.push(j(De(ee)));
          var ye = null;
        } else
          ye = ee;
        return ye;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        l.push(bn("select"));
        var Se = null, rn = null, Dn;
        for (Dn in s)
          if (Ie.call(s, Dn)) {
            var Ye = s[Dn];
            if (Ye != null)
              switch (Dn) {
                case "children":
                  Se = Ye;
                  break;
                case "dangerouslySetInnerHTML":
                  rn = Ye;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  Be(
                    l,
                    Dn,
                    Ye
                  );
              }
          }
        return l.push(sn), vt(l, rn, Se), Se;
      case "option":
        var Wt = _.selectedValue;
        l.push(bn("option"));
        var Ln = null, cr = null, St = null, ot = null, Zt;
        for (Zt in s)
          if (Ie.call(s, Zt)) {
            var ln = s[Zt];
            if (ln != null)
              switch (Zt) {
                case "children":
                  Ln = ln;
                  break;
                case "selected":
                  St = ln;
                  break;
                case "dangerouslySetInnerHTML":
                  ot = ln;
                  break;
                case "value":
                  cr = ln;
                default:
                  Be(
                    l,
                    Zt,
                    ln
                  );
              }
          }
        if (Wt != null) {
          var Gn = cr !== null ? "" + cr : ra(Ln);
          if (Zr(Wt)) {
            for (var Rn = 0; Rn < Wt.length; Rn++)
              if ("" + Wt[Rn] === Gn) {
                l.push(fl);
                break;
              }
          } else
            "" + Wt === Gn && l.push(fl);
        } else
          St && l.push(fl);
        return l.push(sn), vt(l, ot, Ln), Ln;
      case "textarea":
        l.push(bn("textarea"));
        var Ft = null, ka = null, ni = null, ti;
        for (ti in s)
          if (Ie.call(s, ti)) {
            var Ca = s[ti];
            if (Ca != null)
              switch (ti) {
                case "children":
                  ni = Ca;
                  break;
                case "value":
                  Ft = Ca;
                  break;
                case "defaultValue":
                  ka = Ca;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(Q(91));
                default:
                  Be(
                    l,
                    ti,
                    Ca
                  );
              }
          }
        if (Ft === null && ka !== null && (Ft = ka), l.push(sn), ni != null) {
          if (Ft != null)
            throw Error(Q(92));
          if (Zr(ni)) {
            if (1 < ni.length)
              throw Error(Q(93));
            Ft = "" + ni[0];
          }
          Ft = "" + ni;
        }
        return typeof Ft == "string" && Ft[0] === `
` && l.push(Fc), Ft !== null && l.push(
          j(De("" + Ft))
        ), null;
      case "input":
        l.push(bn("input"));
        var ri = null, du = null, Yi = null, mu = null, Yu = null, Mu = null, Bc = null, Gu = null, Iu = null, Pl;
        for (Pl in s)
          if (Ie.call(s, Pl)) {
            var ur = s[Pl];
            if (ur != null)
              switch (Pl) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(Q(399, "input"));
                case "name":
                  ri = ur;
                  break;
                case "formAction":
                  du = ur;
                  break;
                case "formEncType":
                  Yi = ur;
                  break;
                case "formMethod":
                  mu = ur;
                  break;
                case "formTarget":
                  Yu = ur;
                  break;
                case "defaultChecked":
                  Iu = ur;
                  break;
                case "defaultValue":
                  Bc = ur;
                  break;
                case "checked":
                  Gu = ur;
                  break;
                case "value":
                  Mu = ur;
                  break;
                default:
                  Be(
                    l,
                    Pl,
                    ur
                  );
              }
          }
        var Du = Ya(
          l,
          v,
          w,
          du,
          Yi,
          mu,
          Yu,
          ri
        );
        return Gu !== null ? yr(l, "checked", Gu) : Iu !== null && yr(l, "checked", Iu), Mu !== null ? Be(l, "value", Mu) : Bc !== null && Be(l, "value", Bc), l.push(ta), Du != null && Du.forEach(er, l), null;
      case "button":
        l.push(bn("button"));
        var Pr = null, Nc = null, Uc = null, gu = null, vu = null, vn = null, mc = null, oo;
        for (oo in s)
          if (Ie.call(s, oo)) {
            var Xn = s[oo];
            if (Xn != null)
              switch (oo) {
                case "children":
                  Pr = Xn;
                  break;
                case "dangerouslySetInnerHTML":
                  Nc = Xn;
                  break;
                case "name":
                  Uc = Xn;
                  break;
                case "formAction":
                  gu = Xn;
                  break;
                case "formEncType":
                  vu = Xn;
                  break;
                case "formMethod":
                  vn = Xn;
                  break;
                case "formTarget":
                  mc = Xn;
                  break;
                default:
                  Be(
                    l,
                    oo,
                    Xn
                  );
              }
          }
        var Pa = Ya(
          l,
          v,
          w,
          gu,
          vu,
          vn,
          mc,
          Uc
        );
        if (l.push(sn), Pa != null && Pa.forEach(er, l), vt(l, Nc, Pr), typeof Pr == "string") {
          l.push(
            j(De(Pr))
          );
          var Sl = null;
        } else
          Sl = Pr;
        return Sl;
      case "form":
        l.push(bn("form"));
        var Sa = null, co = null, Sr = null, Fa = null, Fr = null, Gi = null, tc;
        for (tc in s)
          if (Ie.call(s, tc)) {
            var Fl = s[tc];
            if (Fl != null)
              switch (tc) {
                case "children":
                  Sa = Fl;
                  break;
                case "dangerouslySetInnerHTML":
                  co = Fl;
                  break;
                case "action":
                  Sr = Fl;
                  break;
                case "encType":
                  Fa = Fl;
                  break;
                case "method":
                  Fr = Fl;
                  break;
                case "target":
                  Gi = Fl;
                  break;
                default:
                  Be(
                    l,
                    tc,
                    Fl
                  );
              }
          }
        var Wr = null, Lu = null;
        if (typeof Sr == "function") {
          var Al = nu(
            v,
            Sr
          );
          Al !== null ? (Sr = Al.action || "", Fa = Al.encType, Fr = Al.method, Gi = Al.target, Wr = Al.data, Lu = Al.name) : (l.push(
            lt,
            j("action"),
            br,
            dn,
            Nn
          ), Gi = Fr = Fa = Sr = null, la(v, w));
        }
        if (Sr != null && Be(l, "action", Sr), Fa != null && Be(l, "encType", Fa), Fr != null && Be(l, "method", Fr), Gi != null && Be(l, "target", Gi), l.push(sn), Lu !== null && (l.push(wi), Jn(l, "name", Lu), l.push(ta), Wr != null && Wr.forEach(er, l)), vt(l, co, Sa), typeof Sa == "string") {
          l.push(
            j(De(Sa))
          );
          var _u = null;
        } else
          _u = Sa;
        return _u;
      case "menuitem":
        l.push(bn("menuitem"));
        for (var bu in s)
          if (Ie.call(s, bu)) {
            var Yc = s[bu];
            if (Yc != null)
              switch (bu) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(Q(400));
                default:
                  Be(
                    l,
                    bu,
                    Yc
                  );
              }
          }
        return l.push(sn), null;
      case "object":
        l.push(bn("object"));
        var Gc = null, Xu = null, pl;
        for (pl in s)
          if (Ie.call(s, pl)) {
            var Aa = s[pl];
            if (Aa != null)
              switch (pl) {
                case "children":
                  Gc = Aa;
                  break;
                case "dangerouslySetInnerHTML":
                  Xu = Aa;
                  break;
                case "data":
                  var Hu = Cn("" + Aa);
                  if (Hu === "")
                    break;
                  l.push(
                    lt,
                    j("data"),
                    br,
                    j(De(Hu)),
                    Nn
                  );
                  break;
                default:
                  Be(
                    l,
                    pl,
                    Aa
                  );
              }
          }
        if (l.push(sn), vt(l, Xu, Gc), typeof Gc == "string") {
          l.push(
            j(De(Gc))
          );
          var li = null;
        } else
          li = Gc;
        return li;
      case "title":
        if (_.insertionMode === 4 || _.tagScope & 1 || s.itemProp != null)
          var rc = Ga(
            l,
            s
          );
        else
          D ? rc = null : (Ga(w.hoistableChunks, s), rc = void 0);
        return rc;
      case "link":
        var yu = s.rel, ii = s.href, lc = s.precedence;
        if (_.insertionMode === 4 || _.tagScope & 1 || s.itemProp != null || typeof yu != "string" || typeof ii != "string" || ii === "") {
          bt(l, s);
          var en = null;
        } else if (s.rel === "stylesheet")
          if (typeof lc != "string" || s.disabled != null || s.onLoad || s.onError)
            en = bt(
              l,
              s
            );
          else {
            var Xi = w.styles.get(lc), uo = v.styleResources.hasOwnProperty(ii) ? v.styleResources[ii] : void 0;
            if (uo !== null) {
              v.styleResources[ii] = null, Xi || (Xi = {
                precedence: j(De(lc)),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, w.styles.set(lc, Xi));
              var pa = {
                state: 0,
                props: gt({}, s, {
                  "data-precedence": s.precedence,
                  precedence: null
                })
              };
              if (uo) {
                uo.length === 2 && ja(pa.props, uo);
                var so = w.preloads.stylesheets.get(ii);
                so && 0 < so.length ? so.length = 0 : pa.state = 1;
              }
              Xi.sheets.set(ii, pa), P && P.stylesheets.add(pa);
            } else if (Xi) {
              var Xc = Xi.sheets.get(ii);
              Xc && P && P.stylesheets.add(Xc);
            }
            A && l.push(Qr), en = null;
          }
        else
          s.onLoad || s.onError ? en = bt(
            l,
            s
          ) : (A && l.push(Qr), en = D ? null : bt(w.hoistableChunks, s));
        return en;
      case "script":
        var ic = s.async;
        if (typeof s.src != "string" || !s.src || !ic || typeof ic == "function" || typeof ic == "symbol" || s.onLoad || s.onError || _.insertionMode === 4 || _.tagScope & 1 || s.itemProp != null)
          var ac = Ti(
            l,
            s
          );
        else {
          var _n = s.src;
          if (s.type === "module")
            var Ar = v.moduleScriptResources, xn = w.preloads.moduleScripts;
          else
            Ar = v.scriptResources, xn = w.preloads.scripts;
          var Oa = Ar.hasOwnProperty(_n) ? Ar[_n] : void 0;
          if (Oa !== null) {
            Ar[_n] = null;
            var oc = s;
            if (Oa) {
              Oa.length === 2 && (oc = gt({}, s), ja(oc, Oa));
              var Zi = xn.get(_n);
              Zi && (Zi.length = 0);
            }
            var fn = [];
            w.scripts.add(fn), Ti(fn, oc);
          }
          A && l.push(Qr), ac = null;
        }
        return ac;
      case "style":
        var wu = s.precedence, Ol = s.href;
        if (_.insertionMode === 4 || _.tagScope & 1 || s.itemProp != null || typeof wu != "string" || typeof Ol != "string" || Ol === "") {
          l.push(bn("style"));
          var fo = null, Wu = null, cc;
          for (cc in s)
            if (Ie.call(s, cc)) {
              var Zc = s[cc];
              if (Zc != null)
                switch (cc) {
                  case "children":
                    fo = Zc;
                    break;
                  case "dangerouslySetInnerHTML":
                    Wu = Zc;
                    break;
                  default:
                    Be(
                      l,
                      cc,
                      Zc
                    );
                }
            }
          l.push(sn);
          var uc = Array.isArray(fo) ? 2 > fo.length ? fo[0] : null : fo;
          typeof uc != "function" && typeof uc != "symbol" && uc !== null && uc !== void 0 && l.push(
            j(("" + uc).replace(Sc, Jr))
          ), vt(l, Wu, fo), l.push(It("style"));
          var n = null;
        } else {
          var r = w.styles.get(wu);
          if ((v.styleResources.hasOwnProperty(Ol) ? v.styleResources[Ol] : void 0) !== null) {
            v.styleResources[Ol] = null, r ? r.hrefs.push(
              j(De(Ol))
            ) : (r = {
              precedence: j(
                De(wu)
              ),
              rules: [],
              hrefs: [j(De(Ol))],
              sheets: /* @__PURE__ */ new Map()
            }, w.styles.set(wu, r));
            var c = r.rules, d = null, y = null, R;
            for (R in s)
              if (Ie.call(s, R)) {
                var p = s[R];
                if (p != null)
                  switch (R) {
                    case "children":
                      d = p;
                      break;
                    case "dangerouslySetInnerHTML":
                      y = p;
                  }
              }
            var M = Array.isArray(d) ? 2 > d.length ? d[0] : null : d;
            typeof M != "function" && typeof M != "symbol" && M !== null && M !== void 0 && c.push(
              j(
                ("" + M).replace(Sc, Jr)
              )
            ), vt(c, y, d);
          }
          r && P && P.styles.add(r), A && l.push(Qr), n = void 0;
        }
        return n;
      case "meta":
        if (_.insertionMode === 4 || _.tagScope & 1 || s.itemProp != null)
          var N = nr(
            l,
            s,
            "meta"
          );
        else
          A && l.push(Qr), N = D ? null : typeof s.charSet == "string" ? nr(w.charsetChunks, s, "meta") : s.name === "viewport" ? nr(w.viewportChunks, s, "meta") : nr(w.hoistableChunks, s, "meta");
        return N;
      case "listing":
      case "pre":
        l.push(bn(a));
        var I = null, te = null, K;
        for (K in s)
          if (Ie.call(s, K)) {
            var le = s[K];
            if (le != null)
              switch (K) {
                case "children":
                  I = le;
                  break;
                case "dangerouslySetInnerHTML":
                  te = le;
                  break;
                default:
                  Be(
                    l,
                    K,
                    le
                  );
              }
          }
        if (l.push(sn), te != null) {
          if (I != null)
            throw Error(Q(60));
          if (typeof te != "object" || !("__html" in te))
            throw Error(Q(61));
          var ie = te.__html;
          ie != null && (typeof ie == "string" && 0 < ie.length && ie[0] === `
` ? l.push(Fc, j(ie)) : l.push(j("" + ie)));
        }
        return typeof I == "string" && I[0] === `
` && l.push(Fc), I;
      case "img":
        var G = s.src, we = s.srcSet;
        if (!(s.loading === "lazy" || !G && !we || typeof G != "string" && G != null || typeof we != "string" && we != null) && s.fetchPriority !== "low" && !(_.tagScope & 3) && (typeof G != "string" || G[4] !== ":" || G[0] !== "d" && G[0] !== "D" || G[1] !== "a" && G[1] !== "A" || G[2] !== "t" && G[2] !== "T" || G[3] !== "a" && G[3] !== "A") && (typeof we != "string" || we[4] !== ":" || we[0] !== "d" && we[0] !== "D" || we[1] !== "a" && we[1] !== "A" || we[2] !== "t" && we[2] !== "T" || we[3] !== "a" && we[3] !== "A")) {
          var Le = typeof s.sizes == "string" ? s.sizes : void 0, Te = we ? we + `
` + (Le || "") : G, Fe = w.preloads.images, kn = Fe.get(Te);
          if (kn)
            (s.fetchPriority === "high" || 10 > w.highImagePreloads.size) && (Fe.delete(Te), w.highImagePreloads.add(kn));
          else if (!v.imageResources.hasOwnProperty(Te)) {
            v.imageResources[Te] = Bn;
            var be = s.crossOrigin, Ue = typeof be == "string" ? be === "use-credentials" ? be : "" : void 0, Ze = w.headers, At;
            Ze && 0 < Ze.remainingCapacity && typeof s.srcSet != "string" && (s.fetchPriority === "high" || 500 > Ze.highImagePreloads.length) && (At = Vl(G, "image", {
              imageSrcSet: s.srcSet,
              imageSizes: s.sizes,
              crossOrigin: Ue,
              integrity: s.integrity,
              nonce: s.nonce,
              type: s.type,
              fetchPriority: s.fetchPriority,
              referrerPolicy: s.refererPolicy
            }), 0 <= (Ze.remainingCapacity -= At.length + 2)) ? (w.resets.image[Te] = Bn, Ze.highImagePreloads && (Ze.highImagePreloads += ", "), Ze.highImagePreloads += At) : (kn = [], bt(kn, {
              rel: "preload",
              as: "image",
              href: we ? void 0 : G,
              imageSrcSet: we,
              imageSizes: Le,
              crossOrigin: Ue,
              integrity: s.integrity,
              type: s.type,
              fetchPriority: s.fetchPriority,
              referrerPolicy: s.referrerPolicy
            }), s.fetchPriority === "high" || 10 > w.highImagePreloads.size ? w.highImagePreloads.add(kn) : (w.bulkPreloads.add(kn), Fe.set(Te, kn)));
          }
        }
        return nr(l, s, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return nr(l, s, a);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > _.insertionMode) {
          var Zn = k || w.preamble;
          if (Zn.headChunks)
            throw Error(Q(545, "`<head>`"));
          Zn.headChunks = [];
          var $n = dl(
            Zn.headChunks,
            s,
            "head"
          );
        } else
          $n = Ei(
            l,
            s,
            "head"
          );
        return $n;
      case "body":
        if (2 > _.insertionMode) {
          var Sn = k || w.preamble;
          if (Sn.bodyChunks)
            throw Error(Q(545, "`<body>`"));
          Sn.bodyChunks = [];
          var zr = dl(
            Sn.bodyChunks,
            s,
            "body"
          );
        } else
          zr = Ei(
            l,
            s,
            "body"
          );
        return zr;
      case "html":
        if (_.insertionMode === 0) {
          var Qt = k || w.preamble;
          if (Qt.htmlChunks)
            throw Error(Q(545, "`<html>`"));
          Qt.htmlChunks = [Io];
          var qe = dl(
            Qt.htmlChunks,
            s,
            "html"
          );
        } else
          qe = Ei(
            l,
            s,
            "html"
          );
        return qe;
      default:
        if (a.indexOf("-") !== -1) {
          l.push(bn(a));
          var e = null, t = null, u;
          for (u in s)
            if (Ie.call(s, u)) {
              var h = s[u];
              if (h != null) {
                var b = u;
                switch (u) {
                  case "children":
                    e = h;
                    break;
                  case "dangerouslySetInnerHTML":
                    t = h;
                    break;
                  case "style":
                    yi(l, h);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    b = "class";
                  default:
                    if (hi(u) && typeof h != "function" && typeof h != "symbol" && h !== !1) {
                      if (h === !0)
                        h = "";
                      else if (typeof h == "object")
                        continue;
                      l.push(
                        lt,
                        j(b),
                        br,
                        j(De(h)),
                        Nn
                      );
                    }
                }
              }
            }
          return l.push(sn), vt(l, t, e), e;
        }
    }
    return Ei(l, s, a);
  }
  var Xa = /* @__PURE__ */ new Map();
  function It(l) {
    var a = Xa.get(l);
    return a === void 0 && (a = m("</" + l + ">"), Xa.set(l, a)), a;
  }
  function ru(l, a) {
    l = l.preamble, l.htmlChunks === null && a.htmlChunks && (l.htmlChunks = a.htmlChunks, a.contribution |= 1), l.headChunks === null && a.headChunks && (l.headChunks = a.headChunks, a.contribution |= 4), l.bodyChunks === null && a.bodyChunks && (l.bodyChunks = a.bodyChunks, a.contribution |= 2);
  }
  function Ri(l, a) {
    a = a.bootstrapChunks;
    for (var s = 0; s < a.length - 1; s++)
      X(l, a[s]);
    return s < a.length ? (s = a[s], a.length = 0, ce(l, s)) : !0;
  }
  var Mr = m('<template id="'), Yl = m('"></template>'), ia = m("<!--$-->"), Do = m(
    '<!--$?--><template id="'
  ), aa = m('"></template>'), Tr = m("<!--$!-->"), xi = m("<!--/$-->"), oa = m("<template"), Gl = m('"'), gl = m(' data-dgst="');
  m(' data-msg="'), m(' data-stck="'), m(' data-cstck="');
  var yt = m("></template>");
  function vl(l, a, s) {
    if (X(l, Do), s === null)
      throw Error(Q(395));
    return X(l, a.boundaryPrefix), X(l, j(s.toString(16))), ce(l, aa);
  }
  var lu = m("<!--"), Er = m("-->");
  function Xl(l, a) {
    a = a.contribution, a !== 0 && (X(l, lu), X(l, j("" + a)), X(l, Er));
  }
  var Za = m('<div hidden id="'), bl = m('">'), An = m("</div>"), ki = m(
    '<svg aria-hidden="true" style="display:none" id="'
  ), Gt = m('">'), Xt = m("</svg>"), Lo = m(
    '<math aria-hidden="true" style="display:none" id="'
  ), _o = m('">'), wt = m("</math>"), Qa = m('<table hidden id="'), Qe = m('">'), Tt = m("</table>"), Ci = m('<table hidden><tbody id="'), Zl = m('">'), yl = m("</tbody></table>"), wl = m('<table hidden><tr id="'), ca = m('">'), Et = m("</tr></table>"), Tl = m(
    '<table hidden><colgroup id="'
  ), Ql = m('">'), tr = m("</colgroup></table>");
  function ua(l, a, s, v) {
    switch (s.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return X(l, Za), X(l, a.segmentPrefix), X(l, j(v.toString(16))), ce(l, bl);
      case 4:
        return X(l, ki), X(l, a.segmentPrefix), X(l, j(v.toString(16))), ce(l, Gt);
      case 5:
        return X(l, Lo), X(l, a.segmentPrefix), X(l, j(v.toString(16))), ce(l, _o);
      case 6:
        return X(l, Qa), X(l, a.segmentPrefix), X(l, j(v.toString(16))), ce(l, Qe);
      case 7:
        return X(l, Ci), X(l, a.segmentPrefix), X(l, j(v.toString(16))), ce(l, Zl);
      case 8:
        return X(l, wl), X(l, a.segmentPrefix), X(l, j(v.toString(16))), ce(l, ca);
      case 9:
        return X(l, Tl), X(l, a.segmentPrefix), X(l, j(v.toString(16))), ce(l, Ql);
      default:
        throw Error(Q(397));
    }
  }
  function Jl(l, a) {
    switch (a.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return ce(l, An);
      case 4:
        return ce(l, Xt);
      case 5:
        return ce(l, wt);
      case 6:
        return ce(l, Tt);
      case 7:
        return ce(l, yl);
      case 8:
        return ce(l, Et);
      case 9:
        return ce(l, tr);
      default:
        throw Error(Q(397));
    }
  }
  var Vr = m(
    '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
  ), El = m('$RS("'), Ho = m('","'), sa = m('")<\/script>');
  m('<template data-rsi="" data-sid="'), m('" data-pid="');
  var Ac = m(
    '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("'
  ), Pi = m('$RC("'), Wo = m(
    `$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`
  ), pc = m(
    `$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`
  ), Ja = m('$RR("'), zo = m('","'), iu = m('",'), Va = m('"'), Si = m(")<\/script>");
  m('<template data-rci="" data-bid="'), m('<template data-rri="" data-bid="'), m('" data-sid="'), m('" data-sty="');
  var fa = m(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
  ), Fi = m('$RX("'), Bo = m('"'), Ai = m(","), ha = m(")<\/script>");
  m('<template data-rxi="" data-bid="'), m('" data-dgst="'), m('" data-msg="'), m('" data-stck="'), m('" data-cstck="');
  var da = /[<\u2028\u2029]/g;
  function pi(l) {
    return JSON.stringify(l).replace(
      da,
      function(a) {
        switch (a) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var Oi = /[&><\u2028\u2029]/g;
  function Kr(l) {
    return JSON.stringify(l).replace(
      Oi,
      function(a) {
        switch (a) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var Rl = m(
    '<style media="not all" data-precedence="'
  ), No = m('" data-href="'), ga = m('">'), Rt = m("</style>"), Mi = !1, qr = !0;
  function Ii(l) {
    var a = l.rules, s = l.hrefs, v = 0;
    if (s.length) {
      for (X(this, Rl), X(this, l.precedence), X(this, No); v < s.length - 1; v++)
        X(this, s[v]), X(this, Ke);
      for (X(this, s[v]), X(this, ga), v = 0; v < a.length; v++)
        X(this, a[v]);
      qr = ce(
        this,
        Rt
      ), Mi = !0, a.length = 0, s.length = 0;
    }
  }
  function Ka(l) {
    return l.state !== 2 ? Mi = !0 : !1;
  }
  function jr(l, a, s) {
    return Mi = !1, qr = !0, a.styles.forEach(Ii, l), a.stylesheets.forEach(Ka), Mi && (s.stylesToHoist = !0), qr;
  }
  function gn(l) {
    for (var a = 0; a < l.length; a++)
      X(this, l[a]);
    l.length = 0;
  }
  var Un = [];
  function rr(l) {
    bt(Un, l.props);
    for (var a = 0; a < Un.length; a++)
      X(this, Un[a]);
    Un.length = 0, l.state = 2;
  }
  var Di = m(
    '<style data-precedence="'
  ), Pn = m('" data-href="'), Ke = m(" "), Oc = m('">'), Uo = m("</style>");
  function Vn(l) {
    var a = 0 < l.sheets.size;
    l.sheets.forEach(rr, this), l.sheets.clear();
    var s = l.rules, v = l.hrefs;
    if (!a || v.length) {
      if (X(this, Di), X(this, l.precedence), l = 0, v.length) {
        for (X(this, Pn); l < v.length - 1; l++)
          X(this, v[l]), X(this, Ke);
        X(this, v[l]);
      }
      for (X(this, Oc), l = 0; l < s.length; l++)
        X(this, s[l]);
      X(this, Uo), s.length = 0, v.length = 0;
    }
  }
  function Mc(l) {
    if (l.state === 0) {
      l.state = 1;
      var a = l.props;
      for (bt(Un, {
        rel: "preload",
        as: "style",
        href: l.props.href,
        crossOrigin: a.crossOrigin,
        fetchPriority: a.fetchPriority,
        integrity: a.integrity,
        media: a.media,
        hrefLang: a.hrefLang,
        referrerPolicy: a.referrerPolicy
      }), l = 0; l < Un.length; l++)
        X(this, Un[l]);
      Un.length = 0;
    }
  }
  function Ic(l) {
    l.sheets.forEach(Mc, this), l.sheets.clear();
  }
  var qa = m("["), mo = m(",["), xl = m(","), Rr = m("]");
  function Au(l, a) {
    X(l, qa);
    var s = qa;
    a.stylesheets.forEach(function(v) {
      if (v.state !== 2)
        if (v.state === 3)
          X(l, s), X(
            l,
            j(
              Kr("" + v.props.href)
            )
          ), X(l, Rr), s = mo;
        else {
          X(l, s);
          var w = v.props["data-precedence"], k = v.props, P = Cn("" + v.props.href);
          X(
            l,
            j(Kr(P))
          ), w = "" + w, X(l, xl), X(
            l,
            j(Kr(w))
          );
          for (var _ in k)
            if (Ie.call(k, _) && (w = k[_], w != null))
              switch (_) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(Q(399, "link"));
                default:
                  it(
                    l,
                    _,
                    w
                  );
              }
          X(l, Rr), s = mo, v.state = 3;
        }
    }), X(l, Rr);
  }
  function it(l, a, s) {
    var v = a.toLowerCase();
    switch (typeof s) {
      case "function":
      case "symbol":
        return;
    }
    switch (a) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        v = "class", a = "" + s;
        break;
      case "hidden":
        if (s === !1)
          return;
        a = "";
        break;
      case "src":
      case "href":
        s = Cn(s), a = "" + s;
        break;
      default:
        if (2 < a.length && (a[0] === "o" || a[0] === "O") && (a[1] === "n" || a[1] === "N") || !hi(a))
          return;
        a = "" + s;
    }
    X(l, xl), X(
      l,
      j(Kr(v))
    ), X(l, xl), X(
      l,
      j(Kr(a))
    );
  }
  function Dt() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set() };
  }
  function at(l) {
    var a = Yn || null;
    if (a) {
      var s = a.resumableState, v = a.renderState;
      if (typeof l == "string" && l) {
        if (!s.dnsResources.hasOwnProperty(l)) {
          s.dnsResources[l] = null, s = v.headers;
          var w, k;
          (k = s && 0 < s.remainingCapacity) && (k = (w = "<" + ("" + l).replace(
            Ir,
            lr
          ) + ">; rel=dns-prefetch", 0 <= (s.remainingCapacity -= w.length + 2))), k ? (v.resets.dns[l] = null, s.preconnects && (s.preconnects += ", "), s.preconnects += w) : (w = [], bt(w, { href: l, rel: "dns-prefetch" }), v.preconnects.add(w));
        }
        mi(a);
      }
    } else
      Yt.D(l);
  }
  function yn(l, a) {
    var s = Yn || null;
    if (s) {
      var v = s.resumableState, w = s.renderState;
      if (typeof l == "string" && l) {
        var k = a === "use-credentials" ? "credentials" : typeof a == "string" ? "anonymous" : "default";
        if (!v.connectResources[k].hasOwnProperty(l)) {
          v.connectResources[k][l] = null, v = w.headers;
          var P, _;
          if (_ = v && 0 < v.remainingCapacity) {
            if (_ = "<" + ("" + l).replace(
              Ir,
              lr
            ) + ">; rel=preconnect", typeof a == "string") {
              var A = ("" + a).replace(
                $a,
                Go
              );
              _ += '; crossorigin="' + A + '"';
            }
            _ = (P = _, 0 <= (v.remainingCapacity -= P.length + 2));
          }
          _ ? (w.resets.connect[k][l] = null, v.preconnects && (v.preconnects += ", "), v.preconnects += P) : (k = [], bt(k, {
            rel: "preconnect",
            href: l,
            crossOrigin: a
          }), w.preconnects.add(k));
        }
        mi(s);
      }
    } else
      Yt.C(l, a);
  }
  function Je(l, a, s) {
    var v = Yn || null;
    if (v) {
      var w = v.resumableState, k = v.renderState;
      if (a && l) {
        switch (a) {
          case "image":
            if (s)
              var P = s.imageSrcSet, _ = s.imageSizes, A = s.fetchPriority;
            var D = P ? P + `
` + (_ || "") : l;
            if (w.imageResources.hasOwnProperty(D))
              return;
            w.imageResources[D] = Bn, w = k.headers;
            var ee;
            w && 0 < w.remainingCapacity && typeof P != "string" && A === "high" && (ee = Vl(l, a, s), 0 <= (w.remainingCapacity -= ee.length + 2)) ? (k.resets.image[D] = Bn, w.highImagePreloads && (w.highImagePreloads += ", "), w.highImagePreloads += ee) : (w = [], bt(
              w,
              gt(
                { rel: "preload", href: P ? void 0 : l, as: a },
                s
              )
            ), A === "high" ? k.highImagePreloads.add(w) : (k.bulkPreloads.add(w), k.preloads.images.set(D, w)));
            break;
          case "style":
            if (w.styleResources.hasOwnProperty(l))
              return;
            P = [], bt(
              P,
              gt({ rel: "preload", href: l, as: a }, s)
            ), w.styleResources[l] = !s || typeof s.crossOrigin != "string" && typeof s.integrity != "string" ? Bn : [s.crossOrigin, s.integrity], k.preloads.stylesheets.set(l, P), k.bulkPreloads.add(P);
            break;
          case "script":
            if (w.scriptResources.hasOwnProperty(l))
              return;
            P = [], k.preloads.scripts.set(l, P), k.bulkPreloads.add(P), bt(
              P,
              gt({ rel: "preload", href: l, as: a }, s)
            ), w.scriptResources[l] = !s || typeof s.crossOrigin != "string" && typeof s.integrity != "string" ? Bn : [s.crossOrigin, s.integrity];
            break;
          default:
            if (w.unknownResources.hasOwnProperty(a)) {
              if (P = w.unknownResources[a], P.hasOwnProperty(l))
                return;
            } else
              P = {}, w.unknownResources[a] = P;
            if (P[l] = Bn, (w = k.headers) && 0 < w.remainingCapacity && a === "font" && (D = Vl(l, a, s), 0 <= (w.remainingCapacity -= D.length + 2)))
              k.resets.font[l] = Bn, w.fontPreloads && (w.fontPreloads += ", "), w.fontPreloads += D;
            else
              switch (w = [], l = gt({ rel: "preload", href: l, as: a }, s), bt(w, l), a) {
                case "font":
                  k.fontPreloads.add(w);
                  break;
                default:
                  k.bulkPreloads.add(w);
              }
        }
        mi(v);
      }
    } else
      Yt.L(l, a, s);
  }
  function Yo(l, a) {
    var s = Yn || null;
    if (s) {
      var v = s.resumableState, w = s.renderState;
      if (l) {
        var k = a && typeof a.as == "string" ? a.as : "script";
        switch (k) {
          case "script":
            if (v.moduleScriptResources.hasOwnProperty(l))
              return;
            k = [], v.moduleScriptResources[l] = !a || typeof a.crossOrigin != "string" && typeof a.integrity != "string" ? Bn : [a.crossOrigin, a.integrity], w.preloads.moduleScripts.set(l, k);
            break;
          default:
            if (v.moduleUnknownResources.hasOwnProperty(k)) {
              var P = v.unknownResources[k];
              if (P.hasOwnProperty(l))
                return;
            } else
              P = {}, v.moduleUnknownResources[k] = P;
            k = [], P[l] = Bn;
        }
        bt(k, gt({ rel: "modulepreload", href: l }, a)), w.bulkPreloads.add(k), mi(s);
      }
    } else
      Yt.m(l, a);
  }
  function Dc(l, a, s) {
    var v = Yn || null;
    if (v) {
      var w = v.resumableState, k = v.renderState;
      if (l) {
        a = a || "default";
        var P = k.styles.get(a), _ = w.styleResources.hasOwnProperty(l) ? w.styleResources[l] : void 0;
        _ !== null && (w.styleResources[l] = null, P || (P = {
          precedence: j(De(a)),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, k.styles.set(a, P)), a = {
          state: 0,
          props: gt(
            { rel: "stylesheet", href: l, "data-precedence": a },
            s
          )
        }, _ && (_.length === 2 && ja(a.props, _), (k = k.preloads.stylesheets.get(l)) && 0 < k.length ? k.length = 0 : a.state = 1), P.sheets.set(l, a), mi(v));
      }
    } else
      Yt.S(l, a, s);
  }
  function au(l, a) {
    var s = Yn || null;
    if (s) {
      var v = s.resumableState, w = s.renderState;
      if (l) {
        var k = v.scriptResources.hasOwnProperty(l) ? v.scriptResources[l] : void 0;
        k !== null && (v.scriptResources[l] = null, a = gt({ src: l, async: !0 }, a), k && (k.length === 2 && ja(a, k), l = w.preloads.scripts.get(l)) && (l.length = 0), l = [], w.scripts.add(l), Ti(l, a), mi(s));
      }
    } else
      Yt.X(l, a);
  }
  function ou(l, a) {
    var s = Yn || null;
    if (s) {
      var v = s.resumableState, w = s.renderState;
      if (l) {
        var k = v.moduleScriptResources.hasOwnProperty(
          l
        ) ? v.moduleScriptResources[l] : void 0;
        k !== null && (v.moduleScriptResources[l] = null, a = gt({ src: l, type: "module", async: !0 }, a), k && (k.length === 2 && ja(a, k), l = w.preloads.moduleScripts.get(l)) && (l.length = 0), l = [], w.scripts.add(l), Ti(l, a), mi(s));
      }
    } else
      Yt.M(l, a);
  }
  function ja(l, a) {
    l.crossOrigin == null && (l.crossOrigin = a[0]), l.integrity == null && (l.integrity = a[1]);
  }
  function Vl(l, a, s) {
    l = ("" + l).replace(
      Ir,
      lr
    ), a = ("" + a).replace(
      $a,
      Go
    ), a = "<" + l + '>; rel=preload; as="' + a + '"';
    for (var v in s)
      Ie.call(s, v) && (l = s[v], typeof l == "string" && (a += "; " + v.toLowerCase() + '="' + ("" + l).replace(
        $a,
        Go
      ) + '"'));
    return a;
  }
  var Ir = /[<>\r\n]/g;
  function lr(l) {
    switch (l) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var $a = /["';,\r\n]/g;
  function Go(l) {
    switch (l) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function Lc(l) {
    this.styles.add(l);
  }
  function eo(l) {
    this.stylesheets.add(l);
  }
  var pn = Function.prototype.bind, pu = Symbol.for("react.client.reference");
  function Lt(l) {
    if (l == null)
      return null;
    if (typeof l == "function")
      return l.$$typeof === pu ? null : l.displayName || l.name || null;
    if (typeof l == "string")
      return l;
    switch (l) {
      case Ut:
        return "Fragment";
      case Co:
        return "Profiler";
      case Xr:
        return "StrictMode";
      case ul:
        return "Suspense";
      case q:
        return "SuspenseList";
      case Na:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case Nl:
          return "Portal";
        case z:
          return (l.displayName || "Context") + ".Provider";
        case Ba:
          return (l._context.displayName || "Context") + ".Consumer";
        case Ce:
          var a = l.render;
          return l = l.displayName, l || (l = a.displayName || a.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case U:
          return a = l.displayName || null, a !== null ? a : Lt(l.type) || "Memo";
        case sl:
          a = l._payload, l = l._init;
          try {
            return Lt(l(a));
          } catch {
          }
      }
    return null;
  }
  var cu = {}, Li = null;
  function i(l, a) {
    if (l !== a) {
      l.context._currentValue = l.parentValue, l = l.parent;
      var s = a.parent;
      if (l === null) {
        if (s !== null)
          throw Error(Q(401));
      } else {
        if (s === null)
          throw Error(Q(401));
        i(l, s);
      }
      a.context._currentValue = a.value;
    }
  }
  function o(l) {
    l.context._currentValue = l.parentValue, l = l.parent, l !== null && o(l);
  }
  function f(l) {
    var a = l.parent;
    a !== null && f(a), l.context._currentValue = l.value;
  }
  function g(l, a) {
    if (l.context._currentValue = l.parentValue, l = l.parent, l === null)
      throw Error(Q(402));
    l.depth === a.depth ? i(l, a) : g(l, a);
  }
  function T(l, a) {
    var s = a.parent;
    if (s === null)
      throw Error(Q(402));
    l.depth === s.depth ? i(l, s) : T(l, s), a.context._currentValue = a.value;
  }
  function x(l) {
    var a = Li;
    a !== l && (a === null ? f(l) : l === null ? o(a) : a.depth === l.depth ? i(a, l) : a.depth > l.depth ? g(a, l) : T(a, l), Li = l);
  }
  var C = {
    enqueueSetState: function(l, a) {
      l = l._reactInternals, l.queue !== null && l.queue.push(a);
    },
    enqueueReplaceState: function(l, a) {
      l = l._reactInternals, l.replace = !0, l.queue = [a];
    },
    enqueueForceUpdate: function() {
    }
  }, H = { id: 1, overflow: "" };
  function L(l, a, s) {
    var v = l.id;
    l = l.overflow;
    var w = 32 - B(v) - 1;
    v &= ~(1 << w), s += 1;
    var k = 32 - B(a) + w;
    if (30 < k) {
      var P = w - w % 5;
      return k = (v & (1 << P) - 1).toString(32), v >>= P, w -= P, {
        id: 1 << 32 - B(a) + w | s << w | v,
        overflow: k + l
      };
    }
    return {
      id: 1 << k | s << w | v,
      overflow: l
    };
  }
  var B = Math.clz32 ? Math.clz32 : ae, oe = Math.log, $ = Math.LN2;
  function ae(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (oe(l) / $ | 0) | 0;
  }
  var se = Error(Q(460));
  function Ee() {
  }
  function he(l, a, s) {
    switch (s = l[s], s === void 0 ? l.push(a) : s !== a && (a.then(Ee, Ee), a = s), a.status) {
      case "fulfilled":
        return a.value;
      case "rejected":
        throw a.reason;
      default:
        switch (typeof a.status == "string" ? a.then(Ee, Ee) : (l = a, l.status = "pending", l.then(
          function(v) {
            if (a.status === "pending") {
              var w = a;
              w.status = "fulfilled", w.value = v;
            }
          },
          function(v) {
            if (a.status === "pending") {
              var w = a;
              w.status = "rejected", w.reason = v;
            }
          }
        )), a.status) {
          case "fulfilled":
            return a.value;
          case "rejected":
            throw a.reason;
        }
        throw Ne = a, se;
    }
  }
  var Ne = null;
  function Ve() {
    if (Ne === null)
      throw Error(Q(459));
    var l = Ne;
    return Ne = null, l;
  }
  function Ge(l, a) {
    return l === a && (l !== 0 || 1 / l === 1 / a) || l !== l && a !== a;
  }
  var cn = typeof Object.is == "function" ? Object.is : Ge, de = null, _e = null, Re = null, Kn = null, xt = null, ve = null, $e = !1, On = !1, mn = 0, $r = 0, tn = -1, Mn = 0, _t = null, kt = null, el = 0;
  function Ct() {
    if (de === null)
      throw Error(Q(321));
    return de;
  }
  function Dr() {
    if (0 < el)
      throw Error(Q(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function ir() {
    return ve === null ? xt === null ? ($e = !1, xt = ve = Dr()) : ($e = !0, ve = xt) : ve.next === null ? ($e = !1, ve = ve.next = Dr()) : ($e = !0, ve = ve.next), ve;
  }
  function In() {
    var l = _t;
    return _t = null, l;
  }
  function xr() {
    Kn = Re = _e = de = null, On = !1, xt = null, el = 0, ve = kt = null;
  }
  function ar(l, a) {
    return typeof a == "function" ? a(l) : a;
  }
  function nl(l, a, s) {
    if (de = Ct(), ve = ir(), $e) {
      var v = ve.queue;
      if (a = v.dispatch, kt !== null && (s = kt.get(v), s !== void 0)) {
        kt.delete(v), v = ve.memoizedState;
        do
          v = l(v, s.action), s = s.next;
        while (s !== null);
        return ve.memoizedState = v, [v, a];
      }
      return [ve.memoizedState, a];
    }
    return l = l === ar ? typeof a == "function" ? a() : a : s !== void 0 ? s(a) : a, ve.memoizedState = l, l = ve.queue = { last: null, dispatch: null }, l = l.dispatch = kr.bind(
      null,
      de,
      l
    ), [ve.memoizedState, l];
  }
  function Lr(l, a) {
    if (de = Ct(), ve = ir(), a = a === void 0 ? null : a, ve !== null) {
      var s = ve.memoizedState;
      if (s !== null && a !== null) {
        var v = s[1];
        e:
          if (v === null)
            v = !1;
          else {
            for (var w = 0; w < v.length && w < a.length; w++)
              if (!cn(a[w], v[w])) {
                v = !1;
                break e;
              }
            v = !0;
          }
        if (v)
          return s[0];
      }
    }
    return l = l(), ve.memoizedState = [l, a], l;
  }
  function kr(l, a, s) {
    if (25 <= el)
      throw Error(Q(301));
    if (l === de)
      if (On = !0, l = { action: s, next: null }, kt === null && (kt = /* @__PURE__ */ new Map()), s = kt.get(a), s === void 0)
        kt.set(a, l);
      else {
        for (a = s; a.next !== null; )
          a = a.next;
        a.next = l;
      }
  }
  function _c() {
    throw Error(Q(394));
  }
  function Kl() {
    throw Error(Q(479));
  }
  function tl(l, a, s) {
    Ct();
    var v = $r++, w = Re;
    if (typeof l.$$FORM_ACTION == "function") {
      var k = null, P = Kn;
      w = w.formState;
      var _ = l.$$IS_SIGNATURE_EQUAL;
      if (w !== null && typeof _ == "function") {
        var A = w[1];
        _.call(l, w[2], w[3]) && (k = s !== void 0 ? "p" + s : "k" + Ua(
          JSON.stringify([P, null, v]),
          0
        ), A === k && (tn = v, a = w[0]));
      }
      var D = l.bind(null, a);
      return l = function(Y) {
        D(Y);
      }, typeof D.$$FORM_ACTION == "function" && (l.$$FORM_ACTION = function(Y) {
        Y = D.$$FORM_ACTION(Y), s !== void 0 && (s += "", Y.action = s);
        var ue = Y.data;
        return ue && (k === null && (k = s !== void 0 ? "p" + s : "k" + Ua(
          JSON.stringify([
            P,
            null,
            v
          ]),
          0
        )), ue.append("$ACTION_KEY", k)), Y;
      }), [a, l, !1];
    }
    var ee = l.bind(null, a);
    return [
      a,
      function(Y) {
        ee(Y);
      },
      !1
    ];
  }
  function Xo(l) {
    var a = Mn;
    return Mn += 1, _t === null && (_t = []), he(_t, l, a);
  }
  function uu() {
    throw Error(Q(393));
  }
  function va() {
  }
  var su = {
    readContext: function(l) {
      return l._currentValue;
    },
    use: function(l) {
      if (l !== null && typeof l == "object") {
        if (typeof l.then == "function")
          return Xo(l);
        if (l.$$typeof === z)
          return l._currentValue;
      }
      throw Error(Q(438, String(l)));
    },
    useContext: function(l) {
      return Ct(), l._currentValue;
    },
    useMemo: Lr,
    useReducer: nl,
    useRef: function(l) {
      de = Ct(), ve = ir();
      var a = ve.memoizedState;
      return a === null ? (l = { current: l }, ve.memoizedState = l) : a;
    },
    useState: function(l) {
      return nl(ar, l);
    },
    useInsertionEffect: va,
    useLayoutEffect: va,
    useCallback: function(l, a) {
      return Lr(function() {
        return l;
      }, a);
    },
    useImperativeHandle: va,
    useEffect: va,
    useDebugValue: va,
    useDeferredValue: function(l, a) {
      return Ct(), a !== void 0 ? a : l;
    },
    useTransition: function() {
      return Ct(), [!1, _c];
    },
    useId: function() {
      var l = _e.treeContext, a = l.overflow;
      l = l.id, l = (l & ~(1 << 32 - B(l) - 1)).toString(32) + a;
      var s = qn;
      if (s === null)
        throw Error(Q(404));
      return a = mn++, l = "«" + s.idPrefix + "R" + l, 0 < a && (l += "H" + a.toString(32)), l + "»";
    },
    useSyncExternalStore: function(l, a, s) {
      if (s === void 0)
        throw Error(Q(407));
      return s();
    },
    useOptimistic: function(l) {
      return Ct(), [l, Kl];
    },
    useActionState: tl,
    useFormState: tl,
    useHostTransitionStatus: function() {
      return Ct(), Ao;
    },
    useMemoCache: function(l) {
      for (var a = Array(l), s = 0; s < l; s++)
        a[s] = qt;
      return a;
    },
    useCacheRefresh: function() {
      return uu;
    }
  }, qn = null, Ht = {
    getCacheForType: function() {
      throw Error(Q(248));
    }
  }, Tn, Zo;
  function rl(l) {
    if (Tn === void 0)
      try {
        throw Error();
      } catch (s) {
        var a = s.stack.trim().match(/\n( *(at )?)/);
        Tn = a && a[1] || "", Zo = -1 < s.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < s.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Tn + l + Zo;
  }
  var _i = !1;
  function En(l, a) {
    if (!l || _i)
      return "";
    _i = !0;
    var s = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var v = {
        DetermineComponentFrameRoot: function() {
          try {
            if (a) {
              var Y = function() {
                throw Error();
              };
              if (Object.defineProperty(Y.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(Y, []);
                } catch (ge) {
                  var ue = ge;
                }
                Reflect.construct(l, [], Y);
              } else {
                try {
                  Y.call();
                } catch (ge) {
                  ue = ge;
                }
                l.call(Y.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (ge) {
                ue = ge;
              }
              (Y = l()) && typeof Y.catch == "function" && Y.catch(function() {
              });
            }
          } catch (ge) {
            if (ge && ue && typeof ge.stack == "string")
              return [ge.stack, ue.stack];
          }
          return [null, null];
        }
      };
      v.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var w = Object.getOwnPropertyDescriptor(
        v.DetermineComponentFrameRoot,
        "name"
      );
      w && w.configurable && Object.defineProperty(
        v.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var k = v.DetermineComponentFrameRoot(), P = k[0], _ = k[1];
      if (P && _) {
        var A = P.split(`
`), D = _.split(`
`);
        for (w = v = 0; v < A.length && !A[v].includes("DetermineComponentFrameRoot"); )
          v++;
        for (; w < D.length && !D[w].includes(
          "DetermineComponentFrameRoot"
        ); )
          w++;
        if (v === A.length || w === D.length)
          for (v = A.length - 1, w = D.length - 1; 1 <= v && 0 <= w && A[v] !== D[w]; )
            w--;
        for (; 1 <= v && 0 <= w; v--, w--)
          if (A[v] !== D[w]) {
            if (v !== 1 || w !== 1)
              do
                if (v--, w--, 0 > w || A[v] !== D[w]) {
                  var ee = `
` + A[v].replace(" at new ", " at ");
                  return l.displayName && ee.includes("<anonymous>") && (ee = ee.replace("<anonymous>", l.displayName)), ee;
                }
              while (1 <= v && 0 <= w);
            break;
          }
      }
    } finally {
      _i = !1, Error.prepareStackTrace = s;
    }
    return (s = l ? l.displayName || l.name : "") ? rl(s) : "";
  }
  function _r(l) {
    if (typeof l == "string")
      return rl(l);
    if (typeof l == "function")
      return l.prototype && l.prototype.isReactComponent ? En(l, !0) : En(l, !1);
    if (typeof l == "object" && l !== null) {
      switch (l.$$typeof) {
        case Ce:
          return En(l.render, !1);
        case U:
          return En(l.type, !1);
        case sl:
          var a = l, s = a._payload;
          a = a._init;
          try {
            l = a(s);
          } catch {
            return rl("Lazy");
          }
          return _r(l);
      }
      if (typeof l.name == "string")
        return s = l.env, rl(
          l.name + (s ? " [" + s + "]" : "")
        );
    }
    switch (l) {
      case q:
        return rl("SuspenseList");
      case ul:
        return rl("Suspense");
    }
    return "";
  }
  function no(l) {
    if (typeof l == "object" && l !== null && typeof l.environmentName == "string") {
      var a = l.environmentName;
      l = [l].slice(0), typeof l[0] == "string" ? l.splice(
        0,
        1,
        "%c%s%c " + l[0],
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + a + " ",
        ""
      ) : l.splice(
        0,
        0,
        "%c%s%c ",
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + a + " ",
        ""
      ), l.unshift(console), a = pn.apply(console.error, l), a();
    } else
      console.error(l);
    return null;
  }
  function ll() {
  }
  function to(l, a, s, v, w, k, P, _, A, D, ee) {
    var Y = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = l, this.renderState = a, this.rootFormatContext = s, this.progressiveChunkSize = v === void 0 ? 12800 : v, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.abortableTasks = Y, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = w === void 0 ? no : w, this.onPostpone = D === void 0 ? ll : D, this.onAllReady = k === void 0 ? ll : k, this.onShellReady = P === void 0 ? ll : P, this.onShellError = _ === void 0 ? ll : _, this.onFatalError = A === void 0 ? ll : A, this.formState = ee === void 0 ? null : ee;
  }
  function ba(l, a, s, v, w, k, P, _, A, D, ee, Y) {
    return a = new to(
      a,
      s,
      v,
      w,
      k,
      P,
      _,
      A,
      D,
      ee,
      Y
    ), s = kl(
      a,
      0,
      null,
      v,
      !1,
      !1
    ), s.parentFlushed = !0, l = ya(
      a,
      null,
      l,
      -1,
      null,
      s,
      null,
      null,
      a.abortableTasks,
      null,
      v,
      null,
      H,
      null,
      !1
    ), Hr(l), a.pingedTasks.push(l), a;
  }
  function ql(l, a, s, v, w, k, P, _, A, D, ee) {
    return l = ba(
      l,
      a,
      s,
      v,
      w,
      k,
      P,
      _,
      A,
      D,
      ee,
      void 0
    ), l.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, l;
  }
  var Yn = null;
  function Qo(l, a) {
    l.pingedTasks.push(a), l.pingedTasks.length === 1 && (l.flushScheduled = l.destination !== null, l.trackedPostpones !== null || l.status === 10 ? Pe(function() {
      return Wc(l);
    }) : Mt(function() {
      return Wc(l);
    }));
  }
  function or(l, a, s, v) {
    return {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: a,
      errorDigest: null,
      contentState: Dt(),
      fallbackState: Dt(),
      contentPreamble: s,
      fallbackPreamble: v,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    };
  }
  function ya(l, a, s, v, w, k, P, _, A, D, ee, Y, ue, ge, ye) {
    l.allPendingTasks++, w === null ? l.pendingRootTasks++ : w.pendingTasks++;
    var Se = {
      replay: null,
      node: s,
      childIndex: v,
      ping: function() {
        return Qo(l, Se);
      },
      blockedBoundary: w,
      blockedSegment: k,
      blockedPreamble: P,
      hoistableState: _,
      abortSet: A,
      keyPath: D,
      formatContext: ee,
      context: Y,
      treeContext: ue,
      componentStack: ge,
      thenableState: a,
      isFallback: ye
    };
    return A.add(Se), Se;
  }
  function Hi(l, a, s, v, w, k, P, _, A, D, ee, Y, ue, ge) {
    l.allPendingTasks++, k === null ? l.pendingRootTasks++ : k.pendingTasks++, s.pendingTasks++;
    var ye = {
      replay: s,
      node: v,
      childIndex: w,
      ping: function() {
        return Qo(l, ye);
      },
      blockedBoundary: k,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: P,
      abortSet: _,
      keyPath: A,
      formatContext: D,
      context: ee,
      treeContext: Y,
      componentStack: ue,
      thenableState: a,
      isFallback: ge
    };
    return _.add(ye), ye;
  }
  function kl(l, a, s, v, w, k) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: a,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: v,
      boundary: s,
      lastPushedText: w,
      textEmbedded: k
    };
  }
  function Hr(l) {
    var a = l.node;
    if (typeof a == "object" && a !== null)
      switch (a.$$typeof) {
        case ko:
          l.componentStack = { parent: l.componentStack, type: a.type };
      }
  }
  function Wi(l) {
    var a = {};
    return l && Object.defineProperty(a, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var s = "", v = l;
          do
            s += _r(v.type), v = v.parent;
          while (v);
          var w = s;
        } catch (k) {
          w = `
Error generating stack: ` + k.message + `
` + k.stack;
        }
        return Object.defineProperty(a, "componentStack", {
          value: w
        }), w;
      }
    }), a;
  }
  function Pt(l, a, s) {
    if (l = l.onError, a = l(a, s), a == null || typeof a == "string")
      return a;
  }
  function jl(l, a) {
    var s = l.onShellError, v = l.onFatalError;
    s(a), v(a), l.destination !== null ? (l.status = 14, fi(l.destination, a)) : (l.status = 13, l.fatalError = a);
  }
  function fu(l, a, s, v, w, k) {
    var P = a.thenableState;
    for (a.thenableState = null, de = {}, _e = a, Re = l, Kn = s, $r = mn = 0, tn = -1, Mn = 0, _t = P, l = v(w, k); On; )
      On = !1, $r = mn = 0, tn = -1, Mn = 0, el += 1, ve = null, l = v(w, k);
    return xr(), l;
  }
  function Jo(l, a, s, v, w, k, P) {
    var _ = !1;
    if (k !== 0 && l.formState !== null) {
      var A = a.blockedSegment;
      if (A !== null) {
        _ = !0, A = A.chunks;
        for (var D = 0; D < k; D++)
          D === P ? A.push(Su) : A.push(hl);
      }
    }
    k = a.keyPath, a.keyPath = s, w ? (s = a.treeContext, a.treeContext = L(s, 1, 0), Cr(l, a, v, -1), a.treeContext = s) : _ ? Cr(l, a, v, -1) : jn(l, a, v, -1), a.keyPath = k;
  }
  function ro(l, a, s, v, w, k) {
    if (typeof v == "function")
      if (v.prototype && v.prototype.isReactComponent) {
        var P = w;
        if ("ref" in w) {
          P = {};
          for (var _ in w)
            _ !== "ref" && (P[_] = w[_]);
        }
        var A = v.defaultProps;
        if (A) {
          P === w && (P = gt({}, P, w));
          for (var D in A)
            P[D] === void 0 && (P[D] = A[D]);
        }
        w = P, P = cu, A = v.contextType, typeof A == "object" && A !== null && (P = A._currentValue), P = new v(w, P);
        var ee = P.state !== void 0 ? P.state : null;
        if (P.updater = C, P.props = w, P.state = ee, A = { queue: [], replace: !1 }, P._reactInternals = A, k = v.contextType, P.context = typeof k == "object" && k !== null ? k._currentValue : cu, k = v.getDerivedStateFromProps, typeof k == "function" && (k = k(w, ee), ee = k == null ? ee : gt({}, ee, k), P.state = ee), typeof v.getDerivedStateFromProps != "function" && typeof P.getSnapshotBeforeUpdate != "function" && (typeof P.UNSAFE_componentWillMount == "function" || typeof P.componentWillMount == "function"))
          if (v = P.state, typeof P.componentWillMount == "function" && P.componentWillMount(), typeof P.UNSAFE_componentWillMount == "function" && P.UNSAFE_componentWillMount(), v !== P.state && C.enqueueReplaceState(
            P,
            P.state,
            null
          ), A.queue !== null && 0 < A.queue.length)
            if (v = A.queue, k = A.replace, A.queue = null, A.replace = !1, k && v.length === 1)
              P.state = v[0];
            else {
              for (A = k ? v[0] : P.state, ee = !0, k = k ? 1 : 0; k < v.length; k++)
                D = v[k], D = typeof D == "function" ? D.call(P, A, w, void 0) : D, D != null && (ee ? (ee = !1, A = gt({}, A, D)) : gt(A, D));
              P.state = A;
            }
          else
            A.queue = null;
        if (v = P.render(), l.status === 12)
          throw null;
        w = a.keyPath, a.keyPath = s, jn(l, a, v, -1), a.keyPath = w;
      } else {
        if (v = fu(l, a, s, v, w, void 0), l.status === 12)
          throw null;
        Jo(
          l,
          a,
          s,
          v,
          mn !== 0,
          $r,
          tn
        );
      }
    else if (typeof v == "string")
      if (P = a.blockedSegment, P === null)
        P = w.children, A = a.formatContext, ee = a.keyPath, a.formatContext = bi(A, v, w), a.keyPath = s, Cr(l, a, P, -1), a.formatContext = A, a.keyPath = ee;
      else {
        k = tu(
          P.chunks,
          v,
          w,
          l.resumableState,
          l.renderState,
          a.blockedPreamble,
          a.hoistableState,
          a.formatContext,
          P.lastPushedText,
          a.isFallback
        ), P.lastPushedText = !1, A = a.formatContext, ee = a.keyPath, a.keyPath = s, (a.formatContext = bi(A, v, w)).insertionMode === 3 ? (s = kl(
          l,
          0,
          null,
          a.formatContext,
          !1,
          !1
        ), P.preambleChildren.push(s), s = ya(
          l,
          null,
          k,
          -1,
          a.blockedBoundary,
          s,
          a.blockedPreamble,
          a.hoistableState,
          l.abortableTasks,
          a.keyPath,
          a.formatContext,
          a.context,
          a.treeContext,
          a.componentStack,
          a.isFallback
        ), Hr(s), l.pingedTasks.push(s)) : Cr(l, a, k, -1), a.formatContext = A, a.keyPath = ee;
        e: {
          switch (a = P.chunks, l = l.resumableState, v) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break e;
            case "body":
              if (1 >= A.insertionMode) {
                l.hasBody = !0;
                break e;
              }
              break;
            case "html":
              if (A.insertionMode === 0) {
                l.hasHtml = !0;
                break e;
              }
              break;
            case "head":
              if (1 >= A.insertionMode)
                break e;
          }
          a.push(It(v));
        }
        P.lastPushedText = !1;
      }
    else {
      switch (v) {
        case Po:
        case Xr:
        case Co:
        case Ut:
          v = a.keyPath, a.keyPath = s, jn(l, a, w.children, -1), a.keyPath = v;
          return;
        case Na:
          w.mode !== "hidden" && (v = a.keyPath, a.keyPath = s, jn(l, a, w.children, -1), a.keyPath = v);
          return;
        case q:
          v = a.keyPath, a.keyPath = s, jn(l, a, w.children, -1), a.keyPath = v;
          return;
        case Cu:
        case wc:
          throw Error(Q(343));
        case ul:
          e:
            if (a.replay !== null) {
              v = a.keyPath, a.keyPath = s, s = w.children;
              try {
                Cr(l, a, s, -1);
              } finally {
                a.keyPath = v;
              }
            } else {
              v = a.keyPath;
              var Y = a.blockedBoundary;
              k = a.blockedPreamble;
              var ue = a.hoistableState;
              D = a.blockedSegment, _ = w.fallback, w = w.children;
              var ge = /* @__PURE__ */ new Set(), ye = 2 > a.formatContext.insertionMode ? or(
                l,
                ge,
                me(),
                me()
              ) : or(l, ge, null, null);
              l.trackedPostpones !== null && (ye.trackedContentKeyPath = s);
              var Se = kl(
                l,
                D.chunks.length,
                ye,
                a.formatContext,
                !1,
                !1
              );
              D.children.push(Se), D.lastPushedText = !1;
              var rn = kl(
                l,
                0,
                null,
                a.formatContext,
                !1,
                !1
              );
              if (rn.parentFlushed = !0, l.trackedPostpones !== null) {
                P = [s[0], "Suspense Fallback", s[2]], A = [P[1], P[2], [], null], l.trackedPostpones.workingMap.set(P, A), ye.trackedFallbackNode = A, a.blockedSegment = Se, a.blockedPreamble = ye.fallbackPreamble, a.keyPath = P, Se.status = 6;
                try {
                  Cr(l, a, _, -1), Se.lastPushedText && Se.textEmbedded && Se.chunks.push(Qr), Se.status = 1;
                } catch (Dn) {
                  throw Se.status = l.status === 12 ? 3 : 4, Dn;
                } finally {
                  a.blockedSegment = D, a.blockedPreamble = k, a.keyPath = v;
                }
                a = ya(
                  l,
                  null,
                  w,
                  -1,
                  ye,
                  rn,
                  ye.contentPreamble,
                  ye.contentState,
                  a.abortSet,
                  s,
                  a.formatContext,
                  a.context,
                  a.treeContext,
                  a.componentStack,
                  a.isFallback
                ), Hr(a), l.pingedTasks.push(a);
              } else {
                a.blockedBoundary = ye, a.blockedPreamble = ye.contentPreamble, a.hoistableState = ye.contentState, a.blockedSegment = rn, a.keyPath = s, rn.status = 6;
                try {
                  if (Cr(l, a, w, -1), rn.lastPushedText && rn.textEmbedded && rn.chunks.push(Qr), rn.status = 1, Bi(ye, rn), ye.pendingTasks === 0 && ye.status === 0) {
                    ye.status = 1, l.pendingRootTasks === 0 && a.blockedPreamble && il(l);
                    break e;
                  }
                } catch (Dn) {
                  ye.status = 4, l.status === 12 ? (rn.status = 3, P = l.fatalError) : (rn.status = 4, P = Dn), A = Wi(a.componentStack), ee = Pt(
                    l,
                    P,
                    A
                  ), ye.errorDigest = ee, zi(l, ye);
                } finally {
                  a.blockedBoundary = Y, a.blockedPreamble = k, a.hoistableState = ue, a.blockedSegment = D, a.keyPath = v;
                }
                a = ya(
                  l,
                  null,
                  _,
                  -1,
                  Y,
                  Se,
                  ye.fallbackPreamble,
                  ye.fallbackState,
                  ge,
                  [s[0], "Suspense Fallback", s[2]],
                  a.formatContext,
                  a.context,
                  a.treeContext,
                  a.componentStack,
                  !0
                ), Hr(a), l.pingedTasks.push(a);
              }
            }
          return;
      }
      if (typeof v == "object" && v !== null)
        switch (v.$$typeof) {
          case Ce:
            if ("ref" in w)
              for (ye in P = {}, w)
                ye !== "ref" && (P[ye] = w[ye]);
            else
              P = w;
            v = fu(
              l,
              a,
              s,
              v.render,
              P,
              k
            ), Jo(
              l,
              a,
              s,
              v,
              mn !== 0,
              $r,
              tn
            );
            return;
          case U:
            ro(l, a, s, v.type, w, k);
            return;
          case za:
          case z:
            if (A = w.children, P = a.keyPath, w = w.value, ee = v._currentValue, v._currentValue = w, k = Li, Li = v = {
              parent: k,
              depth: k === null ? 0 : k.depth + 1,
              context: v,
              parentValue: ee,
              value: w
            }, a.context = v, a.keyPath = s, jn(l, a, A, -1), l = Li, l === null)
              throw Error(Q(403));
            l.context._currentValue = l.parentValue, l = Li = l.parent, a.context = l, a.keyPath = P;
            return;
          case Ba:
            w = w.children, v = w(v._context._currentValue), w = a.keyPath, a.keyPath = s, jn(l, a, v, -1), a.keyPath = w;
            return;
          case sl:
            if (P = v._init, v = P(v._payload), l.status === 12)
              throw null;
            ro(l, a, s, v, w, k);
            return;
        }
      throw Error(
        Q(130, v == null ? v : typeof v, "")
      );
    }
  }
  function Hc(l, a, s, v, w) {
    var k = a.replay, P = a.blockedBoundary, _ = kl(
      l,
      0,
      null,
      a.formatContext,
      !1,
      !1
    );
    _.id = s, _.parentFlushed = !0;
    try {
      a.replay = null, a.blockedSegment = _, Cr(l, a, v, w), _.status = 1, P === null ? l.completedRootSegment = _ : (Bi(P, _), P.parentFlushed && l.partialBoundaries.push(P));
    } finally {
      a.replay = k, a.blockedSegment = null;
    }
  }
  function jn(l, a, s, v) {
    a.replay !== null && typeof a.replay.slots == "number" ? Hc(l, a, a.replay.slots, s, v) : (a.node = s, a.childIndex = v, s = a.componentStack, Hr(a), wa(l, a), a.componentStack = s);
  }
  function wa(l, a) {
    var s = a.node, v = a.childIndex;
    if (s !== null) {
      if (typeof s == "object") {
        switch (s.$$typeof) {
          case ko:
            var w = s.type, k = s.key, P = s.props;
            s = P.ref;
            var _ = s !== void 0 ? s : null, A = Lt(w), D = k ?? (v === -1 ? 0 : v);
            if (k = [a.keyPath, A, D], a.replay !== null)
              e: {
                var ee = a.replay;
                for (v = ee.nodes, s = 0; s < v.length; s++) {
                  var Y = v[s];
                  if (D === Y[1]) {
                    if (Y.length === 4) {
                      if (A !== null && A !== Y[0])
                        throw Error(
                          Q(490, Y[0], A)
                        );
                      var ue = Y[2];
                      A = Y[3], D = a.node, a.replay = {
                        nodes: ue,
                        slots: A,
                        pendingTasks: 1
                      };
                      try {
                        if (ro(l, a, k, w, P, _), a.replay.pendingTasks === 1 && 0 < a.replay.nodes.length)
                          throw Error(Q(488));
                        a.replay.pendingTasks--;
                      } catch (Ln) {
                        if (typeof Ln == "object" && Ln !== null && (Ln === se || typeof Ln.then == "function"))
                          throw a.node === D && (a.replay = ee), Ln;
                        a.replay.pendingTasks--, P = Wi(a.componentStack), k = a.blockedBoundary, w = Ln, P = Pt(l, w, P), Cl(
                          l,
                          k,
                          ue,
                          A,
                          w,
                          P
                        );
                      }
                      a.replay = ee;
                    } else {
                      if (w !== ul)
                        throw Error(
                          Q(
                            490,
                            "Suspense",
                            Lt(w) || "Unknown"
                          )
                        );
                      n: {
                        ee = void 0, w = Y[5], _ = Y[2], A = Y[3], D = Y[4] === null ? [] : Y[4][2], Y = Y[4] === null ? null : Y[4][3];
                        var ge = a.keyPath, ye = a.replay, Se = a.blockedBoundary, rn = a.hoistableState, Dn = P.children, Ye = P.fallback, Wt = /* @__PURE__ */ new Set();
                        P = 2 > a.formatContext.insertionMode ? or(
                          l,
                          Wt,
                          me(),
                          me()
                        ) : or(
                          l,
                          Wt,
                          null,
                          null
                        ), P.parentFlushed = !0, P.rootSegmentID = w, a.blockedBoundary = P, a.hoistableState = P.contentState, a.keyPath = k, a.replay = {
                          nodes: _,
                          slots: A,
                          pendingTasks: 1
                        };
                        try {
                          if (Cr(l, a, Dn, -1), a.replay.pendingTasks === 1 && 0 < a.replay.nodes.length)
                            throw Error(Q(488));
                          if (a.replay.pendingTasks--, P.pendingTasks === 0 && P.status === 0) {
                            P.status = 1, l.completedBoundaries.push(P);
                            break n;
                          }
                        } catch (Ln) {
                          P.status = 4, ue = Wi(a.componentStack), ee = Pt(
                            l,
                            Ln,
                            ue
                          ), P.errorDigest = ee, a.replay.pendingTasks--, l.clientRenderedBoundaries.push(P);
                        } finally {
                          a.blockedBoundary = Se, a.hoistableState = rn, a.replay = ye, a.keyPath = ge;
                        }
                        a = Hi(
                          l,
                          null,
                          {
                            nodes: D,
                            slots: Y,
                            pendingTasks: 0
                          },
                          Ye,
                          -1,
                          Se,
                          P.fallbackState,
                          Wt,
                          [k[0], "Suspense Fallback", k[2]],
                          a.formatContext,
                          a.context,
                          a.treeContext,
                          a.componentStack,
                          !0
                        ), Hr(a), l.pingedTasks.push(a);
                      }
                    }
                    v.splice(s, 1);
                    break e;
                  }
                }
              }
            else
              ro(l, a, k, w, P, _);
            return;
          case Nl:
            throw Error(Q(257));
          case sl:
            if (ue = s._init, s = ue(s._payload), l.status === 12)
              throw null;
            jn(l, a, s, v);
            return;
        }
        if (Zr(s)) {
          Ta(l, a, s, v);
          return;
        }
        if (s === null || typeof s != "object" ? ue = null : (ue = xe && s[xe] || s["@@iterator"], ue = typeof ue == "function" ? ue : null), ue && (ue = ue.call(s))) {
          if (s = ue.next(), !s.done) {
            P = [];
            do
              P.push(s.value), s = ue.next();
            while (!s.done);
            Ta(l, a, P, v);
          }
          return;
        }
        if (typeof s.then == "function")
          return a.thenableState = null, jn(l, a, Xo(s), v);
        if (s.$$typeof === z)
          return jn(
            l,
            a,
            s._currentValue,
            v
          );
        throw v = Object.prototype.toString.call(s), Error(
          Q(
            31,
            v === "[object Object]" ? "object with keys {" + Object.keys(s).join(", ") + "}" : v
          )
        );
      }
      typeof s == "string" ? (v = a.blockedSegment, v !== null && (v.lastPushedText = Cc(
        v.chunks,
        s,
        l.renderState,
        v.lastPushedText
      ))) : (typeof s == "number" || typeof s == "bigint") && (v = a.blockedSegment, v !== null && (v.lastPushedText = Cc(
        v.chunks,
        "" + s,
        l.renderState,
        v.lastPushedText
      )));
    }
  }
  function Ta(l, a, s, v) {
    var w = a.keyPath;
    if (v !== -1 && (a.keyPath = [a.keyPath, "Fragment", v], a.replay !== null)) {
      for (var k = a.replay, P = k.nodes, _ = 0; _ < P.length; _++) {
        var A = P[_];
        if (A[1] === v) {
          v = A[2], A = A[3], a.replay = { nodes: v, slots: A, pendingTasks: 1 };
          try {
            if (Ta(l, a, s, -1), a.replay.pendingTasks === 1 && 0 < a.replay.nodes.length)
              throw Error(Q(488));
            a.replay.pendingTasks--;
          } catch (Y) {
            if (typeof Y == "object" && Y !== null && (Y === se || typeof Y.then == "function"))
              throw Y;
            a.replay.pendingTasks--, s = Wi(a.componentStack);
            var D = a.blockedBoundary, ee = Y;
            s = Pt(l, ee, s), Cl(
              l,
              D,
              v,
              A,
              ee,
              s
            );
          }
          a.replay = k, P.splice(_, 1);
          break;
        }
      }
      a.keyPath = w;
      return;
    }
    if (k = a.treeContext, P = s.length, a.replay !== null && (_ = a.replay.slots, _ !== null && typeof _ == "object")) {
      for (v = 0; v < P; v++)
        A = s[v], a.treeContext = L(k, P, v), D = _[v], typeof D == "number" ? (Hc(l, a, D, A, v), delete _[v]) : Cr(l, a, A, v);
      a.treeContext = k, a.keyPath = w;
      return;
    }
    for (_ = 0; _ < P; _++)
      v = s[_], a.treeContext = L(k, P, _), Cr(l, a, v, _);
    a.treeContext = k, a.keyPath = w;
  }
  function zi(l, a) {
    l = l.trackedPostpones, l !== null && (a = a.trackedContentKeyPath, a !== null && (a = l.workingMap.get(a), a !== void 0 && (a.length = 4, a[2] = [], a[3] = null)));
  }
  function Vo(l, a, s) {
    return Hi(
      l,
      s,
      a.replay,
      a.node,
      a.childIndex,
      a.blockedBoundary,
      a.hoistableState,
      a.abortSet,
      a.keyPath,
      a.formatContext,
      a.context,
      a.treeContext,
      a.componentStack,
      a.isFallback
    );
  }
  function Ko(l, a, s) {
    var v = a.blockedSegment, w = kl(
      l,
      v.chunks.length,
      null,
      a.formatContext,
      v.lastPushedText,
      !0
    );
    return v.children.push(w), v.lastPushedText = !1, ya(
      l,
      s,
      a.node,
      a.childIndex,
      a.blockedBoundary,
      w,
      a.blockedPreamble,
      a.hoistableState,
      a.abortSet,
      a.keyPath,
      a.formatContext,
      a.context,
      a.treeContext,
      a.componentStack,
      a.isFallback
    );
  }
  function Cr(l, a, s, v) {
    var w = a.formatContext, k = a.context, P = a.keyPath, _ = a.treeContext, A = a.componentStack, D = a.blockedSegment;
    if (D === null)
      try {
        return jn(l, a, s, v);
      } catch (ue) {
        if (xr(), s = ue === se ? Ve() : ue, typeof s == "object" && s !== null) {
          if (typeof s.then == "function") {
            v = In(), l = Vo(l, a, v).ping, s.then(l, l), a.formatContext = w, a.context = k, a.keyPath = P, a.treeContext = _, a.componentStack = A, x(k);
            return;
          }
          if (s.message === "Maximum call stack size exceeded") {
            s = In(), s = Vo(l, a, s), l.pingedTasks.push(s), a.formatContext = w, a.context = k, a.keyPath = P, a.treeContext = _, a.componentStack = A, x(k);
            return;
          }
        }
      }
    else {
      var ee = D.children.length, Y = D.chunks.length;
      try {
        return jn(l, a, s, v);
      } catch (ue) {
        if (xr(), D.children.length = ee, D.chunks.length = Y, s = ue === se ? Ve() : ue, typeof s == "object" && s !== null) {
          if (typeof s.then == "function") {
            v = In(), l = Ko(l, a, v).ping, s.then(l, l), a.formatContext = w, a.context = k, a.keyPath = P, a.treeContext = _, a.componentStack = A, x(k);
            return;
          }
          if (s.message === "Maximum call stack size exceeded") {
            s = In(), s = Ko(l, a, s), l.pingedTasks.push(s), a.formatContext = w, a.context = k, a.keyPath = P, a.treeContext = _, a.componentStack = A, x(k);
            return;
          }
        }
      }
    }
    throw a.formatContext = w, a.context = k, a.keyPath = P, a.treeContext = _, x(k), s;
  }
  function Ou(l) {
    var a = l.blockedBoundary;
    l = l.blockedSegment, l !== null && (l.status = 3, jo(this, a, l));
  }
  function Cl(l, a, s, v, w, k) {
    for (var P = 0; P < s.length; P++) {
      var _ = s[P];
      if (_.length === 4)
        Cl(
          l,
          a,
          _[2],
          _[3],
          w,
          k
        );
      else {
        _ = _[5];
        var A = l, D = k, ee = or(
          A,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        ee.parentFlushed = !0, ee.rootSegmentID = _, ee.status = 4, ee.errorDigest = D, ee.parentFlushed && A.clientRenderedBoundaries.push(ee);
      }
    }
    if (s.length = 0, v !== null) {
      if (a === null)
        throw Error(Q(487));
      if (a.status !== 4 && (a.status = 4, a.errorDigest = k, a.parentFlushed && l.clientRenderedBoundaries.push(a)), typeof v == "object")
        for (var Y in v)
          delete v[Y];
    }
  }
  function hu(l, a, s) {
    var v = l.blockedBoundary, w = l.blockedSegment;
    if (w !== null) {
      if (w.status === 6)
        return;
      w.status = 3;
    }
    if (w = Wi(l.componentStack), v === null) {
      if (a.status !== 13 && a.status !== 14) {
        if (v = l.replay, v === null) {
          Pt(a, s, w), jl(a, s);
          return;
        }
        v.pendingTasks--, v.pendingTasks === 0 && 0 < v.nodes.length && (l = Pt(a, s, w), Cl(
          a,
          null,
          v.nodes,
          v.slots,
          s,
          l
        )), a.pendingRootTasks--, a.pendingRootTasks === 0 && lo(a);
      }
    } else
      v.pendingTasks--, v.status !== 4 && (v.status = 4, l = Pt(a, s, w), v.status = 4, v.errorDigest = l, zi(a, v), v.parentFlushed && a.clientRenderedBoundaries.push(v)), v.fallbackAbortableTasks.forEach(function(k) {
        return hu(k, a, s);
      }), v.fallbackAbortableTasks.clear();
    a.allPendingTasks--, a.allPendingTasks === 0 && qo(a);
  }
  function $l(l, a) {
    try {
      var s = l.renderState, v = s.onHeaders;
      if (v) {
        var w = s.headers;
        if (w) {
          s.headers = null;
          var k = w.preconnects;
          if (w.fontPreloads && (k && (k += ", "), k += w.fontPreloads), w.highImagePreloads && (k && (k += ", "), k += w.highImagePreloads), !a) {
            var P = s.styles.values(), _ = P.next();
            e:
              for (; 0 < w.remainingCapacity && !_.done; _ = P.next())
                for (var A = _.value.sheets.values(), D = A.next(); 0 < w.remainingCapacity && !D.done; D = A.next()) {
                  var ee = D.value, Y = ee.props, ue = Y.href, ge = ee.props, ye = Vl(ge.href, "style", {
                    crossOrigin: ge.crossOrigin,
                    integrity: ge.integrity,
                    nonce: ge.nonce,
                    type: ge.type,
                    fetchPriority: ge.fetchPriority,
                    referrerPolicy: ge.referrerPolicy,
                    media: ge.media
                  });
                  if (0 <= (w.remainingCapacity -= ye.length + 2))
                    s.resets.style[ue] = Bn, k && (k += ", "), k += ye, s.resets.style[ue] = typeof Y.crossOrigin == "string" || typeof Y.integrity == "string" ? [Y.crossOrigin, Y.integrity] : Bn;
                  else
                    break e;
                }
          }
          v(k ? { Link: k } : {});
        }
      }
    } catch (Se) {
      Pt(l, Se, {});
    }
  }
  function lo(l) {
    l.trackedPostpones === null && $l(l, !0), l.trackedPostpones === null && il(l), l.onShellError = ll, l = l.onShellReady, l();
  }
  function qo(l) {
    $l(
      l,
      l.trackedPostpones === null ? !0 : l.completedRootSegment === null || l.completedRootSegment.status !== 5
    ), il(l), l = l.onAllReady, l();
  }
  function Bi(l, a) {
    if (a.chunks.length === 0 && a.children.length === 1 && a.children[0].boundary === null && a.children[0].id === -1) {
      var s = a.children[0];
      s.id = a.id, s.parentFlushed = !0, s.status === 1 && Bi(l, s);
    } else
      l.completedSegments.push(a);
  }
  function jo(l, a, s) {
    if (a === null) {
      if (s !== null && s.parentFlushed) {
        if (l.completedRootSegment !== null)
          throw Error(Q(389));
        l.completedRootSegment = s;
      }
      l.pendingRootTasks--, l.pendingRootTasks === 0 && lo(l);
    } else
      a.pendingTasks--, a.status !== 4 && (a.pendingTasks === 0 ? (a.status === 0 && (a.status = 1), s !== null && s.parentFlushed && s.status === 1 && Bi(a, s), a.parentFlushed && l.completedBoundaries.push(a), a.status === 1 && (a.fallbackAbortableTasks.forEach(Ou, l), a.fallbackAbortableTasks.clear(), l.pendingRootTasks === 0 && l.trackedPostpones === null && a.contentPreamble !== null && il(l))) : s !== null && s.parentFlushed && s.status === 1 && (Bi(a, s), a.completedSegments.length === 1 && a.parentFlushed && l.partialBoundaries.push(a)));
    l.allPendingTasks--, l.allPendingTasks === 0 && qo(l);
  }
  function Wc(l) {
    if (l.status !== 14 && l.status !== 13) {
      var a = Li, s = gr.H;
      gr.H = su;
      var v = gr.A;
      gr.A = Ht;
      var w = Yn;
      Yn = l;
      var k = qn;
      qn = l.resumableState;
      try {
        var P = l.pingedTasks, _;
        for (_ = 0; _ < P.length; _++) {
          var A = P[_], D = l, ee = A.blockedSegment;
          if (ee === null) {
            var Y = D;
            if (A.replay.pendingTasks !== 0) {
              x(A.context);
              try {
                if (typeof A.replay.slots == "number" ? Hc(
                  Y,
                  A,
                  A.replay.slots,
                  A.node,
                  A.childIndex
                ) : wa(Y, A), A.replay.pendingTasks === 1 && 0 < A.replay.nodes.length)
                  throw Error(Q(488));
                A.replay.pendingTasks--, A.abortSet.delete(A), jo(Y, A.blockedBoundary, null);
              } catch (Gn) {
                xr();
                var ue = Gn === se ? Ve() : Gn;
                if (typeof ue == "object" && ue !== null && typeof ue.then == "function") {
                  var ge = A.ping;
                  ue.then(ge, ge), A.thenableState = In();
                } else {
                  A.replay.pendingTasks--, A.abortSet.delete(A);
                  var ye = Wi(A.componentStack);
                  D = void 0;
                  var Se = Y, rn = A.blockedBoundary, Dn = Y.status === 12 ? Y.fatalError : ue, Ye = A.replay.nodes, Wt = A.replay.slots;
                  D = Pt(
                    Se,
                    Dn,
                    ye
                  ), Cl(
                    Se,
                    rn,
                    Ye,
                    Wt,
                    Dn,
                    D
                  ), Y.pendingRootTasks--, Y.pendingRootTasks === 0 && lo(Y), Y.allPendingTasks--, Y.allPendingTasks === 0 && qo(Y);
                }
              } finally {
              }
            }
          } else if (Y = void 0, Se = ee, Se.status === 0) {
            Se.status = 6, x(A.context);
            var Ln = Se.children.length, cr = Se.chunks.length;
            try {
              wa(D, A), Se.lastPushedText && Se.textEmbedded && Se.chunks.push(Qr), A.abortSet.delete(A), Se.status = 1, jo(D, A.blockedBoundary, Se);
            } catch (Gn) {
              xr(), Se.children.length = Ln, Se.chunks.length = cr;
              var St = Gn === se ? Ve() : D.status === 12 ? D.fatalError : Gn;
              if (typeof St == "object" && St !== null && typeof St.then == "function") {
                Se.status = 0, A.thenableState = In();
                var ot = A.ping;
                St.then(ot, ot);
              } else {
                var Zt = Wi(A.componentStack);
                A.abortSet.delete(A), Se.status = 4;
                var ln = A.blockedBoundary;
                Y = Pt(
                  D,
                  St,
                  Zt
                ), ln === null ? jl(D, St) : (ln.pendingTasks--, ln.status !== 4 && (ln.status = 4, ln.errorDigest = Y, zi(D, ln), ln.parentFlushed && D.clientRenderedBoundaries.push(ln), D.pendingRootTasks === 0 && D.trackedPostpones === null && ln.contentPreamble !== null && il(D))), D.allPendingTasks--, D.allPendingTasks === 0 && qo(D);
              }
            } finally {
            }
          }
        }
        P.splice(0, _), l.destination !== null && Ni(l, l.destination);
      } catch (Gn) {
        Pt(l, Gn, {}), jl(l, Gn);
      } finally {
        qn = k, gr.H = s, gr.A = v, s === su && x(a), Yn = w;
      }
    }
  }
  function zc(l, a, s) {
    a.preambleChildren.length && s.push(a.preambleChildren);
    for (var v = !1, w = 0; w < a.children.length; w++)
      v = $o(
        l,
        a.children[w],
        s
      ) || v;
    return v;
  }
  function $o(l, a, s) {
    var v = a.boundary;
    if (v === null)
      return zc(
        l,
        a,
        s
      );
    var w = v.contentPreamble, k = v.fallbackPreamble;
    if (w === null || k === null)
      return !1;
    switch (v.status) {
      case 1:
        if (ru(l.renderState, w), a = v.completedSegments[0], !a)
          throw Error(Q(391));
        return zc(
          l,
          a,
          s
        );
      case 5:
        if (l.trackedPostpones !== null)
          return !0;
      case 4:
        if (a.status === 1)
          return ru(l.renderState, k), zc(
            l,
            a,
            s
          );
      default:
        return !0;
    }
  }
  function il(l) {
    if (l.completedRootSegment && l.completedPreambleSegments === null) {
      var a = [], s = $o(
        l,
        l.completedRootSegment,
        a
      ), v = l.renderState.preamble;
      (s === !1 || v.headChunks && v.bodyChunks) && (l.completedPreambleSegments = a);
    }
  }
  function ei(l, a, s, v) {
    switch (s.parentFlushed = !0, s.status) {
      case 0:
        s.id = l.nextSegmentId++;
      case 5:
        return v = s.id, s.lastPushedText = !1, s.textEmbedded = !1, l = l.renderState, X(a, Mr), X(a, l.placeholderPrefix), l = j(v.toString(16)), X(a, l), ce(a, Yl);
      case 1:
        s.status = 2;
        var w = !0, k = s.chunks, P = 0;
        s = s.children;
        for (var _ = 0; _ < s.length; _++) {
          for (w = s[_]; P < w.index; P++)
            X(a, k[P]);
          w = io(l, a, w, v);
        }
        for (; P < k.length - 1; P++)
          X(a, k[P]);
        return P < k.length && (w = ce(a, k[P])), w;
      default:
        throw Error(Q(390));
    }
  }
  function io(l, a, s, v) {
    var w = s.boundary;
    if (w === null)
      return ei(l, a, s, v);
    if (w.parentFlushed = !0, w.status === 4) {
      var k = w.errorDigest;
      return ce(a, Tr), X(a, oa), k && (X(a, gl), X(a, j(De(k))), X(
        a,
        Gl
      )), ce(a, yt), ei(l, a, s, v), (l = w.fallbackPreamble) && Xl(a, l), ce(a, xi);
    }
    if (w.status !== 1)
      return w.status === 0 && (w.rootSegmentID = l.nextSegmentId++), 0 < w.completedSegments.length && l.partialBoundaries.push(w), vl(
        a,
        l.renderState,
        w.rootSegmentID
      ), v && (w = w.fallbackState, w.styles.forEach(Lc, v), w.stylesheets.forEach(
        eo,
        v
      )), ei(l, a, s, v), ce(a, xi);
    if (w.byteSize > l.progressiveChunkSize)
      return w.rootSegmentID = l.nextSegmentId++, l.completedBoundaries.push(w), vl(
        a,
        l.renderState,
        w.rootSegmentID
      ), ei(l, a, s, v), ce(a, xi);
    if (v && (s = w.contentState, s.styles.forEach(Lc, v), s.stylesheets.forEach(eo, v)), ce(a, ia), s = w.completedSegments, s.length !== 1)
      throw Error(Q(391));
    return io(l, a, s[0], v), (l = w.contentPreamble) && Xl(a, l), ce(a, xi);
  }
  function Ea(l, a, s, v) {
    return ua(
      a,
      l.renderState,
      s.parentFormatContext,
      s.id
    ), io(l, a, s, v), Jl(a, s.parentFormatContext);
  }
  function ec(l, a, s) {
    for (var v = s.completedSegments, w = 0; w < v.length; w++)
      ao(
        l,
        a,
        s,
        v[w]
      );
    v.length = 0, jr(
      a,
      s.contentState,
      l.renderState
    ), v = l.resumableState, l = l.renderState, w = s.rootSegmentID, s = s.contentState;
    var k = l.stylesToHoist;
    return l.stylesToHoist = !1, X(a, l.startInlineScript), k ? v.instructions & 2 ? v.instructions & 8 ? X(a, Ja) : (v.instructions |= 8, X(a, pc)) : (v.instructions |= 10, X(a, Wo)) : v.instructions & 2 ? X(a, Pi) : (v.instructions |= 2, X(a, Ac)), v = j(w.toString(16)), X(a, l.boundaryPrefix), X(a, v), X(a, zo), X(a, l.segmentPrefix), X(a, v), k ? (X(a, iu), Au(a, s)) : X(a, Va), s = ce(a, Si), Ri(a, l) && s;
  }
  function ao(l, a, s, v) {
    if (v.status === 2)
      return !0;
    var w = s.contentState, k = v.id;
    if (k === -1) {
      if ((v.id = s.rootSegmentID) === -1)
        throw Error(Q(392));
      return Ea(l, a, v, w);
    }
    return k === s.rootSegmentID ? Ea(l, a, v, w) : (Ea(l, a, v, w), s = l.resumableState, l = l.renderState, X(a, l.startInlineScript), s.instructions & 1 ? X(a, El) : (s.instructions |= 1, X(a, Vr)), X(a, l.segmentPrefix), k = j(k.toString(16)), X(a, k), X(a, Ho), X(a, l.placeholderPrefix), X(a, k), a = ce(a, sa), a);
  }
  function Ni(l, a) {
    Xe = new Uint8Array(2048), dt = 0;
    try {
      if (!(0 < l.pendingRootTasks)) {
        var s, v = l.completedRootSegment;
        if (v !== null) {
          if (v.status === 5)
            return;
          var w = l.completedPreambleSegments;
          if (w === null)
            return;
          var k = l.renderState, P = k.preamble, _ = P.htmlChunks, A = P.headChunks, D;
          if (_) {
            for (D = 0; D < _.length; D++)
              X(a, _[D]);
            if (A)
              for (D = 0; D < A.length; D++)
                X(a, A[D]);
            else
              X(a, bn("head")), X(a, sn);
          } else if (A)
            for (D = 0; D < A.length; D++)
              X(a, A[D]);
          var ee = k.charsetChunks;
          for (D = 0; D < ee.length; D++)
            X(a, ee[D]);
          ee.length = 0, k.preconnects.forEach(gn, a), k.preconnects.clear();
          var Y = k.viewportChunks;
          for (D = 0; D < Y.length; D++)
            X(a, Y[D]);
          Y.length = 0, k.fontPreloads.forEach(gn, a), k.fontPreloads.clear(), k.highImagePreloads.forEach(gn, a), k.highImagePreloads.clear(), k.styles.forEach(Vn, a);
          var ue = k.importMapChunks;
          for (D = 0; D < ue.length; D++)
            X(a, ue[D]);
          ue.length = 0, k.bootstrapScripts.forEach(gn, a), k.scripts.forEach(gn, a), k.scripts.clear(), k.bulkPreloads.forEach(gn, a), k.bulkPreloads.clear();
          var ge = k.hoistableChunks;
          for (D = 0; D < ge.length; D++)
            X(a, ge[D]);
          for (k = ge.length = 0; k < w.length; k++) {
            var ye = w[k];
            for (P = 0; P < ye.length; P++)
              io(l, a, ye[P], null);
          }
          var Se = l.renderState.preamble, rn = Se.headChunks;
          (Se.htmlChunks || rn) && X(a, It("head"));
          var Dn = Se.bodyChunks;
          if (Dn)
            for (w = 0; w < Dn.length; w++)
              X(a, Dn[w]);
          io(l, a, v, null), l.completedRootSegment = null, Ri(a, l.renderState);
        }
        var Ye = l.renderState;
        v = 0;
        var Wt = Ye.viewportChunks;
        for (v = 0; v < Wt.length; v++)
          X(a, Wt[v]);
        Wt.length = 0, Ye.preconnects.forEach(gn, a), Ye.preconnects.clear(), Ye.fontPreloads.forEach(gn, a), Ye.fontPreloads.clear(), Ye.highImagePreloads.forEach(
          gn,
          a
        ), Ye.highImagePreloads.clear(), Ye.styles.forEach(Ic, a), Ye.scripts.forEach(gn, a), Ye.scripts.clear(), Ye.bulkPreloads.forEach(gn, a), Ye.bulkPreloads.clear();
        var Ln = Ye.hoistableChunks;
        for (v = 0; v < Ln.length; v++)
          X(a, Ln[v]);
        Ln.length = 0;
        var cr = l.clientRenderedBoundaries;
        for (s = 0; s < cr.length; s++) {
          var St = cr[s];
          Ye = a;
          var ot = l.resumableState, Zt = l.renderState, ln = St.rootSegmentID, Gn = St.errorDigest;
          X(
            Ye,
            Zt.startInlineScript
          ), ot.instructions & 4 ? X(Ye, Fi) : (ot.instructions |= 4, X(Ye, fa)), X(Ye, Zt.boundaryPrefix), X(Ye, j(ln.toString(16))), X(Ye, Bo), Gn && (X(
            Ye,
            Ai
          ), X(
            Ye,
            j(
              pi(Gn || "")
            )
          ));
          var Rn = ce(
            Ye,
            ha
          );
          if (!Rn) {
            l.destination = null, s++, cr.splice(0, s);
            return;
          }
        }
        cr.splice(0, s);
        var Ft = l.completedBoundaries;
        for (s = 0; s < Ft.length; s++)
          if (!ec(l, a, Ft[s])) {
            l.destination = null, s++, Ft.splice(0, s);
            return;
          }
        Ft.splice(0, s), si(a), Xe = new Uint8Array(2048), dt = 0;
        var ka = l.partialBoundaries;
        for (s = 0; s < ka.length; s++) {
          var ni = ka[s];
          e: {
            cr = l, St = a;
            var ti = ni.completedSegments;
            for (Rn = 0; Rn < ti.length; Rn++)
              if (!ao(
                cr,
                St,
                ni,
                ti[Rn]
              )) {
                Rn++, ti.splice(0, Rn);
                var Ca = !1;
                break e;
              }
            ti.splice(0, Rn), Ca = jr(
              St,
              ni.contentState,
              cr.renderState
            );
          }
          if (!Ca) {
            l.destination = null, s++, ka.splice(0, s);
            return;
          }
        }
        ka.splice(0, s);
        var ri = l.completedBoundaries;
        for (s = 0; s < ri.length; s++)
          if (!ec(l, a, ri[s])) {
            l.destination = null, s++, ri.splice(0, s);
            return;
          }
        ri.splice(0, s);
      }
    } finally {
      l.allPendingTasks === 0 && l.pingedTasks.length === 0 && l.clientRenderedBoundaries.length === 0 && l.completedBoundaries.length === 0 ? (l.flushScheduled = !1, s = l.resumableState, s.hasBody && X(a, It("body")), s.hasHtml && X(a, It("html")), si(a), l.status = 14, a.close(), l.destination = null) : si(a);
    }
  }
  function Ui(l) {
    l.flushScheduled = l.destination !== null, Pe(function() {
      return Wc(l);
    }), Mt(function() {
      l.status === 10 && (l.status = 11), l.trackedPostpones === null && $l(l, l.pendingRootTasks === 0);
    });
  }
  function mi(l) {
    l.flushScheduled === !1 && l.pingedTasks.length === 0 && l.destination !== null && (l.flushScheduled = !0, Mt(function() {
      var a = l.destination;
      a ? Ni(l, a) : l.flushScheduled = !1;
    }));
  }
  function Ra(l, a) {
    if (l.status === 13)
      l.status = 14, fi(a, l.fatalError);
    else if (l.status !== 14 && l.destination === null) {
      l.destination = a;
      try {
        Ni(l, a);
      } catch (s) {
        Pt(l, s, {}), jl(l, s);
      }
    }
  }
  function xa(l, a) {
    (l.status === 11 || l.status === 10) && (l.status = 12);
    try {
      var s = l.abortableTasks;
      if (0 < s.size) {
        var v = a === void 0 ? Error(Q(432)) : typeof a == "object" && a !== null && typeof a.then == "function" ? Error(Q(530)) : a;
        l.fatalError = v, s.forEach(function(w) {
          return hu(w, l, v);
        }), s.clear();
      }
      l.destination !== null && Ni(l, l.destination);
    } catch (w) {
      Pt(l, w, {}), jl(l, w);
    }
  }
  function nc() {
    var l = yc.version;
    if (l !== "19.1.0")
      throw Error(
        Q(
          527,
          l,
          "19.1.0"
        )
      );
  }
  return nc(), nc(), us.prerender = function(l, a) {
    return new Promise(function(s, v) {
      var w = a ? a.onHeaders : void 0, k;
      w && (k = function(ee) {
        w(new Headers(ee));
      });
      var P = ea(
        a ? a.identifierPrefix : void 0,
        a ? a.unstable_externalRuntimeSrc : void 0,
        a ? a.bootstrapScriptContent : void 0,
        a ? a.bootstrapScripts : void 0,
        a ? a.bootstrapModules : void 0
      ), _ = ql(
        l,
        P,
        ma(
          P,
          void 0,
          a ? a.unstable_externalRuntimeSrc : void 0,
          a ? a.importMap : void 0,
          k,
          a ? a.maxHeadersLength : void 0
        ),
        Oo(a ? a.namespaceURI : void 0),
        a ? a.progressiveChunkSize : void 0,
        a ? a.onError : void 0,
        function() {
          var ee = {
            prelude: new ReadableStream(
              {
                type: "bytes",
                pull: function(Y) {
                  Ra(_, Y);
                },
                cancel: function(Y) {
                  _.destination = null, xa(_, Y);
                }
              },
              { highWaterMark: 0 }
            )
          };
          s(ee);
        },
        void 0,
        void 0,
        v,
        a ? a.onPostpone : void 0
      );
      if (a && a.signal) {
        var A = a.signal;
        if (A.aborted)
          xa(_, A.reason);
        else {
          var D = function() {
            xa(_, A.reason), A.removeEventListener("abort", D);
          };
          A.addEventListener("abort", D);
        }
      }
      Ui(_);
    });
  }, us.renderToReadableStream = function(l, a) {
    return new Promise(function(s, v) {
      var w, k, P = new Promise(function(ge, ye) {
        k = ge, w = ye;
      }), _ = a ? a.onHeaders : void 0, A;
      _ && (A = function(ge) {
        _(new Headers(ge));
      });
      var D = ea(
        a ? a.identifierPrefix : void 0,
        a ? a.unstable_externalRuntimeSrc : void 0,
        a ? a.bootstrapScriptContent : void 0,
        a ? a.bootstrapScripts : void 0,
        a ? a.bootstrapModules : void 0
      ), ee = ba(
        l,
        D,
        ma(
          D,
          a ? a.nonce : void 0,
          a ? a.unstable_externalRuntimeSrc : void 0,
          a ? a.importMap : void 0,
          A,
          a ? a.maxHeadersLength : void 0
        ),
        Oo(a ? a.namespaceURI : void 0),
        a ? a.progressiveChunkSize : void 0,
        a ? a.onError : void 0,
        k,
        function() {
          var ge = new ReadableStream(
            {
              type: "bytes",
              pull: function(ye) {
                Ra(ee, ye);
              },
              cancel: function(ye) {
                ee.destination = null, xa(ee, ye);
              }
            },
            { highWaterMark: 0 }
          );
          ge.allReady = P, s(ge);
        },
        function(ge) {
          P.catch(function() {
          }), v(ge);
        },
        w,
        a ? a.onPostpone : void 0,
        a ? a.formState : void 0
      );
      if (a && a.signal) {
        var Y = a.signal;
        if (Y.aborted)
          xa(ee, Y.reason);
        else {
          var ue = function() {
            xa(ee, Y.reason), Y.removeEventListener("abort", ue);
          };
          Y.addEventListener("abort", ue);
        }
      }
      Ui(ee);
    });
  }, us.version = "19.1.0", us;
}
var ss = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hs;
function Ns() {
  return Hs || (Hs = 1, process.env.NODE_ENV !== "production" && function() {
    function yc(n, r, c, d) {
      return "" + r + (c === "s" ? "\\73 " : "\\53 ") + d;
    }
    function Uu(n, r, c, d) {
      return "" + r + (c === "s" ? "\\u0073" : "\\u0053") + d;
    }
    function Q(n) {
      return Object.prototype.toString.call(n).replace(/^\[object (.*)\]$/, function(r, c) {
        return c;
      });
    }
    function ko(n) {
      var r = JSON.stringify(n);
      return '"' + n + '"' === r ? n : r;
    }
    function Nl(n) {
      switch (typeof n) {
        case "string":
          return JSON.stringify(
            10 >= n.length ? n : n.slice(0, 10) + "..."
          );
        case "object":
          return gn(n) ? "[...]" : n !== null && n.$$typeof === Di ? "client" : (n = Q(n), n === "Object" ? "{...}" : n);
        case "function":
          return n.$$typeof === Di ? "client" : (n = n.displayName || n.name) ? "function " + n : "function";
        default:
          return String(n);
      }
    }
    function Ut(n) {
      if (typeof n == "string")
        return n;
      switch (n) {
        case Kr:
          return "Suspense";
        case Rl:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case Oi:
            return Ut(n.render);
          case No:
            return Ut(n.type);
          case ga:
            var r = n._payload;
            n = n._init;
            try {
              return Ut(n(r));
            } catch {
            }
        }
      return "";
    }
    function Xr(n, r) {
      var c = Q(n);
      if (c !== "Object" && c !== "Array")
        return c;
      var d = -1, y = 0;
      if (gn(n))
        if (rr.has(n)) {
          var R = rr.get(n);
          c = "<" + Ut(R) + ">";
          for (var p = 0; p < n.length; p++) {
            var M = n[p];
            M = typeof M == "string" ? M : typeof M == "object" && M !== null ? "{" + Xr(M) + "}" : "{" + Nl(M) + "}", "" + p === r ? (d = c.length, y = M.length, c += M) : c = 15 > M.length && 40 > c.length + M.length ? c + M : c + "{...}";
          }
          c += "</" + Ut(R) + ">";
        } else {
          for (c = "[", R = 0; R < n.length; R++)
            0 < R && (c += ", "), p = n[R], p = typeof p == "object" && p !== null ? Xr(p) : Nl(p), "" + R === r ? (d = c.length, y = p.length, c += p) : c = 10 > p.length && 40 > c.length + p.length ? c + p : c + "...";
          c += "]";
        }
      else if (n.$$typeof === Si)
        c = "<" + Ut(n.type) + "/>";
      else {
        if (n.$$typeof === Di)
          return "client";
        if (Un.has(n)) {
          for (c = Un.get(n), c = "<" + (Ut(c) || "..."), R = Object.keys(n), p = 0; p < R.length; p++) {
            c += " ", M = R[p], c += ko(M) + "=";
            var N = n[M], I = M === r && typeof N == "object" && N !== null ? Xr(N) : Nl(N);
            typeof N != "string" && (I = "{" + I + "}"), M === r ? (d = c.length, y = I.length, c += I) : c = 10 > I.length && 40 > c.length + I.length ? c + I : c + "...";
          }
          c += ">";
        } else {
          for (c = "{", R = Object.keys(n), p = 0; p < R.length; p++)
            0 < p && (c += ", "), M = R[p], c += ko(M) + ": ", N = n[M], N = typeof N == "object" && N !== null ? Xr(N) : Nl(N), M === r ? (d = c.length, y = N.length, c += N) : c = 10 > N.length && 40 > c.length + N.length ? c + N : c + "...";
          c += "}";
        }
      }
      return r === void 0 ? c : -1 < d && 0 < y ? (n = " ".repeat(d) + "^".repeat(y), `
  ` + c + `
  ` + n) : `
  ` + c;
    }
    function Co(n, r) {
      var c = n.length & 3, d = n.length - c, y = r;
      for (r = 0; r < d; ) {
        var R = n.charCodeAt(r) & 255 | (n.charCodeAt(++r) & 255) << 8 | (n.charCodeAt(++r) & 255) << 16 | (n.charCodeAt(++r) & 255) << 24;
        ++r, R = 3432918353 * (R & 65535) + ((3432918353 * (R >>> 16) & 65535) << 16) & 4294967295, R = R << 15 | R >>> 17, R = 461845907 * (R & 65535) + ((461845907 * (R >>> 16) & 65535) << 16) & 4294967295, y ^= R, y = y << 13 | y >>> 19, y = 5 * (y & 65535) + ((5 * (y >>> 16) & 65535) << 16) & 4294967295, y = (y & 65535) + 27492 + (((y >>> 16) + 58964 & 65535) << 16);
      }
      switch (R = 0, c) {
        case 3:
          R ^= (n.charCodeAt(r + 2) & 255) << 16;
        case 2:
          R ^= (n.charCodeAt(r + 1) & 255) << 8;
        case 1:
          R ^= n.charCodeAt(r) & 255, R = 3432918353 * (R & 65535) + ((3432918353 * (R >>> 16) & 65535) << 16) & 4294967295, R = R << 15 | R >>> 17, y ^= 461845907 * (R & 65535) + ((461845907 * (R >>> 16) & 65535) << 16) & 4294967295;
      }
      return y ^= n.length, y ^= y >>> 16, y = 2246822507 * (y & 65535) + ((2246822507 * (y >>> 16) & 65535) << 16) & 4294967295, y ^= y >>> 13, y = 3266489909 * (y & 65535) + ((3266489909 * (y >>> 16) & 65535) << 16) & 4294967295, (y ^ y >>> 16) >>> 0;
    }
    function za(n) {
      return typeof Symbol == "function" && Symbol.toStringTag && n[Symbol.toStringTag] || n.constructor.name || "Object";
    }
    function Ba(n) {
      try {
        return z(n), !1;
      } catch {
        return !0;
      }
    }
    function z(n) {
      return "" + n;
    }
    function Ce(n, r) {
      if (Ba(n))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          r,
          za(n)
        ), z(n);
    }
    function ul(n, r) {
      if (Ba(n))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          r,
          za(n)
        ), z(n);
    }
    function q(n) {
      if (Ba(n))
        return console.error(
          "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
          za(n)
        ), z(n);
    }
    function U(n) {
      return Ke.call(Vn, n) ? !0 : Ke.call(Uo, n) ? !1 : Oc.test(n) ? Vn[n] = !0 : (Uo[n] = !0, console.error("Invalid attribute name: `%s`", n), !1);
    }
    function sl(n, r) {
      qa[r.type] || r.onChange || r.onInput || r.readOnly || r.disabled || r.value == null || console.error(
        n === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), r.onChange || r.readOnly || r.disabled || r.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function wc(n, r) {
      if (Ke.call(xl, r) && xl[r])
        return !0;
      if (Au.test(r)) {
        if (n = "aria-" + r.slice(4).toLowerCase(), n = mo.hasOwnProperty(n) ? n : null, n == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            r
          ), xl[r] = !0;
        if (r !== n)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            r,
            n
          ), xl[r] = !0;
      }
      if (Rr.test(r)) {
        if (n = r.toLowerCase(), n = mo.hasOwnProperty(n) ? n : null, n == null)
          return xl[r] = !0, !1;
        r !== n && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          r,
          n
        ), xl[r] = !0);
      }
      return !0;
    }
    function Na(n, r) {
      var c = [], d;
      for (d in r)
        wc(n, d) || c.push(d);
      r = c.map(function(y) {
        return "`" + y + "`";
      }).join(", "), c.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        r,
        n
      ) : 1 < c.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        r,
        n
      );
    }
    function Po(n, r, c, d) {
      if (Ke.call(at, r) && at[r])
        return !0;
      var y = r.toLowerCase();
      if (y === "onfocusin" || y === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), at[r] = !0;
      if (typeof c == "function" && (n === "form" && r === "action" || n === "input" && r === "formAction" || n === "button" && r === "formAction"))
        return !0;
      if (d != null) {
        if (n = d.possibleRegistrationNames, d.registrationNameDependencies.hasOwnProperty(r))
          return !0;
        if (d = n.hasOwnProperty(y) ? n[y] : null, d != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            r,
            d
          ), at[r] = !0;
        if (yn.test(r))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            r
          ), at[r] = !0;
      } else if (yn.test(r))
        return Je.test(r) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          r
        ), at[r] = !0;
      if (Yo.test(r) || Dc.test(r))
        return !0;
      if (y === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), at[r] = !0;
      if (y === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), at[r] = !0;
      if (y === "is" && c !== null && c !== void 0 && typeof c != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof c
        ), at[r] = !0;
      if (typeof c == "number" && isNaN(c))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          r
        ), at[r] = !0;
      if (Dt.hasOwnProperty(y)) {
        if (y = Dt[y], y !== r)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            r,
            y
          ), at[r] = !0;
      } else if (r !== y)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          r,
          y
        ), at[r] = !0;
      switch (r) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof c) {
        case "boolean":
          switch (r) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return y = r.toLowerCase().slice(0, 5), y === "data-" || y === "aria-" ? !0 : (c ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                c,
                r,
                r,
                c,
                r
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                c,
                r,
                r,
                c,
                r,
                r,
                r
              ), at[r] = !0);
          }
        case "function":
        case "symbol":
          return at[r] = !0, !1;
        case "string":
          if (c === "false" || c === "true") {
            switch (r) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              c,
              r,
              c === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              r,
              c
            ), at[r] = !0;
          }
      }
      return !0;
    }
    function qt(n, r, c) {
      var d = [], y;
      for (y in r)
        Po(n, y, r[y], c) || d.push(y);
      r = d.map(function(R) {
        return "`" + R + "`";
      }).join(", "), d.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        r,
        n
      ) : 1 < d.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        r,
        n
      );
    }
    function Cu(n) {
      return n.replace(ja, function(r, c) {
        return c.toUpperCase();
      });
    }
    function xe(n) {
      if (typeof n == "boolean" || typeof n == "number" || typeof n == "bigint")
        return "" + n;
      q(n), n = "" + n;
      var r = Lc.exec(n);
      if (r) {
        var c = "", d, y = 0;
        for (d = r.index; d < n.length; d++) {
          switch (n.charCodeAt(d)) {
            case 34:
              r = "&quot;";
              break;
            case 38:
              r = "&amp;";
              break;
            case 39:
              r = "&#x27;";
              break;
            case 60:
              r = "&lt;";
              break;
            case 62:
              r = "&gt;";
              break;
            default:
              continue;
          }
          y !== d && (c += n.slice(y, d)), y = d + 1, c += r;
        }
        n = y !== d ? c + n.slice(y, d) : c;
      }
      return n;
    }
    function Zr(n) {
      return pu.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
    }
    function Ua(n) {
      return q(n), ("" + n).replace(L, Uu);
    }
    function mt(n, r, c, d, y) {
      return {
        idPrefix: n === void 0 ? "" : n,
        nextFormID: 0,
        streamingFormat: 0,
        bootstrapScriptContent: c,
        bootstrapScripts: d,
        bootstrapModules: y,
        instructions: o,
        hasBody: !1,
        hasHtml: !1,
        unknownResources: {},
        dnsResources: {},
        connectResources: { default: {}, anonymous: {}, credentials: {} },
        imageResources: {},
        styleResources: {},
        scriptResources: {},
        moduleUnknownResources: {},
        moduleScriptResources: {}
      };
    }
    function je() {
      return {
        htmlChunks: null,
        headChunks: null,
        bodyChunks: null,
        contribution: oe
      };
    }
    function Mt(n, r, c) {
      return {
        insertionMode: n,
        selectedValue: r,
        tagScope: c
      };
    }
    function jc(n, r, c) {
      switch (r) {
        case "noscript":
          return Mt(
            se,
            null,
            n.tagScope | 1
          );
        case "select":
          return Mt(
            se,
            c.value != null ? c.value : c.defaultValue,
            n.tagScope
          );
        case "svg":
          return Mt(he, null, n.tagScope);
        case "picture":
          return Mt(
            se,
            null,
            n.tagScope | 2
          );
        case "math":
          return Mt(Ne, null, n.tagScope);
        case "foreignObject":
          return Mt(se, null, n.tagScope);
        case "table":
          return Mt(
            Ve,
            null,
            n.tagScope
          );
        case "thead":
        case "tbody":
        case "tfoot":
          return Mt(
            Ge,
            null,
            n.tagScope
          );
        case "colgroup":
          return Mt(
            de,
            null,
            n.tagScope
          );
        case "tr":
          return Mt(
            cn,
            null,
            n.tagScope
          );
        case "head":
          if (n.insertionMode < se)
            return Mt(
              Ee,
              null,
              n.tagScope
            );
          break;
        case "html":
          if (n.insertionMode === $)
            return Mt(
              ae,
              null,
              n.tagScope
            );
      }
      return n.insertionMode >= Ve || n.insertionMode < se ? Mt(se, null, n.tagScope) : n;
    }
    function $c(n, r) {
      if (typeof r != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      var c = !0, d;
      for (d in r)
        if (Ke.call(r, d)) {
          var y = r[d];
          if (y != null && typeof y != "boolean" && y !== "") {
            if (d.indexOf("--") === 0) {
              var R = xe(d);
              ul(y, d), y = xe(("" + y).trim());
            } else {
              R = d;
              var p = y;
              if (-1 < R.indexOf("-")) {
                var M = R;
                Ir.hasOwnProperty(M) && Ir[M] || (Ir[M] = !0, console.error(
                  "Unsupported style property %s. Did you mean %s?",
                  M,
                  Cu(M.replace(ou, "ms-"))
                ));
              } else if (au.test(R))
                M = R, Ir.hasOwnProperty(M) && Ir[M] || (Ir[M] = !0, console.error(
                  "Unsupported vendor-prefixed style property %s. Did you mean %s?",
                  M,
                  M.charAt(0).toUpperCase() + M.slice(1)
                ));
              else if (Vl.test(p)) {
                M = R;
                var N = p;
                lr.hasOwnProperty(N) && lr[N] || (lr[N] = !0, console.error(
                  `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
                  M,
                  N.replace(
                    Vl,
                    ""
                  )
                ));
              }
              typeof p == "number" && (isNaN(p) ? $a || ($a = !0, console.error(
                "`NaN` is an invalid value for the `%s` css style property.",
                R
              )) : isFinite(p) || Go || (Go = !0, console.error(
                "`Infinity` is an invalid value for the `%s` css style property.",
                R
              ))), R = d, p = _e.get(R), p !== void 0 || (p = xe(
                R.replace(eo, "-$1").toLowerCase().replace(pn, "-ms-")
              ), _e.set(R, p)), R = p, typeof y == "number" ? y = y === 0 || Mc.has(d) ? "" + y : y + "px" : (ul(y, d), y = xe(
                ("" + y).trim()
              ));
            }
            c ? (c = !1, n.push(
              Re,
              R,
              Kn,
              y
            )) : n.push(xt, R, Kn, y);
          }
        }
      c || n.push(On);
    }
    function Pe(n, r, c) {
      c && typeof c != "function" && typeof c != "symbol" && n.push(ve, r, mn);
    }
    function Xe(n, r, c) {
      typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" && n.push(
        ve,
        r,
        $e,
        xe(c),
        On
      );
    }
    function dt(n, r) {
      this.push('<input type="hidden"'), X(n), Xe(this, "name", r), Xe(this, "value", n), this.push(Mn);
    }
    function X(n) {
      if (typeof n != "string")
        throw Error(
          "File/Blob fields are not yet supported in progressive forms. Will fallback to client hydration."
        );
    }
    function ce(n, r) {
      if (typeof r.$$FORM_ACTION == "function") {
        var c = n.nextFormID++;
        n = n.idPrefix + c;
        try {
          var d = r.$$FORM_ACTION(n);
          if (d) {
            var y = d.data;
            y != null && y.forEach(X);
          }
          return d;
        } catch (R) {
          if (typeof R == "object" && R !== null && typeof R.then == "function")
            throw R;
          console.error(
            `Failed to serialize an action for progressive enhancement:
%s`,
            R
          );
        }
      }
      return null;
    }
    function si(n, r, c, d, y, R, p, M) {
      var N = null;
      if (typeof d == "function") {
        M === null || ar || (ar = !0, console.error(
          'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
        )), y === null && R === null || Lr || (Lr = !0, console.error(
          "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
        )), p === null || nl || (nl = !0, console.error(
          "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
        ));
        var I = ce(r, d);
        I !== null ? (M = I.name, d = I.action || "", y = I.encType, R = I.method, p = I.target, N = I.data) : (n.push(
          ve,
          "formAction",
          $e,
          $r,
          On
        ), p = R = y = d = M = null, gt(r, c));
      }
      return M != null && pe(n, "name", M), d != null && pe(n, "formAction", d), y != null && pe(n, "formEncType", y), R != null && pe(n, "formMethod", R), p != null && pe(n, "formTarget", p), N;
    }
    function pe(n, r, c) {
      switch (r) {
        case "className":
          Xe(n, "class", c);
          break;
        case "tabIndex":
          Xe(n, "tabindex", c);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          Xe(n, r, c);
          break;
        case "style":
          $c(n, c);
          break;
        case "src":
        case "href":
          if (c === "") {
            console.error(
              r === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              r,
              r
            );
            break;
          }
        case "action":
        case "formAction":
          if (c == null || typeof c == "function" || typeof c == "symbol" || typeof c == "boolean")
            break;
          Ce(c, r), c = Zr("" + c), n.push(
            ve,
            r,
            $e,
            xe(c),
            On
          );
          break;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "ref":
          break;
        case "autoFocus":
        case "multiple":
        case "muted":
          Pe(n, r.toLowerCase(), c);
          break;
        case "xlinkHref":
          if (typeof c == "function" || typeof c == "symbol" || typeof c == "boolean")
            break;
          Ce(c, r), c = Zr("" + c), n.push(
            ve,
            "xlink:href",
            $e,
            xe(c),
            On
          );
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          typeof c != "function" && typeof c != "symbol" && n.push(
            ve,
            r,
            $e,
            xe(c),
            On
          );
          break;
        case "inert":
          c !== "" || B[r] || (B[r] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            r
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          c && typeof c != "function" && typeof c != "symbol" && n.push(ve, r, mn);
          break;
        case "capture":
        case "download":
          c === !0 ? n.push(ve, r, mn) : c !== !1 && typeof c != "function" && typeof c != "symbol" && n.push(
            ve,
            r,
            $e,
            xe(c),
            On
          );
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          typeof c != "function" && typeof c != "symbol" && !isNaN(c) && 1 <= c && n.push(
            ve,
            r,
            $e,
            xe(c),
            On
          );
          break;
        case "rowSpan":
        case "start":
          typeof c == "function" || typeof c == "symbol" || isNaN(c) || n.push(
            ve,
            r,
            $e,
            xe(c),
            On
          );
          break;
        case "xlinkActuate":
          Xe(n, "xlink:actuate", c);
          break;
        case "xlinkArcrole":
          Xe(n, "xlink:arcrole", c);
          break;
        case "xlinkRole":
          Xe(n, "xlink:role", c);
          break;
        case "xlinkShow":
          Xe(n, "xlink:show", c);
          break;
        case "xlinkTitle":
          Xe(n, "xlink:title", c);
          break;
        case "xlinkType":
          Xe(n, "xlink:type", c);
          break;
        case "xmlBase":
          Xe(n, "xml:base", c);
          break;
        case "xmlLang":
          Xe(n, "xml:lang", c);
          break;
        case "xmlSpace":
          Xe(n, "xml:space", c);
          break;
        default:
          if ((!(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (r = Ic.get(r) || r, U(r))) {
            switch (typeof c) {
              case "function":
              case "symbol":
                return;
              case "boolean":
                var d = r.toLowerCase().slice(0, 5);
                if (d !== "data-" && d !== "aria-")
                  return;
            }
            n.push(
              ve,
              r,
              $e,
              xe(c),
              On
            );
          }
      }
    }
    function j(n, r, c) {
      if (r != null) {
        if (c != null)
          throw Error(
            "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
          );
        if (typeof r != "object" || !("__html" in r))
          throw Error(
            "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
          );
        r = r.__html, r != null && (q(r), n.push("" + r));
      }
    }
    function m(n, r) {
      var c = n[r];
      c != null && (c = gn(c), n.multiple && !c ? console.error(
        "The `%s` prop supplied to <select> must be an array if `multiple` is true.",
        r
      ) : !n.multiple && c && console.error(
        "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.",
        r
      ));
    }
    function fi(n) {
      var r = "";
      return iu.Children.forEach(n, function(c) {
        c != null && (r += c, Dr || typeof c == "string" || typeof c == "number" || typeof c == "bigint" || (Dr = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        )));
      }), r;
    }
    function gt(n, r) {
      (n.instructions & 16) === o && (n.instructions |= 16, r.bootstrapChunks.unshift(
        r.startInlineScript,
        kr,
        "<\/script>"
      ));
    }
    function Ie(n, r) {
      n.push(Ae("link"));
      for (var c in r)
        if (Ke.call(r, c)) {
          var d = r[c];
          if (d != null)
            switch (c) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(
                  "link is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                );
              default:
                pe(n, c, d);
            }
        }
      return n.push(Mn), null;
    }
    function hn(n) {
      return q(n), ("" + n).replace(_c, yc);
    }
    function zn(n, r, c) {
      n.push(Ae(c));
      for (var d in r)
        if (Ke.call(r, d)) {
          var y = r[d];
          if (y != null)
            switch (d) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(
                  c + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                );
              default:
                pe(n, d, y);
            }
        }
      return n.push(Mn), null;
    }
    function So(n, r) {
      n.push(Ae("title"));
      var c = null, d = null, y;
      for (y in r)
        if (Ke.call(r, y)) {
          var R = r[y];
          if (R != null)
            switch (y) {
              case "children":
                c = R;
                break;
              case "dangerouslySetInnerHTML":
                d = R;
                break;
              default:
                pe(n, y, R);
            }
        }
      return n.push(tn), r = Array.isArray(c) ? 2 > c.length ? c[0] : null : c, typeof r != "function" && typeof r != "symbol" && r !== null && r !== void 0 && n.push(xe("" + r)), j(n, d, c), n.push(di("title")), null;
    }
    function hi(n, r) {
      n.push(Ae("script"));
      var c = null, d = null, y;
      for (y in r)
        if (Ke.call(r, y)) {
          var R = r[y];
          if (R != null)
            switch (y) {
              case "children":
                c = R;
                break;
              case "dangerouslySetInnerHTML":
                d = R;
                break;
              default:
                pe(n, y, R);
            }
        }
      return n.push(tn), c != null && typeof c != "string" && (r = typeof c == "number" ? "a number for children" : Array.isArray(c) ? "an array for children" : "something unexpected for children", console.error(
        "A script element was rendered with %s. If script element has children it must be a single string. Consider using dangerouslySetInnerHTML or passing a plain string as children.",
        r
      )), j(n, d, c), typeof c == "string" && n.push(Ua(c)), n.push(di("script")), null;
    }
    function Tc(n, r, c) {
      n.push(Ae(c));
      var d = c = null, y;
      for (y in r)
        if (Ke.call(r, y)) {
          var R = r[y];
          if (R != null)
            switch (y) {
              case "children":
                c = R;
                break;
              case "dangerouslySetInnerHTML":
                d = R;
                break;
              default:
                pe(n, y, R);
            }
        }
      return n.push(tn), j(n, d, c), c;
    }
    function ze(n, r, c) {
      n.push(Ae(c));
      var d = c = null, y;
      for (y in r)
        if (Ke.call(r, y)) {
          var R = r[y];
          if (R != null)
            switch (y) {
              case "children":
                c = R;
                break;
              case "dangerouslySetInnerHTML":
                d = R;
                break;
              default:
                pe(n, y, R);
            }
        }
      return n.push(tn), j(n, d, c), typeof c == "string" ? (n.push(xe(c)), null) : c;
    }
    function Ae(n) {
      var r = Xo.get(n);
      if (r === void 0) {
        if (!tl.test(n))
          throw Error("Invalid tag: " + n);
        r = "<" + n, Xo.set(n, r);
      }
      return r;
    }
    function De(n, r, c, d, y, R, p, M, N, I) {
      Na(r, c), r !== "input" && r !== "textarea" && r !== "select" || c == null || c.value !== null || it || (it = !0, r === "select" && c.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        r
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        r
      ));
      e:
        if (r.indexOf("-") === -1)
          var te = !1;
        else
          switch (r) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              te = !1;
              break e;
            default:
              te = !0;
          }
      switch (te || typeof c.is == "string" || qt(r, c, null), !c.suppressContentEditableWarning && c.contentEditable && c.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      ), M.insertionMode !== he && M.insertionMode !== Ne && r.indexOf("-") === -1 && r.toLowerCase() !== r && console.error(
        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
        r
      ), r) {
        case "div":
        case "span":
        case "svg":
        case "path":
          break;
        case "a":
          n.push(Ae("a"));
          var K = null, le = null, ie;
          for (ie in c)
            if (Ke.call(c, ie)) {
              var G = c[ie];
              if (G != null)
                switch (ie) {
                  case "children":
                    K = G;
                    break;
                  case "dangerouslySetInnerHTML":
                    le = G;
                    break;
                  case "href":
                    G === "" ? Xe(n, "href", "") : pe(n, ie, G);
                    break;
                  default:
                    pe(n, ie, G);
                }
            }
          if (n.push(tn), j(n, le, K), typeof K == "string") {
            n.push(xe(K));
            var we = null;
          } else
            we = K;
          return we;
        case "g":
        case "p":
        case "li":
          break;
        case "select":
          sl("select", c), m(c, "value"), m(c, "defaultValue"), c.value === void 0 || c.defaultValue === void 0 || el || (console.error(
            "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
          ), el = !0), n.push(Ae("select"));
          var Le = null, Te = null, Fe;
          for (Fe in c)
            if (Ke.call(c, Fe)) {
              var kn = c[Fe];
              if (kn != null)
                switch (Fe) {
                  case "children":
                    Le = kn;
                    break;
                  case "dangerouslySetInnerHTML":
                    Te = kn;
                    break;
                  case "defaultValue":
                  case "value":
                    break;
                  default:
                    pe(
                      n,
                      Fe,
                      kn
                    );
                }
            }
          return n.push(tn), j(n, Te, Le), Le;
        case "option":
          var be = M.selectedValue;
          n.push(Ae("option"));
          var Ue = null, Ze = null, At = null, Zn = null, $n;
          for ($n in c)
            if (Ke.call(c, $n)) {
              var Sn = c[$n];
              if (Sn != null)
                switch ($n) {
                  case "children":
                    Ue = Sn;
                    break;
                  case "selected":
                    At = Sn, In || (console.error(
                      "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
                    ), In = !0);
                    break;
                  case "dangerouslySetInnerHTML":
                    Zn = Sn;
                    break;
                  case "value":
                    Ze = Sn;
                  default:
                    pe(
                      n,
                      $n,
                      Sn
                    );
                }
            }
          if (be != null) {
            if (Ze !== null) {
              Ce(Ze, "value");
              var zr = "" + Ze;
            } else
              Zn === null || ir || (ir = !0, console.error(
                "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
              )), zr = fi(Ue);
            if (gn(be)) {
              for (var Qt = 0; Qt < be.length; Qt++)
                if (Ce(be[Qt], "value"), "" + be[Qt] === zr) {
                  n.push(' selected=""');
                  break;
                }
            } else
              Ce(be, "select.value"), "" + be === zr && n.push(' selected=""');
          } else
            At && n.push(' selected=""');
          return n.push(tn), j(n, Zn, Ue), Ue;
        case "textarea":
          sl("textarea", c), c.value === void 0 || c.defaultValue === void 0 || Ct || (console.error(
            "Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components"
          ), Ct = !0), n.push(Ae("textarea"));
          var qe = null, e = null, t = null, u;
          for (u in c)
            if (Ke.call(c, u)) {
              var h = c[u];
              if (h != null)
                switch (u) {
                  case "children":
                    t = h;
                    break;
                  case "value":
                    qe = h;
                    break;
                  case "defaultValue":
                    e = h;
                    break;
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  default:
                    pe(
                      n,
                      u,
                      h
                    );
                }
            }
          if (qe === null && e !== null && (qe = e), n.push(tn), t != null) {
            if (console.error(
              "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
            ), qe != null)
              throw Error(
                "If you supply `defaultValue` on a <textarea>, do not pass children."
              );
            if (gn(t)) {
              if (1 < t.length)
                throw Error("<textarea> can only have at most one child.");
              q(t[0]), qe = "" + t[0];
            }
            q(t), qe = "" + t;
          }
          return typeof qe == "string" && qe[0] === `
` && n.push(Kl), qe !== null && (Ce(qe, "value"), n.push(xe("" + qe))), null;
        case "input":
          sl("input", c), n.push(Ae("input"));
          var b = null, E = null, S = null, F = null, W = null, O = null, V = null, J = null, re = null, ne;
          for (ne in c)
            if (Ke.call(c, ne)) {
              var Z = c[ne];
              if (Z != null)
                switch (ne) {
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  case "name":
                    b = Z;
                    break;
                  case "formAction":
                    E = Z;
                    break;
                  case "formEncType":
                    S = Z;
                    break;
                  case "formMethod":
                    F = Z;
                    break;
                  case "formTarget":
                    W = Z;
                    break;
                  case "defaultChecked":
                    re = Z;
                    break;
                  case "defaultValue":
                    V = Z;
                    break;
                  case "checked":
                    J = Z;
                    break;
                  case "value":
                    O = Z;
                    break;
                  default:
                    pe(
                      n,
                      ne,
                      Z
                    );
                }
            }
          E === null || c.type === "image" || c.type === "submit" || xr || (xr = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          ));
          var He = si(
            n,
            d,
            y,
            E,
            S,
            F,
            W,
            b
          );
          return J === null || re === null || kt || (console.error(
            "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
            "A component",
            c.type
          ), kt = !0), O === null || V === null || _t || (console.error(
            "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
            "A component",
            c.type
          ), _t = !0), J !== null ? Pe(n, "checked", J) : re !== null && Pe(n, "checked", re), O !== null ? pe(n, "value", O) : V !== null && pe(n, "value", V), n.push(Mn), He != null && He.forEach(dt, n), null;
        case "button":
          n.push(Ae("button"));
          var nn = null, Oe = null, fe = null, Qn = null, un = null, Me = null, zt = null, sr;
          for (sr in c)
            if (Ke.call(c, sr)) {
              var et = c[sr];
              if (et != null)
                switch (sr) {
                  case "children":
                    nn = et;
                    break;
                  case "dangerouslySetInnerHTML":
                    Oe = et;
                    break;
                  case "name":
                    fe = et;
                    break;
                  case "formAction":
                    Qn = et;
                    break;
                  case "formEncType":
                    un = et;
                    break;
                  case "formMethod":
                    Me = et;
                    break;
                  case "formTarget":
                    zt = et;
                    break;
                  default:
                    pe(
                      n,
                      sr,
                      et
                    );
                }
            }
          Qn === null || c.type == null || c.type === "submit" || xr || (xr = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          ));
          var ct = si(
            n,
            d,
            y,
            Qn,
            un,
            Me,
            zt,
            fe
          );
          if (n.push(tn), ct != null && ct.forEach(dt, n), j(n, Oe, nn), typeof nn == "string") {
            n.push(xe(nn));
            var wn = null;
          } else
            wn = nn;
          return wn;
        case "form":
          n.push(Ae("form"));
          var Bt = null, Nt = null, We = null, Fn = null, an = null, Jt = null, Vt;
          for (Vt in c)
            if (Ke.call(c, Vt)) {
              var ut = c[Vt];
              if (ut != null)
                switch (Vt) {
                  case "children":
                    Bt = ut;
                    break;
                  case "dangerouslySetInnerHTML":
                    Nt = ut;
                    break;
                  case "action":
                    We = ut;
                    break;
                  case "encType":
                    Fn = ut;
                    break;
                  case "method":
                    an = ut;
                    break;
                  case "target":
                    Jt = ut;
                    break;
                  default:
                    pe(
                      n,
                      Vt,
                      ut
                    );
                }
            }
          var Ml = null, pr = null;
          if (typeof We == "function") {
            Fn === null && an === null || Lr || (Lr = !0, console.error(
              "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
            )), Jt === null || nl || (nl = !0, console.error(
              "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
            ));
            var Il = ce(
              d,
              We
            );
            Il !== null ? (We = Il.action || "", Fn = Il.encType, an = Il.method, Jt = Il.target, Ml = Il.data, pr = Il.name) : (n.push(
              ve,
              "action",
              $e,
              $r,
              On
            ), Jt = an = Fn = We = null, gt(d, y));
          }
          if (We != null && pe(n, "action", We), Fn != null && pe(n, "encType", Fn), an != null && pe(n, "method", an), Jt != null && pe(n, "target", Jt), n.push(tn), pr !== null && (n.push('<input type="hidden"'), Xe(n, "name", pr), n.push(Mn), Ml != null && Ml.forEach(
            dt,
            n
          )), j(n, Nt, Bt), typeof Bt == "string") {
            n.push(xe(Bt));
            var ho = null;
          } else
            ho = Bt;
          return ho;
        case "menuitem":
          n.push(Ae("menuitem"));
          for (var Dl in c)
            if (Ke.call(c, Dl)) {
              var Ma = c[Dl];
              if (Ma != null)
                switch (Dl) {
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "menuitems cannot have `children` nor `dangerouslySetInnerHTML`."
                    );
                  default:
                    pe(
                      n,
                      Dl,
                      Ma
                    );
                }
            }
          return n.push(tn), null;
        case "object":
          n.push(Ae("object"));
          var Br = null, go = null, Kt;
          for (Kt in c)
            if (Ke.call(c, Kt)) {
              var st = c[Kt];
              if (st != null)
                switch (Kt) {
                  case "children":
                    Br = st;
                    break;
                  case "dangerouslySetInnerHTML":
                    go = st;
                    break;
                  case "data":
                    Ce(st, "data");
                    var Hn = Zr("" + st);
                    if (Hn === "") {
                      console.error(
                        'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                        Kt,
                        Kt
                      );
                      break;
                    }
                    n.push(
                      ve,
                      "data",
                      $e,
                      xe(Hn),
                      On
                    );
                    break;
                  default:
                    pe(
                      n,
                      Kt,
                      st
                    );
                }
            }
          if (n.push(tn), j(n, go, Br), typeof Br == "string") {
            n.push(xe(Br));
            var fr = null;
          } else
            fr = Br;
          return fr;
        case "title":
          var Nr = M.insertionMode, Ia = !!(M.tagScope & 1);
          if (Ke.call(c, "children")) {
            var Ur = c.children, Ll = Array.isArray(Ur) ? 2 > Ur.length ? Ur[0] : null : Ur;
            Array.isArray(Ur) && 1 < Ur.length ? console.error(
              "React expects the `children` prop of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found an Array with length %s instead. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert `children` of <title> tags to a single string value which is why Arrays of length greater than 1 are not supported. When using JSX it can be common to combine text nodes and value nodes. For example: <title>hello {nameOfUser}</title>. While not immediately apparent, `children` in this case is an Array with length 2. If your `children` prop is using this form try rewriting it using a template string: <title>{`hello ${nameOfUser}`}</title>.",
              Ur.length
            ) : typeof Ll == "function" || typeof Ll == "symbol" ? console.error(
              "React expect children of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found %s instead. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert children of <title> tags to a single string value.",
              typeof Ll == "function" ? "a Function" : "a Sybmol"
            ) : Ll && Ll.toString === {}.toString && (Ll.$$typeof != null ? console.error(
              "React expects the `children` prop of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found an object that appears to be a React element which never implements a suitable `toString` method. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert children of <title> tags to a single string value which is why rendering React elements is not supported. If the `children` of <title> is a React Component try moving the <title> tag into that component. If the `children` of <title> is some HTML markup change it to be Text only to be valid HTML."
            ) : console.error(
              "React expects the `children` prop of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found an object that does not implement a suitable `toString` method. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert children of <title> tags to a single string value. Using the default `toString` method available on every object is almost certainly an error. Consider whether the `children` of this <title> is an object in error and change it to a string or number value if so. Otherwise implement a `toString` method that React can use to produce a valid <title>."
            ));
          }
          if (Nr === he || Ia || c.itemProp != null)
            var mr = So(
              n,
              c
            );
          else
            I ? mr = null : (So(y.hoistableChunks, c), mr = void 0);
          return mr;
        case "link":
          var Qc = c.rel, nt = c.href, hr = c.precedence;
          if (M.insertionMode === he || M.tagScope & 1 || c.itemProp != null || typeof Qc != "string" || typeof nt != "string" || nt === "") {
            Qc === "stylesheet" && typeof c.precedence == "string" && (typeof nt == "string" && nt || console.error(
              'React encountered a `<link rel="stylesheet" .../>` with a `precedence` prop and expected the `href` prop to be a non-empty string but ecountered %s instead. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop ensure there is a non-empty string `href` prop as well, otherwise remove the `precedence` prop.',
              nt === null ? "`null`" : nt === void 0 ? "`undefined`" : nt === "" ? "an empty string" : 'something with type "' + typeof nt + '"'
            )), Ie(n, c);
            var ai = null;
          } else if (c.rel === "stylesheet")
            if (typeof hr != "string" || c.disabled != null || c.onLoad || c.onError) {
              if (typeof hr == "string") {
                if (c.disabled != null)
                  console.error(
                    'React encountered a `<link rel="stylesheet" .../>` with a `precedence` prop and a `disabled` prop. The presence of the `disabled` prop indicates an intent to manage the stylesheet active state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the `disabled` prop, otherwise remove the `precedence` prop.'
                  );
                else if (c.onLoad || c.onError) {
                  var oi = c.onLoad && c.onError ? "`onLoad` and `onError` props" : c.onLoad ? "`onLoad` prop" : "`onError` prop";
                  console.error(
                    'React encountered a `<link rel="stylesheet" .../>` with a `precedence` prop and %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                    oi,
                    oi
                  );
                }
              }
              ai = Ie(
                n,
                c
              );
            } else {
              var _l = y.styles.get(hr), Da = d.styleResources.hasOwnProperty(
                nt
              ) ? d.styleResources[nt] : void 0;
              if (Da !== C) {
                d.styleResources[nt] = C, _l || (_l = {
                  precedence: xe(hr),
                  rules: [],
                  hrefs: [],
                  sheets: /* @__PURE__ */ new Map()
                }, y.styles.set(hr, _l));
                var al = {
                  state: ye,
                  props: Pn({}, c, {
                    "data-precedence": c.precedence,
                    precedence: null
                  })
                };
                if (Da) {
                  Da.length === 2 && ma(al.props, Da);
                  var Qi = y.preloads.stylesheets.get(nt);
                  Qi && 0 < Qi.length ? Qi.length = 0 : al.state = Se;
                }
                _l.sheets.set(nt, al), p && p.stylesheets.add(al);
              } else if (_l) {
                var Ji = _l.sheets.get(nt);
                Ji && p && p.stylesheets.add(Ji);
              }
              N && n.push("<!-- -->"), ai = null;
            }
          else
            c.onLoad || c.onError ? ai = Ie(
              n,
              c
            ) : (N && n.push("<!-- -->"), ai = I ? null : Ie(y.hoistableChunks, c));
          return ai;
        case "script":
          var Vi = c.async;
          if (typeof c.src != "string" || !c.src || !Vi || typeof Vi == "function" || typeof Vi == "symbol" || c.onLoad || c.onError || M.insertionMode === he || M.tagScope & 1 || c.itemProp != null)
            var Ki = hi(
              n,
              c
            );
          else {
            var Yr = c.src;
            if (c.type === "module")
              var Hl = d.moduleScriptResources, Jc = y.preloads.moduleScripts;
            else
              Hl = d.scriptResources, Jc = y.preloads.scripts;
            var ol = Hl.hasOwnProperty(Yr) ? Hl[Yr] : void 0;
            if (ol !== C) {
              Hl[Yr] = C;
              var vo = c;
              if (ol) {
                ol.length === 2 && (vo = Pn({}, c), ma(vo, ol));
                var bo = Jc.get(Yr);
                bo && (bo.length = 0);
              }
              var Tu = [];
              y.scripts.add(Tu), hi(Tu, vo);
            }
            N && n.push("<!-- -->"), Ki = null;
          }
          return Ki;
        case "style":
          var ci = M.insertionMode, Vc = !!(M.tagScope & 1);
          if (Ke.call(c, "children")) {
            var Or = c.children, Wl = Array.isArray(Or) ? 2 > Or.length ? Or[0] : null : Or;
            (typeof Wl == "function" || typeof Wl == "symbol" || Array.isArray(Wl)) && console.error(
              "React expect children of <style> tags to be a string, number, or object with a `toString` method but found %s instead. In browsers style Elements can only have `Text` Nodes as children.",
              typeof Wl == "function" ? "a Function" : typeof Wl == "symbol" ? "a Sybmol" : "an Array"
            );
          }
          var Wn = c.precedence, pt = c.href;
          if (ci === he || Vc || c.itemProp != null || typeof Wn != "string" || typeof pt != "string" || pt === "") {
            n.push(Ae("style"));
            var dr = null, Eu = null, zl;
            for (zl in c)
              if (Ke.call(c, zl)) {
                var qi = c[zl];
                if (qi != null)
                  switch (zl) {
                    case "children":
                      dr = qi;
                      break;
                    case "dangerouslySetInnerHTML":
                      Eu = qi;
                      break;
                    default:
                      pe(
                        n,
                        zl,
                        qi
                      );
                  }
              }
            n.push(tn);
            var La = Array.isArray(dr) ? 2 > dr.length ? dr[0] : null : dr;
            typeof La != "function" && typeof La != "symbol" && La !== null && La !== void 0 && n.push(hn(La)), j(
              n,
              Eu,
              dr
            ), n.push(di("style"));
            var zu = null;
          } else {
            pt.includes(" ") && console.error(
              'React expected the `href` prop for a <style> tag opting into hoisting semantics using the `precedence` prop to not have any spaces but ecountered spaces instead. using spaces in this prop will cause hydration of this style to fail on the client. The href for the <style> where this ocurred is "%s".',
              pt
            );
            var ft = y.styles.get(Wn), sc = d.styleResources.hasOwnProperty(pt) ? d.styleResources[pt] : void 0;
            if (sc !== C) {
              d.styleResources[pt] = C, sc && console.error(
                'React encountered a hoistable style tag for the same href as a preload: "%s". When using a style tag to inline styles you should not also preload it as a stylsheet.',
                pt
              ), ft ? ft.hrefs.push(
                xe(pt)
              ) : (ft = {
                precedence: xe(Wn),
                rules: [],
                hrefs: [xe(pt)],
                sheets: /* @__PURE__ */ new Map()
              }, y.styles.set(
                Wn,
                ft
              ));
              var yo = ft.rules, _a = null, fc = null, wo;
              for (wo in c)
                if (Ke.call(c, wo)) {
                  var Kc = c[wo];
                  if (Kc != null)
                    switch (wo) {
                      case "children":
                        _a = Kc;
                        break;
                      case "dangerouslySetInnerHTML":
                        fc = Kc;
                    }
                }
              var hc = Array.isArray(_a) ? 2 > _a.length ? _a[0] : null : _a;
              typeof hc != "function" && typeof hc != "symbol" && hc !== null && hc !== void 0 && yo.push(hn(hc)), j(yo, fc, _a);
            }
            ft && p && p.styles.add(ft), N && n.push("<!-- -->"), zu = void 0;
          }
          return zu;
        case "meta":
          if (M.insertionMode === he || M.tagScope & 1 || c.itemProp != null)
            var Zu = zn(
              n,
              c,
              "meta"
            );
          else
            N && n.push("<!-- -->"), Zu = I ? null : typeof c.charSet == "string" ? zn(y.charsetChunks, c, "meta") : c.name === "viewport" ? zn(y.viewportChunks, c, "meta") : zn(
              y.hoistableChunks,
              c,
              "meta"
            );
          return Zu;
        case "listing":
        case "pre":
          n.push(Ae(r));
          var dc = null, To = null, Ha;
          for (Ha in c)
            if (Ke.call(c, Ha)) {
              var ui = c[Ha];
              if (ui != null)
                switch (Ha) {
                  case "children":
                    dc = ui;
                    break;
                  case "dangerouslySetInnerHTML":
                    To = ui;
                    break;
                  default:
                    pe(
                      n,
                      Ha,
                      ui
                    );
                }
            }
          if (n.push(tn), To != null) {
            if (dc != null)
              throw Error(
                "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
              );
            if (typeof To != "object" || !("__html" in To))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            var Wa = To.__html;
            Wa != null && (typeof Wa == "string" && 0 < Wa.length && Wa[0] === `
` ? n.push(Kl, Wa) : (q(Wa), n.push("" + Wa)));
          }
          return typeof dc == "string" && dc[0] === `
` && n.push(Kl), dc;
        case "img":
          var Ot = c.src, ht = c.srcSet;
          if (!(c.loading === "lazy" || !Ot && !ht || typeof Ot != "string" && Ot != null || typeof ht != "string" && ht != null) && c.fetchPriority !== "low" && !(M.tagScope & 3) && (typeof Ot != "string" || Ot[4] !== ":" || Ot[0] !== "d" && Ot[0] !== "D" || Ot[1] !== "a" && Ot[1] !== "A" || Ot[2] !== "t" && Ot[2] !== "T" || Ot[3] !== "a" && Ot[3] !== "A") && (typeof ht != "string" || ht[4] !== ":" || ht[0] !== "d" && ht[0] !== "D" || ht[1] !== "a" && ht[1] !== "A" || ht[2] !== "t" && ht[2] !== "T" || ht[3] !== "a" && ht[3] !== "A")) {
            var Qu = typeof c.sizes == "string" ? c.sizes : void 0, gc = ht ? ht + `
` + (Qu || "") : Ot, Ju = y.preloads.images, Eo = Ju.get(gc);
            if (Eo)
              (c.fetchPriority === "high" || 10 > y.highImagePreloads.size) && (Ju.delete(gc), y.highImagePreloads.add(Eo));
            else if (!d.imageResources.hasOwnProperty(gc)) {
              d.imageResources[gc] = H;
              var Ro = c.crossOrigin, Bu = typeof Ro == "string" ? Ro === "use-credentials" ? Ro : "" : void 0, xo = y.headers, ji;
              xo && 0 < xo.remainingCapacity && typeof c.srcSet != "string" && (c.fetchPriority === "high" || 500 > xo.highImagePreloads.length) && (ji = ea(Ot, "image", {
                imageSrcSet: c.srcSet,
                imageSizes: c.sizes,
                crossOrigin: Bu,
                integrity: c.integrity,
                nonce: c.nonce,
                type: c.type,
                fetchPriority: c.fetchPriority,
                referrerPolicy: c.refererPolicy
              }), 0 <= (xo.remainingCapacity -= ji.length + 2)) ? (y.resets.image[gc] = H, xo.highImagePreloads && (xo.highImagePreloads += ", "), xo.highImagePreloads += ji) : (Eo = [], Ie(Eo, {
                rel: "preload",
                as: "image",
                href: ht ? void 0 : Ot,
                imageSrcSet: ht,
                imageSizes: Qu,
                crossOrigin: Bu,
                integrity: c.integrity,
                type: c.type,
                fetchPriority: c.fetchPriority,
                referrerPolicy: c.referrerPolicy
              }), c.fetchPriority === "high" || 10 > y.highImagePreloads.size ? y.highImagePreloads.add(Eo) : (y.bulkPreloads.add(Eo), Ju.set(gc, Eo)));
            }
          }
          return zn(n, c, "img");
        case "base":
        case "area":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return zn(n, c, r);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          break;
        case "head":
          if (M.insertionMode < se) {
            var qc = R || y.preamble;
            if (qc.headChunks)
              throw Error("The `<head>` tag may only be rendered once.");
            qc.headChunks = [];
            var es = Tc(
              qc.headChunks,
              c,
              "head"
            );
          } else
            es = ze(
              n,
              c,
              "head"
            );
          return es;
        case "body":
          if (M.insertionMode < se) {
            var Ru = R || y.preamble;
            if (Ru.bodyChunks)
              throw Error("The `<body>` tag may only be rendered once.");
            Ru.bodyChunks = [];
            var Vu = Tc(
              Ru.bodyChunks,
              c,
              "body"
            );
          } else
            Vu = ze(
              n,
              c,
              "body"
            );
          return Vu;
        case "html":
          if (M.insertionMode === $) {
            var xu = R || y.preamble;
            if (xu.htmlChunks)
              throw Error("The `<html>` tag may only be rendered once.");
            xu.htmlChunks = [Ln];
            var ns = Tc(
              xu.htmlChunks,
              c,
              "html"
            );
          } else
            ns = ze(
              n,
              c,
              "html"
            );
          return ns;
        default:
          if (r.indexOf("-") !== -1) {
            n.push(Ae(r));
            var vc = null, ts = null, ku;
            for (ku in c)
              if (Ke.call(c, ku)) {
                var Gr = c[ku];
                if (Gr != null) {
                  var rs = ku;
                  switch (ku) {
                    case "children":
                      vc = Gr;
                      break;
                    case "dangerouslySetInnerHTML":
                      ts = Gr;
                      break;
                    case "style":
                      $c(n, Gr);
                      break;
                    case "suppressContentEditableWarning":
                    case "suppressHydrationWarning":
                    case "ref":
                      break;
                    case "className":
                      rs = "class";
                    default:
                      if (U(ku) && typeof Gr != "function" && typeof Gr != "symbol" && Gr !== !1) {
                        if (Gr === !0)
                          Gr = "";
                        else if (typeof Gr == "object")
                          continue;
                        n.push(
                          ve,
                          rs,
                          $e,
                          xe(Gr),
                          On
                        );
                      }
                  }
                }
              }
            return n.push(tn), j(
              n,
              ts,
              vc
            ), vc;
          }
      }
      return ze(n, c, r);
    }
    function di(n) {
      var r = uu.get(n);
      return r === void 0 && (r = "</" + n + ">", uu.set(n, r)), r;
    }
    function Ec(n, r) {
      n = n.preamble, n.htmlChunks === null && r.htmlChunks && (n.htmlChunks = r.htmlChunks, r.contribution |= 1), n.headChunks === null && r.headChunks && (n.headChunks = r.headChunks, r.contribution |= 4), n.bodyChunks === null && r.bodyChunks && (n.bodyChunks = r.bodyChunks, r.contribution |= 2);
    }
    function tt(n, r) {
      r = r.bootstrapChunks;
      for (var c = 0; c < r.length - 1; c++)
        n.push(r[c]);
      return c < r.length ? (c = r[c], r.length = 0, n.push(c)) : !0;
    }
    function Cn(n, r, c) {
      if (n.push(Ht), c === null)
        throw Error(
          "An ID must have been assigned before we can complete the boundary."
        );
      return n.push(r.boundaryPrefix), r = c.toString(16), n.push(r), n.push(Tn);
    }
    function gr(n, r) {
      r = r.contribution, r !== oe && (n.push(ql), n.push("" + r), n.push(Yn));
    }
    function Fo(n, r, c, d) {
      switch (c.insertionMode) {
        case $:
        case ae:
        case Ee:
        case se:
          return n.push(Qo), n.push(r.segmentPrefix), r = d.toString(16), n.push(r), n.push(or);
        case he:
          return n.push(Hi), n.push(r.segmentPrefix), r = d.toString(16), n.push(r), n.push(kl);
        case Ne:
          return n.push(Wi), n.push(r.segmentPrefix), r = d.toString(16), n.push(r), n.push(Pt);
        case Ve:
          return n.push(fu), n.push(r.segmentPrefix), r = d.toString(16), n.push(r), n.push(Jo);
        case Ge:
          return n.push(Hc), n.push(r.segmentPrefix), r = d.toString(16), n.push(r), n.push(jn);
        case cn:
          return n.push(Ta), n.push(r.segmentPrefix), r = d.toString(16), n.push(r), n.push(zi);
        case de:
          return n.push(Ko), n.push(r.segmentPrefix), r = d.toString(16), n.push(r), n.push(Cr);
        default:
          throw Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Ao(n, r) {
      switch (r.insertionMode) {
        case $:
        case ae:
        case Ee:
        case se:
          return n.push(ya);
        case he:
          return n.push(Hr);
        case Ne:
          return n.push(jl);
        case Ve:
          return n.push(ro);
        case Ge:
          return n.push(wa);
        case cn:
          return n.push(Vo);
        case de:
          return n.push(Ou);
        default:
          throw Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Yt(n) {
      return JSON.stringify(n).replace(
        mi,
        function(r) {
          switch (r) {
            case "<":
              return "\\u003c";
            case "\u2028":
              return "\\u2028";
            case "\u2029":
              return "\\u2029";
            default:
              throw Error(
                "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
              );
          }
        }
      );
    }
    function Bn(n) {
      return JSON.stringify(n).replace(
        Ra,
        function(r) {
          switch (r) {
            case "&":
              return "\\u0026";
            case ">":
              return "\\u003e";
            case "<":
              return "\\u003c";
            case "\u2028":
              return "\\u2028";
            case "\u2029":
              return "\\u2029";
            default:
              throw Error(
                "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
              );
          }
        }
      );
    }
    function ke(n) {
      var r = n.rules, c = n.hrefs;
      0 < r.length && c.length === 0 && console.error(
        "React expected to have at least one href for an a hoistable style but found none. This is a bug in React."
      );
      var d = 0;
      if (c.length) {
        for (this.push(xa), this.push(n.precedence), this.push(nc); d < c.length - 1; d++)
          this.push(c[d]), this.push(_);
        for (this.push(c[d]), this.push(l), d = 0; d < r.length; d++)
          this.push(r[d]);
        v = this.push(a), s = !0, r.length = 0, c.length = 0;
      }
    }
    function jt(n) {
      return n.state !== rn ? s = !0 : !1;
    }
    function gi(n, r, c) {
      return s = !1, v = !0, r.styles.forEach(ke, n), r.stylesheets.forEach(jt), s && (c.stylesToHoist = !0), v;
    }
    function vr(n) {
      for (var r = 0; r < n.length; r++)
        this.push(n[r]);
      n.length = 0;
    }
    function rt(n) {
      Ie(w, n.props);
      for (var r = 0; r < w.length; r++)
        this.push(w[r]);
      w.length = 0, n.state = rn;
    }
    function Rc(n) {
      var r = 0 < n.sheets.size;
      n.sheets.forEach(rt, this), n.sheets.clear();
      var c = n.rules, d = n.hrefs;
      if (!r || d.length) {
        if (this.push(k), this.push(n.precedence), n = 0, d.length) {
          for (this.push(P); n < d.length - 1; n++)
            this.push(d[n]), this.push(_);
          this.push(d[n]);
        }
        for (this.push(A), n = 0; n < c.length; n++)
          this.push(c[n]);
        this.push(D), c.length = 0, d.length = 0;
      }
    }
    function xc(n) {
      if (n.state === ye) {
        n.state = Se;
        var r = n.props;
        for (Ie(w, {
          rel: "preload",
          as: "style",
          href: n.props.href,
          crossOrigin: r.crossOrigin,
          fetchPriority: r.fetchPriority,
          integrity: r.integrity,
          media: r.media,
          hrefLang: r.hrefLang,
          referrerPolicy: r.referrerPolicy
        }), n = 0; n < w.length; n++)
          this.push(w[n]);
        w.length = 0;
      }
    }
    function $i(n) {
      n.sheets.forEach(xc, this), n.sheets.clear();
    }
    function kc(n, r) {
      n.push(ee);
      var c = ee;
      r.stylesheets.forEach(function(d) {
        if (d.state !== rn)
          if (d.state === Dn)
            n.push(c), d = d.props.href, Ce(d, "href"), d = Bn("" + d), n.push(d), n.push(ge), c = Y;
          else {
            n.push(c);
            var y = d.props["data-precedence"], R = d.props, p = Zr("" + d.props.href);
            p = Bn(p), n.push(p), Ce(y, "precedence"), y = "" + y, n.push(ue), y = Bn(y), n.push(y);
            for (var M in R)
              if (Ke.call(R, M) && (y = R[M], y != null))
                switch (M) {
                  case "href":
                  case "rel":
                  case "precedence":
                  case "data-precedence":
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "link is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    Ul(
                      n,
                      M,
                      y
                    );
                }
            n.push(ge), c = Y, d.state = Dn;
          }
      }), n.push(ge);
    }
    function Ul(n, r, c) {
      var d = r.toLowerCase();
      switch (typeof c) {
        case "function":
        case "symbol":
          return;
      }
      switch (r) {
        case "innerHTML":
        case "dangerouslySetInnerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "style":
        case "ref":
          return;
        case "className":
          d = "class", Ce(c, d), r = "" + c;
          break;
        case "hidden":
          if (c === !1)
            return;
          r = "";
          break;
        case "src":
        case "href":
          c = Zr(c), Ce(c, d), r = "" + c;
          break;
        default:
          if (2 < r.length && (r[0] === "o" || r[0] === "O") && (r[1] === "n" || r[1] === "N") || !U(r))
            return;
          Ce(c, d), r = "" + c;
      }
      n.push(ue), d = Bn(d), n.push(d), n.push(ue), d = Bn(r), n.push(d);
    }
    function vi() {
      return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set() };
    }
    function po(n, r, c, d) {
      (n.scriptResources.hasOwnProperty(c) || n.moduleScriptResources.hasOwnProperty(c)) && console.error(
        'Internal React Error: React expected bootstrap script or module with src "%s" to not have been preloaded already. please file an issue',
        c
      ), n.scriptResources[c] = C, n.moduleScriptResources[c] = C, n = [], Ie(n, d), r.bootstrapScripts.add(n);
    }
    function ma(n, r) {
      n.crossOrigin == null && (n.crossOrigin = r[0]), n.integrity == null && (n.integrity = r[1]);
    }
    function ea(n, r, c) {
      n = me(n), r = Oo(r, "as"), r = "<" + n + '>; rel=preload; as="' + r + '"';
      for (var d in c)
        Ke.call(c, d) && (n = c[d], typeof n == "string" && (r += "; " + d.toLowerCase() + '="' + Oo(
          n,
          d
        ) + '"'));
      return r;
    }
    function me(n) {
      return Ce(n, "href"), ("" + n).replace(
        Ye,
        $t
      );
    }
    function $t(n) {
      switch (n) {
        case "<":
          return "%3C";
        case ">":
          return "%3E";
        case `
`:
          return "%0A";
        case "\r":
          return "%0D";
        default:
          throw Error(
            "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
          );
      }
    }
    function Oo(n, r) {
      return Ba(n) && (console.error(
        "The provided `%s` option is an unsupported type %s. This value must be coerced to a string before using it here.",
        r,
        za(n)
      ), z(n)), ("" + n).replace(
        Wt,
        bi
      );
    }
    function bi(n) {
      switch (n) {
        case '"':
          return "%22";
        case "'":
          return "%27";
        case ";":
          return "%3B";
        case ",":
          return "%2C";
        case `
`:
          return "%0A";
        case "\r":
          return "%0D";
        default:
          throw Error(
            "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
          );
      }
    }
    function Qr(n) {
      this.styles.add(n);
    }
    function Cc(n) {
      this.stylesheets.add(n);
    }
    function eu(n, r) {
      var c = n.idPrefix, d = [], y = n.bootstrapScriptContent, R = n.bootstrapScripts, p = n.bootstrapModules;
      if (y !== void 0 && d.push(
        "<script>",
        Ua(y),
        "<\/script>"
      ), c = {
        placeholderPrefix: c + "P:",
        segmentPrefix: c + "S:",
        boundaryPrefix: c + "B:",
        startInlineScript: "<script>",
        preamble: je(),
        externalRuntimeScript: null,
        bootstrapChunks: d,
        importMapChunks: [],
        onHeaders: void 0,
        headers: null,
        resets: {
          font: {},
          dns: {},
          connect: { default: {}, anonymous: {}, credentials: {} },
          image: {},
          style: {}
        },
        charsetChunks: [],
        viewportChunks: [],
        hoistableChunks: [],
        preconnects: /* @__PURE__ */ new Set(),
        fontPreloads: /* @__PURE__ */ new Set(),
        highImagePreloads: /* @__PURE__ */ new Set(),
        styles: /* @__PURE__ */ new Map(),
        bootstrapScripts: /* @__PURE__ */ new Set(),
        scripts: /* @__PURE__ */ new Set(),
        bulkPreloads: /* @__PURE__ */ new Set(),
        preloads: {
          images: /* @__PURE__ */ new Map(),
          stylesheets: /* @__PURE__ */ new Map(),
          scripts: /* @__PURE__ */ new Map(),
          moduleScripts: /* @__PURE__ */ new Map()
        },
        nonce: void 0,
        hoistableState: null,
        stylesToHoist: !1
      }, R !== void 0)
        for (y = 0; y < R.length; y++) {
          var M = R[y], N, I = void 0, te = void 0, K = {
            rel: "preload",
            as: "script",
            fetchPriority: "low",
            nonce: void 0
          };
          typeof M == "string" ? K.href = N = M : (K.href = N = M.src, K.integrity = te = typeof M.integrity == "string" ? M.integrity : void 0, K.crossOrigin = I = typeof M == "string" || M.crossOrigin == null ? void 0 : M.crossOrigin === "use-credentials" ? "use-credentials" : ""), po(n, c, N, K), d.push('<script src="', xe(N)), typeof te == "string" && d.push(
            '" integrity="',
            xe(te)
          ), typeof I == "string" && d.push(
            '" crossorigin="',
            xe(I)
          ), d.push('" async=""><\/script>');
        }
      if (p !== void 0)
        for (R = 0; R < p.length; R++)
          y = p[R], I = N = void 0, te = {
            rel: "modulepreload",
            fetchPriority: "low",
            nonce: void 0
          }, typeof y == "string" ? te.href = M = y : (te.href = M = y.src, te.integrity = I = typeof y.integrity == "string" ? y.integrity : void 0, te.crossOrigin = N = typeof y == "string" || y.crossOrigin == null ? void 0 : y.crossOrigin === "use-credentials" ? "use-credentials" : ""), po(
            n,
            c,
            M,
            te
          ), d.push(
            '<script type="module" src="',
            xe(M)
          ), typeof I == "string" && d.push(
            '" integrity="',
            xe(I)
          ), typeof N == "string" && d.push(
            '" crossorigin="',
            xe(N)
          ), d.push('" async=""><\/script>');
      return {
        placeholderPrefix: c.placeholderPrefix,
        segmentPrefix: c.segmentPrefix,
        boundaryPrefix: c.boundaryPrefix,
        startInlineScript: c.startInlineScript,
        preamble: c.preamble,
        externalRuntimeScript: c.externalRuntimeScript,
        bootstrapChunks: c.bootstrapChunks,
        importMapChunks: c.importMapChunks,
        onHeaders: c.onHeaders,
        headers: c.headers,
        resets: c.resets,
        charsetChunks: c.charsetChunks,
        viewportChunks: c.viewportChunks,
        hoistableChunks: c.hoistableChunks,
        preconnects: c.preconnects,
        fontPreloads: c.fontPreloads,
        highImagePreloads: c.highImagePreloads,
        styles: c.styles,
        bootstrapScripts: c.bootstrapScripts,
        scripts: c.scripts,
        bulkPreloads: c.bulkPreloads,
        preloads: c.preloads,
        stylesToHoist: c.stylesToHoist,
        generateStaticMarkup: r
      };
    }
    function Pc(n, r, c, d) {
      return c.generateStaticMarkup ? (n.push(xe(r)), !1) : (r === "" ? n = d : (d && n.push("<!-- -->"), n.push(xe(r)), n = !0), n);
    }
    function Mo(n, r, c, d) {
      r.generateStaticMarkup || c && d && n.push("<!-- -->");
    }
    function on(n) {
      if (n == null)
        return null;
      if (typeof n == "function")
        return n.$$typeof === St ? null : n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case Fi:
          return "Fragment";
        case Ai:
          return "Profiler";
        case Bo:
          return "StrictMode";
        case Kr:
          return "Suspense";
        case Rl:
          return "SuspenseList";
        case Mi:
          return "Activity";
      }
      if (typeof n == "object")
        switch (typeof n.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), n.$$typeof) {
          case fa:
            return "Portal";
          case pi:
            return (n.displayName || "Context") + ".Provider";
          case da:
            return (n._context.displayName || "Context") + ".Consumer";
          case Oi:
            var r = n.render;
            return n = n.displayName, n || (n = r.displayName || r.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
          case No:
            return r = n.displayName || null, r !== null ? r : on(n.type) || "Memo";
          case ga:
            r = n._payload, n = n._init;
            try {
              return on(n(r));
            } catch {
            }
        }
      return null;
    }
    function yi(n, r) {
      if (n !== r) {
        n.context._currentValue2 = n.parentValue, n = n.parent;
        var c = r.parent;
        if (n === null) {
          if (c !== null)
            throw Error(
              "The stacks must reach the root at the same time. This is a bug in React."
            );
        } else {
          if (c === null)
            throw Error(
              "The stacks must reach the root at the same time. This is a bug in React."
            );
          yi(n, c);
        }
        r.context._currentValue2 = r.value;
      }
    }
    function lt(n) {
      n.context._currentValue2 = n.parentValue, n = n.parent, n !== null && lt(n);
    }
    function br(n) {
      var r = n.parent;
      r !== null && br(r), n.context._currentValue2 = n.value;
    }
    function Nn(n, r) {
      if (n.context._currentValue2 = n.parentValue, n = n.parent, n === null)
        throw Error(
          "The depth must equal at least at zero before reaching the root. This is a bug in React."
        );
      n.depth === r.depth ? yi(n, r) : Nn(n, r);
    }
    function na(n, r) {
      var c = r.parent;
      if (c === null)
        throw Error(
          "The depth must equal at least at zero before reaching the root. This is a bug in React."
        );
      n.depth === c.depth ? yi(n, c) : na(n, c), r.context._currentValue2 = r.value;
    }
    function yr(n) {
      var r = ln;
      r !== n && (r === null ? br(n) : n === null ? lt(r) : r.depth === n.depth ? yi(r, n) : r.depth > n.depth ? Nn(r, n) : na(r, n), ln = n);
    }
    function Jn(n) {
      if (n !== null && typeof n != "function") {
        var r = String(n);
        mu.has(r) || (mu.add(r), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          n
        ));
      }
    }
    function dn(n, r) {
      n = (n = n.constructor) && on(n) || "ReactClass";
      var c = n + "." + r;
      Gn[c] || (console.error(
        `Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`,
        r,
        n
      ), Gn[c] = !0);
    }
    function wi(n, r, c) {
      var d = n.id;
      n = n.overflow;
      var y = 32 - Bc(d) - 1;
      d &= ~(1 << y), c += 1;
      var R = 32 - Bc(r) + y;
      if (30 < R) {
        var p = y - y % 5;
        return R = (d & (1 << p) - 1).toString(32), d >>= p, y -= p, {
          id: 1 << 32 - Bc(r) + y | c << y | d,
          overflow: R + n
        };
      }
      return {
        id: 1 << R | c << y | d,
        overflow: n
      };
    }
    function er(n) {
      return n >>>= 0, n === 0 ? 32 : 31 - (Gu(n) / Iu | 0) | 0;
    }
    function wr() {
    }
    function nu(n, r, c) {
      switch (c = n[c], c === void 0 ? n.push(r) : c !== r && (r.then(wr, wr), r = c), r.status) {
        case "fulfilled":
          return r.value;
        case "rejected":
          throw r.reason;
        default:
          switch (typeof r.status == "string" ? r.then(wr, wr) : (n = r, n.status = "pending", n.then(
            function(d) {
              if (r.status === "pending") {
                var y = r;
                y.status = "fulfilled", y.value = d;
              }
            },
            function(d) {
              if (r.status === "pending") {
                var y = r;
                y.status = "rejected", y.reason = d;
              }
            }
          )), r.status) {
            case "fulfilled":
              return r.value;
            case "rejected":
              throw r.reason;
          }
          throw ur = r, Pl;
      }
    }
    function Ya() {
      if (ur === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var n = ur;
      return ur = null, n;
    }
    function Be(n, r) {
      return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
    }
    function sn() {
      if (Pr === null)
        throw Error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        );
      return Fr && console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      ), Pr;
    }
    function ta() {
      if (0 < Fa)
        throw Error("Rendered more hooks than during the previous render");
      return { memoizedState: null, queue: null, next: null };
    }
    function vt() {
      return vn === null ? vu === null ? (mc = !1, vu = vn = ta()) : (mc = !0, vn = vu) : vn.next === null ? (mc = !1, vn = vn.next = ta()) : (mc = !0, vn = vn.next), vn;
    }
    function ra() {
      var n = co;
      return co = null, n;
    }
    function fl() {
      Fr = !1, gu = Uc = Nc = Pr = null, oo = !1, vu = null, Fa = 0, vn = Sr = null;
    }
    function Pu(n) {
      return Fr && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), n._currentValue2;
    }
    function la(n, r) {
      return typeof r == "function" ? r(n) : r;
    }
    function Su(n, r, c) {
      if (n !== la && (Gi = "useReducer"), Pr = sn(), vn = vt(), mc) {
        if (c = vn.queue, r = c.dispatch, Sr !== null) {
          var d = Sr.get(c);
          if (d !== void 0) {
            Sr.delete(c), c = vn.memoizedState;
            do {
              var y = d.action;
              Fr = !0, c = n(c, y), Fr = !1, d = d.next;
            } while (d !== null);
            return vn.memoizedState = c, [c, r];
          }
        }
        return [vn.memoizedState, r];
      }
      return Fr = !0, n = n === la ? typeof r == "function" ? r() : r : c !== void 0 ? c(r) : r, Fr = !1, vn.memoizedState = n, n = vn.queue = { last: null, dispatch: null }, n = n.dispatch = bt.bind(
        null,
        Pr,
        n
      ), [vn.memoizedState, n];
    }
    function hl(n, r) {
      if (Pr = sn(), vn = vt(), r = r === void 0 ? null : r, vn !== null) {
        var c = vn.memoizedState;
        if (c !== null && r !== null) {
          e: {
            var d = c[1];
            if (d === null)
              console.error(
                "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
                Gi
              ), d = !1;
            else {
              r.length !== d.length && console.error(
                `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
                Gi,
                "[" + r.join(", ") + "]",
                "[" + d.join(", ") + "]"
              );
              for (var y = 0; y < d.length && y < r.length; y++)
                if (!Du(r[y], d[y])) {
                  d = !1;
                  break e;
                }
              d = !0;
            }
          }
          if (d)
            return c[0];
        }
      }
      return Fr = !0, n = n(), Fr = !1, vn.memoizedState = [n, r], n;
    }
    function bt(n, r, c) {
      if (25 <= Fa)
        throw Error(
          "Too many re-renders. React limits the number of renders to prevent an infinite loop."
        );
      if (n === Pr)
        if (oo = !0, n = { action: c, next: null }, Sr === null && (Sr = /* @__PURE__ */ new Map()), c = Sr.get(r), c === void 0)
          Sr.set(r, n);
        else {
          for (r = c; r.next !== null; )
            r = r.next;
          r.next = n;
        }
    }
    function Sc() {
      throw Error("startTransition cannot be called during server rendering.");
    }
    function Jr() {
      throw Error("Cannot update optimistic state while rendering.");
    }
    function nr(n, r, c) {
      sn();
      var d = Pa++, y = Uc;
      if (typeof n.$$FORM_ACTION == "function") {
        var R = null, p = gu;
        y = y.formState;
        var M = n.$$IS_SIGNATURE_EQUAL;
        if (y !== null && typeof M == "function") {
          var N = y[1];
          M.call(n, y[2], y[3]) && (R = c !== void 0 ? "p" + c : "k" + Co(
            JSON.stringify([
              p,
              null,
              d
            ]),
            0
          ), N === R && (Sl = d, r = y[0]));
        }
        var I = n.bind(null, r);
        return n = function(K) {
          I(K);
        }, typeof I.$$FORM_ACTION == "function" && (n.$$FORM_ACTION = function(K) {
          K = I.$$FORM_ACTION(K), c !== void 0 && (Ce(c, "target"), c += "", K.action = c);
          var le = K.data;
          return le && (R === null && (R = c !== void 0 ? "p" + c : "k" + Co(
            JSON.stringify([
              p,
              null,
              d
            ]),
            0
          )), le.append("$ACTION_KEY", R)), K;
        }), [r, n, !1];
      }
      var te = n.bind(null, r);
      return [
        r,
        function(K) {
          te(K);
        },
        !1
      ];
    }
    function Ga(n) {
      var r = Sa;
      return Sa += 1, co === null && (co = []), nu(co, n, r);
    }
    function Ti() {
      throw Error("Cache cannot be refreshed during server rendering.");
    }
    function dl() {
    }
    function Ei() {
    }
    function Fc() {
      if (Al === 0) {
        _u = console.log, bu = console.info, Yc = console.warn, Gc = console.error, Xu = console.group, pl = console.groupCollapsed, Aa = console.groupEnd;
        var n = {
          configurable: !0,
          enumerable: !0,
          value: Ei,
          writable: !0
        };
        Object.defineProperties(console, {
          info: n,
          log: n,
          warn: n,
          error: n,
          group: n,
          groupCollapsed: n,
          groupEnd: n
        });
      }
      Al++;
    }
    function Fu() {
      if (Al--, Al === 0) {
        var n = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: Pn({}, n, { value: _u }),
          info: Pn({}, n, { value: bu }),
          warn: Pn({}, n, { value: Yc }),
          error: Pn({}, n, { value: Gc }),
          group: Pn({}, n, { value: Xu }),
          groupCollapsed: Pn({}, n, { value: pl }),
          groupEnd: Pn({}, n, { value: Aa })
        });
      }
      0 > Al && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function ml(n) {
      if (Hu === void 0)
        try {
          throw Error();
        } catch (c) {
          var r = c.stack.trim().match(/\n( *(at )?)/);
          Hu = r && r[1] || "", li = -1 < c.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < c.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + Hu + n + li;
    }
    function bn(n, r) {
      if (!n || rc)
        return "";
      var c = yu.get(n);
      if (c !== void 0)
        return c;
      rc = !0, c = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var d = null;
      d = Lt.H, Lt.H = null, Fc();
      try {
        var y = {
          DetermineComponentFrameRoot: function() {
            try {
              if (r) {
                var le = function() {
                  throw Error();
                };
                if (Object.defineProperty(le.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(le, []);
                  } catch (G) {
                    var ie = G;
                  }
                  Reflect.construct(n, [], le);
                } else {
                  try {
                    le.call();
                  } catch (G) {
                    ie = G;
                  }
                  n.call(le.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (G) {
                  ie = G;
                }
                (le = n()) && typeof le.catch == "function" && le.catch(function() {
                });
              }
            } catch (G) {
              if (G && ie && typeof G.stack == "string")
                return [G.stack, ie.stack];
            }
            return [null, null];
          }
        };
        y.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var R = Object.getOwnPropertyDescriptor(
          y.DetermineComponentFrameRoot,
          "name"
        );
        R && R.configurable && Object.defineProperty(
          y.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var p = y.DetermineComponentFrameRoot(), M = p[0], N = p[1];
        if (M && N) {
          var I = M.split(`
`), te = N.split(`
`);
          for (p = R = 0; R < I.length && !I[R].includes(
            "DetermineComponentFrameRoot"
          ); )
            R++;
          for (; p < te.length && !te[p].includes(
            "DetermineComponentFrameRoot"
          ); )
            p++;
          if (R === I.length || p === te.length)
            for (R = I.length - 1, p = te.length - 1; 1 <= R && 0 <= p && I[R] !== te[p]; )
              p--;
          for (; 1 <= R && 0 <= p; R--, p--)
            if (I[R] !== te[p]) {
              if (R !== 1 || p !== 1)
                do
                  if (R--, p--, 0 > p || I[R] !== te[p]) {
                    var K = `
` + I[R].replace(
                      " at new ",
                      " at "
                    );
                    return n.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", n.displayName)), typeof n == "function" && yu.set(n, K), K;
                  }
                while (1 <= R && 0 <= p);
              break;
            }
        }
      } finally {
        rc = !1, Lt.H = d, Fu(), Error.prepareStackTrace = c;
      }
      return I = (I = n ? n.displayName || n.name : "") ? ml(I) : "", typeof n == "function" && yu.set(n, I), I;
    }
    function Io(n) {
      var r = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, n = n.stack, Error.prepareStackTrace = r, n.startsWith(`Error: react-stack-top-frame
`) && (n = n.slice(29)), r = n.indexOf(`
`), r !== -1 && (n = n.slice(r + 1)), r = n.indexOf("react-stack-bottom-frame"), r !== -1 && (r = n.lastIndexOf(
        `
`,
        r
      )), r !== -1)
        n = n.slice(0, r);
      else
        return "";
      return n;
    }
    function tu(n) {
      if (typeof n == "string")
        return ml(n);
      if (typeof n == "function")
        return n.prototype && n.prototype.isReactComponent ? bn(n, !0) : bn(n, !1);
      if (typeof n == "object" && n !== null) {
        switch (n.$$typeof) {
          case Oi:
            return bn(n.render, !1);
          case No:
            return bn(n.type, !1);
          case ga:
            var r = n, c = r._payload;
            r = r._init;
            try {
              n = r(c);
            } catch {
              return ml("Lazy");
            }
            return tu(n);
        }
        if (typeof n.name == "string")
          return c = n.env, ml(
            n.name + (c ? " [" + c + "]" : "")
          );
      }
      switch (n) {
        case Rl:
          return ml("SuspenseList");
        case Kr:
          return ml("Suspense");
      }
      return "";
    }
    function Xa(n) {
      if (typeof n == "object" && n !== null && typeof n.environmentName == "string") {
        var r = n.environmentName;
        n = [n].slice(0), typeof n[0] == "string" ? n.splice(
          0,
          1,
          "[%s] " + n[0],
          " " + r + " "
        ) : n.splice(0, 0, "[%s] ", " " + r + " "), n.unshift(console), r = cr.apply(console.error, n), r();
      } else
        console.error(n);
      return null;
    }
    function It() {
    }
    function ru(n, r, c, d, y, R, p, M, N, I, te) {
      var K = /* @__PURE__ */ new Set();
      this.destination = null, this.flushScheduled = !1, this.resumableState = n, this.renderState = r, this.rootFormatContext = c, this.progressiveChunkSize = d === void 0 ? 12800 : d, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.abortableTasks = K, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = y === void 0 ? Xa : y, this.onPostpone = I === void 0 ? It : I, this.onAllReady = R === void 0 ? It : R, this.onShellReady = p === void 0 ? It : p, this.onShellError = M === void 0 ? It : M, this.onFatalError = N === void 0 ? It : N, this.formState = te === void 0 ? null : te, this.didWarnForKey = null;
    }
    function Ri(n, r, c, d, y, R, p, M, N, I, te, K) {
      var le = ic();
      return 1e3 < le - so && (Lt.recentlyCreatedOwnerStacks = 0, so = le), r = new ru(
        r,
        c,
        d,
        y,
        R,
        p,
        M,
        N,
        I,
        te,
        K
      ), c = aa(
        r,
        0,
        null,
        d,
        !1,
        !1
      ), c.parentFlushed = !0, n = ia(
        r,
        null,
        n,
        -1,
        null,
        c,
        null,
        null,
        r.abortableTasks,
        null,
        d,
        null,
        Mu,
        null,
        !1,
        ot,
        null
      ), oa(n), r.pingedTasks.push(n), r;
    }
    function Mr(n, r) {
      n.pingedTasks.push(r), n.pingedTasks.length === 1 && (n.flushScheduled = n.destination !== null, Et(n));
    }
    function Yl(n, r, c, d) {
      return {
        status: Ar,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: r,
        errorDigest: null,
        contentState: vi(),
        fallbackState: vi(),
        contentPreamble: c,
        fallbackPreamble: d,
        trackedContentKeyPath: null,
        trackedFallbackNode: null,
        errorMessage: null,
        errorStack: null,
        errorComponentStack: null
      };
    }
    function ia(n, r, c, d, y, R, p, M, N, I, te, K, le, ie, G, we, Le) {
      n.allPendingTasks++, y === null ? n.pendingRootTasks++ : y.pendingTasks++;
      var Te = {
        replay: null,
        node: c,
        childIndex: d,
        ping: function() {
          return Mr(n, Te);
        },
        blockedBoundary: y,
        blockedSegment: R,
        blockedPreamble: p,
        hoistableState: M,
        abortSet: N,
        keyPath: I,
        formatContext: te,
        context: K,
        treeContext: le,
        componentStack: ie,
        thenableState: r,
        isFallback: G
      };
      return Te.debugTask = Le, N.add(Te), Te;
    }
    function Do(n, r, c, d, y, R, p, M, N, I, te, K, le, ie, G, we) {
      n.allPendingTasks++, R === null ? n.pendingRootTasks++ : R.pendingTasks++, c.pendingTasks++;
      var Le = {
        replay: c,
        node: d,
        childIndex: y,
        ping: function() {
          return Mr(n, Le);
        },
        blockedBoundary: R,
        blockedSegment: null,
        blockedPreamble: null,
        hoistableState: p,
        abortSet: M,
        keyPath: N,
        formatContext: I,
        context: te,
        treeContext: K,
        componentStack: le,
        thenableState: r,
        isFallback: ie
      };
      return Le.debugTask = we, M.add(Le), Le;
    }
    function aa(n, r, c, d, y, R) {
      return {
        status: Ar,
        parentFlushed: !1,
        id: -1,
        index: r,
        chunks: [],
        children: [],
        preambleChildren: [],
        parentFormatContext: d,
        boundary: c,
        lastPushedText: y,
        textEmbedded: R
      };
    }
    function Tr() {
      if (Wr === null || Wr.componentStack === null)
        return "";
      var n = Wr.componentStack;
      try {
        var r = "";
        if (typeof n.type == "string")
          r += ml(n.type);
        else if (typeof n.type == "function") {
          if (!n.owner) {
            var c = r, d = n.type, y = d ? d.displayName || d.name : "", R = y ? ml(y) : "";
            r = c + R;
          }
        } else
          n.owner || (r += tu(n.type));
        for (; n; )
          c = null, n.debugStack != null ? c = Io(
            n.debugStack
          ) : (R = n, R.stack != null && (c = typeof R.stack != "string" ? R.stack = Io(
            R.stack
          ) : R.stack)), (n = n.owner) && c && (r += `
` + c);
        var p = r;
      } catch (M) {
        p = `
Error generating stack: ` + M.message + `
` + M.stack;
      }
      return p;
    }
    function xi(n, r) {
      if (r != null)
        for (var c = 0; c < r.length; c++) {
          var d = r[c];
          typeof d.name == "string" && d.debugStack !== void 0 && (n.componentStack = {
            parent: n.componentStack,
            type: d,
            owner: d.owner,
            stack: d.debugStack
          }, n.debugTask = d.debugTask);
        }
    }
    function oa(n) {
      var r = n.node;
      if (typeof r == "object" && r !== null)
        switch (r.$$typeof) {
          case Si:
            var c = r.type, d = r._owner, y = r._debugStack;
            xi(n, r._debugInfo), n.debugTask = r._debugTask, n.componentStack = {
              parent: n.componentStack,
              type: c,
              owner: d,
              stack: y
            };
            break;
          case ga:
            xi(n, r._debugInfo);
            break;
          default:
            typeof r.then == "function" && xi(n, r._debugInfo);
        }
    }
    function Gl(n) {
      var r = {};
      return n && Object.defineProperty(r, "componentStack", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          try {
            var c = "", d = n;
            do
              c += tu(d.type), d = d.parent;
            while (d);
            var y = c;
          } catch (R) {
            y = `
Error generating stack: ` + R.message + `
` + R.stack;
          }
          return Object.defineProperty(r, "componentStack", {
            value: y
          }), y;
        }
      }), r;
    }
    function gl(n, r, c, d, y) {
      n.errorDigest = r, c instanceof Error ? (r = String(c.message), c = String(c.stack)) : (r = typeof c == "object" && c !== null ? Xr(c) : String(c), c = null), y = y ? `Switched to client rendering because the server rendering aborted due to:

` : `Switched to client rendering because the server rendering errored:

`, n.errorMessage = y + r, n.errorStack = c !== null ? y + c : null, n.errorComponentStack = d.componentStack;
    }
    function yt(n, r, c, d) {
      if (n = n.onError, r = d ? d.run(n.bind(null, r, c)) : n(r, c), r != null && typeof r != "string")
        console.error(
          'onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "%s" instead',
          typeof r
        );
      else
        return r;
    }
    function vl(n, r, c, d) {
      c = n.onShellError;
      var y = n.onFatalError;
      d ? (d.run(c.bind(null, r)), d.run(y.bind(null, r))) : (c(r), y(r)), n.destination !== null ? (n.status = Zi, n.destination.destroy(r)) : (n.status = 13, n.fatalError = r);
    }
    function lu(n, r, c, d, y, R) {
      var p = r.thenableState;
      for (r.thenableState = null, Pr = {}, Nc = r, Uc = n, gu = c, Fr = !1, Pa = Xn = 0, Sl = -1, Sa = 0, co = p, n = lc(d, y, R); oo; )
        oo = !1, Pa = Xn = 0, Sl = -1, Sa = 0, Fa += 1, vn = null, n = d(y, R);
      return fl(), n;
    }
    function Er(n, r, c, d, y, R, p) {
      var M = !1;
      if (R !== 0 && n.formState !== null) {
        var N = r.blockedSegment;
        if (N !== null) {
          M = !0, N = N.chunks;
          for (var I = 0; I < R; I++)
            I === p ? N.push("<!--F!-->") : N.push("<!--F-->");
        }
      }
      R = r.keyPath, r.keyPath = c, y ? (c = r.treeContext, r.treeContext = wi(c, 1, 0), wt(n, r, d, -1), r.treeContext = c) : M ? wt(n, r, d, -1) : An(n, r, d, -1), r.keyPath = R;
    }
    function Xl(n, r, c, d, y, R) {
      if (typeof d == "function")
        if (d.prototype && d.prototype.isReactComponent) {
          var p = y;
          if ("ref" in y) {
            p = {};
            for (var M in y)
              M !== "ref" && (p[M] = y[M]);
          }
          var N = d.defaultProps;
          if (N) {
            p === y && (p = Pn({}, p, y));
            for (var I in N)
              p[I] === void 0 && (p[I] = N[I]);
          }
          var te = p, K = ot, le = d.contextType;
          if ("contextType" in d && le !== null && (le === void 0 || le.$$typeof !== pi) && !Yi.has(d)) {
            Yi.add(d);
            var ie = le === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof le != "object" ? " However, it is set to a " + typeof le + "." : le.$$typeof === da ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(le).join(", ") + "}.";
            console.error(
              "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
              on(d) || "Component",
              ie
            );
          }
          typeof le == "object" && le !== null && (K = le._currentValue2);
          var G = new d(te, K);
          if (typeof d.getDerivedStateFromProps == "function" && (G.state === null || G.state === void 0)) {
            var we = on(d) || "Component";
            Ft.has(we) || (Ft.add(we), console.error(
              "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
              we,
              G.state === null ? "null" : "undefined",
              we
            ));
          }
          if (typeof d.getDerivedStateFromProps == "function" || typeof G.getSnapshotBeforeUpdate == "function") {
            var Le = null, Te = null, Fe = null;
            if (typeof G.componentWillMount == "function" && G.componentWillMount.__suppressDeprecationWarning !== !0 ? Le = "componentWillMount" : typeof G.UNSAFE_componentWillMount == "function" && (Le = "UNSAFE_componentWillMount"), typeof G.componentWillReceiveProps == "function" && G.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Te = "componentWillReceiveProps" : typeof G.UNSAFE_componentWillReceiveProps == "function" && (Te = "UNSAFE_componentWillReceiveProps"), typeof G.componentWillUpdate == "function" && G.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Fe = "componentWillUpdate" : typeof G.UNSAFE_componentWillUpdate == "function" && (Fe = "UNSAFE_componentWillUpdate"), Le !== null || Te !== null || Fe !== null) {
              var kn = on(d) || "Component", be = typeof d.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
              ni.has(kn) || (ni.add(
                kn
              ), console.error(
                `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
                kn,
                be,
                Le !== null ? `
  ` + Le : "",
                Te !== null ? `
  ` + Te : "",
                Fe !== null ? `
  ` + Fe : ""
              ));
            }
          }
          var Ue = on(d) || "Component";
          G.render || (d.prototype && typeof d.prototype.render == "function" ? console.error(
            "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
            Ue
          ) : console.error(
            "No `render` method found on the %s instance: you may have forgotten to define `render`.",
            Ue
          )), !G.getInitialState || G.getInitialState.isReactClassApproved || G.state || console.error(
            "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
            Ue
          ), G.getDefaultProps && !G.getDefaultProps.isReactClassApproved && console.error(
            "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
            Ue
          ), G.contextType && console.error(
            "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
            Ue
          ), d.childContextTypes && !du.has(d) && (du.add(d), console.error(
            "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
            Ue
          )), d.contextTypes && !ri.has(d) && (ri.add(d), console.error(
            "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
            Ue
          )), typeof G.componentShouldUpdate == "function" && console.error(
            "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
            Ue
          ), d.prototype && d.prototype.isPureReactComponent && typeof G.shouldComponentUpdate < "u" && console.error(
            "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
            on(d) || "A pure component"
          ), typeof G.componentDidUnmount == "function" && console.error(
            "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
            Ue
          ), typeof G.componentDidReceiveProps == "function" && console.error(
            "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
            Ue
          ), typeof G.componentWillRecieveProps == "function" && console.error(
            "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
            Ue
          ), typeof G.UNSAFE_componentWillRecieveProps == "function" && console.error(
            "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
            Ue
          );
          var Ze = G.props !== te;
          G.props !== void 0 && Ze && console.error(
            "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
            Ue
          ), G.defaultProps && console.error(
            "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
            Ue,
            Ue
          ), typeof G.getSnapshotBeforeUpdate != "function" || typeof G.componentDidUpdate == "function" || ka.has(d) || (ka.add(d), console.error(
            "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
            on(d)
          )), typeof G.getDerivedStateFromProps == "function" && console.error(
            "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
            Ue
          ), typeof G.getDerivedStateFromError == "function" && console.error(
            "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
            Ue
          ), typeof d.getSnapshotBeforeUpdate == "function" && console.error(
            "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
            Ue
          );
          var At = G.state;
          At && (typeof At != "object" || gn(At)) && console.error("%s.state: must be set to an object or null", Ue), typeof G.getChildContext == "function" && typeof d.childContextTypes != "object" && console.error(
            "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
            Ue
          );
          var Zn = G.state !== void 0 ? G.state : null;
          G.updater = Yu, G.props = te, G.state = Zn;
          var $n = { queue: [], replace: !1 };
          G._reactInternals = $n;
          var Sn = d.contextType;
          if (G.context = typeof Sn == "object" && Sn !== null ? Sn._currentValue2 : ot, G.state === te) {
            var zr = on(d) || "Component";
            ti.has(
              zr
            ) || (ti.add(
              zr
            ), console.error(
              "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
              zr
            ));
          }
          var Qt = d.getDerivedStateFromProps;
          if (typeof Qt == "function") {
            var qe = Qt(
              te,
              Zn
            );
            if (qe === void 0) {
              var e = on(d) || "Component";
              Ca.has(e) || (Ca.add(e), console.error(
                "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
                e
              ));
            }
            var t = qe == null ? Zn : Pn({}, Zn, qe);
            G.state = t;
          }
          if (typeof d.getDerivedStateFromProps != "function" && typeof G.getSnapshotBeforeUpdate != "function" && (typeof G.UNSAFE_componentWillMount == "function" || typeof G.componentWillMount == "function")) {
            var u = G.state;
            if (typeof G.componentWillMount == "function") {
              if (G.componentWillMount.__suppressDeprecationWarning !== !0) {
                var h = on(d) || "Unknown";
                Rn[h] || (console.warn(
                  `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
                  h
                ), Rn[h] = !0);
              }
              G.componentWillMount();
            }
            if (typeof G.UNSAFE_componentWillMount == "function" && G.UNSAFE_componentWillMount(), u !== G.state && (console.error(
              "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
              on(d) || "Component"
            ), Yu.enqueueReplaceState(
              G,
              G.state,
              null
            )), $n.queue !== null && 0 < $n.queue.length) {
              var b = $n.queue, E = $n.replace;
              if ($n.queue = null, $n.replace = !1, E && b.length === 1)
                G.state = b[0];
              else {
                for (var S = E ? b[0] : G.state, F = !0, W = E ? 1 : 0; W < b.length; W++) {
                  var O = b[W], V = typeof O == "function" ? O.call(
                    G,
                    S,
                    te,
                    void 0
                  ) : O;
                  V != null && (F ? (F = !1, S = Pn(
                    {},
                    S,
                    V
                  )) : Pn(S, V));
                }
                G.state = S;
              }
            } else
              $n.queue = null;
          }
          var J = Xi(G);
          if (n.status === 12)
            throw null;
          G.props !== te && (cc || console.error(
            "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
            on(d) || "a component"
          ), cc = !0);
          var re = r.keyPath;
          r.keyPath = c, An(n, r, J, -1), r.keyPath = re;
        } else {
          if (d.prototype && typeof d.prototype.render == "function") {
            var ne = on(d) || "Unknown";
            wu[ne] || (console.error(
              "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
              ne,
              ne
            ), wu[ne] = !0);
          }
          var Z = lu(
            n,
            r,
            c,
            d,
            y,
            void 0
          );
          if (n.status === 12)
            throw null;
          var He = Xn !== 0, nn = Pa, Oe = Sl;
          if (d.contextTypes) {
            var fe = on(d) || "Unknown";
            Ol[fe] || (Ol[fe] = !0, console.error(
              "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
              fe
            ));
          }
          if (d && d.childContextTypes && console.error(
            `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
            d.displayName || d.name || "Component"
          ), typeof d.getDerivedStateFromProps == "function") {
            var Qn = on(d) || "Unknown";
            Wu[Qn] || (console.error(
              "%s: Function components do not support getDerivedStateFromProps.",
              Qn
            ), Wu[Qn] = !0);
          }
          if (typeof d.contextType == "object" && d.contextType !== null) {
            var un = on(d) || "Unknown";
            fo[un] || (console.error(
              "%s: Function components do not support contextType.",
              un
            ), fo[un] = !0);
          }
          Er(
            n,
            r,
            c,
            Z,
            He,
            nn,
            Oe
          );
        }
      else if (typeof d == "string") {
        var Me = r.blockedSegment;
        if (Me === null) {
          var zt = y.children, sr = r.formatContext, et = r.keyPath;
          r.formatContext = jc(sr, d, y), r.keyPath = c, wt(n, r, zt, -1), r.formatContext = sr, r.keyPath = et;
        } else {
          var ct = De(
            Me.chunks,
            d,
            y,
            n.resumableState,
            n.renderState,
            r.blockedPreamble,
            r.hoistableState,
            r.formatContext,
            Me.lastPushedText,
            r.isFallback
          );
          Me.lastPushedText = !1;
          var wn = r.formatContext, Bt = r.keyPath;
          if (r.keyPath = c, (r.formatContext = jc(
            wn,
            d,
            y
          )).insertionMode === Ee) {
            var Nt = aa(
              n,
              0,
              null,
              r.formatContext,
              !1,
              !1
            );
            Me.preambleChildren.push(Nt);
            var We = ia(
              n,
              null,
              ct,
              -1,
              r.blockedBoundary,
              Nt,
              r.blockedPreamble,
              r.hoistableState,
              n.abortableTasks,
              r.keyPath,
              r.formatContext,
              r.context,
              r.treeContext,
              r.componentStack,
              r.isFallback,
              ot,
              r.debugTask
            );
            oa(We), n.pingedTasks.push(We);
          } else
            wt(n, r, ct, -1);
          r.formatContext = wn, r.keyPath = Bt;
          e: {
            var Fn = Me.chunks, an = n.resumableState;
            switch (d) {
              case "title":
              case "style":
              case "script":
              case "area":
              case "base":
              case "br":
              case "col":
              case "embed":
              case "hr":
              case "img":
              case "input":
              case "keygen":
              case "link":
              case "meta":
              case "param":
              case "source":
              case "track":
              case "wbr":
                break e;
              case "body":
                if (wn.insertionMode <= ae) {
                  an.hasBody = !0;
                  break e;
                }
                break;
              case "html":
                if (wn.insertionMode === $) {
                  an.hasHtml = !0;
                  break e;
                }
                break;
              case "head":
                if (wn.insertionMode <= ae)
                  break e;
            }
            Fn.push(di(d));
          }
          Me.lastPushedText = !1;
        }
      } else {
        switch (d) {
          case qr:
          case Bo:
          case Ai:
          case Fi:
            var Jt = r.keyPath;
            r.keyPath = c, An(n, r, y.children, -1), r.keyPath = Jt;
            return;
          case Mi:
            if (y.mode !== "hidden") {
              var Vt = r.keyPath;
              r.keyPath = c, An(n, r, y.children, -1), r.keyPath = Vt;
            }
            return;
          case Rl:
            var ut = r.keyPath;
            r.keyPath = c, An(n, r, y.children, -1), r.keyPath = ut;
            return;
          case Ka:
          case Rt:
            throw Error(
              "ReactDOMServer does not yet support scope components."
            );
          case Kr:
            e:
              if (r.replay !== null) {
                var Ml = r.keyPath;
                r.keyPath = c;
                var pr = y.children;
                try {
                  wt(n, r, pr, -1);
                } finally {
                  r.keyPath = Ml;
                }
              } else {
                var Il = r.keyPath, ho = r.blockedBoundary, Dl = r.blockedPreamble, Ma = r.hoistableState, Br = r.blockedSegment, go = y.fallback, Kt = y.children, st = /* @__PURE__ */ new Set(), Hn = r.formatContext.insertionMode < se ? Yl(
                  n,
                  st,
                  je(),
                  je()
                ) : Yl(
                  n,
                  st,
                  null,
                  null
                );
                n.trackedPostpones !== null && (Hn.trackedContentKeyPath = c);
                var fr = aa(
                  n,
                  Br.chunks.length,
                  Hn,
                  r.formatContext,
                  !1,
                  !1
                );
                Br.children.push(fr), Br.lastPushedText = !1;
                var Nr = aa(
                  n,
                  0,
                  null,
                  r.formatContext,
                  !1,
                  !1
                );
                if (Nr.parentFlushed = !0, n.trackedPostpones !== null) {
                  var Ia = [
                    c[0],
                    "Suspense Fallback",
                    c[2]
                  ], Ur = [
                    Ia[1],
                    Ia[2],
                    [],
                    null
                  ];
                  n.trackedPostpones.workingMap.set(
                    Ia,
                    Ur
                  ), Hn.trackedFallbackNode = Ur, r.blockedSegment = fr, r.blockedPreamble = Hn.fallbackPreamble, r.keyPath = Ia, fr.status = 6;
                  try {
                    wt(n, r, go, -1), Mo(
                      fr.chunks,
                      n.renderState,
                      fr.lastPushedText,
                      fr.textEmbedded
                    ), fr.status = xn;
                  } catch (Or) {
                    throw fr.status = n.status === 12 ? 3 : 4, Or;
                  } finally {
                    r.blockedSegment = Br, r.blockedPreamble = Dl, r.keyPath = Il;
                  }
                  var Ll = ia(
                    n,
                    null,
                    Kt,
                    -1,
                    Hn,
                    Nr,
                    Hn.contentPreamble,
                    Hn.contentState,
                    r.abortSet,
                    c,
                    r.formatContext,
                    r.context,
                    r.treeContext,
                    r.componentStack,
                    r.isFallback,
                    ot,
                    r.debugTask
                  );
                  oa(Ll), n.pingedTasks.push(Ll);
                } else {
                  r.blockedBoundary = Hn, r.blockedPreamble = Hn.contentPreamble, r.hoistableState = Hn.contentState, r.blockedSegment = Nr, r.keyPath = c, Nr.status = 6;
                  try {
                    if (wt(n, r, Kt, -1), Mo(
                      Nr.chunks,
                      n.renderState,
                      Nr.lastPushedText,
                      Nr.textEmbedded
                    ), Nr.status = xn, wl(Hn, Nr), Hn.pendingTasks === 0 && Hn.status === Ar) {
                      Hn.status = xn, n.pendingRootTasks === 0 && r.blockedPreamble && tr(n);
                      break e;
                    }
                  } catch (Or) {
                    if (Hn.status = _n, n.status === 12) {
                      Nr.status = 3;
                      var mr = n.fatalError;
                    } else
                      Nr.status = 4, mr = Or;
                    var Qc = Gl(r.componentStack), nt = yt(
                      n,
                      mr,
                      Qc,
                      r.debugTask
                    );
                    gl(
                      Hn,
                      nt,
                      mr,
                      Qc,
                      !1
                    ), Xt(n, Hn);
                  } finally {
                    r.blockedBoundary = ho, r.blockedPreamble = Dl, r.hoistableState = Ma, r.blockedSegment = Br, r.keyPath = Il;
                  }
                  var hr = ia(
                    n,
                    null,
                    go,
                    -1,
                    ho,
                    fr,
                    Hn.fallbackPreamble,
                    Hn.fallbackState,
                    st,
                    [c[0], "Suspense Fallback", c[2]],
                    r.formatContext,
                    r.context,
                    r.treeContext,
                    r.componentStack,
                    !0,
                    ot,
                    r.debugTask
                  );
                  oa(hr), n.pingedTasks.push(hr);
                }
              }
            return;
        }
        if (typeof d == "object" && d !== null)
          switch (d.$$typeof) {
            case Oi:
              if ("ref" in y) {
                var ai = {};
                for (var oi in y)
                  oi !== "ref" && (ai[oi] = y[oi]);
              } else
                ai = y;
              var _l = lu(
                n,
                r,
                c,
                d.render,
                ai,
                R
              );
              Er(
                n,
                r,
                c,
                _l,
                Xn !== 0,
                Pa,
                Sl
              );
              return;
            case No:
              Xl(n, r, c, d.type, y, R);
              return;
            case ha:
            case pi:
              var Da = y.value, al = y.children, Qi = r.context, Ji = r.keyPath, Vi = d._currentValue2;
              d._currentValue2 = Da, d._currentRenderer2 !== void 0 && d._currentRenderer2 !== null && d._currentRenderer2 !== Zt && console.error(
                "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
              ), d._currentRenderer2 = Zt;
              var Ki = ln, Yr = {
                parent: Ki,
                depth: Ki === null ? 0 : Ki.depth + 1,
                context: d,
                parentValue: Vi,
                value: Da
              };
              ln = Yr, r.context = Yr, r.keyPath = c, An(n, r, al, -1);
              var Hl = ln;
              if (Hl === null)
                throw Error(
                  "Tried to pop a Context at the root of the app. This is a bug in React."
                );
              Hl.context !== d && console.error(
                "The parent context is not the expected context. This is probably a bug in React."
              ), Hl.context._currentValue2 = Hl.parentValue, d._currentRenderer2 !== void 0 && d._currentRenderer2 !== null && d._currentRenderer2 !== Zt && console.error(
                "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
              ), d._currentRenderer2 = Zt;
              var Jc = ln = Hl.parent;
              r.context = Jc, r.keyPath = Ji, Qi !== r.context && console.error(
                "Popping the context provider did not return back to the original snapshot. This is a bug in React."
              );
              return;
            case da:
              var ol = d._context, vo = y.children;
              typeof vo != "function" && console.error(
                "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
              );
              var bo = vo(ol._currentValue2), Tu = r.keyPath;
              r.keyPath = c, An(n, r, bo, -1), r.keyPath = Tu;
              return;
            case ga:
              var ci = pa(d);
              if (n.status === 12)
                throw null;
              Xl(n, r, c, ci, y, R);
              return;
          }
        var Vc = "";
        throw (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (Vc += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), Error(
          "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + ((d == null ? d : typeof d) + "." + Vc)
        );
      }
    }
    function Za(n, r, c, d, y) {
      var R = r.replay, p = r.blockedBoundary, M = aa(
        n,
        0,
        null,
        r.formatContext,
        !1,
        !1
      );
      M.id = c, M.parentFlushed = !0;
      try {
        r.replay = null, r.blockedSegment = M, wt(n, r, d, y), M.status = xn, p === null ? n.completedRootSegment = M : (wl(p, M), p.parentFlushed && n.partialBoundaries.push(p));
      } finally {
        r.replay = R, r.blockedSegment = null;
      }
    }
    function bl(n, r, c, d, y, R, p, M, N, I) {
      R = I.nodes;
      for (var te = 0; te < R.length; te++) {
        var K = R[te];
        if (y === K[1]) {
          if (K.length === 4) {
            if (d !== null && d !== K[0])
              throw Error(
                "Expected the resume to render <" + K[0] + "> in this slot but instead it rendered <" + d + ">. The tree doesn't match so React will fallback to client rendering."
              );
            var le = K[2];
            K = K[3], d = r.node, r.replay = { nodes: le, slots: K, pendingTasks: 1 };
            try {
              if (Xl(n, r, c, p, M, N), r.replay.pendingTasks === 1 && 0 < r.replay.nodes.length)
                throw Error(
                  "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                );
              r.replay.pendingTasks--;
            } catch (be) {
              if (typeof be == "object" && be !== null && (be === Pl || typeof be.then == "function"))
                throw r.node === d && (r.replay = I), be;
              r.replay.pendingTasks--, p = Gl(r.componentStack), M = n, n = r.blockedBoundary, c = be, N = K, K = yt(M, c, p, r.debugTask), Qe(
                M,
                n,
                le,
                N,
                c,
                K,
                p,
                !1
              );
            }
            r.replay = I;
          } else {
            if (p !== Kr)
              throw Error(
                "Expected the resume to render <Suspense> in this slot but instead it rendered <" + (on(p) || "Unknown") + ">. The tree doesn't match so React will fallback to client rendering."
              );
            e: {
              I = void 0, p = K[5], N = K[2], d = K[3], y = K[4] === null ? [] : K[4][2], K = K[4] === null ? null : K[4][3];
              var ie = r.keyPath, G = r.replay, we = r.blockedBoundary, Le = r.hoistableState, Te = M.children, Fe = M.fallback, kn = /* @__PURE__ */ new Set();
              M = r.formatContext.insertionMode < se ? Yl(
                n,
                kn,
                je(),
                je()
              ) : Yl(
                n,
                kn,
                null,
                null
              ), M.parentFlushed = !0, M.rootSegmentID = p, r.blockedBoundary = M, r.hoistableState = M.contentState, r.keyPath = c, r.replay = { nodes: N, slots: d, pendingTasks: 1 };
              try {
                if (wt(n, r, Te, -1), r.replay.pendingTasks === 1 && 0 < r.replay.nodes.length)
                  throw Error(
                    "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                  );
                if (r.replay.pendingTasks--, M.pendingTasks === 0 && M.status === Ar) {
                  M.status = xn, n.completedBoundaries.push(M);
                  break e;
                }
              } catch (be) {
                M.status = _n, le = Gl(r.componentStack), I = yt(
                  n,
                  be,
                  le,
                  r.debugTask
                ), gl(M, I, be, le, !1), r.replay.pendingTasks--, n.clientRenderedBoundaries.push(M);
              } finally {
                r.blockedBoundary = we, r.hoistableState = Le, r.replay = G, r.keyPath = ie;
              }
              M = Do(
                n,
                null,
                { nodes: y, slots: K, pendingTasks: 0 },
                Fe,
                -1,
                we,
                M.fallbackState,
                kn,
                [c[0], "Suspense Fallback", c[2]],
                r.formatContext,
                r.context,
                r.treeContext,
                r.componentStack,
                !0,
                ot,
                r.debugTask
              ), oa(M), n.pingedTasks.push(M);
            }
          }
          R.splice(te, 1);
          break;
        }
      }
    }
    function An(n, r, c, d) {
      r.replay !== null && typeof r.replay.slots == "number" ? Za(n, r, r.replay.slots, c, d) : (r.node = c, r.childIndex = d, c = r.componentStack, d = r.debugTask, oa(r), ki(n, r), r.componentStack = c, r.debugTask = d);
    }
    function ki(n, r) {
      var c = r.node, d = r.childIndex;
      if (c !== null) {
        if (typeof c == "object") {
          switch (c.$$typeof) {
            case Si:
              var y = c.type, R = c.key;
              c = c.props;
              var p = c.ref;
              p = p !== void 0 ? p : null;
              var M = r.debugTask, N = on(y);
              R = R ?? (d === -1 ? 0 : d);
              var I = [r.keyPath, N, R];
              r.replay !== null ? M ? M.run(
                bl.bind(
                  null,
                  n,
                  r,
                  I,
                  N,
                  R,
                  d,
                  y,
                  c,
                  p,
                  r.replay
                )
              ) : bl(
                n,
                r,
                I,
                N,
                R,
                d,
                y,
                c,
                p,
                r.replay
              ) : M ? M.run(
                Xl.bind(
                  null,
                  n,
                  r,
                  I,
                  y,
                  c,
                  p
                )
              ) : Xl(n, r, I, y, c, p);
              return;
            case fa:
              throw Error(
                "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render."
              );
            case ga:
              if (c = pa(c), n.status === 12)
                throw null;
              An(n, r, c, d);
              return;
          }
          if (gn(c)) {
            Gt(n, r, c, d);
            return;
          }
          if (c === null || typeof c != "object" ? R = null : (y = jr && c[jr] || c["@@iterator"], R = typeof y == "function" ? y : null), R && (y = R.call(c))) {
            if (y === c ? (d !== -1 || r.componentStack === null || typeof r.componentStack.type != "function" || Object.prototype.toString.call(r.componentStack.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(y) !== "[object Generator]") && (Zc || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), Zc = !0) : c.entries !== R || uc || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), uc = !0), c = y.next(), !c.done) {
              R = [];
              do
                R.push(c.value), c = y.next();
              while (!c.done);
              Gt(n, r, R, d);
            }
            return;
          }
          if (typeof c.then == "function")
            return r.thenableState = null, An(
              n,
              r,
              Ga(c),
              d
            );
          if (c.$$typeof === pi)
            return An(
              n,
              r,
              c._currentValue2,
              d
            );
          throw n = Object.prototype.toString.call(c), Error(
            "Objects are not valid as a React child (found: " + (n === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : n) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        typeof c == "string" ? (r = r.blockedSegment, r !== null && (r.lastPushedText = Pc(
          r.chunks,
          c,
          n.renderState,
          r.lastPushedText
        ))) : typeof c == "number" || typeof c == "bigint" ? (r = r.blockedSegment, r !== null && (r.lastPushedText = Pc(
          r.chunks,
          "" + c,
          n.renderState,
          r.lastPushedText
        ))) : (typeof c == "function" && (n = c.displayName || c.name || "Component", console.error(
          "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.",
          n,
          n
        )), typeof c == "symbol" && console.error(
          `Symbols are not valid as a React child.
  %s`,
          String(c)
        ));
      }
    }
    function Gt(n, r, c, d) {
      var y = r.keyPath, R = r.componentStack, p = r.debugTask;
      if (xi(r, r.node._debugInfo), d !== -1 && (r.keyPath = [r.keyPath, "Fragment", d], r.replay !== null)) {
        for (var M = r.replay, N = M.nodes, I = 0; I < N.length; I++) {
          var te = N[I];
          if (te[1] === d) {
            d = te[2], te = te[3], r.replay = { nodes: d, slots: te, pendingTasks: 1 };
            try {
              if (Gt(n, r, c, -1), r.replay.pendingTasks === 1 && 0 < r.replay.nodes.length)
                throw Error(
                  "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                );
              r.replay.pendingTasks--;
            } catch (Te) {
              if (typeof Te == "object" && Te !== null && (Te === Pl || typeof Te.then == "function"))
                throw Te;
              r.replay.pendingTasks--;
              var K = Gl(r.componentStack);
              c = r.blockedBoundary;
              var le = Te, ie = te;
              te = yt(
                n,
                le,
                K,
                r.debugTask
              ), Qe(
                n,
                c,
                d,
                ie,
                le,
                te,
                K,
                !1
              );
            }
            r.replay = M, N.splice(I, 1);
            break;
          }
        }
        r.keyPath = y, r.componentStack = R, r.debugTask = p;
        return;
      }
      if (M = r.treeContext, N = c.length, r.replay !== null && (I = r.replay.slots, I !== null && typeof I == "object")) {
        for (d = 0; d < N; d++)
          te = c[d], r.treeContext = wi(
            M,
            N,
            d
          ), le = I[d], typeof le == "number" ? (Za(n, r, le, te, d), delete I[d]) : wt(n, r, te, d);
        r.treeContext = M, r.keyPath = y, r.componentStack = R, r.debugTask = p;
        return;
      }
      for (I = 0; I < N; I++) {
        if (d = c[I], ie = n, te = r, le = d, le !== null && typeof le == "object" && (le.$$typeof === Si || le.$$typeof === fa) && le._store && (!le._store.validated && le.key == null || le._store.validated === 2)) {
          if (typeof le._store != "object")
            throw Error(
              "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
            );
          if (le._store.validated = 1, K = ie.didWarnForKey, K == null && (K = ie.didWarnForKey = /* @__PURE__ */ new WeakSet()), ie = te.componentStack, ie !== null && !K.has(ie)) {
            K.add(ie);
            var G = on(le.type);
            K = le._owner;
            var we = ie.owner;
            if (ie = "", we && typeof we.type < "u") {
              var Le = on(we.type);
              Le && (ie = `

Check the render method of \`` + Le + "`.");
            }
            ie || G && (ie = `

Check the top-level render call using <` + G + ">."), G = "", K != null && we !== K && (we = null, typeof K.type < "u" ? we = on(K.type) : typeof K.name == "string" && (we = K.name), we && (G = " It was passed a child from " + we + ".")), K = te.componentStack, te.componentStack = {
              parent: te.componentStack,
              type: le.type,
              owner: le._owner,
              stack: le._debugStack
            }, console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              ie,
              G
            ), te.componentStack = K;
          }
        }
        r.treeContext = wi(M, N, I), wt(n, r, d, I);
      }
      r.treeContext = M, r.keyPath = y, r.componentStack = R, r.debugTask = p;
    }
    function Xt(n, r) {
      n = n.trackedPostpones, n !== null && (r = r.trackedContentKeyPath, r !== null && (r = n.workingMap.get(r), r !== void 0 && (r.length = 4, r[2] = [], r[3] = null)));
    }
    function Lo(n, r, c) {
      return Do(
        n,
        c,
        r.replay,
        r.node,
        r.childIndex,
        r.blockedBoundary,
        r.hoistableState,
        r.abortSet,
        r.keyPath,
        r.formatContext,
        r.context,
        r.treeContext,
        r.componentStack,
        r.isFallback,
        ot,
        r.debugTask
      );
    }
    function _o(n, r, c) {
      var d = r.blockedSegment, y = aa(
        n,
        d.chunks.length,
        null,
        r.formatContext,
        d.lastPushedText,
        !0
      );
      return d.children.push(y), d.lastPushedText = !1, ia(
        n,
        c,
        r.node,
        r.childIndex,
        r.blockedBoundary,
        y,
        r.blockedPreamble,
        r.hoistableState,
        r.abortSet,
        r.keyPath,
        r.formatContext,
        r.context,
        r.treeContext,
        r.componentStack,
        r.isFallback,
        ot,
        r.debugTask
      );
    }
    function wt(n, r, c, d) {
      var y = r.formatContext, R = r.context, p = r.keyPath, M = r.treeContext, N = r.componentStack, I = r.debugTask, te = r.blockedSegment;
      if (te === null)
        try {
          return An(n, r, c, d);
        } catch (ie) {
          if (fl(), c = ie === Pl ? Ya() : ie, typeof c == "object" && c !== null) {
            if (typeof c.then == "function") {
              d = ra(), n = Lo(
                n,
                r,
                d
              ).ping, c.then(n, n), r.formatContext = y, r.context = R, r.keyPath = p, r.treeContext = M, r.componentStack = N, r.debugTask = I, yr(R);
              return;
            }
            if (c.message === "Maximum call stack size exceeded") {
              c = ra(), c = Lo(n, r, c), n.pingedTasks.push(c), r.formatContext = y, r.context = R, r.keyPath = p, r.treeContext = M, r.componentStack = N, r.debugTask = I, yr(R);
              return;
            }
          }
        }
      else {
        var K = te.children.length, le = te.chunks.length;
        try {
          return An(n, r, c, d);
        } catch (ie) {
          if (fl(), te.children.length = K, te.chunks.length = le, c = ie === Pl ? Ya() : ie, typeof c == "object" && c !== null) {
            if (typeof c.then == "function") {
              d = ra(), n = _o(
                n,
                r,
                d
              ).ping, c.then(n, n), r.formatContext = y, r.context = R, r.keyPath = p, r.treeContext = M, r.componentStack = N, r.debugTask = I, yr(R);
              return;
            }
            if (c.message === "Maximum call stack size exceeded") {
              c = ra(), c = _o(n, r, c), n.pingedTasks.push(c), r.formatContext = y, r.context = R, r.keyPath = p, r.treeContext = M, r.componentStack = N, r.debugTask = I, yr(R);
              return;
            }
          }
        }
      }
      throw r.formatContext = y, r.context = R, r.keyPath = p, r.treeContext = M, yr(R), c;
    }
    function Qa(n) {
      var r = n.blockedBoundary;
      n = n.blockedSegment, n !== null && (n.status = 3, ca(this, r, n));
    }
    function Qe(n, r, c, d, y, R, p, M) {
      for (var N = 0; N < c.length; N++) {
        var I = c[N];
        if (I.length === 4)
          Qe(
            n,
            r,
            I[2],
            I[3],
            y,
            R,
            p,
            M
          );
        else {
          var te = n;
          I = I[5];
          var K = y, le = R, ie = p, G = M, we = Yl(
            te,
            /* @__PURE__ */ new Set(),
            null,
            null
          );
          we.parentFlushed = !0, we.rootSegmentID = I, we.status = _n, gl(
            we,
            le,
            K,
            ie,
            G
          ), we.parentFlushed && te.clientRenderedBoundaries.push(we);
        }
      }
      if (c.length = 0, d !== null) {
        if (r === null)
          throw Error(
            "We should not have any resumable nodes in the shell. This is a bug in React."
          );
        if (r.status !== _n && (r.status = _n, gl(
          r,
          R,
          y,
          p,
          M
        ), r.parentFlushed && n.clientRenderedBoundaries.push(r)), typeof d == "object")
          for (var Le in d)
            delete d[Le];
      }
    }
    function Tt(n, r, c) {
      var d = n.blockedBoundary, y = n.blockedSegment;
      if (y !== null) {
        if (y.status === 6)
          return;
        y.status = 3;
      }
      if (y = Gl(n.componentStack), d === null) {
        if (r.status !== 13 && r.status !== Zi) {
          if (d = n.replay, d === null) {
            yt(r, c, y, null), vl(r, c, y, null);
            return;
          }
          d.pendingTasks--, d.pendingTasks === 0 && 0 < d.nodes.length && (n = yt(r, c, y, null), Qe(
            r,
            null,
            d.nodes,
            d.slots,
            c,
            n,
            y,
            !0
          )), r.pendingRootTasks--, r.pendingRootTasks === 0 && Zl(r);
        }
      } else
        d.pendingTasks--, d.status !== _n && (d.status = _n, n = yt(r, c, y, null), d.status = _n, gl(d, n, c, y, !0), Xt(r, d), d.parentFlushed && r.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(R) {
          return Tt(R, r, c);
        }), d.fallbackAbortableTasks.clear();
      r.allPendingTasks--, r.allPendingTasks === 0 && yl(r);
    }
    function Ci(n, r) {
      try {
        var c = n.renderState, d = c.onHeaders;
        if (d) {
          var y = c.headers;
          if (y) {
            c.headers = null;
            var R = y.preconnects;
            if (y.fontPreloads && (R && (R += ", "), R += y.fontPreloads), y.highImagePreloads && (R && (R += ", "), R += y.highImagePreloads), !r) {
              var p = c.styles.values(), M = p.next();
              e:
                for (; 0 < y.remainingCapacity && !M.done; M = p.next())
                  for (var N = M.value.sheets.values(), I = N.next(); 0 < y.remainingCapacity && !I.done; I = N.next()) {
                    var te = I.value, K = te.props, le = K.href, ie = te.props, G = ea(
                      ie.href,
                      "style",
                      {
                        crossOrigin: ie.crossOrigin,
                        integrity: ie.integrity,
                        nonce: ie.nonce,
                        type: ie.type,
                        fetchPriority: ie.fetchPriority,
                        referrerPolicy: ie.referrerPolicy,
                        media: ie.media
                      }
                    );
                    if (0 <= (y.remainingCapacity -= G.length + 2))
                      c.resets.style[le] = H, R && (R += ", "), R += G, c.resets.style[le] = typeof K.crossOrigin == "string" || typeof K.integrity == "string" ? [K.crossOrigin, K.integrity] : H;
                    else
                      break e;
                  }
            }
            d(R ? { Link: R } : {});
          }
        }
      } catch (we) {
        yt(n, we, {}, null);
      }
    }
    function Zl(n) {
      n.trackedPostpones === null && Ci(n, !0), n.trackedPostpones === null && tr(n), n.onShellError = It, n = n.onShellReady, n();
    }
    function yl(n) {
      Ci(
        n,
        n.trackedPostpones === null ? !0 : n.completedRootSegment === null || n.completedRootSegment.status !== oc
      ), tr(n), n = n.onAllReady, n();
    }
    function wl(n, r) {
      if (r.chunks.length === 0 && r.children.length === 1 && r.children[0].boundary === null && r.children[0].id === -1) {
        var c = r.children[0];
        c.id = r.id, c.parentFlushed = !0, c.status === xn && wl(n, c);
      } else
        n.completedSegments.push(r);
    }
    function ca(n, r, c) {
      if (r === null) {
        if (c !== null && c.parentFlushed) {
          if (n.completedRootSegment !== null)
            throw Error(
              "There can only be one root segment. This is a bug in React."
            );
          n.completedRootSegment = c;
        }
        n.pendingRootTasks--, n.pendingRootTasks === 0 && Zl(n);
      } else
        r.pendingTasks--, r.status !== _n && (r.pendingTasks === 0 ? (r.status === Ar && (r.status = xn), c !== null && c.parentFlushed && c.status === xn && wl(r, c), r.parentFlushed && n.completedBoundaries.push(r), r.status === xn && (r.fallbackAbortableTasks.forEach(
          Qa,
          n
        ), r.fallbackAbortableTasks.clear(), n.pendingRootTasks === 0 && n.trackedPostpones === null && r.contentPreamble !== null && tr(n))) : c !== null && c.parentFlushed && c.status === xn && (wl(r, c), r.completedSegments.length === 1 && r.parentFlushed && n.partialBoundaries.push(r)));
      n.allPendingTasks--, n.allPendingTasks === 0 && yl(n);
    }
    function Et(n) {
      if (n.status !== Zi && n.status !== 13) {
        var r = ln, c = Lt.H;
        Lt.H = tc;
        var d = Lt.A;
        Lt.A = Lu;
        var y = fn;
        fn = n;
        var R = Lt.getCurrentStack;
        Lt.getCurrentStack = Tr;
        var p = Fl;
        Fl = n.resumableState;
        try {
          var M = n.pingedTasks, N;
          for (N = 0; N < M.length; N++) {
            var I = n, te = M[N], K = te.blockedSegment;
            if (K === null) {
              var le = void 0, ie = I;
              if (I = te, I.replay.pendingTasks !== 0) {
                yr(I.context), le = Wr, Wr = I;
                try {
                  if (typeof I.replay.slots == "number" ? Za(
                    ie,
                    I,
                    I.replay.slots,
                    I.node,
                    I.childIndex
                  ) : ki(ie, I), I.replay.pendingTasks === 1 && 0 < I.replay.nodes.length)
                    throw Error(
                      "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                    );
                  I.replay.pendingTasks--, I.abortSet.delete(I), ca(ie, I.blockedBoundary, null);
                } catch (t) {
                  fl();
                  var G = t === Pl ? Ya() : t;
                  if (typeof G == "object" && G !== null && typeof G.then == "function") {
                    var we = I.ping;
                    G.then(we, we), I.thenableState = ra();
                  } else {
                    I.replay.pendingTasks--, I.abortSet.delete(I);
                    var Le = Gl(I.componentStack), Te = void 0, Fe = ie, kn = I.blockedBoundary, be = ie.status === 12 ? ie.fatalError : G, Ue = Le, Ze = I.replay.nodes, At = I.replay.slots;
                    Te = yt(
                      Fe,
                      be,
                      Ue,
                      I.debugTask
                    ), Qe(
                      Fe,
                      kn,
                      Ze,
                      At,
                      be,
                      Te,
                      Ue,
                      !1
                    ), ie.pendingRootTasks--, ie.pendingRootTasks === 0 && Zl(ie), ie.allPendingTasks--, ie.allPendingTasks === 0 && yl(ie);
                  }
                } finally {
                  Wr = le;
                }
              }
            } else if (ie = le = void 0, Te = te, Fe = K, Fe.status === Ar) {
              Fe.status = 6, yr(Te.context), ie = Wr, Wr = Te;
              var Zn = Fe.children.length, $n = Fe.chunks.length;
              try {
                ki(I, Te), Mo(
                  Fe.chunks,
                  I.renderState,
                  Fe.lastPushedText,
                  Fe.textEmbedded
                ), Te.abortSet.delete(Te), Fe.status = xn, ca(
                  I,
                  Te.blockedBoundary,
                  Fe
                );
              } catch (t) {
                fl(), Fe.children.length = Zn, Fe.chunks.length = $n;
                var Sn = t === Pl ? Ya() : I.status === 12 ? I.fatalError : t;
                if (typeof Sn == "object" && Sn !== null && typeof Sn.then == "function") {
                  Fe.status = Ar, Te.thenableState = ra();
                  var zr = Te.ping;
                  Sn.then(zr, zr);
                } else {
                  var Qt = Gl(
                    Te.componentStack
                  );
                  Te.abortSet.delete(Te), Fe.status = 4;
                  var qe = Te.blockedBoundary, e = Te.debugTask;
                  le = yt(
                    I,
                    Sn,
                    Qt,
                    e
                  ), qe === null ? vl(
                    I,
                    Sn,
                    Qt,
                    e
                  ) : (qe.pendingTasks--, qe.status !== _n && (qe.status = _n, gl(
                    qe,
                    le,
                    Sn,
                    Qt,
                    !1
                  ), Xt(I, qe), qe.parentFlushed && I.clientRenderedBoundaries.push(
                    qe
                  ), I.pendingRootTasks === 0 && I.trackedPostpones === null && qe.contentPreamble !== null && tr(I))), I.allPendingTasks--, I.allPendingTasks === 0 && yl(I);
                }
              } finally {
                Wr = ie;
              }
            }
          }
          M.splice(0, N), n.destination !== null && sa(
            n,
            n.destination
          );
        } catch (t) {
          M = {}, yt(n, t, M, null), vl(n, t, M, null);
        } finally {
          Fl = p, Lt.H = c, Lt.A = d, Lt.getCurrentStack = R, c === tc && yr(r), fn = y;
        }
      }
    }
    function Tl(n, r, c) {
      r.preambleChildren.length && c.push(r.preambleChildren);
      for (var d = !1, y = 0; y < r.children.length; y++)
        d = Ql(
          n,
          r.children[y],
          c
        ) || d;
      return d;
    }
    function Ql(n, r, c) {
      var d = r.boundary;
      if (d === null)
        return Tl(
          n,
          r,
          c
        );
      var y = d.contentPreamble, R = d.fallbackPreamble;
      if (y === null || R === null)
        return !1;
      switch (d.status) {
        case xn:
          if (Ec(n.renderState, y), r = d.completedSegments[0], !r)
            throw Error(
              "A previously unvisited boundary must have exactly one root segment. This is a bug in React."
            );
          return Tl(
            n,
            r,
            c
          );
        case oc:
          if (n.trackedPostpones !== null)
            return !0;
        case _n:
          if (r.status === xn)
            return Ec(n.renderState, R), Tl(
              n,
              r,
              c
            );
        default:
          return !0;
      }
    }
    function tr(n) {
      if (n.completedRootSegment && n.completedPreambleSegments === null) {
        var r = [], c = Ql(
          n,
          n.completedRootSegment,
          r
        ), d = n.renderState.preamble;
        (c === !1 || d.headChunks && d.bodyChunks) && (n.completedPreambleSegments = r);
      }
    }
    function ua(n, r, c, d) {
      switch (c.parentFlushed = !0, c.status) {
        case Ar:
          c.id = n.nextSegmentId++;
        case oc:
          return d = c.id, c.lastPushedText = !1, c.textEmbedded = !1, n = n.renderState, r.push(va), r.push(n.placeholderPrefix), n = d.toString(16), r.push(n), r.push(su);
        case xn:
          c.status = Oa;
          var y = !0, R = c.chunks, p = 0;
          c = c.children;
          for (var M = 0; M < c.length; M++) {
            for (y = c[M]; p < y.index; p++)
              r.push(R[p]);
            y = Jl(n, r, y, d);
          }
          for (; p < R.length - 1; p++)
            r.push(R[p]);
          return p < R.length && (y = r.push(R[p])), y;
        default:
          throw Error(
            "Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React."
          );
      }
    }
    function Jl(n, r, c, d) {
      var y = c.boundary;
      if (y === null)
        return ua(n, r, c, d);
      if (y.parentFlushed = !0, y.status === _n) {
        if (!n.renderState.generateStaticMarkup) {
          var R = y.errorDigest, p = y.errorMessage, M = y.errorStack, N = y.errorComponentStack;
          r.push(Zo), r.push(_i), R && (r.push(_r), R = xe(R), r.push(R), r.push(
            En
          )), p && (r.push(no), p = xe(p), r.push(p), r.push(
            En
          )), M && (r.push(ll), M = xe(M), r.push(M), r.push(
            En
          )), N && (r.push(to), N = xe(N), r.push(N), r.push(
            En
          )), r.push(ba);
        }
        return ua(n, r, c, d), n.renderState.generateStaticMarkup ? r = !0 : ((n = y.fallbackPreamble) && gr(r, n), r = r.push(rl)), r;
      }
      if (y.status !== xn)
        return y.status === Ar && (y.rootSegmentID = n.nextSegmentId++), 0 < y.completedSegments.length && n.partialBoundaries.push(y), Cn(
          r,
          n.renderState,
          y.rootSegmentID
        ), d && (y = y.fallbackState, y.styles.forEach(Qr, d), y.stylesheets.forEach(
          Cc,
          d
        )), ua(n, r, c, d), r.push(rl);
      if (y.byteSize > n.progressiveChunkSize)
        return y.rootSegmentID = n.nextSegmentId++, n.completedBoundaries.push(y), Cn(
          r,
          n.renderState,
          y.rootSegmentID
        ), ua(n, r, c, d), r.push(rl);
      if (d && (c = y.contentState, c.styles.forEach(Qr, d), c.stylesheets.forEach(Cc, d)), n.renderState.generateStaticMarkup || r.push(qn), c = y.completedSegments, c.length !== 1)
        throw Error(
          "A previously unvisited boundary must have exactly one root segment. This is a bug in React."
        );
      return Jl(n, r, c[0], d), n.renderState.generateStaticMarkup ? r = !0 : ((n = y.contentPreamble) && gr(r, n), r = r.push(rl)), r;
    }
    function Vr(n, r, c, d) {
      return Fo(
        r,
        n.renderState,
        c.parentFormatContext,
        c.id
      ), Jl(n, r, c, d), Ao(r, c.parentFormatContext);
    }
    function El(n, r, c) {
      for (var d = c.completedSegments, y = 0; y < d.length; y++)
        Ho(
          n,
          r,
          c,
          d[y]
        );
      d.length = 0, gi(
        r,
        c.contentState,
        n.renderState
      ), d = n.resumableState, n = n.renderState, y = c.rootSegmentID, c = c.contentState;
      var R = n.stylesToHoist;
      return n.stylesToHoist = !1, r.push(n.startInlineScript), R ? (d.instructions & g) === o ? (d.instructions = d.instructions | x | g, r.push(jo)) : (d.instructions & x) === o ? (d.instructions |= x, r.push(Wc)) : r.push(zc) : (d.instructions & g) === o ? (d.instructions |= g, r.push(qo)) : r.push(Bi), d = y.toString(16), r.push(n.boundaryPrefix), r.push(d), r.push($o), r.push(n.segmentPrefix), r.push(d), R ? (r.push(il), kc(r, c)) : r.push(ei), c = r.push(io), tt(r, n) && c;
    }
    function Ho(n, r, c, d) {
      if (d.status === Oa)
        return !0;
      var y = c.contentState, R = d.id;
      if (R === -1) {
        if ((d.id = c.rootSegmentID) === -1)
          throw Error(
            "A root segment ID must have been assigned by now. This is a bug in React."
          );
        return Vr(
          n,
          r,
          d,
          y
        );
      }
      return R === c.rootSegmentID ? Vr(
        n,
        r,
        d,
        y
      ) : (Vr(n, r, d, y), c = n.resumableState, n = n.renderState, r.push(n.startInlineScript), (c.instructions & f) === o ? (c.instructions |= f, r.push(Cl)) : r.push(hu), r.push(n.segmentPrefix), R = R.toString(16), r.push(R), r.push($l), r.push(n.placeholderPrefix), r.push(R), r = r.push(lo), r);
    }
    function sa(n, r) {
      try {
        if (!(0 < n.pendingRootTasks)) {
          var c, d = n.completedRootSegment;
          if (d !== null) {
            if (d.status === oc)
              return;
            var y = n.completedPreambleSegments;
            if (y === null)
              return;
            var R = n.renderState, p = R.preamble, M = p.htmlChunks, N = p.headChunks, I;
            if (M) {
              for (I = 0; I < M.length; I++)
                r.push(M[I]);
              if (N)
                for (I = 0; I < N.length; I++)
                  r.push(N[I]);
              else {
                var te = Ae("head");
                r.push(te), r.push(tn);
              }
            } else if (N)
              for (I = 0; I < N.length; I++)
                r.push(N[I]);
            var K = R.charsetChunks;
            for (I = 0; I < K.length; I++)
              r.push(K[I]);
            K.length = 0, R.preconnects.forEach(vr, r), R.preconnects.clear();
            var le = R.viewportChunks;
            for (I = 0; I < le.length; I++)
              r.push(le[I]);
            le.length = 0, R.fontPreloads.forEach(vr, r), R.fontPreloads.clear(), R.highImagePreloads.forEach(vr, r), R.highImagePreloads.clear(), R.styles.forEach(Rc, r);
            var ie = R.importMapChunks;
            for (I = 0; I < ie.length; I++)
              r.push(ie[I]);
            ie.length = 0, R.bootstrapScripts.forEach(vr, r), R.scripts.forEach(vr, r), R.scripts.clear(), R.bulkPreloads.forEach(vr, r), R.bulkPreloads.clear();
            var G = R.hoistableChunks;
            for (I = 0; I < G.length; I++)
              r.push(G[I]);
            for (R = G.length = 0; R < y.length; R++) {
              var we = y[R];
              for (p = 0; p < we.length; p++)
                Jl(n, r, we[p], null);
            }
            var Le = n.renderState.preamble, Te = Le.headChunks;
            if (Le.htmlChunks || Te) {
              var Fe = di("head");
              r.push(Fe);
            }
            var kn = Le.bodyChunks;
            if (kn)
              for (y = 0; y < kn.length; y++)
                r.push(kn[y]);
            Jl(n, r, d, null), n.completedRootSegment = null, tt(r, n.renderState);
          }
          var be = n.renderState;
          d = 0;
          var Ue = be.viewportChunks;
          for (d = 0; d < Ue.length; d++)
            r.push(Ue[d]);
          Ue.length = 0, be.preconnects.forEach(vr, r), be.preconnects.clear(), be.fontPreloads.forEach(vr, r), be.fontPreloads.clear(), be.highImagePreloads.forEach(
            vr,
            r
          ), be.highImagePreloads.clear(), be.styles.forEach($i, r), be.scripts.forEach(vr, r), be.scripts.clear(), be.bulkPreloads.forEach(vr, r), be.bulkPreloads.clear();
          var Ze = be.hoistableChunks;
          for (d = 0; d < Ze.length; d++)
            r.push(Ze[d]);
          Ze.length = 0;
          var At = n.clientRenderedBoundaries;
          for (c = 0; c < At.length; c++) {
            var Zn = At[c];
            be = r;
            var $n = n.resumableState, Sn = n.renderState, zr = Zn.rootSegmentID, Qt = Zn.errorDigest, qe = Zn.errorMessage, e = Zn.errorStack, t = Zn.errorComponentStack;
            be.push(Sn.startInlineScript), ($n.instructions & T) === o ? ($n.instructions |= T, be.push(Ea)) : be.push(ec), be.push(Sn.boundaryPrefix);
            var u = zr.toString(16);
            if (be.push(u), be.push(ao), Qt || qe || e || t) {
              be.push(Ni);
              var h = Yt(
                Qt || ""
              );
              be.push(h);
            }
            if (qe || e || t) {
              be.push(Ni);
              var b = Yt(
                qe || ""
              );
              be.push(b);
            }
            if (e || t) {
              be.push(Ni);
              var E = Yt(
                e || ""
              );
              be.push(E);
            }
            if (t) {
              be.push(Ni);
              var S = Yt(t);
              be.push(S);
            }
            var F = be.push(
              Ui
            );
            if (!F) {
              n.destination = null, c++, At.splice(0, c);
              return;
            }
          }
          At.splice(0, c);
          var W = n.completedBoundaries;
          for (c = 0; c < W.length; c++)
            if (!El(
              n,
              r,
              W[c]
            )) {
              n.destination = null, c++, W.splice(0, c);
              return;
            }
          W.splice(0, c);
          var O = n.partialBoundaries;
          for (c = 0; c < O.length; c++) {
            e: {
              At = n, Zn = r;
              var V = O[c], J = V.completedSegments;
              for (F = 0; F < J.length; F++)
                if (!Ho(
                  At,
                  Zn,
                  V,
                  J[F]
                )) {
                  F++, J.splice(0, F);
                  var re = !1;
                  break e;
                }
              J.splice(0, F), re = gi(
                Zn,
                V.contentState,
                At.renderState
              );
            }
            if (!re) {
              n.destination = null, c++, O.splice(0, c);
              return;
            }
          }
          O.splice(0, c);
          var ne = n.completedBoundaries;
          for (c = 0; c < ne.length; c++)
            if (!El(n, r, ne[c])) {
              n.destination = null, c++, ne.splice(0, c);
              return;
            }
          ne.splice(0, c);
        }
      } finally {
        n.allPendingTasks === 0 && n.pingedTasks.length === 0 && n.clientRenderedBoundaries.length === 0 && n.completedBoundaries.length === 0 && (n.flushScheduled = !1, c = n.resumableState, c.hasBody && (O = di("body"), r.push(O)), c.hasHtml && (c = di("html"), r.push(c)), n.abortableTasks.size !== 0 && console.error(
          "There was still abortable task at the root when we closed. This is a bug in React."
        ), n.status = Zi, r.push(null), n.destination = null);
      }
    }
    function Ac(n) {
      n.flushScheduled = n.destination !== null, Et(n), n.status === 10 && (n.status = 11), n.trackedPostpones === null && Ci(n, n.pendingRootTasks === 0);
    }
    function Pi(n) {
      if (n.flushScheduled === !1 && n.pingedTasks.length === 0 && n.destination !== null) {
        n.flushScheduled = !0;
        var r = n.destination;
        r ? sa(n, r) : n.flushScheduled = !1;
      }
    }
    function Wo(n, r) {
      if (n.status === 13)
        n.status = Zi, r.destroy(n.fatalError);
      else if (n.status !== Zi && n.destination === null) {
        n.destination = r;
        try {
          sa(n, r);
        } catch (c) {
          r = {}, yt(n, c, r, null), vl(n, c, r, null);
        }
      }
    }
    function pc(n, r) {
      (n.status === 11 || n.status === 10) && (n.status = 12);
      try {
        var c = n.abortableTasks;
        if (0 < c.size) {
          var d = r === void 0 ? Error("The render was aborted by the server without a reason.") : typeof r == "object" && r !== null && typeof r.then == "function" ? Error("The render was aborted by the server with a promise.") : r;
          n.fatalError = d, c.forEach(function(y) {
            return Tt(y, n, d);
          }), c.clear();
        }
        n.destination !== null && sa(n, n.destination);
      } catch (y) {
        r = {}, yt(n, y, r, null), vl(n, y, r, null);
      }
    }
    function Ja() {
    }
    function zo(n, r, c, d) {
      var y = !1, R = null, p = "", M = !1;
      if (r = mt(
        r ? r.identifierPrefix : void 0
      ), n = Ri(
        n,
        r,
        eu(r, c),
        Mt($, null, 0),
        1 / 0,
        Ja,
        void 0,
        function() {
          M = !0;
        },
        void 0,
        void 0,
        void 0
      ), Ac(n), pc(n, d), Wo(n, {
        push: function(N) {
          return N !== null && (p += N), !0;
        },
        destroy: function(N) {
          y = !0, R = N;
        }
      }), y && R !== d)
        throw R;
      if (!M)
        throw Error(
          "A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."
        );
      return p;
    }
    var iu = bs, Va = ys, Si = Symbol.for("react.transitional.element"), fa = Symbol.for("react.portal"), Fi = Symbol.for("react.fragment"), Bo = Symbol.for("react.strict_mode"), Ai = Symbol.for("react.profiler"), ha = Symbol.for("react.provider"), da = Symbol.for("react.consumer"), pi = Symbol.for("react.context"), Oi = Symbol.for("react.forward_ref"), Kr = Symbol.for("react.suspense"), Rl = Symbol.for("react.suspense_list"), No = Symbol.for("react.memo"), ga = Symbol.for("react.lazy"), Rt = Symbol.for("react.scope"), Mi = Symbol.for("react.activity"), qr = Symbol.for("react.legacy_hidden"), Ii = Symbol.for("react.memo_cache_sentinel"), Ka = Symbol.for("react.view_transition"), jr = Symbol.iterator, gn = Array.isArray, Un = /* @__PURE__ */ new WeakMap(), rr = /* @__PURE__ */ new WeakMap(), Di = Symbol.for("react.client.reference"), Pn = Object.assign, Ke = Object.prototype.hasOwnProperty, Oc = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Uo = {}, Vn = {}, Mc = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), Ic = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), qa = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, mo = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, xl = {}, Rr = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Au = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), it = !1, Dt = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, at = {}, yn = /^on./, Je = /^on[^A-Z]/, Yo = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Dc = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), au = /^(?:webkit|moz|o)[A-Z]/, ou = /^-ms-/, ja = /-(.)/g, Vl = /;\s*$/, Ir = {}, lr = {}, $a = !1, Go = !1, Lc = /["'&<>]/, eo = /([A-Z])/g, pn = /^ms-/, pu = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, Lt = iu.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, cu = Va.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Li = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), i = cu.d;
    cu.d = {
      f: i.f,
      r: i.r,
      D: function(n) {
        var r = fn || null;
        if (r) {
          var c = r.resumableState, d = r.renderState;
          if (typeof n == "string" && n) {
            if (!c.dnsResources.hasOwnProperty(n)) {
              c.dnsResources[n] = C, c = d.headers;
              var y, R;
              (R = c && 0 < c.remainingCapacity) && (R = (y = "<" + me(n) + ">; rel=dns-prefetch", 0 <= (c.remainingCapacity -= y.length + 2))), R ? (d.resets.dns[n] = C, c.preconnects && (c.preconnects += ", "), c.preconnects += y) : (y = [], Ie(y, { href: n, rel: "dns-prefetch" }), d.preconnects.add(y));
            }
            Pi(r);
          }
        } else
          i.D(n);
      },
      C: function(n, r) {
        var c = fn || null;
        if (c) {
          var d = c.resumableState, y = c.renderState;
          if (typeof n == "string" && n) {
            var R = r === "use-credentials" ? "credentials" : typeof r == "string" ? "anonymous" : "default";
            if (!d.connectResources[R].hasOwnProperty(n)) {
              d.connectResources[R][n] = C, d = y.headers;
              var p, M;
              if (M = d && 0 < d.remainingCapacity) {
                if (M = "<" + me(n) + ">; rel=preconnect", typeof r == "string") {
                  var N = Oo(
                    r,
                    "crossOrigin"
                  );
                  M += '; crossorigin="' + N + '"';
                }
                M = (p = M, 0 <= (d.remainingCapacity -= p.length + 2));
              }
              M ? (y.resets.connect[R][n] = C, d.preconnects && (d.preconnects += ", "), d.preconnects += p) : (R = [], Ie(R, {
                rel: "preconnect",
                href: n,
                crossOrigin: r
              }), y.preconnects.add(R));
            }
            Pi(c);
          }
        } else
          i.C(n, r);
      },
      L: function(n, r, c) {
        var d = fn || null;
        if (d) {
          var y = d.resumableState, R = d.renderState;
          if (r && n) {
            switch (r) {
              case "image":
                if (c)
                  var p = c.imageSrcSet, M = c.imageSizes, N = c.fetchPriority;
                var I = p ? p + `
` + (M || "") : n;
                if (y.imageResources.hasOwnProperty(I))
                  return;
                y.imageResources[I] = H, y = R.headers;
                var te;
                y && 0 < y.remainingCapacity && typeof p != "string" && N === "high" && (te = ea(n, r, c), 0 <= (y.remainingCapacity -= te.length + 2)) ? (R.resets.image[I] = H, y.highImagePreloads && (y.highImagePreloads += ", "), y.highImagePreloads += te) : (y = [], Ie(
                  y,
                  Pn(
                    {
                      rel: "preload",
                      href: p ? void 0 : n,
                      as: r
                    },
                    c
                  )
                ), N === "high" ? R.highImagePreloads.add(y) : (R.bulkPreloads.add(y), R.preloads.images.set(I, y)));
                break;
              case "style":
                if (y.styleResources.hasOwnProperty(n))
                  return;
                p = [], Ie(
                  p,
                  Pn({ rel: "preload", href: n, as: r }, c)
                ), y.styleResources[n] = !c || typeof c.crossOrigin != "string" && typeof c.integrity != "string" ? H : [c.crossOrigin, c.integrity], R.preloads.stylesheets.set(n, p), R.bulkPreloads.add(p);
                break;
              case "script":
                if (y.scriptResources.hasOwnProperty(n))
                  return;
                p = [], R.preloads.scripts.set(n, p), R.bulkPreloads.add(p), Ie(
                  p,
                  Pn({ rel: "preload", href: n, as: r }, c)
                ), y.scriptResources[n] = !c || typeof c.crossOrigin != "string" && typeof c.integrity != "string" ? H : [c.crossOrigin, c.integrity];
                break;
              default:
                if (y.unknownResources.hasOwnProperty(r)) {
                  if (p = y.unknownResources[r], p.hasOwnProperty(n))
                    return;
                } else
                  p = {}, y.unknownResources[r] = p;
                if (p[n] = H, (y = R.headers) && 0 < y.remainingCapacity && r === "font" && (I = ea(n, r, c), 0 <= (y.remainingCapacity -= I.length + 2)))
                  R.resets.font[n] = H, y.fontPreloads && (y.fontPreloads += ", "), y.fontPreloads += I;
                else
                  switch (y = [], n = Pn(
                    { rel: "preload", href: n, as: r },
                    c
                  ), Ie(y, n), r) {
                    case "font":
                      R.fontPreloads.add(y);
                      break;
                    default:
                      R.bulkPreloads.add(y);
                  }
            }
            Pi(d);
          }
        } else
          i.L(n, r, c);
      },
      m: function(n, r) {
        var c = fn || null;
        if (c) {
          var d = c.resumableState, y = c.renderState;
          if (n) {
            var R = r && typeof r.as == "string" ? r.as : "script";
            switch (R) {
              case "script":
                if (d.moduleScriptResources.hasOwnProperty(n))
                  return;
                R = [], d.moduleScriptResources[n] = !r || typeof r.crossOrigin != "string" && typeof r.integrity != "string" ? H : [r.crossOrigin, r.integrity], y.preloads.moduleScripts.set(n, R);
                break;
              default:
                if (d.moduleUnknownResources.hasOwnProperty(R)) {
                  var p = d.unknownResources[R];
                  if (p.hasOwnProperty(n))
                    return;
                } else
                  p = {}, d.moduleUnknownResources[R] = p;
                R = [], p[n] = H;
            }
            Ie(
              R,
              Pn({ rel: "modulepreload", href: n }, r)
            ), y.bulkPreloads.add(R), Pi(c);
          }
        } else
          i.m(n, r);
      },
      X: function(n, r) {
        var c = fn || null;
        if (c) {
          var d = c.resumableState, y = c.renderState;
          if (n) {
            var R = d.scriptResources.hasOwnProperty(
              n
            ) ? d.scriptResources[n] : void 0;
            R !== C && (d.scriptResources[n] = C, r = Pn({ src: n, async: !0 }, r), R && (R.length === 2 && ma(r, R), n = y.preloads.scripts.get(n)) && (n.length = 0), n = [], y.scripts.add(n), hi(n, r), Pi(c));
          }
        } else
          i.X(n, r);
      },
      S: function(n, r, c) {
        var d = fn || null;
        if (d) {
          var y = d.resumableState, R = d.renderState;
          if (n) {
            r = r || "default";
            var p = R.styles.get(r), M = y.styleResources.hasOwnProperty(n) ? y.styleResources[n] : void 0;
            M !== C && (y.styleResources[n] = C, p || (p = {
              precedence: xe(r),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, R.styles.set(r, p)), r = {
              state: ye,
              props: Pn(
                {
                  rel: "stylesheet",
                  href: n,
                  "data-precedence": r
                },
                c
              )
            }, M && (M.length === 2 && ma(r.props, M), (R = R.preloads.stylesheets.get(n)) && 0 < R.length ? R.length = 0 : r.state = Se), p.sheets.set(n, r), Pi(d));
          }
        } else
          i.S(n, r, c);
      },
      M: function(n, r) {
        var c = fn || null;
        if (c) {
          var d = c.resumableState, y = c.renderState;
          if (n) {
            var R = d.moduleScriptResources.hasOwnProperty(n) ? d.moduleScriptResources[n] : void 0;
            R !== C && (d.moduleScriptResources[n] = C, r = Pn(
              { src: n, type: "module", async: !0 },
              r
            ), R && (R.length === 2 && ma(r, R), n = y.preloads.moduleScripts.get(n)) && (n.length = 0), n = [], y.scripts.add(n), hi(n, r), Pi(c));
          }
        } else
          i.M(n, r);
      }
    };
    var o = 0, f = 1, g = 2, T = 4, x = 8, C = null, H = [];
    Object.freeze(H);
    var L = /(<\/|<)(s)(cript)/gi, B = {}, oe = 0, $ = 0, ae = 1, se = 2, Ee = 3, he = 4, Ne = 5, Ve = 6, Ge = 7, cn = 8, de = 9, _e = /* @__PURE__ */ new Map(), Re = ' style="', Kn = ":", xt = ";", ve = " ", $e = '="', On = '"', mn = '=""', $r = xe(
      "javascript:throw new Error('React form unexpectedly submitted.')"
    ), tn = ">", Mn = "/>", _t = !1, kt = !1, el = !1, Ct = !1, Dr = !1, ir = !1, In = !1, xr = !1, ar = !1, nl = !1, Lr = !1, kr = `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`, _c = /(<\/|<)(s)(tyle)/gi, Kl = `
`, tl = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Xo = /* @__PURE__ */ new Map(), uu = /* @__PURE__ */ new Map(), va = '<template id="', su = '"></template>', qn = "<!--$-->", Ht = '<!--$?--><template id="', Tn = '"></template>', Zo = "<!--$!-->", rl = "<!--/$-->", _i = "<template", En = '"', _r = ' data-dgst="', no = ' data-msg="', ll = ' data-stck="', to = ' data-cstck="', ba = "></template>", ql = "<!--", Yn = "-->", Qo = '<div hidden id="', or = '">', ya = "</div>", Hi = '<svg aria-hidden="true" style="display:none" id="', kl = '">', Hr = "</svg>", Wi = '<math aria-hidden="true" style="display:none" id="', Pt = '">', jl = "</math>", fu = '<table hidden id="', Jo = '">', ro = "</table>", Hc = '<table hidden><tbody id="', jn = '">', wa = "</tbody></table>", Ta = '<table hidden><tr id="', zi = '">', Vo = "</tr></table>", Ko = '<table hidden><colgroup id="', Cr = '">', Ou = "</colgroup></table>", Cl = '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("', hu = '$RS("', $l = '","', lo = '")<\/script>', qo = '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("', Bi = '$RC("', jo = `$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`, Wc = `$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`, zc = '$RR("', $o = '","', il = '",', ei = '"', io = ")<\/script>", Ea = '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("', ec = '$RX("', ao = '"', Ni = ",", Ui = ")<\/script>", mi = /[<\u2028\u2029]/g, Ra = /[&><\u2028\u2029]/g, xa = '<style media="not all" data-precedence="', nc = '" data-href="', l = '">', a = "</style>", s = !1, v = !0, w = [], k = '<style data-precedence="', P = '" data-href="', _ = " ", A = '">', D = "</style>", ee = "[", Y = ",[", ue = ",", ge = "]", ye = 0, Se = 1, rn = 2, Dn = 3, Ye = /[<>\r\n]/g, Wt = /["';,\r\n]/g, Ln = "", cr = Function.prototype.bind, St = Symbol.for("react.client.reference"), ot = {};
    Object.freeze(ot);
    var Zt = {}, ln = null, Gn = {}, Rn = {}, Ft = /* @__PURE__ */ new Set(), ka = /* @__PURE__ */ new Set(), ni = /* @__PURE__ */ new Set(), ti = /* @__PURE__ */ new Set(), Ca = /* @__PURE__ */ new Set(), ri = /* @__PURE__ */ new Set(), du = /* @__PURE__ */ new Set(), Yi = /* @__PURE__ */ new Set(), mu = /* @__PURE__ */ new Set(), Yu = {
      enqueueSetState: function(n, r, c) {
        var d = n._reactInternals;
        d.queue === null ? dn(n, "setState") : (d.queue.push(r), c != null && Jn(c));
      },
      enqueueReplaceState: function(n, r, c) {
        n = n._reactInternals, n.replace = !0, n.queue = [r], c != null && Jn(c);
      },
      enqueueForceUpdate: function(n, r) {
        n._reactInternals.queue === null ? dn(n, "forceUpdate") : r != null && Jn(r);
      }
    }, Mu = { id: 1, overflow: "" }, Bc = Math.clz32 ? Math.clz32 : er, Gu = Math.log, Iu = Math.LN2, Pl = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), ur = null, Du = typeof Object.is == "function" ? Object.is : Be, Pr = null, Nc = null, Uc = null, gu = null, vu = null, vn = null, mc = !1, oo = !1, Xn = 0, Pa = 0, Sl = -1, Sa = 0, co = null, Sr = null, Fa = 0, Fr = !1, Gi, tc = {
      readContext: Pu,
      use: function(n) {
        if (n !== null && typeof n == "object") {
          if (typeof n.then == "function")
            return Ga(n);
          if (n.$$typeof === pi)
            return Pu(n);
        }
        throw Error(
          "An unsupported type was passed to use(): " + String(n)
        );
      },
      useContext: function(n) {
        return Gi = "useContext", sn(), n._currentValue2;
      },
      useMemo: hl,
      useReducer: Su,
      useRef: function(n) {
        Pr = sn(), vn = vt();
        var r = vn.memoizedState;
        return r === null ? (n = { current: n }, Object.seal(n), vn.memoizedState = n) : r;
      },
      useState: function(n) {
        return Gi = "useState", Su(la, n);
      },
      useInsertionEffect: dl,
      useLayoutEffect: dl,
      useCallback: function(n, r) {
        return hl(function() {
          return n;
        }, r);
      },
      useImperativeHandle: dl,
      useEffect: dl,
      useDebugValue: dl,
      useDeferredValue: function(n, r) {
        return sn(), r !== void 0 ? r : n;
      },
      useTransition: function() {
        return sn(), [!1, Sc];
      },
      useId: function() {
        var n = Nc.treeContext, r = n.overflow;
        n = n.id, n = (n & ~(1 << 32 - Bc(n) - 1)).toString(32) + r;
        var c = Fl;
        if (c === null)
          throw Error(
            "Invalid hook call. Hooks can only be called inside of the body of a function component."
          );
        return r = Xn++, n = "«" + c.idPrefix + "R" + n, 0 < r && (n += "H" + r.toString(32)), n + "»";
      },
      useSyncExternalStore: function(n, r, c) {
        if (c === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        return c();
      },
      useOptimistic: function(n) {
        return sn(), [n, Jr];
      },
      useActionState: nr,
      useFormState: nr,
      useHostTransitionStatus: function() {
        return sn(), Li;
      },
      useMemoCache: function(n) {
        for (var r = Array(n), c = 0; c < n; c++)
          r[c] = Ii;
        return r;
      },
      useCacheRefresh: function() {
        return Ti;
      }
    }, Fl = null, Wr = null, Lu = {
      getCacheForType: function() {
        throw Error("Not implemented.");
      },
      getOwner: function() {
        return Wr === null ? null : Wr.componentStack;
      }
    }, Al = 0, _u, bu, Yc, Gc, Xu, pl, Aa;
    Ei.__reactDisabledLog = !0;
    var Hu, li, rc = !1, yu = new (typeof WeakMap == "function" ? WeakMap : Map)(), ii = {
      "react-stack-bottom-frame": function(n, r, c) {
        return n(r, c);
      }
    }, lc = ii["react-stack-bottom-frame"].bind(ii), en = {
      "react-stack-bottom-frame": function(n) {
        return n.render();
      }
    }, Xi = en["react-stack-bottom-frame"].bind(en), uo = {
      "react-stack-bottom-frame": function(n) {
        var r = n._init;
        return r(n._payload);
      }
    }, pa = uo["react-stack-bottom-frame"].bind(uo), so = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var Xc = performance, ic = function() {
        return Xc.now();
      };
    else {
      var ac = Date;
      ic = function() {
        return ac.now();
      };
    }
    var _n = 4, Ar = 0, xn = 1, Oa = 2, oc = 5, Zi = 14, fn = null, wu = {}, Ol = {}, fo = {}, Wu = {}, cc = !1, Zc = !1, uc = !1;
    ss.renderToStaticMarkup = function(n, r) {
      return zo(
        n,
        r,
        !0,
        'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
      );
    }, ss.renderToString = function(n, r) {
      return zo(
        n,
        r,
        !1,
        'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
      );
    }, ss.version = "19.1.0";
  }()), ss;
}
var fs = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ws;
function Us() {
  return Ws || (Ws = 1, process.env.NODE_ENV !== "production" && function() {
    function yc(e, t, u, h) {
      return "" + t + (u === "s" ? "\\73 " : "\\53 ") + h;
    }
    function Uu(e, t, u, h) {
      return "" + t + (u === "s" ? "\\u0073" : "\\u0053") + h;
    }
    function Q(e) {
      return Object.prototype.toString.call(e).replace(/^\[object (.*)\]$/, function(t, u) {
        return u;
      });
    }
    function ko(e) {
      var t = JSON.stringify(e);
      return '"' + e + '"' === t ? e : t;
    }
    function Nl(e) {
      switch (typeof e) {
        case "string":
          return JSON.stringify(
            10 >= e.length ? e : e.slice(0, 10) + "..."
          );
        case "object":
          return Vn(e) ? "[...]" : e !== null && e.$$typeof === qa ? "client" : (e = Q(e), e === "Object" ? "{...}" : e);
        case "function":
          return e.$$typeof === qa ? "client" : (e = e.displayName || e.name) ? "function " + e : "function";
        default:
          return String(e);
      }
    }
    function Ut(e) {
      if (typeof e == "string")
        return e;
      switch (e) {
        case Ka:
          return "Suspense";
        case jr:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Ii:
            return Ut(e.render);
          case gn:
            return Ut(e.type);
          case Un:
            var t = e._payload;
            e = e._init;
            try {
              return Ut(e(t));
            } catch {
            }
        }
      return "";
    }
    function Xr(e, t) {
      var u = Q(e);
      if (u !== "Object" && u !== "Array")
        return u;
      var h = -1, b = 0;
      if (Vn(e))
        if (Ic.has(e)) {
          var E = Ic.get(e);
          u = "<" + Ut(E) + ">";
          for (var S = 0; S < e.length; S++) {
            var F = e[S];
            F = typeof F == "string" ? F : typeof F == "object" && F !== null ? "{" + Xr(F) + "}" : "{" + Nl(F) + "}", "" + S === t ? (h = u.length, b = F.length, u += F) : u = 15 > F.length && 40 > u.length + F.length ? u + F : u + "{...}";
          }
          u += "</" + Ut(E) + ">";
        } else {
          for (u = "[", E = 0; E < e.length; E++)
            0 < E && (u += ", "), S = e[E], S = typeof S == "object" && S !== null ? Xr(S) : Nl(S), "" + E === t ? (h = u.length, b = S.length, u += S) : u = 10 > S.length && 40 > u.length + S.length ? u + S : u + "...";
          u += "]";
        }
      else if (e.$$typeof === Oi)
        u = "<" + Ut(e.type) + "/>";
      else {
        if (e.$$typeof === qa)
          return "client";
        if (Mc.has(e)) {
          for (u = Mc.get(e), u = "<" + (Ut(u) || "..."), E = Object.keys(e), S = 0; S < E.length; S++) {
            u += " ", F = E[S], u += ko(F) + "=";
            var W = e[F], O = F === t && typeof W == "object" && W !== null ? Xr(W) : Nl(W);
            typeof W != "string" && (O = "{" + O + "}"), F === t ? (h = u.length, b = O.length, u += O) : u = 10 > O.length && 40 > u.length + O.length ? u + O : u + "...";
          }
          u += ">";
        } else {
          for (u = "{", E = Object.keys(e), S = 0; S < E.length; S++)
            0 < S && (u += ", "), F = E[S], u += ko(F) + ": ", W = e[F], W = typeof W == "object" && W !== null ? Xr(W) : Nl(W), F === t ? (h = u.length, b = W.length, u += W) : u = 10 > W.length && 40 > u.length + W.length ? u + W : u + "...";
          u += "}";
        }
      }
      return t === void 0 ? u : -1 < h && 0 < b ? (e = " ".repeat(h) + "^".repeat(b), `
  ` + u + `
  ` + e) : `
  ` + u;
    }
    function Co(e, t) {
      var u = e.length & 3, h = e.length - u, b = t;
      for (t = 0; t < h; ) {
        var E = e.charCodeAt(t) & 255 | (e.charCodeAt(++t) & 255) << 8 | (e.charCodeAt(++t) & 255) << 16 | (e.charCodeAt(++t) & 255) << 24;
        ++t, E = 3432918353 * (E & 65535) + ((3432918353 * (E >>> 16) & 65535) << 16) & 4294967295, E = E << 15 | E >>> 17, E = 461845907 * (E & 65535) + ((461845907 * (E >>> 16) & 65535) << 16) & 4294967295, b ^= E, b = b << 13 | b >>> 19, b = 5 * (b & 65535) + ((5 * (b >>> 16) & 65535) << 16) & 4294967295, b = (b & 65535) + 27492 + (((b >>> 16) + 58964 & 65535) << 16);
      }
      switch (E = 0, u) {
        case 3:
          E ^= (e.charCodeAt(t + 2) & 255) << 16;
        case 2:
          E ^= (e.charCodeAt(t + 1) & 255) << 8;
        case 1:
          E ^= e.charCodeAt(t) & 255, E = 3432918353 * (E & 65535) + ((3432918353 * (E >>> 16) & 65535) << 16) & 4294967295, E = E << 15 | E >>> 17, b ^= 461845907 * (E & 65535) + ((461845907 * (E >>> 16) & 65535) << 16) & 4294967295;
      }
      return b ^= e.length, b ^= b >>> 16, b = 2246822507 * (b & 65535) + ((2246822507 * (b >>> 16) & 65535) << 16) & 4294967295, b ^= b >>> 13, b = 3266489909 * (b & 65535) + ((3266489909 * (b >>> 16) & 65535) << 16) & 4294967295, (b ^ b >>> 16) >>> 0;
    }
    function za(e) {
      xl.push(e), mo.port2.postMessage(null);
    }
    function Ba(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function z(e, t) {
      if (t.byteLength !== 0)
        if (2048 < t.byteLength)
          0 < Dt && (e.enqueue(
            new Uint8Array(it.buffer, 0, Dt)
          ), it = new Uint8Array(2048), Dt = 0), e.enqueue(t);
        else {
          var u = it.length - Dt;
          u < t.byteLength && (u === 0 ? e.enqueue(it) : (it.set(
            t.subarray(0, u),
            Dt
          ), e.enqueue(it), t = t.subarray(u)), it = new Uint8Array(2048), Dt = 0), it.set(t, Dt), Dt += t.byteLength;
        }
    }
    function Ce(e, t) {
      return z(e, t), !0;
    }
    function ul(e) {
      it && 0 < Dt && (e.enqueue(
        new Uint8Array(it.buffer, 0, Dt)
      ), it = null, Dt = 0);
    }
    function q(e) {
      return at.encode(e);
    }
    function U(e) {
      return e = at.encode(e), 2048 < e.byteLength && console.error(
        "precomputed chunks must be smaller than the view size configured for this host. This is a bug in React."
      ), e;
    }
    function sl(e, t) {
      typeof e.error == "function" ? e.error(t) : e.close();
    }
    function wc(e) {
      return typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
    }
    function Na(e) {
      try {
        return Po(e), !1;
      } catch {
        return !0;
      }
    }
    function Po(e) {
      return "" + e;
    }
    function qt(e, t) {
      if (Na(e))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          wc(e)
        ), Po(e);
    }
    function Cu(e, t) {
      if (Na(e))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          wc(e)
        ), Po(e);
    }
    function xe(e) {
      if (Na(e))
        return console.error(
          "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
          wc(e)
        ), Po(e);
    }
    function Zr(e) {
      return Je.call(au, e) ? !0 : Je.call(Dc, e) ? !1 : Yo.test(e) ? au[e] = !0 : (Dc[e] = !0, console.error("Invalid attribute name: `%s`", e), !1);
    }
    function Ua(e, t) {
      Vl[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || console.error(
        e === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), t.onChange || t.readOnly || t.disabled || t.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function mt(e, t) {
      if (Je.call(lr, t) && lr[t])
        return !0;
      if (Go.test(t)) {
        if (e = "aria-" + t.slice(4).toLowerCase(), e = Ir.hasOwnProperty(e) ? e : null, e == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            t
          ), lr[t] = !0;
        if (t !== e)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            t,
            e
          ), lr[t] = !0;
      }
      if ($a.test(t)) {
        if (e = t.toLowerCase(), e = Ir.hasOwnProperty(e) ? e : null, e == null)
          return lr[t] = !0, !1;
        t !== e && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          t,
          e
        ), lr[t] = !0);
      }
      return !0;
    }
    function je(e, t) {
      var u = [], h;
      for (h in t)
        mt(e, h) || u.push(h);
      t = u.map(function(b) {
        return "`" + b + "`";
      }).join(", "), u.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      ) : 1 < u.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      );
    }
    function Mt(e, t, u, h) {
      if (Je.call(pn, t) && pn[t])
        return !0;
      var b = t.toLowerCase();
      if (b === "onfocusin" || b === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), pn[t] = !0;
      if (typeof u == "function" && (e === "form" && t === "action" || e === "input" && t === "formAction" || e === "button" && t === "formAction"))
        return !0;
      if (h != null) {
        if (e = h.possibleRegistrationNames, h.registrationNameDependencies.hasOwnProperty(t))
          return !0;
        if (h = e.hasOwnProperty(b) ? e[b] : null, h != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            t,
            h
          ), pn[t] = !0;
        if (pu.test(t))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            t
          ), pn[t] = !0;
      } else if (pu.test(t))
        return Lt.test(t) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          t
        ), pn[t] = !0;
      if (cu.test(t) || Li.test(t))
        return !0;
      if (b === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), pn[t] = !0;
      if (b === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), pn[t] = !0;
      if (b === "is" && u !== null && u !== void 0 && typeof u != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof u
        ), pn[t] = !0;
      if (typeof u == "number" && isNaN(u))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          t
        ), pn[t] = !0;
      if (eo.hasOwnProperty(b)) {
        if (b = eo[b], b !== t)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            t,
            b
          ), pn[t] = !0;
      } else if (t !== b)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          t,
          b
        ), pn[t] = !0;
      switch (t) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof u) {
        case "boolean":
          switch (t) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return b = t.toLowerCase().slice(0, 5), b === "data-" || b === "aria-" ? !0 : (u ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                u,
                t,
                t,
                u,
                t
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                u,
                t,
                t,
                u,
                t,
                t,
                t
              ), pn[t] = !0);
          }
        case "function":
        case "symbol":
          return pn[t] = !0, !1;
        case "string":
          if (u === "false" || u === "true") {
            switch (t) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              u,
              t,
              u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              t,
              u
            ), pn[t] = !0;
          }
      }
      return !0;
    }
    function jc(e, t, u) {
      var h = [], b;
      for (b in t)
        Mt(e, b, t[b], u) || h.push(b);
      t = h.map(function(E) {
        return "`" + E + "`";
      }).join(", "), h.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      ) : 1 < h.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      );
    }
    function $c(e) {
      return e.replace(f, function(t, u) {
        return u.toUpperCase();
      });
    }
    function Pe(e) {
      if (typeof e == "boolean" || typeof e == "number" || typeof e == "bigint")
        return "" + e;
      xe(e), e = "" + e;
      var t = L.exec(e);
      if (t) {
        var u = "", h, b = 0;
        for (h = t.index; h < e.length; h++) {
          switch (e.charCodeAt(h)) {
            case 34:
              t = "&quot;";
              break;
            case 38:
              t = "&amp;";
              break;
            case 39:
              t = "&#x27;";
              break;
            case 60:
              t = "&lt;";
              break;
            case 62:
              t = "&gt;";
              break;
            default:
              continue;
          }
          b !== h && (u += e.slice(b, h)), b = h + 1, u += t;
        }
        e = b !== h ? u + e.slice(b, h) : u;
      }
      return e;
    }
    function Xe(e) {
      return $.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
    }
    function dt(e) {
      return xe(e), ("" + e).replace(Mn, Uu);
    }
    function X(e, t, u, h, b, E) {
      var S = t === void 0 ? Kn : U(
        '<script nonce="' + Pe(t) + '">'
      ), F = e.idPrefix;
      u = [];
      var W = e.bootstrapScriptContent, O = e.bootstrapScripts, V = e.bootstrapModules;
      if (W !== void 0 && u.push(
        S,
        q(
          dt(W)
        ),
        xt
      ), W = [], h !== void 0 && (W.push(_t), W.push(
        q(
          dt(JSON.stringify(h))
        )
      ), W.push(kt)), b && typeof E == "number" && 0 >= E && console.error(
        "React expected a positive non-zero `maxHeadersLength` option but found %s instead. When using the `onHeaders` option you may supply an optional `maxHeadersLength` option as well however, when setting this value to zero or less no headers will be captured.",
        E === 0 ? "zero" : E
      ), h = b ? {
        preconnects: "",
        fontPreloads: "",
        highImagePreloads: "",
        remainingCapacity: 2 + (typeof E == "number" ? E : 2e3)
      } : null, b = {
        placeholderPrefix: U(F + "P:"),
        segmentPrefix: U(F + "S:"),
        boundaryPrefix: U(F + "B:"),
        startInlineScript: S,
        preamble: si(),
        externalRuntimeScript: null,
        bootstrapChunks: u,
        importMapChunks: W,
        onHeaders: b,
        headers: h,
        resets: {
          font: {},
          dns: {},
          connect: { default: {}, anonymous: {}, credentials: {} },
          image: {},
          style: {}
        },
        charsetChunks: [],
        viewportChunks: [],
        hoistableChunks: [],
        preconnects: /* @__PURE__ */ new Set(),
        fontPreloads: /* @__PURE__ */ new Set(),
        highImagePreloads: /* @__PURE__ */ new Set(),
        styles: /* @__PURE__ */ new Map(),
        bootstrapScripts: /* @__PURE__ */ new Set(),
        scripts: /* @__PURE__ */ new Set(),
        bulkPreloads: /* @__PURE__ */ new Set(),
        preloads: {
          images: /* @__PURE__ */ new Map(),
          stylesheets: /* @__PURE__ */ new Map(),
          scripts: /* @__PURE__ */ new Map(),
          moduleScripts: /* @__PURE__ */ new Map()
        },
        nonce: t,
        hoistableState: null,
        stylesToHoist: !1
      }, O !== void 0)
        for (h = 0; h < O.length; h++) {
          E = O[h], W = F = void 0;
          var J = {
            rel: "preload",
            as: "script",
            fetchPriority: "low",
            nonce: t
          };
          typeof E == "string" ? J.href = S = E : (J.href = S = E.src, J.integrity = W = typeof E.integrity == "string" ? E.integrity : void 0, J.crossOrigin = F = typeof E == "string" || E.crossOrigin == null ? void 0 : E.crossOrigin === "use-credentials" ? "use-credentials" : ""), Mo(
            e,
            b,
            S,
            J
          ), u.push(
            ve,
            q(Pe(S))
          ), t && u.push(
            On,
            q(Pe(t))
          ), typeof W == "string" && u.push(
            mn,
            q(Pe(W))
          ), typeof F == "string" && u.push(
            $r,
            q(Pe(F))
          ), u.push(tn);
        }
      if (V !== void 0)
        for (O = 0; O < V.length; O++)
          h = V[O], F = S = void 0, W = {
            rel: "modulepreload",
            fetchPriority: "low",
            nonce: t
          }, typeof h == "string" ? W.href = E = h : (W.href = E = h.src, W.integrity = F = typeof h.integrity == "string" ? h.integrity : void 0, W.crossOrigin = S = typeof h == "string" || h.crossOrigin == null ? void 0 : h.crossOrigin === "use-credentials" ? "use-credentials" : ""), Mo(
            e,
            b,
            E,
            W
          ), u.push(
            $e,
            q(Pe(E))
          ), t && u.push(
            On,
            q(Pe(t))
          ), typeof F == "string" && u.push(
            mn,
            q(Pe(F))
          ), typeof S == "string" && u.push(
            $r,
            q(Pe(S))
          ), u.push(tn);
      return b;
    }
    function ce(e, t, u, h, b) {
      return {
        idPrefix: e === void 0 ? "" : e,
        nextFormID: 0,
        streamingFormat: 0,
        bootstrapScriptContent: u,
        bootstrapScripts: h,
        bootstrapModules: b,
        instructions: Ne,
        hasBody: !1,
        hasHtml: !1,
        unknownResources: {},
        dnsResources: {},
        connectResources: { default: {}, anonymous: {}, credentials: {} },
        imageResources: {},
        styleResources: {},
        scriptResources: {},
        moduleUnknownResources: {},
        moduleScriptResources: {}
      };
    }
    function si() {
      return {
        htmlChunks: null,
        headChunks: null,
        bodyChunks: null,
        contribution: Ct
      };
    }
    function pe(e, t, u) {
      return {
        insertionMode: e,
        selectedValue: t,
        tagScope: u
      };
    }
    function j(e) {
      return pe(
        e === "http://www.w3.org/2000/svg" ? ar : e === "http://www.w3.org/1998/Math/MathML" ? nl : Dr,
        null,
        0
      );
    }
    function m(e, t, u) {
      switch (t) {
        case "noscript":
          return pe(
            In,
            null,
            e.tagScope | 1
          );
        case "select":
          return pe(
            In,
            u.value != null ? u.value : u.defaultValue,
            e.tagScope
          );
        case "svg":
          return pe(ar, null, e.tagScope);
        case "picture":
          return pe(
            In,
            null,
            e.tagScope | 2
          );
        case "math":
          return pe(nl, null, e.tagScope);
        case "foreignObject":
          return pe(In, null, e.tagScope);
        case "table":
          return pe(
            Lr,
            null,
            e.tagScope
          );
        case "thead":
        case "tbody":
        case "tfoot":
          return pe(
            kr,
            null,
            e.tagScope
          );
        case "colgroup":
          return pe(
            Kl,
            null,
            e.tagScope
          );
        case "tr":
          return pe(
            _c,
            null,
            e.tagScope
          );
        case "head":
          if (e.insertionMode < In)
            return pe(
              xr,
              null,
              e.tagScope
            );
          break;
        case "html":
          if (e.insertionMode === Dr)
            return pe(
              ir,
              null,
              e.tagScope
            );
      }
      return e.insertionMode >= Lr || e.insertionMode < In ? pe(In, null, e.tagScope) : e;
    }
    function fi(e, t, u, h) {
      return t === "" ? h : (h && e.push(tl), e.push(q(Pe(t))), !0);
    }
    function gt(e, t) {
      if (typeof t != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      var u = !0, h;
      for (h in t)
        if (Je.call(t, h)) {
          var b = t[h];
          if (b != null && typeof b != "boolean" && b !== "") {
            if (h.indexOf("--") === 0) {
              var E = q(Pe(h));
              Cu(b, h), b = q(
                Pe(("" + b).trim())
              );
            } else {
              E = h;
              var S = b;
              if (-1 < E.indexOf("-")) {
                var F = E;
                T.hasOwnProperty(F) && T[F] || (T[F] = !0, console.error(
                  "Unsupported style property %s. Did you mean %s?",
                  F,
                  $c(F.replace(o, "ms-"))
                ));
              } else if (i.test(E))
                F = E, T.hasOwnProperty(F) && T[F] || (T[F] = !0, console.error(
                  "Unsupported vendor-prefixed style property %s. Did you mean %s?",
                  F,
                  F.charAt(0).toUpperCase() + F.slice(1)
                ));
              else if (g.test(S)) {
                F = E;
                var W = S;
                x.hasOwnProperty(W) && x[W] || (x[W] = !0, console.error(
                  `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
                  F,
                  W.replace(
                    g,
                    ""
                  )
                ));
              }
              typeof S == "number" && (isNaN(S) ? C || (C = !0, console.error(
                "`NaN` is an invalid value for the `%s` css style property.",
                E
              )) : isFinite(S) || H || (H = !0, console.error(
                "`Infinity` is an invalid value for the `%s` css style property.",
                E
              ))), E = h, S = Xo.get(E), S !== void 0 || (S = U(
                Pe(
                  E.replace(B, "-$1").toLowerCase().replace(oe, "-ms-")
                )
              ), Xo.set(E, S)), E = S, typeof b == "number" ? b = b === 0 || ou.has(h) ? q("" + b) : q(b + "px") : (Cu(b, h), b = q(
                Pe(("" + b).trim())
              ));
            }
            u ? (u = !1, e.push(
              uu,
              E,
              va,
              b
            )) : e.push(su, E, va, b);
          }
        }
      u || e.push(Tn);
    }
    function Ie(e, t, u) {
      u && typeof u != "function" && typeof u != "symbol" && e.push(
        qn,
        q(t),
        Zo
      );
    }
    function hn(e, t, u) {
      typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" && e.push(
        qn,
        q(t),
        Ht,
        q(Pe(u)),
        Tn
      );
    }
    function zn(e, t) {
      this.push(_i), So(e), hn(this, "name", t), hn(this, "value", e), this.push(_r);
    }
    function So(e) {
      if (typeof e != "string")
        throw Error(
          "File/Blob fields are not yet supported in progressive forms. Will fallback to client hydration."
        );
    }
    function hi(e, t) {
      if (typeof t.$$FORM_ACTION == "function") {
        var u = e.nextFormID++;
        e = e.idPrefix + u;
        try {
          var h = t.$$FORM_ACTION(e);
          if (h) {
            var b = h.data;
            b != null && b.forEach(So);
          }
          return h;
        } catch (E) {
          if (typeof E == "object" && E !== null && typeof E.then == "function")
            throw E;
          console.error(
            `Failed to serialize an action for progressive enhancement:
%s`,
            E
          );
        }
      }
      return null;
    }
    function Tc(e, t, u, h, b, E, S, F) {
      var W = null;
      if (typeof h == "function") {
        F === null || ya || (ya = !0, console.error(
          'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
        )), b === null && E === null || kl || (kl = !0, console.error(
          "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
        )), S === null || Hi || (Hi = !0, console.error(
          "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
        ));
        var O = hi(t, h);
        O !== null ? (F = O.name, h = O.action || "", b = O.encType, E = O.method, S = O.target, W = O.data) : (e.push(
          qn,
          q("formAction"),
          Ht,
          rl,
          Tn
        ), S = E = b = h = F = null, Ec(t, u));
      }
      return F != null && ze(e, "name", F), h != null && ze(e, "formAction", h), b != null && ze(e, "formEncType", b), E != null && ze(e, "formMethod", E), S != null && ze(e, "formTarget", S), W;
    }
    function ze(e, t, u) {
      switch (t) {
        case "className":
          hn(e, "class", u);
          break;
        case "tabIndex":
          hn(e, "tabindex", u);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          hn(e, t, u);
          break;
        case "style":
          gt(e, u);
          break;
        case "src":
        case "href":
          if (u === "") {
            console.error(
              t === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              t,
              t
            );
            break;
          }
        case "action":
        case "formAction":
          if (u == null || typeof u == "function" || typeof u == "symbol" || typeof u == "boolean")
            break;
          qt(u, t), u = Xe("" + u), e.push(
            qn,
            q(t),
            Ht,
            q(Pe(u)),
            Tn
          );
          break;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "ref":
          break;
        case "autoFocus":
        case "multiple":
        case "muted":
          Ie(e, t.toLowerCase(), u);
          break;
        case "xlinkHref":
          if (typeof u == "function" || typeof u == "symbol" || typeof u == "boolean")
            break;
          qt(u, t), u = Xe("" + u), e.push(
            qn,
            q("xlink:href"),
            Ht,
            q(Pe(u)),
            Tn
          );
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          typeof u != "function" && typeof u != "symbol" && e.push(
            qn,
            q(t),
            Ht,
            q(Pe(u)),
            Tn
          );
          break;
        case "inert":
          u !== "" || el[t] || (el[t] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            t
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          u && typeof u != "function" && typeof u != "symbol" && e.push(
            qn,
            q(t),
            Zo
          );
          break;
        case "capture":
        case "download":
          u === !0 ? e.push(
            qn,
            q(t),
            Zo
          ) : u !== !1 && typeof u != "function" && typeof u != "symbol" && e.push(
            qn,
            q(t),
            Ht,
            q(Pe(u)),
            Tn
          );
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          typeof u != "function" && typeof u != "symbol" && !isNaN(u) && 1 <= u && e.push(
            qn,
            q(t),
            Ht,
            q(Pe(u)),
            Tn
          );
          break;
        case "rowSpan":
        case "start":
          typeof u == "function" || typeof u == "symbol" || isNaN(u) || e.push(
            qn,
            q(t),
            Ht,
            q(Pe(u)),
            Tn
          );
          break;
        case "xlinkActuate":
          hn(e, "xlink:actuate", u);
          break;
        case "xlinkArcrole":
          hn(e, "xlink:arcrole", u);
          break;
        case "xlinkRole":
          hn(e, "xlink:role", u);
          break;
        case "xlinkShow":
          hn(e, "xlink:show", u);
          break;
        case "xlinkTitle":
          hn(e, "xlink:title", u);
          break;
        case "xlinkType":
          hn(e, "xlink:type", u);
          break;
        case "xmlBase":
          hn(e, "xml:base", u);
          break;
        case "xmlLang":
          hn(e, "xml:lang", u);
          break;
        case "xmlSpace":
          hn(e, "xml:space", u);
          break;
        default:
          if ((!(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (t = ja.get(t) || t, Zr(t))) {
            switch (typeof u) {
              case "function":
              case "symbol":
                return;
              case "boolean":
                var h = t.toLowerCase().slice(0, 5);
                if (h !== "data-" && h !== "aria-")
                  return;
            }
            e.push(
              qn,
              q(t),
              Ht,
              q(Pe(u)),
              Tn
            );
          }
      }
    }
    function Ae(e, t, u) {
      if (t != null) {
        if (u != null)
          throw Error(
            "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
          );
        if (typeof t != "object" || !("__html" in t))
          throw Error(
            "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
          );
        t = t.__html, t != null && (xe(t), e.push(q("" + t)));
      }
    }
    function De(e, t) {
      var u = e[t];
      u != null && (u = Vn(u), e.multiple && !u ? console.error(
        "The `%s` prop supplied to <select> must be an array if `multiple` is true.",
        t
      ) : !e.multiple && u && console.error(
        "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.",
        t
      ));
    }
    function di(e) {
      var t = "";
      return da.Children.forEach(e, function(u) {
        u != null && (t += u, ql || typeof u == "string" || typeof u == "number" || typeof u == "bigint" || (ql = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        )));
      }), t;
    }
    function Ec(e, t) {
      (e.instructions & 16) === Ne && (e.instructions |= 16, t.bootstrapChunks.unshift(
        t.startInlineScript,
        Wi,
        xt
      ));
    }
    function tt(e, t) {
      e.push(ke("link"));
      for (var u in t)
        if (Je.call(t, u)) {
          var h = t[u];
          if (h != null)
            switch (u) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(
                  "link is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                );
              default:
                ze(e, u, h);
            }
        }
      return e.push(_r), null;
    }
    function Cn(e) {
      return xe(e), ("" + e).replace(fu, yc);
    }
    function gr(e, t, u) {
      e.push(ke(u));
      for (var h in t)
        if (Je.call(t, h)) {
          var b = t[h];
          if (b != null)
            switch (h) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(
                  u + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                );
              default:
                ze(e, h, b);
            }
        }
      return e.push(_r), null;
    }
    function Fo(e, t) {
      e.push(ke("title"));
      var u = null, h = null, b;
      for (b in t)
        if (Je.call(t, b)) {
          var E = t[b];
          if (E != null)
            switch (b) {
              case "children":
                u = E;
                break;
              case "dangerouslySetInnerHTML":
                h = E;
                break;
              default:
                ze(e, b, E);
            }
        }
      return e.push(En), t = Array.isArray(u) ? 2 > u.length ? u[0] : null : u, typeof t != "function" && typeof t != "symbol" && t !== null && t !== void 0 && e.push(q(Pe("" + t))), Ae(e, h, u), e.push(gi("title")), null;
    }
    function Ao(e, t) {
      e.push(ke("script"));
      var u = null, h = null, b;
      for (b in t)
        if (Je.call(t, b)) {
          var E = t[b];
          if (E != null)
            switch (b) {
              case "children":
                u = E;
                break;
              case "dangerouslySetInnerHTML":
                h = E;
                break;
              default:
                ze(e, b, E);
            }
        }
      return e.push(En), u != null && typeof u != "string" && (t = typeof u == "number" ? "a number for children" : Array.isArray(u) ? "an array for children" : "something unexpected for children", console.error(
        "A script element was rendered with %s. If script element has children it must be a single string. Consider using dangerouslySetInnerHTML or passing a plain string as children.",
        t
      )), Ae(e, h, u), typeof u == "string" && e.push(q(dt(u))), e.push(gi("script")), null;
    }
    function Yt(e, t, u) {
      e.push(ke(u));
      var h = u = null, b;
      for (b in t)
        if (Je.call(t, b)) {
          var E = t[b];
          if (E != null)
            switch (b) {
              case "children":
                u = E;
                break;
              case "dangerouslySetInnerHTML":
                h = E;
                break;
              default:
                ze(e, b, E);
            }
        }
      return e.push(En), Ae(e, h, u), u;
    }
    function Bn(e, t, u) {
      e.push(ke(u));
      var h = u = null, b;
      for (b in t)
        if (Je.call(t, b)) {
          var E = t[b];
          if (E != null)
            switch (b) {
              case "children":
                u = E;
                break;
              case "dangerouslySetInnerHTML":
                h = E;
                break;
              default:
                ze(e, b, E);
            }
        }
      return e.push(En), Ae(e, h, u), typeof u == "string" ? (e.push(q(Pe(u))), null) : u;
    }
    function ke(e) {
      var t = Hc.get(e);
      if (t === void 0) {
        if (!ro.test(e))
          throw Error("Invalid tag: " + e);
        t = U("<" + e), Hc.set(e, t);
      }
      return t;
    }
    function jt(e, t, u, h, b, E, S, F, W, O) {
      je(t, u), t !== "input" && t !== "textarea" && t !== "select" || u == null || u.value !== null || Lc || (Lc = !0, t === "select" && u.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        t
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        t
      ));
      e:
        if (t.indexOf("-") === -1)
          var V = !1;
        else
          switch (t) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              V = !1;
              break e;
            default:
              V = !0;
          }
      switch (V || typeof u.is == "string" || jc(t, u, null), !u.suppressContentEditableWarning && u.contentEditable && u.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      ), F.insertionMode !== ar && F.insertionMode !== nl && t.indexOf("-") === -1 && t.toLowerCase() !== t && console.error(
        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
        t
      ), t) {
        case "div":
        case "span":
        case "svg":
        case "path":
          break;
        case "a":
          e.push(ke("a"));
          var J = null, re = null, ne;
          for (ne in u)
            if (Je.call(u, ne)) {
              var Z = u[ne];
              if (Z != null)
                switch (ne) {
                  case "children":
                    J = Z;
                    break;
                  case "dangerouslySetInnerHTML":
                    re = Z;
                    break;
                  case "href":
                    Z === "" ? hn(e, "href", "") : ze(e, ne, Z);
                    break;
                  default:
                    ze(e, ne, Z);
                }
            }
          if (e.push(En), Ae(e, re, J), typeof J == "string") {
            e.push(q(Pe(J)));
            var He = null;
          } else
            He = J;
          return He;
        case "g":
        case "p":
        case "li":
          break;
        case "select":
          Ua("select", u), De(u, "value"), De(u, "defaultValue"), u.value === void 0 || u.defaultValue === void 0 || to || (console.error(
            "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
          ), to = !0), e.push(ke("select"));
          var nn = null, Oe = null, fe;
          for (fe in u)
            if (Je.call(u, fe)) {
              var Qn = u[fe];
              if (Qn != null)
                switch (fe) {
                  case "children":
                    nn = Qn;
                    break;
                  case "dangerouslySetInnerHTML":
                    Oe = Qn;
                    break;
                  case "defaultValue":
                  case "value":
                    break;
                  default:
                    ze(
                      e,
                      fe,
                      Qn
                    );
                }
            }
          return e.push(En), Ae(e, Oe, nn), nn;
        case "option":
          var un = F.selectedValue;
          e.push(ke("option"));
          var Me = null, zt = null, sr = null, et = null, ct;
          for (ct in u)
            if (Je.call(u, ct)) {
              var wn = u[ct];
              if (wn != null)
                switch (ct) {
                  case "children":
                    Me = wn;
                    break;
                  case "selected":
                    sr = wn, Qo || (console.error(
                      "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
                    ), Qo = !0);
                    break;
                  case "dangerouslySetInnerHTML":
                    et = wn;
                    break;
                  case "value":
                    zt = wn;
                  default:
                    ze(
                      e,
                      ct,
                      wn
                    );
                }
            }
          if (un != null) {
            if (zt !== null) {
              qt(zt, "value");
              var Bt = "" + zt;
            } else
              et === null || Yn || (Yn = !0, console.error(
                "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
              )), Bt = di(Me);
            if (Vn(un)) {
              for (var Nt = 0; Nt < un.length; Nt++)
                if (qt(un[Nt], "value"), "" + un[Nt] === Bt) {
                  e.push(Hr);
                  break;
                }
            } else
              qt(un, "select.value"), "" + un === Bt && e.push(Hr);
          } else
            sr && e.push(Hr);
          return e.push(En), Ae(e, et, Me), Me;
        case "textarea":
          Ua("textarea", u), u.value === void 0 || u.defaultValue === void 0 || ba || (console.error(
            "Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components"
          ), ba = !0), e.push(ke("textarea"));
          var We = null, Fn = null, an = null, Jt;
          for (Jt in u)
            if (Je.call(u, Jt)) {
              var Vt = u[Jt];
              if (Vt != null)
                switch (Jt) {
                  case "children":
                    an = Vt;
                    break;
                  case "value":
                    We = Vt;
                    break;
                  case "defaultValue":
                    Fn = Vt;
                    break;
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  default:
                    ze(
                      e,
                      Jt,
                      Vt
                    );
                }
            }
          if (We === null && Fn !== null && (We = Fn), e.push(En), an != null) {
            if (console.error(
              "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
            ), We != null)
              throw Error(
                "If you supply `defaultValue` on a <textarea>, do not pass children."
              );
            if (Vn(an)) {
              if (1 < an.length)
                throw Error("<textarea> can only have at most one child.");
              xe(an[0]), We = "" + an[0];
            }
            xe(an), We = "" + an;
          }
          return typeof We == "string" && We[0] === `
` && e.push(Jo), We !== null && (qt(We, "value"), e.push(
            q(Pe("" + We))
          )), null;
        case "input":
          Ua("input", u), e.push(ke("input"));
          var ut = null, Ml = null, pr = null, Il = null, ho = null, Dl = null, Ma = null, Br = null, go = null, Kt;
          for (Kt in u)
            if (Je.call(u, Kt)) {
              var st = u[Kt];
              if (st != null)
                switch (Kt) {
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  case "name":
                    ut = st;
                    break;
                  case "formAction":
                    Ml = st;
                    break;
                  case "formEncType":
                    pr = st;
                    break;
                  case "formMethod":
                    Il = st;
                    break;
                  case "formTarget":
                    ho = st;
                    break;
                  case "defaultChecked":
                    go = st;
                    break;
                  case "defaultValue":
                    Ma = st;
                    break;
                  case "checked":
                    Br = st;
                    break;
                  case "value":
                    Dl = st;
                    break;
                  default:
                    ze(
                      e,
                      Kt,
                      st
                    );
                }
            }
          Ml === null || u.type === "image" || u.type === "submit" || or || (or = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          ));
          var Hn = Tc(
            e,
            h,
            b,
            Ml,
            pr,
            Il,
            ho,
            ut
          );
          return Br === null || go === null || ll || (console.error(
            "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
            "A component",
            u.type
          ), ll = !0), Dl === null || Ma === null || no || (console.error(
            "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
            "A component",
            u.type
          ), no = !0), Br !== null ? Ie(e, "checked", Br) : go !== null && Ie(e, "checked", go), Dl !== null ? ze(e, "value", Dl) : Ma !== null && ze(e, "value", Ma), e.push(_r), Hn != null && Hn.forEach(zn, e), null;
        case "button":
          e.push(ke("button"));
          var fr = null, Nr = null, Ia = null, Ur = null, Ll = null, mr = null, Qc = null, nt;
          for (nt in u)
            if (Je.call(u, nt)) {
              var hr = u[nt];
              if (hr != null)
                switch (nt) {
                  case "children":
                    fr = hr;
                    break;
                  case "dangerouslySetInnerHTML":
                    Nr = hr;
                    break;
                  case "name":
                    Ia = hr;
                    break;
                  case "formAction":
                    Ur = hr;
                    break;
                  case "formEncType":
                    Ll = hr;
                    break;
                  case "formMethod":
                    mr = hr;
                    break;
                  case "formTarget":
                    Qc = hr;
                    break;
                  default:
                    ze(
                      e,
                      nt,
                      hr
                    );
                }
            }
          Ur === null || u.type == null || u.type === "submit" || or || (or = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          ));
          var ai = Tc(
            e,
            h,
            b,
            Ur,
            Ll,
            mr,
            Qc,
            Ia
          );
          if (e.push(En), ai != null && ai.forEach(zn, e), Ae(e, Nr, fr), typeof fr == "string") {
            e.push(
              q(Pe(fr))
            );
            var oi = null;
          } else
            oi = fr;
          return oi;
        case "form":
          e.push(ke("form"));
          var _l = null, Da = null, al = null, Qi = null, Ji = null, Vi = null, Ki;
          for (Ki in u)
            if (Je.call(u, Ki)) {
              var Yr = u[Ki];
              if (Yr != null)
                switch (Ki) {
                  case "children":
                    _l = Yr;
                    break;
                  case "dangerouslySetInnerHTML":
                    Da = Yr;
                    break;
                  case "action":
                    al = Yr;
                    break;
                  case "encType":
                    Qi = Yr;
                    break;
                  case "method":
                    Ji = Yr;
                    break;
                  case "target":
                    Vi = Yr;
                    break;
                  default:
                    ze(
                      e,
                      Ki,
                      Yr
                    );
                }
            }
          var Hl = null, Jc = null;
          if (typeof al == "function") {
            Qi === null && Ji === null || kl || (kl = !0, console.error(
              "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
            )), Vi === null || Hi || (Hi = !0, console.error(
              "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
            ));
            var ol = hi(
              h,
              al
            );
            ol !== null ? (al = ol.action || "", Qi = ol.encType, Ji = ol.method, Vi = ol.target, Hl = ol.data, Jc = ol.name) : (e.push(
              qn,
              q("action"),
              Ht,
              rl,
              Tn
            ), Vi = Ji = Qi = al = null, Ec(h, b));
          }
          if (al != null && ze(e, "action", al), Qi != null && ze(e, "encType", Qi), Ji != null && ze(e, "method", Ji), Vi != null && ze(e, "target", Vi), e.push(En), Jc !== null && (e.push(_i), hn(e, "name", Jc), e.push(_r), Hl != null && Hl.forEach(
            zn,
            e
          )), Ae(e, Da, _l), typeof _l == "string") {
            e.push(
              q(Pe(_l))
            );
            var vo = null;
          } else
            vo = _l;
          return vo;
        case "menuitem":
          e.push(ke("menuitem"));
          for (var bo in u)
            if (Je.call(u, bo)) {
              var Tu = u[bo];
              if (Tu != null)
                switch (bo) {
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "menuitems cannot have `children` nor `dangerouslySetInnerHTML`."
                    );
                  default:
                    ze(
                      e,
                      bo,
                      Tu
                    );
                }
            }
          return e.push(En), null;
        case "object":
          e.push(ke("object"));
          var ci = null, Vc = null, Or;
          for (Or in u)
            if (Je.call(u, Or)) {
              var Wl = u[Or];
              if (Wl != null)
                switch (Or) {
                  case "children":
                    ci = Wl;
                    break;
                  case "dangerouslySetInnerHTML":
                    Vc = Wl;
                    break;
                  case "data":
                    qt(Wl, "data");
                    var Wn = Xe("" + Wl);
                    if (Wn === "") {
                      console.error(
                        'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                        Or,
                        Or
                      );
                      break;
                    }
                    e.push(
                      qn,
                      q("data"),
                      Ht,
                      q(Pe(Wn)),
                      Tn
                    );
                    break;
                  default:
                    ze(
                      e,
                      Or,
                      Wl
                    );
                }
            }
          if (e.push(En), Ae(e, Vc, ci), typeof ci == "string") {
            e.push(
              q(Pe(ci))
            );
            var pt = null;
          } else
            pt = ci;
          return pt;
        case "title":
          var dr = F.insertionMode, Eu = !!(F.tagScope & 1);
          if (Je.call(u, "children")) {
            var zl = u.children, qi = Array.isArray(zl) ? 2 > zl.length ? zl[0] : null : zl;
            Array.isArray(zl) && 1 < zl.length ? console.error(
              "React expects the `children` prop of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found an Array with length %s instead. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert `children` of <title> tags to a single string value which is why Arrays of length greater than 1 are not supported. When using JSX it can be common to combine text nodes and value nodes. For example: <title>hello {nameOfUser}</title>. While not immediately apparent, `children` in this case is an Array with length 2. If your `children` prop is using this form try rewriting it using a template string: <title>{`hello ${nameOfUser}`}</title>.",
              zl.length
            ) : typeof qi == "function" || typeof qi == "symbol" ? console.error(
              "React expect children of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found %s instead. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert children of <title> tags to a single string value.",
              typeof qi == "function" ? "a Function" : "a Sybmol"
            ) : qi && qi.toString === {}.toString && (qi.$$typeof != null ? console.error(
              "React expects the `children` prop of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found an object that appears to be a React element which never implements a suitable `toString` method. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert children of <title> tags to a single string value which is why rendering React elements is not supported. If the `children` of <title> is a React Component try moving the <title> tag into that component. If the `children` of <title> is some HTML markup change it to be Text only to be valid HTML."
            ) : console.error(
              "React expects the `children` prop of <title> tags to be a string, number, bigint, or object with a novel `toString` method but found an object that does not implement a suitable `toString` method. Browsers treat all child Nodes of <title> tags as Text content and React expects to be able to convert children of <title> tags to a single string value. Using the default `toString` method available on every object is almost certainly an error. Consider whether the `children` of this <title> is an object in error and change it to a string or number value if so. Otherwise implement a `toString` method that React can use to produce a valid <title>."
            ));
          }
          if (dr === ar || Eu || u.itemProp != null)
            var La = Fo(
              e,
              u
            );
          else
            O ? La = null : (Fo(b.hoistableChunks, u), La = void 0);
          return La;
        case "link":
          var zu = u.rel, ft = u.href, sc = u.precedence;
          if (F.insertionMode === ar || F.tagScope & 1 || u.itemProp != null || typeof zu != "string" || typeof ft != "string" || ft === "") {
            zu === "stylesheet" && typeof u.precedence == "string" && (typeof ft == "string" && ft || console.error(
              'React encountered a `<link rel="stylesheet" .../>` with a `precedence` prop and expected the `href` prop to be a non-empty string but ecountered %s instead. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop ensure there is a non-empty string `href` prop as well, otherwise remove the `precedence` prop.',
              ft === null ? "`null`" : ft === void 0 ? "`undefined`" : ft === "" ? "an empty string" : 'something with type "' + typeof ft + '"'
            )), tt(e, u);
            var yo = null;
          } else if (u.rel === "stylesheet")
            if (typeof sc != "string" || u.disabled != null || u.onLoad || u.onError) {
              if (typeof sc == "string") {
                if (u.disabled != null)
                  console.error(
                    'React encountered a `<link rel="stylesheet" .../>` with a `precedence` prop and a `disabled` prop. The presence of the `disabled` prop indicates an intent to manage the stylesheet active state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the `disabled` prop, otherwise remove the `precedence` prop.'
                  );
                else if (u.onLoad || u.onError) {
                  var _a = u.onLoad && u.onError ? "`onLoad` and `onError` props" : u.onLoad ? "`onLoad` prop" : "`onError` prop";
                  console.error(
                    'React encountered a `<link rel="stylesheet" .../>` with a `precedence` prop and %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                    _a,
                    _a
                  );
                }
              }
              yo = tt(
                e,
                u
              );
            } else {
              var fc = b.styles.get(sc), wo = h.styleResources.hasOwnProperty(
                ft
              ) ? h.styleResources[ft] : void 0;
              if (wo !== _e) {
                h.styleResources[ft] = _e, fc || (fc = {
                  precedence: q(Pe(sc)),
                  rules: [],
                  hrefs: [],
                  sheets: /* @__PURE__ */ new Map()
                }, b.styles.set(sc, fc));
                var Kc = {
                  state: Pr,
                  props: yn({}, u, {
                    "data-precedence": u.precedence,
                    precedence: null
                  })
                };
                if (wo) {
                  wo.length === 2 && on(Kc.props, wo);
                  var hc = b.preloads.stylesheets.get(ft);
                  hc && 0 < hc.length ? hc.length = 0 : Kc.state = Nc;
                }
                fc.sheets.set(ft, Kc), S && S.stylesheets.add(Kc);
              } else if (fc) {
                var Zu = fc.sheets.get(ft);
                Zu && S && S.stylesheets.add(Zu);
              }
              W && e.push(tl), yo = null;
            }
          else
            u.onLoad || u.onError ? yo = tt(
              e,
              u
            ) : (W && e.push(tl), yo = O ? null : tt(b.hoistableChunks, u));
          return yo;
        case "script":
          var dc = u.async;
          if (typeof u.src != "string" || !u.src || !dc || typeof dc == "function" || typeof dc == "symbol" || u.onLoad || u.onError || F.insertionMode === ar || F.tagScope & 1 || u.itemProp != null)
            var To = Ao(
              e,
              u
            );
          else {
            var Ha = u.src;
            if (u.type === "module")
              var ui = h.moduleScriptResources, Wa = b.preloads.moduleScripts;
            else
              ui = h.scriptResources, Wa = b.preloads.scripts;
            var Ot = ui.hasOwnProperty(Ha) ? ui[Ha] : void 0;
            if (Ot !== _e) {
              ui[Ha] = _e;
              var ht = u;
              if (Ot) {
                Ot.length === 2 && (ht = yn({}, u), on(ht, Ot));
                var Qu = Wa.get(Ha);
                Qu && (Qu.length = 0);
              }
              var gc = [];
              b.scripts.add(gc), Ao(gc, ht);
            }
            W && e.push(tl), To = null;
          }
          return To;
        case "style":
          var Ju = F.insertionMode, Eo = !!(F.tagScope & 1);
          if (Je.call(u, "children")) {
            var Ro = u.children, Bu = Array.isArray(Ro) ? 2 > Ro.length ? Ro[0] : null : Ro;
            (typeof Bu == "function" || typeof Bu == "symbol" || Array.isArray(Bu)) && console.error(
              "React expect children of <style> tags to be a string, number, or object with a `toString` method but found %s instead. In browsers style Elements can only have `Text` Nodes as children.",
              typeof Bu == "function" ? "a Function" : typeof Bu == "symbol" ? "a Sybmol" : "an Array"
            );
          }
          var xo = u.precedence, ji = u.href;
          if (Ju === ar || Eo || u.itemProp != null || typeof xo != "string" || typeof ji != "string" || ji === "") {
            e.push(ke("style"));
            var qc = null, es = null, Ru;
            for (Ru in u)
              if (Je.call(u, Ru)) {
                var Vu = u[Ru];
                if (Vu != null)
                  switch (Ru) {
                    case "children":
                      qc = Vu;
                      break;
                    case "dangerouslySetInnerHTML":
                      es = Vu;
                      break;
                    default:
                      ze(
                        e,
                        Ru,
                        Vu
                      );
                  }
              }
            e.push(En);
            var xu = Array.isArray(qc) ? 2 > qc.length ? qc[0] : null : qc;
            typeof xu != "function" && typeof xu != "symbol" && xu !== null && xu !== void 0 && e.push(
              q(Cn(xu))
            ), Ae(
              e,
              es,
              qc
            ), e.push(gi("style"));
            var ns = null;
          } else {
            ji.includes(" ") && console.error(
              'React expected the `href` prop for a <style> tag opting into hoisting semantics using the `precedence` prop to not have any spaces but ecountered spaces instead. using spaces in this prop will cause hydration of this style to fail on the client. The href for the <style> where this ocurred is "%s".',
              ji
            );
            var vc = b.styles.get(xo), ts = h.styleResources.hasOwnProperty(ji) ? h.styleResources[ji] : void 0;
            if (ts !== _e) {
              h.styleResources[ji] = _e, ts && console.error(
                'React encountered a hoistable style tag for the same href as a preload: "%s". When using a style tag to inline styles you should not also preload it as a stylsheet.',
                ji
              ), vc ? vc.hrefs.push(
                q(Pe(ji))
              ) : (vc = {
                precedence: q(
                  Pe(xo)
                ),
                rules: [],
                hrefs: [q(Pe(ji))],
                sheets: /* @__PURE__ */ new Map()
              }, b.styles.set(
                xo,
                vc
              ));
              var ku = vc.rules, Gr = null, rs = null, gs;
              for (gs in u)
                if (Je.call(u, gs)) {
                  var ws = u[gs];
                  if (ws != null)
                    switch (gs) {
                      case "children":
                        Gr = ws;
                        break;
                      case "dangerouslySetInnerHTML":
                        rs = ws;
                    }
                }
              var ls = Array.isArray(Gr) ? 2 > Gr.length ? Gr[0] : null : Gr;
              typeof ls != "function" && typeof ls != "symbol" && ls !== null && ls !== void 0 && ku.push(
                q(Cn(ls))
              ), Ae(ku, rs, Gr);
            }
            vc && S && S.styles.add(vc), W && e.push(tl), ns = void 0;
          }
          return ns;
        case "meta":
          if (F.insertionMode === ar || F.tagScope & 1 || u.itemProp != null)
            var Ss = gr(
              e,
              u,
              "meta"
            );
          else
            W && e.push(tl), Ss = O ? null : typeof u.charSet == "string" ? gr(b.charsetChunks, u, "meta") : u.name === "viewport" ? gr(b.viewportChunks, u, "meta") : gr(
              b.hoistableChunks,
              u,
              "meta"
            );
          return Ss;
        case "listing":
        case "pre":
          e.push(ke(t));
          var is = null, as = null, os;
          for (os in u)
            if (Je.call(u, os)) {
              var vs = u[os];
              if (vs != null)
                switch (os) {
                  case "children":
                    is = vs;
                    break;
                  case "dangerouslySetInnerHTML":
                    as = vs;
                    break;
                  default:
                    ze(
                      e,
                      os,
                      vs
                    );
                }
            }
          if (e.push(En), as != null) {
            if (is != null)
              throw Error(
                "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
              );
            if (typeof as != "object" || !("__html" in as))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            var Nu = as.__html;
            Nu != null && (typeof Nu == "string" && 0 < Nu.length && Nu[0] === `
` ? e.push(Jo, q(Nu)) : (xe(Nu), e.push(q("" + Nu))));
          }
          return typeof is == "string" && is[0] === `
` && e.push(Jo), is;
        case "img":
          var Bl = u.src, cl = u.srcSet;
          if (!(u.loading === "lazy" || !Bl && !cl || typeof Bl != "string" && Bl != null || typeof cl != "string" && cl != null) && u.fetchPriority !== "low" && !(F.tagScope & 3) && (typeof Bl != "string" || Bl[4] !== ":" || Bl[0] !== "d" && Bl[0] !== "D" || Bl[1] !== "a" && Bl[1] !== "A" || Bl[2] !== "t" && Bl[2] !== "T" || Bl[3] !== "a" && Bl[3] !== "A") && (typeof cl != "string" || cl[4] !== ":" || cl[0] !== "d" && cl[0] !== "D" || cl[1] !== "a" && cl[1] !== "A" || cl[2] !== "t" && cl[2] !== "T" || cl[3] !== "a" && cl[3] !== "A")) {
            var Fs = typeof u.sizes == "string" ? u.sizes : void 0, ju = cl ? cl + `
` + (Fs || "") : Bl, Ts = b.preloads.images, Ku = Ts.get(ju);
            if (Ku)
              (u.fetchPriority === "high" || 10 > b.highImagePreloads.size) && (Ts.delete(ju), b.highImagePreloads.add(Ku));
            else if (!h.imageResources.hasOwnProperty(ju)) {
              h.imageResources[ju] = Re;
              var Es = u.crossOrigin, As = typeof Es == "string" ? Es === "use-credentials" ? Es : "" : void 0, qu = b.headers, Rs;
              qu && 0 < qu.remainingCapacity && typeof u.srcSet != "string" && (u.fetchPriority === "high" || 500 > qu.highImagePreloads.length) && (Rs = yi(Bl, "image", {
                imageSrcSet: u.srcSet,
                imageSizes: u.sizes,
                crossOrigin: As,
                integrity: u.integrity,
                nonce: u.nonce,
                type: u.type,
                fetchPriority: u.fetchPriority,
                referrerPolicy: u.refererPolicy
              }), 0 <= (qu.remainingCapacity -= Rs.length + 2)) ? (b.resets.image[ju] = Re, qu.highImagePreloads && (qu.highImagePreloads += ", "), qu.highImagePreloads += Rs) : (Ku = [], tt(Ku, {
                rel: "preload",
                as: "image",
                href: cl ? void 0 : Bl,
                imageSrcSet: cl,
                imageSizes: Fs,
                crossOrigin: As,
                integrity: u.integrity,
                type: u.type,
                fetchPriority: u.fetchPriority,
                referrerPolicy: u.referrerPolicy
              }), u.fetchPriority === "high" || 10 > b.highImagePreloads.size ? b.highImagePreloads.add(Ku) : (b.bulkPreloads.add(Ku), Ts.set(ju, Ku)));
            }
          }
          return gr(e, u, "img");
        case "base":
        case "area":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return gr(e, u, t);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          break;
        case "head":
          if (F.insertionMode < In) {
            var xs = E || b.preamble;
            if (xs.headChunks)
              throw Error("The `<head>` tag may only be rendered once.");
            xs.headChunks = [];
            var ps = Yt(
              xs.headChunks,
              u,
              "head"
            );
          } else
            ps = Bn(
              e,
              u,
              "head"
            );
          return ps;
        case "body":
          if (F.insertionMode < In) {
            var ks = E || b.preamble;
            if (ks.bodyChunks)
              throw Error("The `<body>` tag may only be rendered once.");
            ks.bodyChunks = [];
            var Os = Yt(
              ks.bodyChunks,
              u,
              "body"
            );
          } else
            Os = Bn(
              e,
              u,
              "body"
            );
          return Os;
        case "html":
          if (F.insertionMode === Dr) {
            var Cs = E || b.preamble;
            if (Cs.htmlChunks)
              throw Error("The `<html>` tag may only be rendered once.");
            Cs.htmlChunks = [jn];
            var Ms = Yt(
              Cs.htmlChunks,
              u,
              "html"
            );
          } else
            Ms = Bn(
              e,
              u,
              "html"
            );
          return Ms;
        default:
          if (t.indexOf("-") !== -1) {
            e.push(ke(t));
            var Ps = null, Is = null, $u;
            for ($u in u)
              if (Je.call(u, $u)) {
                var bc = u[$u];
                if (bc != null) {
                  var Ds = $u;
                  switch ($u) {
                    case "children":
                      Ps = bc;
                      break;
                    case "dangerouslySetInnerHTML":
                      Is = bc;
                      break;
                    case "style":
                      gt(e, bc);
                      break;
                    case "suppressContentEditableWarning":
                    case "suppressHydrationWarning":
                    case "ref":
                      break;
                    case "className":
                      Ds = "class";
                    default:
                      if (Zr($u) && typeof bc != "function" && typeof bc != "symbol" && bc !== !1) {
                        if (bc === !0)
                          bc = "";
                        else if (typeof bc == "object")
                          continue;
                        e.push(
                          qn,
                          q(Ds),
                          Ht,
                          q(
                            Pe(bc)
                          ),
                          Tn
                        );
                      }
                  }
                }
              }
            return e.push(En), Ae(
              e,
              Is,
              Ps
            ), Ps;
          }
      }
      return Bn(e, u, t);
    }
    function gi(e) {
      var t = wa.get(e);
      return t === void 0 && (t = U("</" + e + ">"), wa.set(e, t)), t;
    }
    function vr(e, t) {
      e = e.preamble, e.htmlChunks === null && t.htmlChunks && (e.htmlChunks = t.htmlChunks, t.contribution |= 1), e.headChunks === null && t.headChunks && (e.headChunks = t.headChunks, t.contribution |= 4), e.bodyChunks === null && t.bodyChunks && (e.bodyChunks = t.bodyChunks, t.contribution |= 2);
    }
    function rt(e, t) {
      t = t.bootstrapChunks;
      for (var u = 0; u < t.length - 1; u++)
        z(e, t[u]);
      return u < t.length ? (u = t[u], t.length = 0, Ce(e, u)) : !0;
    }
    function Rc(e, t, u) {
      if (z(e, Ko), u === null)
        throw Error(
          "An ID must have been assigned before we can complete the boundary."
        );
      return z(e, t.boundaryPrefix), z(e, q(u.toString(16))), Ce(e, Cr);
    }
    function xc(e, t) {
      t = t.contribution, t !== Ct && (z(e, zc), z(e, q("" + t)), z(e, $o));
    }
    function $i(e, t, u, h) {
      switch (u.insertionMode) {
        case Dr:
        case ir:
        case xr:
        case In:
          return z(e, il), z(e, t.segmentPrefix), z(e, q(h.toString(16))), Ce(e, ei);
        case ar:
          return z(e, Ea), z(e, t.segmentPrefix), z(e, q(h.toString(16))), Ce(e, ec);
        case nl:
          return z(e, Ni), z(e, t.segmentPrefix), z(e, q(h.toString(16))), Ce(e, Ui);
        case Lr:
          return z(e, Ra), z(e, t.segmentPrefix), z(e, q(h.toString(16))), Ce(e, xa);
        case kr:
          return z(e, l), z(e, t.segmentPrefix), z(e, q(h.toString(16))), Ce(e, a);
        case _c:
          return z(e, v), z(e, t.segmentPrefix), z(e, q(h.toString(16))), Ce(e, w);
        case Kl:
          return z(e, P), z(e, t.segmentPrefix), z(e, q(h.toString(16))), Ce(e, _);
        default:
          throw Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function kc(e, t) {
      switch (t.insertionMode) {
        case Dr:
        case ir:
        case xr:
        case In:
          return Ce(e, io);
        case ar:
          return Ce(e, ao);
        case nl:
          return Ce(e, mi);
        case Lr:
          return Ce(e, nc);
        case kr:
          return Ce(e, s);
        case _c:
          return Ce(e, k);
        case Kl:
          return Ce(e, A);
        default:
          throw Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Ul(e) {
      return JSON.stringify(e).replace(
        Rn,
        function(t) {
          switch (t) {
            case "<":
              return "\\u003c";
            case "\u2028":
              return "\\u2028";
            case "\u2029":
              return "\\u2029";
            default:
              throw Error(
                "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
              );
          }
        }
      );
    }
    function vi(e) {
      return JSON.stringify(e).replace(
        Ft,
        function(t) {
          switch (t) {
            case "&":
              return "\\u0026";
            case ">":
              return "\\u003e";
            case "<":
              return "\\u003c";
            case "\u2028":
              return "\\u2028";
            case "\u2029":
              return "\\u2029";
            default:
              throw Error(
                "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
              );
          }
        }
      );
    }
    function po(e) {
      var t = e.rules, u = e.hrefs;
      0 < t.length && u.length === 0 && console.error(
        "React expected to have at least one href for an a hoistable style but found none. This is a bug in React."
      );
      var h = 0;
      if (u.length) {
        for (z(this, ka), z(this, e.precedence), z(this, ni); h < u.length - 1; h++)
          z(this, u[h]), z(this, Mu);
        for (z(this, u[h]), z(this, ti), h = 0; h < t.length; h++)
          z(this, t[h]);
        du = Ce(
          this,
          Ca
        ), ri = !0, t.length = 0, u.length = 0;
      }
    }
    function ma(e) {
      return e.state !== Uc ? ri = !0 : !1;
    }
    function ea(e, t, u) {
      return ri = !1, du = !0, t.styles.forEach(po, e), t.stylesheets.forEach(ma), ri && (u.stylesToHoist = !0), du;
    }
    function me(e) {
      for (var t = 0; t < e.length; t++)
        z(this, e[t]);
      e.length = 0;
    }
    function $t(e) {
      tt(Yi, e.props);
      for (var t = 0; t < Yi.length; t++)
        z(this, Yi[t]);
      Yi.length = 0, e.state = Uc;
    }
    function Oo(e) {
      var t = 0 < e.sheets.size;
      e.sheets.forEach($t, this), e.sheets.clear();
      var u = e.rules, h = e.hrefs;
      if (!t || h.length) {
        if (z(this, mu), z(this, e.precedence), e = 0, h.length) {
          for (z(this, Yu); e < h.length - 1; e++)
            z(this, h[e]), z(this, Mu);
          z(this, h[e]);
        }
        for (z(this, Bc), e = 0; e < u.length; e++)
          z(this, u[e]);
        z(this, Gu), u.length = 0, h.length = 0;
      }
    }
    function bi(e) {
      if (e.state === Pr) {
        e.state = Nc;
        var t = e.props;
        for (tt(Yi, {
          rel: "preload",
          as: "style",
          href: e.props.href,
          crossOrigin: t.crossOrigin,
          fetchPriority: t.fetchPriority,
          integrity: t.integrity,
          media: t.media,
          hrefLang: t.hrefLang,
          referrerPolicy: t.referrerPolicy
        }), e = 0; e < Yi.length; e++)
          z(this, Yi[e]);
        Yi.length = 0;
      }
    }
    function Qr(e) {
      e.sheets.forEach(bi, this), e.sheets.clear();
    }
    function Cc(e, t) {
      z(e, Iu);
      var u = Iu;
      t.stylesheets.forEach(function(h) {
        if (h.state !== Uc)
          if (h.state === gu)
            z(e, u), h = h.props.href, qt(h, "href"), z(
              e,
              q(
                vi("" + h)
              )
            ), z(e, Du), u = Pl;
          else {
            z(e, u);
            var b = h.props["data-precedence"], E = h.props, S = Xe("" + h.props.href);
            z(
              e,
              q(vi(S))
            ), qt(b, "precedence"), b = "" + b, z(e, ur), z(
              e,
              q(vi(b))
            );
            for (var F in E)
              if (Je.call(E, F) && (b = E[F], b != null))
                switch (F) {
                  case "href":
                  case "rel":
                  case "precedence":
                  case "data-precedence":
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      "link is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    eu(
                      e,
                      F,
                      b
                    );
                }
            z(e, Du), u = Pl, h.state = gu;
          }
      }), z(e, Du);
    }
    function eu(e, t, u) {
      var h = t.toLowerCase();
      switch (typeof u) {
        case "function":
        case "symbol":
          return;
      }
      switch (t) {
        case "innerHTML":
        case "dangerouslySetInnerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "style":
        case "ref":
          return;
        case "className":
          h = "class", qt(u, h), t = "" + u;
          break;
        case "hidden":
          if (u === !1)
            return;
          t = "";
          break;
        case "src":
        case "href":
          u = Xe(u), qt(u, h), t = "" + u;
          break;
        default:
          if (2 < t.length && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N") || !Zr(t))
            return;
          qt(u, h), t = "" + u;
      }
      z(e, ur), z(
        e,
        q(vi(h))
      ), z(e, ur), z(
        e,
        q(vi(t))
      );
    }
    function Pc() {
      return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set() };
    }
    function Mo(e, t, u, h) {
      (e.scriptResources.hasOwnProperty(u) || e.moduleScriptResources.hasOwnProperty(u)) && console.error(
        'Internal React Error: React expected bootstrap script or module with src "%s" to not have been preloaded already. please file an issue',
        u
      ), e.scriptResources[u] = _e, e.moduleScriptResources[u] = _e, e = [], tt(e, h), t.bootstrapScripts.add(e);
    }
    function on(e, t) {
      e.crossOrigin == null && (e.crossOrigin = t[0]), e.integrity == null && (e.integrity = t[1]);
    }
    function yi(e, t, u) {
      e = lt(e), t = Nn(t, "as"), t = "<" + e + '>; rel=preload; as="' + t + '"';
      for (var h in u)
        Je.call(u, h) && (e = u[h], typeof e == "string" && (t += "; " + h.toLowerCase() + '="' + Nn(
          e,
          h
        ) + '"'));
      return t;
    }
    function lt(e) {
      return qt(e, "href"), ("" + e).replace(
        vu,
        br
      );
    }
    function br(e) {
      switch (e) {
        case "<":
          return "%3C";
        case ">":
          return "%3E";
        case `
`:
          return "%0A";
        case "\r":
          return "%0D";
        default:
          throw Error(
            "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
          );
      }
    }
    function Nn(e, t) {
      return Na(e) && (console.error(
        "The provided `%s` option is an unsupported type %s. This value must be coerced to a string before using it here.",
        t,
        wc(e)
      ), Po(e)), ("" + e).replace(
        vn,
        na
      );
    }
    function na(e) {
      switch (e) {
        case '"':
          return "%22";
        case "'":
          return "%27";
        case ";":
          return "%3B";
        case ",":
          return "%2C";
        case `
`:
          return "%0A";
        case "\r":
          return "%0D";
        default:
          throw Error(
            "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
          );
      }
    }
    function yr(e) {
      this.styles.add(e);
    }
    function Jn(e) {
      this.stylesheets.add(e);
    }
    function dn(e) {
      if (e == null)
        return null;
      if (typeof e == "function")
        return e.$$typeof === oo ? null : e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case Rl:
          return "Fragment";
        case ga:
          return "Profiler";
        case No:
          return "StrictMode";
        case Ka:
          return "Suspense";
        case jr:
          return "SuspenseList";
        case Di:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case Kr:
            return "Portal";
          case qr:
            return (e.displayName || "Context") + ".Provider";
          case Mi:
            return (e._context.displayName || "Context") + ".Consumer";
          case Ii:
            var t = e.render;
            return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case gn:
            return t = e.displayName || null, t !== null ? t : dn(e.type) || "Memo";
          case Un:
            t = e._payload, e = e._init;
            try {
              return dn(e(t));
            } catch {
            }
        }
      return null;
    }
    function wi(e, t) {
      if (e !== t) {
        e.context._currentValue = e.parentValue, e = e.parent;
        var u = t.parent;
        if (e === null) {
          if (u !== null)
            throw Error(
              "The stacks must reach the root at the same time. This is a bug in React."
            );
        } else {
          if (u === null)
            throw Error(
              "The stacks must reach the root at the same time. This is a bug in React."
            );
          wi(e, u);
        }
        t.context._currentValue = t.value;
      }
    }
    function er(e) {
      e.context._currentValue = e.parentValue, e = e.parent, e !== null && er(e);
    }
    function wr(e) {
      var t = e.parent;
      t !== null && wr(t), e.context._currentValue = e.value;
    }
    function nu(e, t) {
      if (e.context._currentValue = e.parentValue, e = e.parent, e === null)
        throw Error(
          "The depth must equal at least at zero before reaching the root. This is a bug in React."
        );
      e.depth === t.depth ? wi(e, t) : nu(e, t);
    }
    function Ya(e, t) {
      var u = t.parent;
      if (u === null)
        throw Error(
          "The depth must equal at least at zero before reaching the root. This is a bug in React."
        );
      e.depth === u.depth ? wi(e, u) : Ya(e, u), t.context._currentValue = t.value;
    }
    function Be(e) {
      var t = Sl;
      t !== e && (t === null ? wr(e) : e === null ? er(t) : t.depth === e.depth ? wi(t, e) : t.depth > e.depth ? nu(t, e) : Ya(t, e), Sl = e);
    }
    function sn(e) {
      if (e !== null && typeof e != "function") {
        var t = String(e);
        Al.has(t) || (Al.add(t), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          e
        ));
      }
    }
    function ta(e, t) {
      e = (e = e.constructor) && dn(e) || "ReactClass";
      var u = e + "." + t;
      Sa[u] || (console.error(
        `Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`,
        t,
        e
      ), Sa[u] = !0);
    }
    function vt(e, t, u) {
      var h = e.id;
      e = e.overflow;
      var b = 32 - Yc(h) - 1;
      h &= ~(1 << b), u += 1;
      var E = 32 - Yc(t) + b;
      if (30 < E) {
        var S = b - b % 5;
        return E = (h & (1 << S) - 1).toString(32), h >>= S, b -= S, {
          id: 1 << 32 - Yc(t) + b | u << b | h,
          overflow: E + e
        };
      }
      return {
        id: 1 << E | u << b | h,
        overflow: e
      };
    }
    function ra(e) {
      return e >>>= 0, e === 0 ? 32 : 31 - (Gc(e) / Xu | 0) | 0;
    }
    function fl() {
    }
    function Pu(e, t, u) {
      switch (u = e[u], u === void 0 ? e.push(t) : u !== t && (t.then(fl, fl), t = u), t.status) {
        case "fulfilled":
          return t.value;
        case "rejected":
          throw t.reason;
        default:
          switch (typeof t.status == "string" ? t.then(fl, fl) : (e = t, e.status = "pending", e.then(
            function(h) {
              if (t.status === "pending") {
                var b = t;
                b.status = "fulfilled", b.value = h;
              }
            },
            function(h) {
              if (t.status === "pending") {
                var b = t;
                b.status = "rejected", b.reason = h;
              }
            }
          )), t.status) {
            case "fulfilled":
              return t.value;
            case "rejected":
              throw t.reason;
          }
          throw Aa = t, pl;
      }
    }
    function la() {
      if (Aa === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var e = Aa;
      return Aa = null, e;
    }
    function Su(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    function hl() {
      if (li === null)
        throw Error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        );
      return xn && console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      ), li;
    }
    function bt() {
      if (0 < Ar)
        throw Error("Rendered more hooks than during the previous render");
      return { memoizedState: null, queue: null, next: null };
    }
    function Sc() {
      return en === null ? lc === null ? (Xi = !1, lc = en = bt()) : (Xi = !0, en = lc) : en.next === null ? (Xi = !1, en = en.next = bt()) : (Xi = !0, en = en.next), en;
    }
    function Jr() {
      var e = ac;
      return ac = null, e;
    }
    function nr() {
      xn = !1, ii = yu = rc = li = null, uo = !1, lc = null, Ar = 0, en = _n = null;
    }
    function Ga(e) {
      return xn && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), e._currentValue;
    }
    function Ti(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function dl(e, t, u) {
      if (e !== Ti && (Oa = "useReducer"), li = hl(), en = Sc(), Xi) {
        if (u = en.queue, t = u.dispatch, _n !== null) {
          var h = _n.get(u);
          if (h !== void 0) {
            _n.delete(u), u = en.memoizedState;
            do {
              var b = h.action;
              xn = !0, u = e(u, b), xn = !1, h = h.next;
            } while (h !== null);
            return en.memoizedState = u, [u, t];
          }
        }
        return [en.memoizedState, t];
      }
      return xn = !0, e = e === Ti ? typeof t == "function" ? t() : t : u !== void 0 ? u(t) : t, xn = !1, en.memoizedState = e, e = en.queue = { last: null, dispatch: null }, e = e.dispatch = Fc.bind(
        null,
        li,
        e
      ), [en.memoizedState, e];
    }
    function Ei(e, t) {
      if (li = hl(), en = Sc(), t = t === void 0 ? null : t, en !== null) {
        var u = en.memoizedState;
        if (u !== null && t !== null) {
          e: {
            var h = u[1];
            if (h === null)
              console.error(
                "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
                Oa
              ), h = !1;
            else {
              t.length !== h.length && console.error(
                `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
                Oa,
                "[" + t.join(", ") + "]",
                "[" + h.join(", ") + "]"
              );
              for (var b = 0; b < h.length && b < t.length; b++)
                if (!Hu(t[b], h[b])) {
                  h = !1;
                  break e;
                }
              h = !0;
            }
          }
          if (h)
            return u[0];
        }
      }
      return xn = !0, e = e(), xn = !1, en.memoizedState = [e, t], e;
    }
    function Fc(e, t, u) {
      if (25 <= Ar)
        throw Error(
          "Too many re-renders. React limits the number of renders to prevent an infinite loop."
        );
      if (e === li)
        if (uo = !0, e = { action: u, next: null }, _n === null && (_n = /* @__PURE__ */ new Map()), u = _n.get(t), u === void 0)
          _n.set(t, e);
        else {
          for (t = u; t.next !== null; )
            t = t.next;
          t.next = e;
        }
    }
    function Fu() {
      throw Error("startTransition cannot be called during server rendering.");
    }
    function ml() {
      throw Error("Cannot update optimistic state while rendering.");
    }
    function bn(e, t, u) {
      hl();
      var h = so++, b = yu;
      if (typeof e.$$FORM_ACTION == "function") {
        var E = null, S = ii;
        b = b.formState;
        var F = e.$$IS_SIGNATURE_EQUAL;
        if (b !== null && typeof F == "function") {
          var W = b[1];
          F.call(e, b[2], b[3]) && (E = u !== void 0 ? "p" + u : "k" + Co(
            JSON.stringify([
              S,
              null,
              h
            ]),
            0
          ), W === E && (Xc = h, t = b[0]));
        }
        var O = e.bind(null, t);
        return e = function(J) {
          O(J);
        }, typeof O.$$FORM_ACTION == "function" && (e.$$FORM_ACTION = function(J) {
          J = O.$$FORM_ACTION(J), u !== void 0 && (qt(u, "target"), u += "", J.action = u);
          var re = J.data;
          return re && (E === null && (E = u !== void 0 ? "p" + u : "k" + Co(
            JSON.stringify([
              S,
              null,
              h
            ]),
            0
          )), re.append("$ACTION_KEY", E)), J;
        }), [t, e, !1];
      }
      var V = e.bind(null, t);
      return [
        t,
        function(J) {
          V(J);
        },
        !1
      ];
    }
    function Io(e) {
      var t = ic;
      return ic += 1, ac === null && (ac = []), Pu(ac, e, t);
    }
    function tu() {
      throw Error("Cache cannot be refreshed during server rendering.");
    }
    function Xa() {
    }
    function It() {
    }
    function ru() {
      if (Ol === 0) {
        fo = console.log, Wu = console.info, cc = console.warn, Zc = console.error, uc = console.group, n = console.groupCollapsed, r = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: It,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      Ol++;
    }
    function Ri() {
      if (Ol--, Ol === 0) {
        var e = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: yn({}, e, { value: fo }),
          info: yn({}, e, { value: Wu }),
          warn: yn({}, e, { value: cc }),
          error: yn({}, e, { value: Zc }),
          group: yn({}, e, { value: uc }),
          groupCollapsed: yn({}, e, { value: n }),
          groupEnd: yn({}, e, { value: r })
        });
      }
      0 > Ol && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function Mr(e) {
      if (c === void 0)
        try {
          throw Error();
        } catch (u) {
          var t = u.stack.trim().match(/\n( *(at )?)/);
          c = t && t[1] || "", d = -1 < u.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < u.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + c + e + d;
    }
    function Yl(e, t) {
      if (!e || y)
        return "";
      var u = R.get(e);
      if (u !== void 0)
        return u;
      y = !0, u = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var h = null;
      h = ae.H, ae.H = null, ru();
      try {
        var b = {
          DetermineComponentFrameRoot: function() {
            try {
              if (t) {
                var re = function() {
                  throw Error();
                };
                if (Object.defineProperty(re.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(re, []);
                  } catch (Z) {
                    var ne = Z;
                  }
                  Reflect.construct(e, [], re);
                } else {
                  try {
                    re.call();
                  } catch (Z) {
                    ne = Z;
                  }
                  e.call(re.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (Z) {
                  ne = Z;
                }
                (re = e()) && typeof re.catch == "function" && re.catch(function() {
                });
              }
            } catch (Z) {
              if (Z && ne && typeof Z.stack == "string")
                return [Z.stack, ne.stack];
            }
            return [null, null];
          }
        };
        b.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var E = Object.getOwnPropertyDescriptor(
          b.DetermineComponentFrameRoot,
          "name"
        );
        E && E.configurable && Object.defineProperty(
          b.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var S = b.DetermineComponentFrameRoot(), F = S[0], W = S[1];
        if (F && W) {
          var O = F.split(`
`), V = W.split(`
`);
          for (S = E = 0; E < O.length && !O[E].includes(
            "DetermineComponentFrameRoot"
          ); )
            E++;
          for (; S < V.length && !V[S].includes(
            "DetermineComponentFrameRoot"
          ); )
            S++;
          if (E === O.length || S === V.length)
            for (E = O.length - 1, S = V.length - 1; 1 <= E && 0 <= S && O[E] !== V[S]; )
              S--;
          for (; 1 <= E && 0 <= S; E--, S--)
            if (O[E] !== V[S]) {
              if (E !== 1 || S !== 1)
                do
                  if (E--, S--, 0 > S || O[E] !== V[S]) {
                    var J = `
` + O[E].replace(
                      " at new ",
                      " at "
                    );
                    return e.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", e.displayName)), typeof e == "function" && R.set(e, J), J;
                  }
                while (1 <= E && 0 <= S);
              break;
            }
        }
      } finally {
        y = !1, ae.H = h, Ri(), Error.prepareStackTrace = u;
      }
      return O = (O = e ? e.displayName || e.name : "") ? Mr(O) : "", typeof e == "function" && R.set(e, O), O;
    }
    function ia(e) {
      var t = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, e = e.stack, Error.prepareStackTrace = t, e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)), t = e.indexOf(`
`), t !== -1 && (e = e.slice(t + 1)), t = e.indexOf("react-stack-bottom-frame"), t !== -1 && (t = e.lastIndexOf(
        `
`,
        t
      )), t !== -1)
        e = e.slice(0, t);
      else
        return "";
      return e;
    }
    function Do(e) {
      if (typeof e == "string")
        return Mr(e);
      if (typeof e == "function")
        return e.prototype && e.prototype.isReactComponent ? Yl(e, !0) : Yl(e, !1);
      if (typeof e == "object" && e !== null) {
        switch (e.$$typeof) {
          case Ii:
            return Yl(e.render, !1);
          case gn:
            return Yl(e.type, !1);
          case Un:
            var t = e, u = t._payload;
            t = t._init;
            try {
              e = t(u);
            } catch {
              return Mr("Lazy");
            }
            return Do(e);
        }
        if (typeof e.name == "string")
          return u = e.env, Mr(
            e.name + (u ? " [" + u + "]" : "")
          );
      }
      switch (e) {
        case jr:
          return Mr("SuspenseList");
        case Ka:
          return Mr("Suspense");
      }
      return "";
    }
    function aa(e) {
      if (typeof e == "object" && e !== null && typeof e.environmentName == "string") {
        var t = e.environmentName;
        e = [e].slice(0), typeof e[0] == "string" ? e.splice(
          0,
          1,
          "%c%s%c " + e[0],
          "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
          " " + t + " ",
          ""
        ) : e.splice(
          0,
          0,
          "%c%s%c ",
          "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
          " " + t + " ",
          ""
        ), e.unshift(console), t = mc.apply(console.error, e), t();
      } else
        console.error(e);
      return null;
    }
    function Tr() {
    }
    function xi(e, t, u, h, b, E, S, F, W, O, V) {
      var J = /* @__PURE__ */ new Set();
      this.destination = null, this.flushScheduled = !1, this.resumableState = e, this.renderState = t, this.rootFormatContext = u, this.progressiveChunkSize = h === void 0 ? 12800 : h, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.abortableTasks = J, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = b === void 0 ? aa : b, this.onPostpone = O === void 0 ? Tr : O, this.onAllReady = E === void 0 ? Tr : E, this.onShellReady = S === void 0 ? Tr : S, this.onShellError = F === void 0 ? Tr : F, this.onFatalError = W === void 0 ? Tr : W, this.formState = V === void 0 ? null : V, this.didWarnForKey = null;
    }
    function oa(e, t, u, h, b, E, S, F, W, O, V, J) {
      var re = G();
      return 1e3 < re - le && (ae.recentlyCreatedOwnerStacks = 0, le = re), t = new xi(
        t,
        u,
        h,
        b,
        E,
        S,
        F,
        W,
        O,
        V,
        J
      ), u = Er(
        t,
        0,
        null,
        h,
        !1,
        !1
      ), u.parentFlushed = !0, e = vl(
        t,
        null,
        e,
        -1,
        null,
        u,
        null,
        null,
        t.abortableTasks,
        null,
        h,
        null,
        bu,
        null,
        !1,
        Xn,
        null
      ), bl(e), t.pingedTasks.push(e), t;
    }
    function Gl(e, t, u, h, b, E, S, F, W, O, V) {
      return e = oa(
        e,
        t,
        u,
        h,
        b,
        E,
        S,
        F,
        W,
        O,
        V,
        void 0
      ), e.trackedPostpones = {
        workingMap: /* @__PURE__ */ new Map(),
        rootNodes: [],
        rootSlots: null
      }, e;
    }
    function gl(e, t) {
      e.pingedTasks.push(t), e.pingedTasks.length === 1 && (e.flushScheduled = e.destination !== null, e.trackedPostpones !== null || e.status === 10 ? Au(function() {
        return sa(e);
      }) : za(function() {
        return sa(e);
      }));
    }
    function yt(e, t, u, h) {
      return {
        status: Te,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: t,
        errorDigest: null,
        contentState: Pc(),
        fallbackState: Pc(),
        contentPreamble: u,
        fallbackPreamble: h,
        trackedContentKeyPath: null,
        trackedFallbackNode: null,
        errorMessage: null,
        errorStack: null,
        errorComponentStack: null
      };
    }
    function vl(e, t, u, h, b, E, S, F, W, O, V, J, re, ne, Z, He, nn) {
      e.allPendingTasks++, b === null ? e.pendingRootTasks++ : b.pendingTasks++;
      var Oe = {
        replay: null,
        node: u,
        childIndex: h,
        ping: function() {
          return gl(e, Oe);
        },
        blockedBoundary: b,
        blockedSegment: E,
        blockedPreamble: S,
        hoistableState: F,
        abortSet: W,
        keyPath: O,
        formatContext: V,
        context: J,
        treeContext: re,
        componentStack: ne,
        thenableState: t,
        isFallback: Z
      };
      return Oe.debugTask = nn, W.add(Oe), Oe;
    }
    function lu(e, t, u, h, b, E, S, F, W, O, V, J, re, ne, Z, He) {
      e.allPendingTasks++, E === null ? e.pendingRootTasks++ : E.pendingTasks++, u.pendingTasks++;
      var nn = {
        replay: u,
        node: h,
        childIndex: b,
        ping: function() {
          return gl(e, nn);
        },
        blockedBoundary: E,
        blockedSegment: null,
        blockedPreamble: null,
        hoistableState: S,
        abortSet: F,
        keyPath: W,
        formatContext: O,
        context: V,
        treeContext: J,
        componentStack: re,
        thenableState: t,
        isFallback: ne
      };
      return nn.debugTask = He, F.add(nn), nn;
    }
    function Er(e, t, u, h, b, E) {
      return {
        status: Te,
        parentFlushed: !1,
        id: -1,
        index: t,
        chunks: [],
        children: [],
        preambleChildren: [],
        parentFormatContext: h,
        boundary: u,
        lastPushedText: b,
        textEmbedded: E
      };
    }
    function Xl() {
      if (fn === null || fn.componentStack === null)
        return "";
      var e = fn.componentStack;
      try {
        var t = "";
        if (typeof e.type == "string")
          t += Mr(e.type);
        else if (typeof e.type == "function") {
          if (!e.owner) {
            var u = t, h = e.type, b = h ? h.displayName || h.name : "", E = b ? Mr(b) : "";
            t = u + E;
          }
        } else
          e.owner || (t += Do(e.type));
        for (; e; )
          u = null, e.debugStack != null ? u = ia(
            e.debugStack
          ) : (E = e, E.stack != null && (u = typeof E.stack != "string" ? E.stack = ia(
            E.stack
          ) : E.stack)), (e = e.owner) && u && (t += `
` + u);
        var S = t;
      } catch (F) {
        S = `
Error generating stack: ` + F.message + `
` + F.stack;
      }
      return S;
    }
    function Za(e, t) {
      if (t != null)
        for (var u = 0; u < t.length; u++) {
          var h = t[u];
          typeof h.name == "string" && h.debugStack !== void 0 && (e.componentStack = {
            parent: e.componentStack,
            type: h,
            owner: h.owner,
            stack: h.debugStack
          }, e.debugTask = h.debugTask);
        }
    }
    function bl(e) {
      var t = e.node;
      if (typeof t == "object" && t !== null)
        switch (t.$$typeof) {
          case Oi:
            var u = t.type, h = t._owner, b = t._debugStack;
            Za(e, t._debugInfo), e.debugTask = t._debugTask, e.componentStack = {
              parent: e.componentStack,
              type: u,
              owner: h,
              stack: b
            };
            break;
          case Un:
            Za(e, t._debugInfo);
            break;
          default:
            typeof t.then == "function" && Za(e, t._debugInfo);
        }
    }
    function An(e) {
      var t = {};
      return e && Object.defineProperty(t, "componentStack", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          try {
            var u = "", h = e;
            do
              u += Do(h.type), h = h.parent;
            while (h);
            var b = u;
          } catch (E) {
            b = `
Error generating stack: ` + E.message + `
` + E.stack;
          }
          return Object.defineProperty(t, "componentStack", {
            value: b
          }), b;
        }
      }), t;
    }
    function ki(e, t, u, h, b) {
      e.errorDigest = t, u instanceof Error ? (t = String(u.message), u = String(u.stack)) : (t = typeof u == "object" && u !== null ? Xr(u) : String(u), u = null), b = b ? `Switched to client rendering because the server rendering aborted due to:

` : `Switched to client rendering because the server rendering errored:

`, e.errorMessage = b + t, e.errorStack = u !== null ? b + u : null, e.errorComponentStack = h.componentStack;
    }
    function Gt(e, t, u, h) {
      if (e = e.onError, t = h ? h.run(e.bind(null, t, u)) : e(t, u), t != null && typeof t != "string")
        console.error(
          'onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "%s" instead',
          typeof t
        );
      else
        return t;
    }
    function Xt(e, t, u, h) {
      u = e.onShellError;
      var b = e.onFatalError;
      h ? (h.run(u.bind(null, t)), h.run(b.bind(null, t))) : (u(t), b(t)), e.destination !== null ? (e.status = Ue, sl(e.destination, t)) : (e.status = 13, e.fatalError = t);
    }
    function Lo(e, t, u, h, b, E) {
      var S = t.thenableState;
      for (t.thenableState = null, li = {}, rc = t, yu = e, ii = u, xn = !1, so = pa = 0, Xc = -1, ic = 0, ac = S, e = M(h, b, E); uo; )
        uo = !1, so = pa = 0, Xc = -1, ic = 0, Ar += 1, en = null, e = h(b, E);
      return nr(), e;
    }
    function _o(e, t, u, h, b, E, S) {
      var F = !1;
      if (E !== 0 && e.formState !== null) {
        var W = t.blockedSegment;
        if (W !== null) {
          F = !0, W = W.chunks;
          for (var O = 0; O < E; O++)
            O === S ? W.push(Pt) : W.push(jl);
        }
      }
      E = t.keyPath, t.keyPath = u, b ? (u = t.treeContext, t.treeContext = vt(u, 1, 0), Et(e, t, h, -1), t.treeContext = u) : F ? Et(e, t, h, -1) : Tt(e, t, h, -1), t.keyPath = E;
    }
    function wt(e, t, u, h, b, E) {
      if (typeof h == "function")
        if (h.prototype && h.prototype.isReactComponent) {
          var S = b;
          if ("ref" in b) {
            S = {};
            for (var F in b)
              F !== "ref" && (S[F] = b[F]);
          }
          var W = h.defaultProps;
          if (W) {
            S === b && (S = yn({}, S, b));
            for (var O in W)
              S[O] === void 0 && (S[O] = W[O]);
          }
          var V = S, J = Xn, re = h.contextType;
          if ("contextType" in h && re !== null && (re === void 0 || re.$$typeof !== qr) && !Lu.has(h)) {
            Lu.add(h);
            var ne = re === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof re != "object" ? " However, it is set to a " + typeof re + "." : re.$$typeof === Mi ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(re).join(", ") + "}.";
            console.error(
              "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
              dn(h) || "Component",
              ne
            );
          }
          typeof re == "object" && re !== null && (J = re._currentValue);
          var Z = new h(V, J);
          if (typeof h.getDerivedStateFromProps == "function" && (Z.state === null || Z.state === void 0)) {
            var He = dn(h) || "Component";
            Sr.has(He) || (Sr.add(He), console.error(
              "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
              He,
              Z.state === null ? "null" : "undefined",
              He
            ));
          }
          if (typeof h.getDerivedStateFromProps == "function" || typeof Z.getSnapshotBeforeUpdate == "function") {
            var nn = null, Oe = null, fe = null;
            if (typeof Z.componentWillMount == "function" && Z.componentWillMount.__suppressDeprecationWarning !== !0 ? nn = "componentWillMount" : typeof Z.UNSAFE_componentWillMount == "function" && (nn = "UNSAFE_componentWillMount"), typeof Z.componentWillReceiveProps == "function" && Z.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Oe = "componentWillReceiveProps" : typeof Z.UNSAFE_componentWillReceiveProps == "function" && (Oe = "UNSAFE_componentWillReceiveProps"), typeof Z.componentWillUpdate == "function" && Z.componentWillUpdate.__suppressDeprecationWarning !== !0 ? fe = "componentWillUpdate" : typeof Z.UNSAFE_componentWillUpdate == "function" && (fe = "UNSAFE_componentWillUpdate"), nn !== null || Oe !== null || fe !== null) {
              var Qn = dn(h) || "Component", un = typeof h.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
              Fr.has(Qn) || (Fr.add(
                Qn
              ), console.error(
                `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
                Qn,
                un,
                nn !== null ? `
  ` + nn : "",
                Oe !== null ? `
  ` + Oe : "",
                fe !== null ? `
  ` + fe : ""
              ));
            }
          }
          var Me = dn(h) || "Component";
          Z.render || (h.prototype && typeof h.prototype.render == "function" ? console.error(
            "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
            Me
          ) : console.error(
            "No `render` method found on the %s instance: you may have forgotten to define `render`.",
            Me
          )), !Z.getInitialState || Z.getInitialState.isReactClassApproved || Z.state || console.error(
            "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
            Me
          ), Z.getDefaultProps && !Z.getDefaultProps.isReactClassApproved && console.error(
            "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
            Me
          ), Z.contextType && console.error(
            "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
            Me
          ), h.childContextTypes && !Wr.has(h) && (Wr.add(h), console.error(
            "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
            Me
          )), h.contextTypes && !Fl.has(h) && (Fl.add(h), console.error(
            "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
            Me
          )), typeof Z.componentShouldUpdate == "function" && console.error(
            "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
            Me
          ), h.prototype && h.prototype.isPureReactComponent && typeof Z.shouldComponentUpdate < "u" && console.error(
            "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
            dn(h) || "A pure component"
          ), typeof Z.componentDidUnmount == "function" && console.error(
            "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
            Me
          ), typeof Z.componentDidReceiveProps == "function" && console.error(
            "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
            Me
          ), typeof Z.componentWillRecieveProps == "function" && console.error(
            "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
            Me
          ), typeof Z.UNSAFE_componentWillRecieveProps == "function" && console.error(
            "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
            Me
          );
          var zt = Z.props !== V;
          Z.props !== void 0 && zt && console.error(
            "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
            Me
          ), Z.defaultProps && console.error(
            "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
            Me,
            Me
          ), typeof Z.getSnapshotBeforeUpdate != "function" || typeof Z.componentDidUpdate == "function" || Fa.has(h) || (Fa.add(h), console.error(
            "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
            dn(h)
          )), typeof Z.getDerivedStateFromProps == "function" && console.error(
            "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
            Me
          ), typeof Z.getDerivedStateFromError == "function" && console.error(
            "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
            Me
          ), typeof h.getSnapshotBeforeUpdate == "function" && console.error(
            "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
            Me
          );
          var sr = Z.state;
          sr && (typeof sr != "object" || Vn(sr)) && console.error("%s.state: must be set to an object or null", Me), typeof Z.getChildContext == "function" && typeof h.childContextTypes != "object" && console.error(
            "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
            Me
          );
          var et = Z.state !== void 0 ? Z.state : null;
          Z.updater = _u, Z.props = V, Z.state = et;
          var ct = { queue: [], replace: !1 };
          Z._reactInternals = ct;
          var wn = h.contextType;
          if (Z.context = typeof wn == "object" && wn !== null ? wn._currentValue : Xn, Z.state === V) {
            var Bt = dn(h) || "Component";
            Gi.has(
              Bt
            ) || (Gi.add(
              Bt
            ), console.error(
              "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
              Bt
            ));
          }
          var Nt = h.getDerivedStateFromProps;
          if (typeof Nt == "function") {
            var We = Nt(
              V,
              et
            );
            if (We === void 0) {
              var Fn = dn(h) || "Component";
              tc.has(Fn) || (tc.add(Fn), console.error(
                "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
                Fn
              ));
            }
            var an = We == null ? et : yn({}, et, We);
            Z.state = an;
          }
          if (typeof h.getDerivedStateFromProps != "function" && typeof Z.getSnapshotBeforeUpdate != "function" && (typeof Z.UNSAFE_componentWillMount == "function" || typeof Z.componentWillMount == "function")) {
            var Jt = Z.state;
            if (typeof Z.componentWillMount == "function") {
              if (Z.componentWillMount.__suppressDeprecationWarning !== !0) {
                var Vt = dn(h) || "Unknown";
                co[Vt] || (console.warn(
                  `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
                  Vt
                ), co[Vt] = !0);
              }
              Z.componentWillMount();
            }
            if (typeof Z.UNSAFE_componentWillMount == "function" && Z.UNSAFE_componentWillMount(), Jt !== Z.state && (console.error(
              "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
              dn(h) || "Component"
            ), _u.enqueueReplaceState(
              Z,
              Z.state,
              null
            )), ct.queue !== null && 0 < ct.queue.length) {
              var ut = ct.queue, Ml = ct.replace;
              if (ct.queue = null, ct.replace = !1, Ml && ut.length === 1)
                Z.state = ut[0];
              else {
                for (var pr = Ml ? ut[0] : Z.state, Il = !0, ho = Ml ? 1 : 0; ho < ut.length; ho++) {
                  var Dl = ut[ho], Ma = typeof Dl == "function" ? Dl.call(
                    Z,
                    pr,
                    V,
                    void 0
                  ) : Dl;
                  Ma != null && (Il ? (Il = !1, pr = yn(
                    {},
                    pr,
                    Ma
                  )) : yn(pr, Ma));
                }
                Z.state = pr;
              }
            } else
              ct.queue = null;
          }
          var Br = I(Z);
          if (e.status === 12)
            throw null;
          Z.props !== V && (zr || console.error(
            "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
            dn(h) || "a component"
          ), zr = !0);
          var go = t.keyPath;
          t.keyPath = u, Tt(e, t, Br, -1), t.keyPath = go;
        } else {
          if (h.prototype && typeof h.prototype.render == "function") {
            var Kt = dn(h) || "Unknown";
            At[Kt] || (console.error(
              "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
              Kt,
              Kt
            ), At[Kt] = !0);
          }
          var st = Lo(
            e,
            t,
            u,
            h,
            b,
            void 0
          );
          if (e.status === 12)
            throw null;
          var Hn = pa !== 0, fr = so, Nr = Xc;
          if (h.contextTypes) {
            var Ia = dn(h) || "Unknown";
            Zn[Ia] || (Zn[Ia] = !0, console.error(
              "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
              Ia
            ));
          }
          if (h && h.childContextTypes && console.error(
            `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
            h.displayName || h.name || "Component"
          ), typeof h.getDerivedStateFromProps == "function") {
            var Ur = dn(h) || "Unknown";
            Sn[Ur] || (console.error(
              "%s: Function components do not support getDerivedStateFromProps.",
              Ur
            ), Sn[Ur] = !0);
          }
          if (typeof h.contextType == "object" && h.contextType !== null) {
            var Ll = dn(h) || "Unknown";
            $n[Ll] || (console.error(
              "%s: Function components do not support contextType.",
              Ll
            ), $n[Ll] = !0);
          }
          _o(
            e,
            t,
            u,
            st,
            Hn,
            fr,
            Nr
          );
        }
      else if (typeof h == "string") {
        var mr = t.blockedSegment;
        if (mr === null) {
          var Qc = b.children, nt = t.formatContext, hr = t.keyPath;
          t.formatContext = m(nt, h, b), t.keyPath = u, Et(e, t, Qc, -1), t.formatContext = nt, t.keyPath = hr;
        } else {
          var ai = jt(
            mr.chunks,
            h,
            b,
            e.resumableState,
            e.renderState,
            t.blockedPreamble,
            t.hoistableState,
            t.formatContext,
            mr.lastPushedText,
            t.isFallback
          );
          mr.lastPushedText = !1;
          var oi = t.formatContext, _l = t.keyPath;
          if (t.keyPath = u, (t.formatContext = m(
            oi,
            h,
            b
          )).insertionMode === xr) {
            var Da = Er(
              e,
              0,
              null,
              t.formatContext,
              !1,
              !1
            );
            mr.preambleChildren.push(Da);
            var al = vl(
              e,
              null,
              ai,
              -1,
              t.blockedBoundary,
              Da,
              t.blockedPreamble,
              t.hoistableState,
              e.abortableTasks,
              t.keyPath,
              t.formatContext,
              t.context,
              t.treeContext,
              t.componentStack,
              t.isFallback,
              Xn,
              t.debugTask
            );
            bl(al), e.pingedTasks.push(al);
          } else
            Et(e, t, ai, -1);
          t.formatContext = oi, t.keyPath = _l;
          e: {
            var Qi = mr.chunks, Ji = e.resumableState;
            switch (h) {
              case "title":
              case "style":
              case "script":
              case "area":
              case "base":
              case "br":
              case "col":
              case "embed":
              case "hr":
              case "img":
              case "input":
              case "keygen":
              case "link":
              case "meta":
              case "param":
              case "source":
              case "track":
              case "wbr":
                break e;
              case "body":
                if (oi.insertionMode <= ir) {
                  Ji.hasBody = !0;
                  break e;
                }
                break;
              case "html":
                if (oi.insertionMode === Dr) {
                  Ji.hasHtml = !0;
                  break e;
                }
                break;
              case "head":
                if (oi.insertionMode <= ir)
                  break e;
            }
            Qi.push(gi(h));
          }
          mr.lastPushedText = !1;
        }
      } else {
        switch (h) {
          case Pn:
          case No:
          case ga:
          case Rl:
            var Vi = t.keyPath;
            t.keyPath = u, Tt(e, t, b.children, -1), t.keyPath = Vi;
            return;
          case Di:
            if (b.mode !== "hidden") {
              var Ki = t.keyPath;
              t.keyPath = u, Tt(e, t, b.children, -1), t.keyPath = Ki;
            }
            return;
          case jr:
            var Yr = t.keyPath;
            t.keyPath = u, Tt(e, t, b.children, -1), t.keyPath = Yr;
            return;
          case Oc:
          case rr:
            throw Error(
              "ReactDOMServer does not yet support scope components."
            );
          case Ka:
            e:
              if (t.replay !== null) {
                var Hl = t.keyPath;
                t.keyPath = u;
                var Jc = b.children;
                try {
                  Et(e, t, Jc, -1);
                } finally {
                  t.keyPath = Hl;
                }
              } else {
                var ol = t.keyPath, vo = t.blockedBoundary, bo = t.blockedPreamble, Tu = t.hoistableState, ci = t.blockedSegment, Vc = b.fallback, Or = b.children, Wl = /* @__PURE__ */ new Set(), Wn = t.formatContext.insertionMode < In ? yt(
                  e,
                  Wl,
                  si(),
                  si()
                ) : yt(
                  e,
                  Wl,
                  null,
                  null
                );
                e.trackedPostpones !== null && (Wn.trackedContentKeyPath = u);
                var pt = Er(
                  e,
                  ci.chunks.length,
                  Wn,
                  t.formatContext,
                  !1,
                  !1
                );
                ci.children.push(pt), ci.lastPushedText = !1;
                var dr = Er(
                  e,
                  0,
                  null,
                  t.formatContext,
                  !1,
                  !1
                );
                if (dr.parentFlushed = !0, e.trackedPostpones !== null) {
                  var Eu = [
                    u[0],
                    "Suspense Fallback",
                    u[2]
                  ], zl = [
                    Eu[1],
                    Eu[2],
                    [],
                    null
                  ];
                  e.trackedPostpones.workingMap.set(
                    Eu,
                    zl
                  ), Wn.trackedFallbackNode = zl, t.blockedSegment = pt, t.blockedPreamble = Wn.fallbackPreamble, t.keyPath = Eu, pt.status = 6;
                  try {
                    Et(e, t, Vc, -1), pt.lastPushedText && pt.textEmbedded && pt.chunks.push(tl), pt.status = Fe;
                  } catch (Ro) {
                    throw pt.status = e.status === 12 ? 3 : 4, Ro;
                  } finally {
                    t.blockedSegment = ci, t.blockedPreamble = bo, t.keyPath = ol;
                  }
                  var qi = vl(
                    e,
                    null,
                    Or,
                    -1,
                    Wn,
                    dr,
                    Wn.contentPreamble,
                    Wn.contentState,
                    t.abortSet,
                    u,
                    t.formatContext,
                    t.context,
                    t.treeContext,
                    t.componentStack,
                    t.isFallback,
                    Xn,
                    t.debugTask
                  );
                  bl(qi), e.pingedTasks.push(qi);
                } else {
                  t.blockedBoundary = Wn, t.blockedPreamble = Wn.contentPreamble, t.hoistableState = Wn.contentState, t.blockedSegment = dr, t.keyPath = u, dr.status = 6;
                  try {
                    if (Et(e, t, Or, -1), dr.lastPushedText && dr.textEmbedded && dr.chunks.push(tl), dr.status = Fe, El(Wn, dr), Wn.pendingTasks === 0 && Wn.status === Te) {
                      Wn.status = Fe, e.pendingRootTasks === 0 && t.blockedPreamble && Wo(e);
                      break e;
                    }
                  } catch (Ro) {
                    if (Wn.status = Le, e.status === 12) {
                      dr.status = 3;
                      var La = e.fatalError;
                    } else
                      dr.status = 4, La = Ro;
                    var zu = An(t.componentStack), ft = Gt(
                      e,
                      La,
                      zu,
                      t.debugTask
                    );
                    ki(
                      Wn,
                      ft,
                      La,
                      zu,
                      !1
                    ), yl(e, Wn);
                  } finally {
                    t.blockedBoundary = vo, t.blockedPreamble = bo, t.hoistableState = Tu, t.blockedSegment = ci, t.keyPath = ol;
                  }
                  var sc = vl(
                    e,
                    null,
                    Vc,
                    -1,
                    vo,
                    pt,
                    Wn.fallbackPreamble,
                    Wn.fallbackState,
                    Wl,
                    [u[0], "Suspense Fallback", u[2]],
                    t.formatContext,
                    t.context,
                    t.treeContext,
                    t.componentStack,
                    !0,
                    Xn,
                    t.debugTask
                  );
                  bl(sc), e.pingedTasks.push(sc);
                }
              }
            return;
        }
        if (typeof h == "object" && h !== null)
          switch (h.$$typeof) {
            case Ii:
              if ("ref" in b) {
                var yo = {};
                for (var _a in b)
                  _a !== "ref" && (yo[_a] = b[_a]);
              } else
                yo = b;
              var fc = Lo(
                e,
                t,
                u,
                h.render,
                yo,
                E
              );
              _o(
                e,
                t,
                u,
                fc,
                pa !== 0,
                so,
                Xc
              );
              return;
            case gn:
              wt(e, t, u, h.type, b, E);
              return;
            case Rt:
            case qr:
              var wo = b.value, Kc = b.children, hc = t.context, Zu = t.keyPath, dc = h._currentValue;
              h._currentValue = wo, h._currentRenderer !== void 0 && h._currentRenderer !== null && h._currentRenderer !== Pa && console.error(
                "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
              ), h._currentRenderer = Pa;
              var To = Sl, Ha = {
                parent: To,
                depth: To === null ? 0 : To.depth + 1,
                context: h,
                parentValue: dc,
                value: wo
              };
              Sl = Ha, t.context = Ha, t.keyPath = u, Tt(e, t, Kc, -1);
              var ui = Sl;
              if (ui === null)
                throw Error(
                  "Tried to pop a Context at the root of the app. This is a bug in React."
                );
              ui.context !== h && console.error(
                "The parent context is not the expected context. This is probably a bug in React."
              ), ui.context._currentValue = ui.parentValue, h._currentRenderer !== void 0 && h._currentRenderer !== null && h._currentRenderer !== Pa && console.error(
                "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
              ), h._currentRenderer = Pa;
              var Wa = Sl = ui.parent;
              t.context = Wa, t.keyPath = Zu, hc !== t.context && console.error(
                "Popping the context provider did not return back to the original snapshot. This is a bug in React."
              );
              return;
            case Mi:
              var Ot = h._context, ht = b.children;
              typeof ht != "function" && console.error(
                "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
              );
              var Qu = ht(Ot._currentValue), gc = t.keyPath;
              t.keyPath = u, Tt(e, t, Qu, -1), t.keyPath = gc;
              return;
            case Un:
              var Ju = K(h);
              if (e.status === 12)
                throw null;
              wt(e, t, u, Ju, b, E);
              return;
          }
        var Eo = "";
        throw (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (Eo += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), Error(
          "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + ((h == null ? h : typeof h) + "." + Eo)
        );
      }
    }
    function Qa(e, t, u, h, b) {
      var E = t.replay, S = t.blockedBoundary, F = Er(
        e,
        0,
        null,
        t.formatContext,
        !1,
        !1
      );
      F.id = u, F.parentFlushed = !0;
      try {
        t.replay = null, t.blockedSegment = F, Et(e, t, h, b), F.status = Fe, S === null ? e.completedRootSegment = F : (El(S, F), S.parentFlushed && e.partialBoundaries.push(S));
      } finally {
        t.replay = E, t.blockedSegment = null;
      }
    }
    function Qe(e, t, u, h, b, E, S, F, W, O) {
      E = O.nodes;
      for (var V = 0; V < E.length; V++) {
        var J = E[V];
        if (b === J[1]) {
          if (J.length === 4) {
            if (h !== null && h !== J[0])
              throw Error(
                "Expected the resume to render <" + J[0] + "> in this slot but instead it rendered <" + h + ">. The tree doesn't match so React will fallback to client rendering."
              );
            var re = J[2];
            J = J[3], h = t.node, t.replay = { nodes: re, slots: J, pendingTasks: 1 };
            try {
              if (wt(e, t, u, S, F, W), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length)
                throw Error(
                  "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                );
              t.replay.pendingTasks--;
            } catch (un) {
              if (typeof un == "object" && un !== null && (un === pl || typeof un.then == "function"))
                throw t.node === h && (t.replay = O), un;
              t.replay.pendingTasks--, S = An(t.componentStack), F = e, e = t.blockedBoundary, u = un, W = J, J = Gt(F, u, S, t.debugTask), Ql(
                F,
                e,
                re,
                W,
                u,
                J,
                S,
                !1
              );
            }
            t.replay = O;
          } else {
            if (S !== Ka)
              throw Error(
                "Expected the resume to render <Suspense> in this slot but instead it rendered <" + (dn(S) || "Unknown") + ">. The tree doesn't match so React will fallback to client rendering."
              );
            e: {
              O = void 0, S = J[5], W = J[2], h = J[3], b = J[4] === null ? [] : J[4][2], J = J[4] === null ? null : J[4][3];
              var ne = t.keyPath, Z = t.replay, He = t.blockedBoundary, nn = t.hoistableState, Oe = F.children, fe = F.fallback, Qn = /* @__PURE__ */ new Set();
              F = t.formatContext.insertionMode < In ? yt(
                e,
                Qn,
                si(),
                si()
              ) : yt(
                e,
                Qn,
                null,
                null
              ), F.parentFlushed = !0, F.rootSegmentID = S, t.blockedBoundary = F, t.hoistableState = F.contentState, t.keyPath = u, t.replay = { nodes: W, slots: h, pendingTasks: 1 };
              try {
                if (Et(e, t, Oe, -1), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length)
                  throw Error(
                    "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                  );
                if (t.replay.pendingTasks--, F.pendingTasks === 0 && F.status === Te) {
                  F.status = Fe, e.completedBoundaries.push(F);
                  break e;
                }
              } catch (un) {
                F.status = Le, re = An(t.componentStack), O = Gt(
                  e,
                  un,
                  re,
                  t.debugTask
                ), ki(F, O, un, re, !1), t.replay.pendingTasks--, e.clientRenderedBoundaries.push(F);
              } finally {
                t.blockedBoundary = He, t.hoistableState = nn, t.replay = Z, t.keyPath = ne;
              }
              F = lu(
                e,
                null,
                { nodes: b, slots: J, pendingTasks: 0 },
                fe,
                -1,
                He,
                F.fallbackState,
                Qn,
                [u[0], "Suspense Fallback", u[2]],
                t.formatContext,
                t.context,
                t.treeContext,
                t.componentStack,
                !0,
                Xn,
                t.debugTask
              ), bl(F), e.pingedTasks.push(F);
            }
          }
          E.splice(V, 1);
          break;
        }
      }
    }
    function Tt(e, t, u, h) {
      t.replay !== null && typeof t.replay.slots == "number" ? Qa(e, t, t.replay.slots, u, h) : (t.node = u, t.childIndex = h, u = t.componentStack, h = t.debugTask, bl(t), Ci(e, t), t.componentStack = u, t.debugTask = h);
    }
    function Ci(e, t) {
      var u = t.node, h = t.childIndex;
      if (u !== null) {
        if (typeof u == "object") {
          switch (u.$$typeof) {
            case Oi:
              var b = u.type, E = u.key;
              u = u.props;
              var S = u.ref;
              S = S !== void 0 ? S : null;
              var F = t.debugTask, W = dn(b);
              E = E ?? (h === -1 ? 0 : h);
              var O = [t.keyPath, W, E];
              t.replay !== null ? F ? F.run(
                Qe.bind(
                  null,
                  e,
                  t,
                  O,
                  W,
                  E,
                  h,
                  b,
                  u,
                  S,
                  t.replay
                )
              ) : Qe(
                e,
                t,
                O,
                W,
                E,
                h,
                b,
                u,
                S,
                t.replay
              ) : F ? F.run(
                wt.bind(
                  null,
                  e,
                  t,
                  O,
                  b,
                  u,
                  S
                )
              ) : wt(e, t, O, b, u, S);
              return;
            case Kr:
              throw Error(
                "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render."
              );
            case Un:
              if (u = K(u), e.status === 12)
                throw null;
              Tt(e, t, u, h);
              return;
          }
          if (Vn(u)) {
            Zl(e, t, u, h);
            return;
          }
          if (u === null || typeof u != "object" ? E = null : (b = Uo && u[Uo] || u["@@iterator"], E = typeof b == "function" ? b : null), E && (b = E.call(u))) {
            if (b === u ? (h !== -1 || t.componentStack === null || typeof t.componentStack.type != "function" || Object.prototype.toString.call(t.componentStack.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(b) !== "[object Generator]") && (Qt || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), Qt = !0) : u.entries !== E || qe || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), qe = !0), u = b.next(), !u.done) {
              E = [];
              do
                E.push(u.value), u = b.next();
              while (!u.done);
              Zl(e, t, E, h);
            }
            return;
          }
          if (typeof u.then == "function")
            return t.thenableState = null, Tt(
              e,
              t,
              Io(u),
              h
            );
          if (u.$$typeof === qr)
            return Tt(
              e,
              t,
              u._currentValue,
              h
            );
          throw e = Object.prototype.toString.call(u), Error(
            "Objects are not valid as a React child (found: " + (e === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : e) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        typeof u == "string" ? (t = t.blockedSegment, t !== null && (t.lastPushedText = fi(
          t.chunks,
          u,
          e.renderState,
          t.lastPushedText
        ))) : typeof u == "number" || typeof u == "bigint" ? (t = t.blockedSegment, t !== null && (t.lastPushedText = fi(
          t.chunks,
          "" + u,
          e.renderState,
          t.lastPushedText
        ))) : (typeof u == "function" && (e = u.displayName || u.name || "Component", console.error(
          "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.",
          e,
          e
        )), typeof u == "symbol" && console.error(
          `Symbols are not valid as a React child.
  %s`,
          String(u)
        ));
      }
    }
    function Zl(e, t, u, h) {
      var b = t.keyPath, E = t.componentStack, S = t.debugTask;
      if (Za(t, t.node._debugInfo), h !== -1 && (t.keyPath = [t.keyPath, "Fragment", h], t.replay !== null)) {
        for (var F = t.replay, W = F.nodes, O = 0; O < W.length; O++) {
          var V = W[O];
          if (V[1] === h) {
            h = V[2], V = V[3], t.replay = { nodes: h, slots: V, pendingTasks: 1 };
            try {
              if (Zl(e, t, u, -1), t.replay.pendingTasks === 1 && 0 < t.replay.nodes.length)
                throw Error(
                  "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                );
              t.replay.pendingTasks--;
            } catch (Oe) {
              if (typeof Oe == "object" && Oe !== null && (Oe === pl || typeof Oe.then == "function"))
                throw Oe;
              t.replay.pendingTasks--;
              var J = An(t.componentStack);
              u = t.blockedBoundary;
              var re = Oe, ne = V;
              V = Gt(
                e,
                re,
                J,
                t.debugTask
              ), Ql(
                e,
                u,
                h,
                ne,
                re,
                V,
                J,
                !1
              );
            }
            t.replay = F, W.splice(O, 1);
            break;
          }
        }
        t.keyPath = b, t.componentStack = E, t.debugTask = S;
        return;
      }
      if (F = t.treeContext, W = u.length, t.replay !== null && (O = t.replay.slots, O !== null && typeof O == "object")) {
        for (h = 0; h < W; h++)
          V = u[h], t.treeContext = vt(
            F,
            W,
            h
          ), re = O[h], typeof re == "number" ? (Qa(e, t, re, V, h), delete O[h]) : Et(e, t, V, h);
        t.treeContext = F, t.keyPath = b, t.componentStack = E, t.debugTask = S;
        return;
      }
      for (O = 0; O < W; O++) {
        if (h = u[O], ne = e, V = t, re = h, re !== null && typeof re == "object" && (re.$$typeof === Oi || re.$$typeof === Kr) && re._store && (!re._store.validated && re.key == null || re._store.validated === 2)) {
          if (typeof re._store != "object")
            throw Error(
              "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
            );
          if (re._store.validated = 1, J = ne.didWarnForKey, J == null && (J = ne.didWarnForKey = /* @__PURE__ */ new WeakSet()), ne = V.componentStack, ne !== null && !J.has(ne)) {
            J.add(ne);
            var Z = dn(re.type);
            J = re._owner;
            var He = ne.owner;
            if (ne = "", He && typeof He.type < "u") {
              var nn = dn(He.type);
              nn && (ne = `

Check the render method of \`` + nn + "`.");
            }
            ne || Z && (ne = `

Check the top-level render call using <` + Z + ">."), Z = "", J != null && He !== J && (He = null, typeof J.type < "u" ? He = dn(J.type) : typeof J.name == "string" && (He = J.name), He && (Z = " It was passed a child from " + He + ".")), J = V.componentStack, V.componentStack = {
              parent: V.componentStack,
              type: re.type,
              owner: re._owner,
              stack: re._debugStack
            }, console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              ne,
              Z
            ), V.componentStack = J;
          }
        }
        t.treeContext = vt(F, W, O), Et(e, t, h, O);
      }
      t.treeContext = F, t.keyPath = b, t.componentStack = E, t.debugTask = S;
    }
    function yl(e, t) {
      e = e.trackedPostpones, e !== null && (t = t.trackedContentKeyPath, t !== null && (t = e.workingMap.get(t), t !== void 0 && (t.length = 4, t[2] = [], t[3] = null)));
    }
    function wl(e, t, u) {
      return lu(
        e,
        u,
        t.replay,
        t.node,
        t.childIndex,
        t.blockedBoundary,
        t.hoistableState,
        t.abortSet,
        t.keyPath,
        t.formatContext,
        t.context,
        t.treeContext,
        t.componentStack,
        t.isFallback,
        Xn,
        t.debugTask
      );
    }
    function ca(e, t, u) {
      var h = t.blockedSegment, b = Er(
        e,
        h.chunks.length,
        null,
        t.formatContext,
        h.lastPushedText,
        !0
      );
      return h.children.push(b), h.lastPushedText = !1, vl(
        e,
        u,
        t.node,
        t.childIndex,
        t.blockedBoundary,
        b,
        t.blockedPreamble,
        t.hoistableState,
        t.abortSet,
        t.keyPath,
        t.formatContext,
        t.context,
        t.treeContext,
        t.componentStack,
        t.isFallback,
        Xn,
        t.debugTask
      );
    }
    function Et(e, t, u, h) {
      var b = t.formatContext, E = t.context, S = t.keyPath, F = t.treeContext, W = t.componentStack, O = t.debugTask, V = t.blockedSegment;
      if (V === null)
        try {
          return Tt(e, t, u, h);
        } catch (ne) {
          if (nr(), u = ne === pl ? la() : ne, typeof u == "object" && u !== null) {
            if (typeof u.then == "function") {
              h = Jr(), e = wl(
                e,
                t,
                h
              ).ping, u.then(e, e), t.formatContext = b, t.context = E, t.keyPath = S, t.treeContext = F, t.componentStack = W, t.debugTask = O, Be(E);
              return;
            }
            if (u.message === "Maximum call stack size exceeded") {
              u = Jr(), u = wl(e, t, u), e.pingedTasks.push(u), t.formatContext = b, t.context = E, t.keyPath = S, t.treeContext = F, t.componentStack = W, t.debugTask = O, Be(E);
              return;
            }
          }
        }
      else {
        var J = V.children.length, re = V.chunks.length;
        try {
          return Tt(e, t, u, h);
        } catch (ne) {
          if (nr(), V.children.length = J, V.chunks.length = re, u = ne === pl ? la() : ne, typeof u == "object" && u !== null) {
            if (typeof u.then == "function") {
              h = Jr(), e = ca(
                e,
                t,
                h
              ).ping, u.then(e, e), t.formatContext = b, t.context = E, t.keyPath = S, t.treeContext = F, t.componentStack = W, t.debugTask = O, Be(E);
              return;
            }
            if (u.message === "Maximum call stack size exceeded") {
              u = Jr(), u = ca(e, t, u), e.pingedTasks.push(u), t.formatContext = b, t.context = E, t.keyPath = S, t.treeContext = F, t.componentStack = W, t.debugTask = O, Be(E);
              return;
            }
          }
        }
      }
      throw t.formatContext = b, t.context = E, t.keyPath = S, t.treeContext = F, Be(E), u;
    }
    function Tl(e) {
      var t = e.blockedBoundary;
      e = e.blockedSegment, e !== null && (e.status = 3, Ho(this, t, e));
    }
    function Ql(e, t, u, h, b, E, S, F) {
      for (var W = 0; W < u.length; W++) {
        var O = u[W];
        if (O.length === 4)
          Ql(
            e,
            t,
            O[2],
            O[3],
            b,
            E,
            S,
            F
          );
        else {
          var V = e;
          O = O[5];
          var J = b, re = E, ne = S, Z = F, He = yt(
            V,
            /* @__PURE__ */ new Set(),
            null,
            null
          );
          He.parentFlushed = !0, He.rootSegmentID = O, He.status = Le, ki(
            He,
            re,
            J,
            ne,
            Z
          ), He.parentFlushed && V.clientRenderedBoundaries.push(He);
        }
      }
      if (u.length = 0, h !== null) {
        if (t === null)
          throw Error(
            "We should not have any resumable nodes in the shell. This is a bug in React."
          );
        if (t.status !== Le && (t.status = Le, ki(
          t,
          E,
          b,
          S,
          F
        ), t.parentFlushed && e.clientRenderedBoundaries.push(t)), typeof h == "object")
          for (var nn in h)
            delete h[nn];
      }
    }
    function tr(e, t, u) {
      var h = e.blockedBoundary, b = e.blockedSegment;
      if (b !== null) {
        if (b.status === 6)
          return;
        b.status = 3;
      }
      if (b = An(e.componentStack), h === null) {
        if (t.status !== 13 && t.status !== Ue) {
          if (h = e.replay, h === null) {
            Gt(t, u, b, null), Xt(t, u, b, null);
            return;
          }
          h.pendingTasks--, h.pendingTasks === 0 && 0 < h.nodes.length && (e = Gt(t, u, b, null), Ql(
            t,
            null,
            h.nodes,
            h.slots,
            u,
            e,
            b,
            !0
          )), t.pendingRootTasks--, t.pendingRootTasks === 0 && Jl(t);
        }
      } else
        h.pendingTasks--, h.status !== Le && (h.status = Le, e = Gt(t, u, b, null), h.status = Le, ki(h, e, u, b, !0), yl(t, h), h.parentFlushed && t.clientRenderedBoundaries.push(h)), h.fallbackAbortableTasks.forEach(function(E) {
          return tr(E, t, u);
        }), h.fallbackAbortableTasks.clear();
      t.allPendingTasks--, t.allPendingTasks === 0 && Vr(t);
    }
    function ua(e, t) {
      try {
        var u = e.renderState, h = u.onHeaders;
        if (h) {
          var b = u.headers;
          if (b) {
            u.headers = null;
            var E = b.preconnects;
            if (b.fontPreloads && (E && (E += ", "), E += b.fontPreloads), b.highImagePreloads && (E && (E += ", "), E += b.highImagePreloads), !t) {
              var S = u.styles.values(), F = S.next();
              e:
                for (; 0 < b.remainingCapacity && !F.done; F = S.next())
                  for (var W = F.value.sheets.values(), O = W.next(); 0 < b.remainingCapacity && !O.done; O = W.next()) {
                    var V = O.value, J = V.props, re = J.href, ne = V.props, Z = yi(
                      ne.href,
                      "style",
                      {
                        crossOrigin: ne.crossOrigin,
                        integrity: ne.integrity,
                        nonce: ne.nonce,
                        type: ne.type,
                        fetchPriority: ne.fetchPriority,
                        referrerPolicy: ne.referrerPolicy,
                        media: ne.media
                      }
                    );
                    if (0 <= (b.remainingCapacity -= Z.length + 2))
                      u.resets.style[re] = Re, E && (E += ", "), E += Z, u.resets.style[re] = typeof J.crossOrigin == "string" || typeof J.integrity == "string" ? [J.crossOrigin, J.integrity] : Re;
                    else
                      break e;
                  }
            }
            h(E ? { Link: E } : {});
          }
        }
      } catch (He) {
        Gt(e, He, {}, null);
      }
    }
    function Jl(e) {
      e.trackedPostpones === null && ua(e, !0), e.trackedPostpones === null && Wo(e), e.onShellError = Tr, e = e.onShellReady, e();
    }
    function Vr(e) {
      ua(
        e,
        e.trackedPostpones === null ? !0 : e.completedRootSegment === null || e.completedRootSegment.status !== be
      ), Wo(e), e = e.onAllReady, e();
    }
    function El(e, t) {
      if (t.chunks.length === 0 && t.children.length === 1 && t.children[0].boundary === null && t.children[0].id === -1) {
        var u = t.children[0];
        u.id = t.id, u.parentFlushed = !0, u.status === Fe && El(e, u);
      } else
        e.completedSegments.push(t);
    }
    function Ho(e, t, u) {
      if (t === null) {
        if (u !== null && u.parentFlushed) {
          if (e.completedRootSegment !== null)
            throw Error(
              "There can only be one root segment. This is a bug in React."
            );
          e.completedRootSegment = u;
        }
        e.pendingRootTasks--, e.pendingRootTasks === 0 && Jl(e);
      } else
        t.pendingTasks--, t.status !== Le && (t.pendingTasks === 0 ? (t.status === Te && (t.status = Fe), u !== null && u.parentFlushed && u.status === Fe && El(t, u), t.parentFlushed && e.completedBoundaries.push(t), t.status === Fe && (t.fallbackAbortableTasks.forEach(
          Tl,
          e
        ), t.fallbackAbortableTasks.clear(), e.pendingRootTasks === 0 && e.trackedPostpones === null && t.contentPreamble !== null && Wo(e))) : u !== null && u.parentFlushed && u.status === Fe && (El(t, u), t.completedSegments.length === 1 && t.parentFlushed && e.partialBoundaries.push(t)));
      e.allPendingTasks--, e.allPendingTasks === 0 && Vr(e);
    }
    function sa(e) {
      if (e.status !== Ue && e.status !== 13) {
        var t = Sl, u = ae.H;
        ae.H = oc;
        var h = ae.A;
        ae.A = wu;
        var b = Ze;
        Ze = e;
        var E = ae.getCurrentStack;
        ae.getCurrentStack = Xl;
        var S = Zi;
        Zi = e.resumableState;
        try {
          var F = e.pingedTasks, W;
          for (W = 0; W < F.length; W++) {
            var O = e, V = F[W], J = V.blockedSegment;
            if (J === null) {
              var re = void 0, ne = O;
              if (O = V, O.replay.pendingTasks !== 0) {
                Be(O.context), re = fn, fn = O;
                try {
                  if (typeof O.replay.slots == "number" ? Qa(
                    ne,
                    O,
                    O.replay.slots,
                    O.node,
                    O.childIndex
                  ) : Ci(ne, O), O.replay.pendingTasks === 1 && 0 < O.replay.nodes.length)
                    throw Error(
                      "Couldn't find all resumable slots by key/index during replaying. The tree doesn't match so React will fallback to client rendering."
                    );
                  O.replay.pendingTasks--, O.abortSet.delete(O), Ho(ne, O.blockedBoundary, null);
                } catch (an) {
                  nr();
                  var Z = an === pl ? la() : an;
                  if (typeof Z == "object" && Z !== null && typeof Z.then == "function") {
                    var He = O.ping;
                    Z.then(He, He), O.thenableState = Jr();
                  } else {
                    O.replay.pendingTasks--, O.abortSet.delete(O);
                    var nn = An(O.componentStack), Oe = void 0, fe = ne, Qn = O.blockedBoundary, un = ne.status === 12 ? ne.fatalError : Z, Me = nn, zt = O.replay.nodes, sr = O.replay.slots;
                    Oe = Gt(
                      fe,
                      un,
                      Me,
                      O.debugTask
                    ), Ql(
                      fe,
                      Qn,
                      zt,
                      sr,
                      un,
                      Oe,
                      Me,
                      !1
                    ), ne.pendingRootTasks--, ne.pendingRootTasks === 0 && Jl(ne), ne.allPendingTasks--, ne.allPendingTasks === 0 && Vr(ne);
                  }
                } finally {
                  fn = re;
                }
              }
            } else if (ne = re = void 0, Oe = V, fe = J, fe.status === Te) {
              fe.status = 6, Be(Oe.context), ne = fn, fn = Oe;
              var et = fe.children.length, ct = fe.chunks.length;
              try {
                Ci(O, Oe), fe.lastPushedText && fe.textEmbedded && fe.chunks.push(tl), Oe.abortSet.delete(Oe), fe.status = Fe, Ho(
                  O,
                  Oe.blockedBoundary,
                  fe
                );
              } catch (an) {
                nr(), fe.children.length = et, fe.chunks.length = ct;
                var wn = an === pl ? la() : O.status === 12 ? O.fatalError : an;
                if (typeof wn == "object" && wn !== null && typeof wn.then == "function") {
                  fe.status = Te, Oe.thenableState = Jr();
                  var Bt = Oe.ping;
                  wn.then(Bt, Bt);
                } else {
                  var Nt = An(
                    Oe.componentStack
                  );
                  Oe.abortSet.delete(Oe), fe.status = 4;
                  var We = Oe.blockedBoundary, Fn = Oe.debugTask;
                  re = Gt(
                    O,
                    wn,
                    Nt,
                    Fn
                  ), We === null ? Xt(
                    O,
                    wn,
                    Nt,
                    Fn
                  ) : (We.pendingTasks--, We.status !== Le && (We.status = Le, ki(
                    We,
                    re,
                    wn,
                    Nt,
                    !1
                  ), yl(O, We), We.parentFlushed && O.clientRenderedBoundaries.push(
                    We
                  ), O.pendingRootTasks === 0 && O.trackedPostpones === null && We.contentPreamble !== null && Wo(O))), O.allPendingTasks--, O.allPendingTasks === 0 && Vr(O);
                }
              } finally {
                fn = ne;
              }
            }
          }
          F.splice(0, W), e.destination !== null && Si(
            e,
            e.destination
          );
        } catch (an) {
          F = {}, Gt(e, an, F, null), Xt(e, an, F, null);
        } finally {
          Zi = S, ae.H = u, ae.A = h, ae.getCurrentStack = E, u === oc && Be(t), Ze = b;
        }
      }
    }
    function Ac(e, t, u) {
      t.preambleChildren.length && u.push(t.preambleChildren);
      for (var h = !1, b = 0; b < t.children.length; b++)
        h = Pi(
          e,
          t.children[b],
          u
        ) || h;
      return h;
    }
    function Pi(e, t, u) {
      var h = t.boundary;
      if (h === null)
        return Ac(
          e,
          t,
          u
        );
      var b = h.contentPreamble, E = h.fallbackPreamble;
      if (b === null || E === null)
        return !1;
      switch (h.status) {
        case Fe:
          if (vr(e.renderState, b), t = h.completedSegments[0], !t)
            throw Error(
              "A previously unvisited boundary must have exactly one root segment. This is a bug in React."
            );
          return Ac(
            e,
            t,
            u
          );
        case be:
          if (e.trackedPostpones !== null)
            return !0;
        case Le:
          if (t.status === Fe)
            return vr(e.renderState, E), Ac(
              e,
              t,
              u
            );
        default:
          return !0;
      }
    }
    function Wo(e) {
      if (e.completedRootSegment && e.completedPreambleSegments === null) {
        var t = [], u = Pi(
          e,
          e.completedRootSegment,
          t
        ), h = e.renderState.preamble;
        (u === !1 || h.headChunks && h.bodyChunks) && (e.completedPreambleSegments = t);
      }
    }
    function pc(e, t, u, h) {
      switch (u.parentFlushed = !0, u.status) {
        case Te:
          u.id = e.nextSegmentId++;
        case be:
          return h = u.id, u.lastPushedText = !1, u.textEmbedded = !1, e = e.renderState, z(t, Ta), z(t, e.placeholderPrefix), e = q(h.toString(16)), z(t, e), Ce(t, zi);
        case Fe:
          u.status = kn;
          var b = !0, E = u.chunks, S = 0;
          u = u.children;
          for (var F = 0; F < u.length; F++) {
            for (b = u[F]; S < b.index; S++)
              z(t, E[S]);
            b = Ja(e, t, b, h);
          }
          for (; S < E.length - 1; S++)
            z(t, E[S]);
          return S < E.length && (b = Ce(t, E[S])), b;
        default:
          throw Error(
            "Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React."
          );
      }
    }
    function Ja(e, t, u, h) {
      var b = u.boundary;
      if (b === null)
        return pc(e, t, u, h);
      if (b.parentFlushed = !0, b.status === Le) {
        var E = b.errorDigest, S = b.errorMessage, F = b.errorStack, W = b.errorComponentStack;
        return Ce(t, Ou), z(t, hu), E && (z(t, lo), z(
          t,
          q(Pe(E))
        ), z(
          t,
          $l
        )), S && (z(t, qo), z(
          t,
          q(Pe(S))
        ), z(
          t,
          $l
        )), F && (z(t, Bi), z(
          t,
          q(Pe(F))
        ), z(
          t,
          $l
        )), W && (z(t, jo), z(
          t,
          q(Pe(W))
        ), z(
          t,
          $l
        )), Ce(t, Wc), pc(e, t, u, h), (e = b.fallbackPreamble) && xc(t, e), Ce(t, Cl);
      }
      if (b.status !== Fe)
        return b.status === Te && (b.rootSegmentID = e.nextSegmentId++), 0 < b.completedSegments.length && e.partialBoundaries.push(b), Rc(
          t,
          e.renderState,
          b.rootSegmentID
        ), h && (b = b.fallbackState, b.styles.forEach(yr, h), b.stylesheets.forEach(
          Jn,
          h
        )), pc(e, t, u, h), Ce(t, Cl);
      if (b.byteSize > e.progressiveChunkSize)
        return b.rootSegmentID = e.nextSegmentId++, e.completedBoundaries.push(b), Rc(
          t,
          e.renderState,
          b.rootSegmentID
        ), pc(e, t, u, h), Ce(t, Cl);
      if (h && (u = b.contentState, u.styles.forEach(yr, h), u.stylesheets.forEach(Jn, h)), Ce(t, Vo), u = b.completedSegments, u.length !== 1)
        throw Error(
          "A previously unvisited boundary must have exactly one root segment. This is a bug in React."
        );
      return Ja(e, t, u[0], h), (e = b.contentPreamble) && xc(t, e), Ce(t, Cl);
    }
    function zo(e, t, u, h) {
      return $i(
        t,
        e.renderState,
        u.parentFormatContext,
        u.id
      ), Ja(e, t, u, h), kc(t, u.parentFormatContext);
    }
    function iu(e, t, u) {
      for (var h = u.completedSegments, b = 0; b < h.length; b++)
        Va(
          e,
          t,
          u,
          h[b]
        );
      h.length = 0, ea(
        t,
        u.contentState,
        e.renderState
      ), h = e.resumableState, e = e.renderState, b = u.rootSegmentID, u = u.contentState;
      var E = e.stylesToHoist;
      return e.stylesToHoist = !1, z(t, e.startInlineScript), E ? (h.instructions & Ge) === Ne ? (h.instructions = h.instructions | de | Ge, z(t, Se)) : (h.instructions & de) === Ne ? (h.instructions |= de, z(
        t,
        rn
      )) : z(t, Dn) : (h.instructions & Ge) === Ne ? (h.instructions |= Ge, z(t, ge)) : z(t, ye), h = q(b.toString(16)), z(t, e.boundaryPrefix), z(t, h), z(t, Ye), z(t, e.segmentPrefix), z(t, h), E ? (z(t, Wt), Cc(t, u)) : z(t, Ln), u = Ce(t, cr), rt(t, e) && u;
    }
    function Va(e, t, u, h) {
      if (h.status === kn)
        return !0;
      var b = u.contentState, E = h.id;
      if (E === -1) {
        if ((h.id = u.rootSegmentID) === -1)
          throw Error(
            "A root segment ID must have been assigned by now. This is a bug in React."
          );
        return zo(
          e,
          t,
          h,
          b
        );
      }
      return E === u.rootSegmentID ? zo(
        e,
        t,
        h,
        b
      ) : (zo(e, t, h, b), u = e.resumableState, e = e.renderState, z(t, e.startInlineScript), (u.instructions & Ve) === Ne ? (u.instructions |= Ve, z(t, D)) : z(t, ee), z(t, e.segmentPrefix), E = q(E.toString(16)), z(t, E), z(t, Y), z(t, e.placeholderPrefix), z(t, E), t = Ce(t, ue), t);
    }
    function Si(e, t) {
      it = new Uint8Array(2048), Dt = 0;
      try {
        if (!(0 < e.pendingRootTasks)) {
          var u, h = e.completedRootSegment;
          if (h !== null) {
            if (h.status === be)
              return;
            var b = e.completedPreambleSegments;
            if (b === null)
              return;
            var E = e.renderState, S = E.preamble, F = S.htmlChunks, W = S.headChunks, O;
            if (F) {
              for (O = 0; O < F.length; O++)
                z(t, F[O]);
              if (W)
                for (O = 0; O < W.length; O++)
                  z(t, W[O]);
              else
                z(t, ke("head")), z(t, En);
            } else if (W)
              for (O = 0; O < W.length; O++)
                z(t, W[O]);
            var V = E.charsetChunks;
            for (O = 0; O < V.length; O++)
              z(t, V[O]);
            V.length = 0, E.preconnects.forEach(me, t), E.preconnects.clear();
            var J = E.viewportChunks;
            for (O = 0; O < J.length; O++)
              z(t, J[O]);
            J.length = 0, E.fontPreloads.forEach(me, t), E.fontPreloads.clear(), E.highImagePreloads.forEach(me, t), E.highImagePreloads.clear(), E.styles.forEach(Oo, t);
            var re = E.importMapChunks;
            for (O = 0; O < re.length; O++)
              z(t, re[O]);
            re.length = 0, E.bootstrapScripts.forEach(me, t), E.scripts.forEach(me, t), E.scripts.clear(), E.bulkPreloads.forEach(me, t), E.bulkPreloads.clear();
            var ne = E.hoistableChunks;
            for (O = 0; O < ne.length; O++)
              z(t, ne[O]);
            for (E = ne.length = 0; E < b.length; E++) {
              var Z = b[E];
              for (S = 0; S < Z.length; S++)
                Ja(e, t, Z[S], null);
            }
            var He = e.renderState.preamble, nn = He.headChunks;
            (He.htmlChunks || nn) && z(t, gi("head"));
            var Oe = He.bodyChunks;
            if (Oe)
              for (b = 0; b < Oe.length; b++)
                z(t, Oe[b]);
            Ja(e, t, h, null), e.completedRootSegment = null, rt(t, e.renderState);
          }
          var fe = e.renderState;
          h = 0;
          var Qn = fe.viewportChunks;
          for (h = 0; h < Qn.length; h++)
            z(
              t,
              Qn[h]
            );
          Qn.length = 0, fe.preconnects.forEach(me, t), fe.preconnects.clear(), fe.fontPreloads.forEach(me, t), fe.fontPreloads.clear(), fe.highImagePreloads.forEach(
            me,
            t
          ), fe.highImagePreloads.clear(), fe.styles.forEach(Qr, t), fe.scripts.forEach(me, t), fe.scripts.clear(), fe.bulkPreloads.forEach(me, t), fe.bulkPreloads.clear();
          var un = fe.hoistableChunks;
          for (h = 0; h < un.length; h++)
            z(
              t,
              un[h]
            );
          un.length = 0;
          var Me = e.clientRenderedBoundaries;
          for (u = 0; u < Me.length; u++) {
            var zt = Me[u];
            fe = t;
            var sr = e.resumableState, et = e.renderState, ct = zt.rootSegmentID, wn = zt.errorDigest, Bt = zt.errorMessage, Nt = zt.errorStack, We = zt.errorComponentStack;
            z(
              fe,
              et.startInlineScript
            ), (sr.instructions & cn) === Ne ? (sr.instructions |= cn, z(fe, St)) : z(fe, ot), z(
              fe,
              et.boundaryPrefix
            ), z(fe, q(ct.toString(16))), z(fe, Zt), (wn || Bt || Nt || We) && (z(
              fe,
              ln
            ), z(
              fe,
              q(
                Ul(wn || "")
              )
            )), (Bt || Nt || We) && (z(
              fe,
              ln
            ), z(
              fe,
              q(
                Ul(Bt || "")
              )
            )), (Nt || We) && (z(
              fe,
              ln
            ), z(
              fe,
              q(
                Ul(Nt || "")
              )
            )), We && (z(
              fe,
              ln
            ), z(
              fe,
              q(
                Ul(We)
              )
            ));
            var Fn = Ce(
              fe,
              Gn
            );
            if (!Fn) {
              e.destination = null, u++, Me.splice(0, u);
              return;
            }
          }
          Me.splice(0, u);
          var an = e.completedBoundaries;
          for (u = 0; u < an.length; u++)
            if (!iu(
              e,
              t,
              an[u]
            )) {
              e.destination = null, u++, an.splice(0, u);
              return;
            }
          an.splice(0, u), ul(t), it = new Uint8Array(2048), Dt = 0;
          var Jt = e.partialBoundaries;
          for (u = 0; u < Jt.length; u++) {
            e: {
              Me = e, zt = t;
              var Vt = Jt[u], ut = Vt.completedSegments;
              for (Fn = 0; Fn < ut.length; Fn++)
                if (!Va(
                  Me,
                  zt,
                  Vt,
                  ut[Fn]
                )) {
                  Fn++, ut.splice(0, Fn);
                  var Ml = !1;
                  break e;
                }
              ut.splice(0, Fn), Ml = ea(
                zt,
                Vt.contentState,
                Me.renderState
              );
            }
            if (!Ml) {
              e.destination = null, u++, Jt.splice(0, u);
              return;
            }
          }
          Jt.splice(0, u);
          var pr = e.completedBoundaries;
          for (u = 0; u < pr.length; u++)
            if (!iu(e, t, pr[u])) {
              e.destination = null, u++, pr.splice(0, u);
              return;
            }
          pr.splice(0, u);
        }
      } finally {
        e.allPendingTasks === 0 && e.pingedTasks.length === 0 && e.clientRenderedBoundaries.length === 0 && e.completedBoundaries.length === 0 ? (e.flushScheduled = !1, u = e.resumableState, u.hasBody && z(t, gi("body")), u.hasHtml && z(t, gi("html")), ul(t), e.abortableTasks.size !== 0 && console.error(
          "There was still abortable task at the root when we closed. This is a bug in React."
        ), e.status = Ue, t.close(), e.destination = null) : ul(t);
      }
    }
    function fa(e) {
      e.flushScheduled = e.destination !== null, Au(function() {
        return sa(e);
      }), za(function() {
        e.status === 10 && (e.status = 11), e.trackedPostpones === null && ua(e, e.pendingRootTasks === 0);
      });
    }
    function Fi(e) {
      e.flushScheduled === !1 && e.pingedTasks.length === 0 && e.destination !== null && (e.flushScheduled = !0, za(function() {
        var t = e.destination;
        t ? Si(e, t) : e.flushScheduled = !1;
      }));
    }
    function Bo(e, t) {
      if (e.status === 13)
        e.status = Ue, sl(t, e.fatalError);
      else if (e.status !== Ue && e.destination === null) {
        e.destination = t;
        try {
          Si(e, t);
        } catch (u) {
          t = {}, Gt(e, u, t, null), Xt(e, u, t, null);
        }
      }
    }
    function Ai(e, t) {
      (e.status === 11 || e.status === 10) && (e.status = 12);
      try {
        var u = e.abortableTasks;
        if (0 < u.size) {
          var h = t === void 0 ? Error("The render was aborted by the server without a reason.") : typeof t == "object" && t !== null && typeof t.then == "function" ? Error("The render was aborted by the server with a promise.") : t;
          e.fatalError = h, u.forEach(function(b) {
            return tr(b, e, h);
          }), u.clear();
        }
        e.destination !== null && Si(e, e.destination);
      } catch (b) {
        t = {}, Gt(e, b, t, null), Xt(e, b, t, null);
      }
    }
    function ha() {
      var e = da.version;
      if (e !== "19.1.0")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (e + `
  - react-dom:  19.1.0
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    }
    var da = bs, pi = ys, Oi = Symbol.for("react.transitional.element"), Kr = Symbol.for("react.portal"), Rl = Symbol.for("react.fragment"), No = Symbol.for("react.strict_mode"), ga = Symbol.for("react.profiler"), Rt = Symbol.for("react.provider"), Mi = Symbol.for("react.consumer"), qr = Symbol.for("react.context"), Ii = Symbol.for("react.forward_ref"), Ka = Symbol.for("react.suspense"), jr = Symbol.for("react.suspense_list"), gn = Symbol.for("react.memo"), Un = Symbol.for("react.lazy"), rr = Symbol.for("react.scope"), Di = Symbol.for("react.activity"), Pn = Symbol.for("react.legacy_hidden"), Ke = Symbol.for("react.memo_cache_sentinel"), Oc = Symbol.for("react.view_transition"), Uo = Symbol.iterator, Vn = Array.isArray, Mc = /* @__PURE__ */ new WeakMap(), Ic = /* @__PURE__ */ new WeakMap(), qa = Symbol.for("react.client.reference"), mo = new MessageChannel(), xl = [];
    mo.port1.onmessage = function() {
      var e = xl.shift();
      e && e();
    };
    var Rr = Promise, Au = typeof queueMicrotask == "function" ? queueMicrotask : function(e) {
      Rr.resolve(null).then(e).catch(Ba);
    }, it = null, Dt = 0, at = new TextEncoder(), yn = Object.assign, Je = Object.prototype.hasOwnProperty, Yo = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Dc = {}, au = {}, ou = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), ja = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), Vl = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, Ir = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, lr = {}, $a = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Go = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Lc = !1, eo = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, pn = {}, pu = /^on./, Lt = /^on[^A-Z]/, cu = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Li = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), i = /^(?:webkit|moz|o)[A-Z]/, o = /^-ms-/, f = /-(.)/g, g = /;\s*$/, T = {}, x = {}, C = !1, H = !1, L = /["'&<>]/, B = /([A-Z])/g, oe = /^ms-/, $ = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, ae = da.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, se = pi.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ee = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), he = se.d;
    se.d = {
      f: he.f,
      r: he.r,
      D: function(e) {
        var t = Ze || null;
        if (t) {
          var u = t.resumableState, h = t.renderState;
          if (typeof e == "string" && e) {
            if (!u.dnsResources.hasOwnProperty(e)) {
              u.dnsResources[e] = _e, u = h.headers;
              var b, E;
              (E = u && 0 < u.remainingCapacity) && (E = (b = "<" + lt(e) + ">; rel=dns-prefetch", 0 <= (u.remainingCapacity -= b.length + 2))), E ? (h.resets.dns[e] = _e, u.preconnects && (u.preconnects += ", "), u.preconnects += b) : (b = [], tt(b, { href: e, rel: "dns-prefetch" }), h.preconnects.add(b));
            }
            Fi(t);
          }
        } else
          he.D(e);
      },
      C: function(e, t) {
        var u = Ze || null;
        if (u) {
          var h = u.resumableState, b = u.renderState;
          if (typeof e == "string" && e) {
            var E = t === "use-credentials" ? "credentials" : typeof t == "string" ? "anonymous" : "default";
            if (!h.connectResources[E].hasOwnProperty(e)) {
              h.connectResources[E][e] = _e, h = b.headers;
              var S, F;
              if (F = h && 0 < h.remainingCapacity) {
                if (F = "<" + lt(e) + ">; rel=preconnect", typeof t == "string") {
                  var W = Nn(
                    t,
                    "crossOrigin"
                  );
                  F += '; crossorigin="' + W + '"';
                }
                F = (S = F, 0 <= (h.remainingCapacity -= S.length + 2));
              }
              F ? (b.resets.connect[E][e] = _e, h.preconnects && (h.preconnects += ", "), h.preconnects += S) : (E = [], tt(E, {
                rel: "preconnect",
                href: e,
                crossOrigin: t
              }), b.preconnects.add(E));
            }
            Fi(u);
          }
        } else
          he.C(e, t);
      },
      L: function(e, t, u) {
        var h = Ze || null;
        if (h) {
          var b = h.resumableState, E = h.renderState;
          if (t && e) {
            switch (t) {
              case "image":
                if (u)
                  var S = u.imageSrcSet, F = u.imageSizes, W = u.fetchPriority;
                var O = S ? S + `
` + (F || "") : e;
                if (b.imageResources.hasOwnProperty(O))
                  return;
                b.imageResources[O] = Re, b = E.headers;
                var V;
                b && 0 < b.remainingCapacity && typeof S != "string" && W === "high" && (V = yi(e, t, u), 0 <= (b.remainingCapacity -= V.length + 2)) ? (E.resets.image[O] = Re, b.highImagePreloads && (b.highImagePreloads += ", "), b.highImagePreloads += V) : (b = [], tt(
                  b,
                  yn(
                    {
                      rel: "preload",
                      href: S ? void 0 : e,
                      as: t
                    },
                    u
                  )
                ), W === "high" ? E.highImagePreloads.add(b) : (E.bulkPreloads.add(b), E.preloads.images.set(O, b)));
                break;
              case "style":
                if (b.styleResources.hasOwnProperty(e))
                  return;
                S = [], tt(
                  S,
                  yn({ rel: "preload", href: e, as: t }, u)
                ), b.styleResources[e] = !u || typeof u.crossOrigin != "string" && typeof u.integrity != "string" ? Re : [u.crossOrigin, u.integrity], E.preloads.stylesheets.set(e, S), E.bulkPreloads.add(S);
                break;
              case "script":
                if (b.scriptResources.hasOwnProperty(e))
                  return;
                S = [], E.preloads.scripts.set(e, S), E.bulkPreloads.add(S), tt(
                  S,
                  yn({ rel: "preload", href: e, as: t }, u)
                ), b.scriptResources[e] = !u || typeof u.crossOrigin != "string" && typeof u.integrity != "string" ? Re : [u.crossOrigin, u.integrity];
                break;
              default:
                if (b.unknownResources.hasOwnProperty(t)) {
                  if (S = b.unknownResources[t], S.hasOwnProperty(e))
                    return;
                } else
                  S = {}, b.unknownResources[t] = S;
                if (S[e] = Re, (b = E.headers) && 0 < b.remainingCapacity && t === "font" && (O = yi(e, t, u), 0 <= (b.remainingCapacity -= O.length + 2)))
                  E.resets.font[e] = Re, b.fontPreloads && (b.fontPreloads += ", "), b.fontPreloads += O;
                else
                  switch (b = [], e = yn(
                    { rel: "preload", href: e, as: t },
                    u
                  ), tt(b, e), t) {
                    case "font":
                      E.fontPreloads.add(b);
                      break;
                    default:
                      E.bulkPreloads.add(b);
                  }
            }
            Fi(h);
          }
        } else
          he.L(e, t, u);
      },
      m: function(e, t) {
        var u = Ze || null;
        if (u) {
          var h = u.resumableState, b = u.renderState;
          if (e) {
            var E = t && typeof t.as == "string" ? t.as : "script";
            switch (E) {
              case "script":
                if (h.moduleScriptResources.hasOwnProperty(e))
                  return;
                E = [], h.moduleScriptResources[e] = !t || typeof t.crossOrigin != "string" && typeof t.integrity != "string" ? Re : [t.crossOrigin, t.integrity], b.preloads.moduleScripts.set(e, E);
                break;
              default:
                if (h.moduleUnknownResources.hasOwnProperty(E)) {
                  var S = h.unknownResources[E];
                  if (S.hasOwnProperty(e))
                    return;
                } else
                  S = {}, h.moduleUnknownResources[E] = S;
                E = [], S[e] = Re;
            }
            tt(
              E,
              yn({ rel: "modulepreload", href: e }, t)
            ), b.bulkPreloads.add(E), Fi(u);
          }
        } else
          he.m(e, t);
      },
      X: function(e, t) {
        var u = Ze || null;
        if (u) {
          var h = u.resumableState, b = u.renderState;
          if (e) {
            var E = h.scriptResources.hasOwnProperty(
              e
            ) ? h.scriptResources[e] : void 0;
            E !== _e && (h.scriptResources[e] = _e, t = yn({ src: e, async: !0 }, t), E && (E.length === 2 && on(t, E), e = b.preloads.scripts.get(e)) && (e.length = 0), e = [], b.scripts.add(e), Ao(e, t), Fi(u));
          }
        } else
          he.X(e, t);
      },
      S: function(e, t, u) {
        var h = Ze || null;
        if (h) {
          var b = h.resumableState, E = h.renderState;
          if (e) {
            t = t || "default";
            var S = E.styles.get(t), F = b.styleResources.hasOwnProperty(e) ? b.styleResources[e] : void 0;
            F !== _e && (b.styleResources[e] = _e, S || (S = {
              precedence: q(Pe(t)),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, E.styles.set(t, S)), t = {
              state: Pr,
              props: yn(
                {
                  rel: "stylesheet",
                  href: e,
                  "data-precedence": t
                },
                u
              )
            }, F && (F.length === 2 && on(t.props, F), (E = E.preloads.stylesheets.get(e)) && 0 < E.length ? E.length = 0 : t.state = Nc), S.sheets.set(e, t), Fi(h));
          }
        } else
          he.S(e, t, u);
      },
      M: function(e, t) {
        var u = Ze || null;
        if (u) {
          var h = u.resumableState, b = u.renderState;
          if (e) {
            var E = h.moduleScriptResources.hasOwnProperty(e) ? h.moduleScriptResources[e] : void 0;
            E !== _e && (h.moduleScriptResources[e] = _e, t = yn(
              { src: e, type: "module", async: !0 },
              t
            ), E && (E.length === 2 && on(t, E), e = b.preloads.moduleScripts.get(e)) && (e.length = 0), e = [], b.scripts.add(e), Ao(e, t), Fi(u));
          }
        } else
          he.M(e, t);
      }
    };
    var Ne = 0, Ve = 1, Ge = 2, cn = 4, de = 8, _e = null, Re = [];
    Object.freeze(Re), U('"></template>');
    var Kn = U("<script>"), xt = U("<\/script>"), ve = U('<script src="'), $e = U('<script type="module" src="'), On = U('" nonce="'), mn = U('" integrity="'), $r = U('" crossorigin="'), tn = U('" async=""><\/script>'), Mn = /(<\/|<)(s)(cript)/gi, _t = U(
      '<script type="importmap">'
    ), kt = U("<\/script>"), el = {}, Ct = 0, Dr = 0, ir = 1, In = 2, xr = 3, ar = 4, nl = 5, Lr = 6, kr = 7, _c = 8, Kl = 9, tl = U("<!-- -->"), Xo = /* @__PURE__ */ new Map(), uu = U(' style="'), va = U(":"), su = U(";"), qn = U(" "), Ht = U('="'), Tn = U('"'), Zo = U('=""'), rl = U(
      Pe(
        "javascript:throw new Error('React form unexpectedly submitted.')"
      )
    ), _i = U('<input type="hidden"'), En = U(">"), _r = U("/>"), no = !1, ll = !1, to = !1, ba = !1, ql = !1, Yn = !1, Qo = !1, or = !1, ya = !1, Hi = !1, kl = !1, Hr = U(' selected=""'), Wi = U(
      `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`
    ), Pt = U("<!--F!-->"), jl = U("<!--F-->"), fu = /(<\/|<)(s)(tyle)/gi, Jo = U(`
`), ro = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Hc = /* @__PURE__ */ new Map(), jn = U("<!DOCTYPE html>"), wa = /* @__PURE__ */ new Map(), Ta = U('<template id="'), zi = U('"></template>'), Vo = U("<!--$-->"), Ko = U(
      '<!--$?--><template id="'
    ), Cr = U('"></template>'), Ou = U("<!--$!-->"), Cl = U("<!--/$-->"), hu = U("<template"), $l = U('"'), lo = U(' data-dgst="'), qo = U(' data-msg="'), Bi = U(' data-stck="'), jo = U(' data-cstck="'), Wc = U("></template>"), zc = U("<!--"), $o = U("-->"), il = U('<div hidden id="'), ei = U('">'), io = U("</div>"), Ea = U(
      '<svg aria-hidden="true" style="display:none" id="'
    ), ec = U('">'), ao = U("</svg>"), Ni = U(
      '<math aria-hidden="true" style="display:none" id="'
    ), Ui = U('">'), mi = U("</math>"), Ra = U('<table hidden id="'), xa = U('">'), nc = U("</table>"), l = U(
      '<table hidden><tbody id="'
    ), a = U('">'), s = U("</tbody></table>"), v = U('<table hidden><tr id="'), w = U('">'), k = U("</tr></table>"), P = U(
      '<table hidden><colgroup id="'
    ), _ = U('">'), A = U("</colgroup></table>"), D = U(
      '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
    ), ee = U('$RS("'), Y = U('","'), ue = U('")<\/script>');
    U('<template data-rsi="" data-sid="'), U('" data-pid="');
    var ge = U(
      '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("'
    ), ye = U('$RC("'), Se = U(
      `$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`
    ), rn = U(
      `$RM=new Map;
$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=
d;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,
t,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("`
    ), Dn = U('$RR("'), Ye = U('","'), Wt = U('",'), Ln = U('"'), cr = U(")<\/script>");
    U('<template data-rci="" data-bid="'), U('<template data-rri="" data-bid="'), U('" data-sid="'), U('" data-sty="');
    var St = U(
      '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
    ), ot = U('$RX("'), Zt = U('"'), ln = U(","), Gn = U(")<\/script>");
    U('<template data-rxi="" data-bid="'), U('" data-dgst="'), U('" data-msg="'), U('" data-stck="'), U('" data-cstck="');
    var Rn = /[<\u2028\u2029]/g, Ft = /[&><\u2028\u2029]/g, ka = U(
      '<style media="not all" data-precedence="'
    ), ni = U('" data-href="'), ti = U('">'), Ca = U("</style>"), ri = !1, du = !0, Yi = [], mu = U(
      '<style data-precedence="'
    ), Yu = U('" data-href="'), Mu = U(" "), Bc = U('">'), Gu = U("</style>"), Iu = U("["), Pl = U(",["), ur = U(","), Du = U("]"), Pr = 0, Nc = 1, Uc = 2, gu = 3, vu = /[<>\r\n]/g, vn = /["';,\r\n]/g, mc = Function.prototype.bind, oo = Symbol.for("react.client.reference"), Xn = {};
    Object.freeze(Xn);
    var Pa = {}, Sl = null, Sa = {}, co = {}, Sr = /* @__PURE__ */ new Set(), Fa = /* @__PURE__ */ new Set(), Fr = /* @__PURE__ */ new Set(), Gi = /* @__PURE__ */ new Set(), tc = /* @__PURE__ */ new Set(), Fl = /* @__PURE__ */ new Set(), Wr = /* @__PURE__ */ new Set(), Lu = /* @__PURE__ */ new Set(), Al = /* @__PURE__ */ new Set(), _u = {
      enqueueSetState: function(e, t, u) {
        var h = e._reactInternals;
        h.queue === null ? ta(e, "setState") : (h.queue.push(t), u != null && sn(u));
      },
      enqueueReplaceState: function(e, t, u) {
        e = e._reactInternals, e.replace = !0, e.queue = [t], u != null && sn(u);
      },
      enqueueForceUpdate: function(e, t) {
        e._reactInternals.queue === null ? ta(e, "forceUpdate") : t != null && sn(t);
      }
    }, bu = { id: 1, overflow: "" }, Yc = Math.clz32 ? Math.clz32 : ra, Gc = Math.log, Xu = Math.LN2, pl = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), Aa = null, Hu = typeof Object.is == "function" ? Object.is : Su, li = null, rc = null, yu = null, ii = null, lc = null, en = null, Xi = !1, uo = !1, pa = 0, so = 0, Xc = -1, ic = 0, ac = null, _n = null, Ar = 0, xn = !1, Oa, oc = {
      readContext: Ga,
      use: function(e) {
        if (e !== null && typeof e == "object") {
          if (typeof e.then == "function")
            return Io(e);
          if (e.$$typeof === qr)
            return Ga(e);
        }
        throw Error(
          "An unsupported type was passed to use(): " + String(e)
        );
      },
      useContext: function(e) {
        return Oa = "useContext", hl(), e._currentValue;
      },
      useMemo: Ei,
      useReducer: dl,
      useRef: function(e) {
        li = hl(), en = Sc();
        var t = en.memoizedState;
        return t === null ? (e = { current: e }, Object.seal(e), en.memoizedState = e) : t;
      },
      useState: function(e) {
        return Oa = "useState", dl(Ti, e);
      },
      useInsertionEffect: Xa,
      useLayoutEffect: Xa,
      useCallback: function(e, t) {
        return Ei(function() {
          return e;
        }, t);
      },
      useImperativeHandle: Xa,
      useEffect: Xa,
      useDebugValue: Xa,
      useDeferredValue: function(e, t) {
        return hl(), t !== void 0 ? t : e;
      },
      useTransition: function() {
        return hl(), [!1, Fu];
      },
      useId: function() {
        var e = rc.treeContext, t = e.overflow;
        e = e.id, e = (e & ~(1 << 32 - Yc(e) - 1)).toString(32) + t;
        var u = Zi;
        if (u === null)
          throw Error(
            "Invalid hook call. Hooks can only be called inside of the body of a function component."
          );
        return t = pa++, e = "«" + u.idPrefix + "R" + e, 0 < t && (e += "H" + t.toString(32)), e + "»";
      },
      useSyncExternalStore: function(e, t, u) {
        if (u === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        return u();
      },
      useOptimistic: function(e) {
        return hl(), [e, ml];
      },
      useActionState: bn,
      useFormState: bn,
      useHostTransitionStatus: function() {
        return hl(), Ee;
      },
      useMemoCache: function(e) {
        for (var t = Array(e), u = 0; u < e; u++)
          t[u] = Ke;
        return t;
      },
      useCacheRefresh: function() {
        return tu;
      }
    }, Zi = null, fn = null, wu = {
      getCacheForType: function() {
        throw Error("Not implemented.");
      },
      getOwner: function() {
        return fn === null ? null : fn.componentStack;
      }
    }, Ol = 0, fo, Wu, cc, Zc, uc, n, r;
    It.__reactDisabledLog = !0;
    var c, d, y = !1, R = new (typeof WeakMap == "function" ? WeakMap : Map)(), p = {
      "react-stack-bottom-frame": function(e, t, u) {
        return e(t, u);
      }
    }, M = p["react-stack-bottom-frame"].bind(p), N = {
      "react-stack-bottom-frame": function(e) {
        return e.render();
      }
    }, I = N["react-stack-bottom-frame"].bind(N), te = {
      "react-stack-bottom-frame": function(e) {
        var t = e._init;
        return t(e._payload);
      }
    }, K = te["react-stack-bottom-frame"].bind(te), le = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var ie = performance, G = function() {
        return ie.now();
      };
    else {
      var we = Date;
      G = function() {
        return we.now();
      };
    }
    var Le = 4, Te = 0, Fe = 1, kn = 2, be = 5, Ue = 14, Ze = null, At = {}, Zn = {}, $n = {}, Sn = {}, zr = !1, Qt = !1, qe = !1;
    ha(), ha(), fs.prerender = function(e, t) {
      return new Promise(function(u, h) {
        var b = t ? t.onHeaders : void 0, E;
        b && (E = function(V) {
          b(new Headers(V));
        });
        var S = ce(
          t ? t.identifierPrefix : void 0,
          t ? t.unstable_externalRuntimeSrc : void 0,
          t ? t.bootstrapScriptContent : void 0,
          t ? t.bootstrapScripts : void 0,
          t ? t.bootstrapModules : void 0
        ), F = Gl(
          e,
          S,
          X(
            S,
            void 0,
            t ? t.unstable_externalRuntimeSrc : void 0,
            t ? t.importMap : void 0,
            E,
            t ? t.maxHeadersLength : void 0
          ),
          j(t ? t.namespaceURI : void 0),
          t ? t.progressiveChunkSize : void 0,
          t ? t.onError : void 0,
          function() {
            var V = {
              prelude: new ReadableStream(
                {
                  type: "bytes",
                  pull: function(J) {
                    Bo(F, J);
                  },
                  cancel: function(J) {
                    F.destination = null, Ai(F, J);
                  }
                },
                { highWaterMark: 0 }
              )
            };
            u(V);
          },
          void 0,
          void 0,
          h,
          t ? t.onPostpone : void 0
        );
        if (t && t.signal) {
          var W = t.signal;
          if (W.aborted)
            Ai(F, W.reason);
          else {
            var O = function() {
              Ai(F, W.reason), W.removeEventListener("abort", O);
            };
            W.addEventListener("abort", O);
          }
        }
        fa(F);
      });
    }, fs.renderToReadableStream = function(e, t) {
      return new Promise(function(u, h) {
        var b, E, S = new Promise(function(ne, Z) {
          E = ne, b = Z;
        }), F = t ? t.onHeaders : void 0, W;
        F && (W = function(ne) {
          F(new Headers(ne));
        });
        var O = ce(
          t ? t.identifierPrefix : void 0,
          t ? t.unstable_externalRuntimeSrc : void 0,
          t ? t.bootstrapScriptContent : void 0,
          t ? t.bootstrapScripts : void 0,
          t ? t.bootstrapModules : void 0
        ), V = oa(
          e,
          O,
          X(
            O,
            t ? t.nonce : void 0,
            t ? t.unstable_externalRuntimeSrc : void 0,
            t ? t.importMap : void 0,
            W,
            t ? t.maxHeadersLength : void 0
          ),
          j(t ? t.namespaceURI : void 0),
          t ? t.progressiveChunkSize : void 0,
          t ? t.onError : void 0,
          E,
          function() {
            var ne = new ReadableStream(
              {
                type: "bytes",
                pull: function(Z) {
                  Bo(V, Z);
                },
                cancel: function(Z) {
                  V.destination = null, Ai(V, Z);
                }
              },
              { highWaterMark: 0 }
            );
            ne.allReady = S, u(ne);
          },
          function(ne) {
            S.catch(function() {
            }), h(ne);
          },
          b,
          t ? t.onPostpone : void 0,
          t ? t.formState : void 0
        );
        if (t && t.signal) {
          var J = t.signal;
          if (J.aborted)
            Ai(V, J.reason);
          else {
            var re = function() {
              Ai(V, J.reason), J.removeEventListener("abort", re);
            };
            J.addEventListener("abort", re);
          }
        }
        fa(V);
      });
    }, fs.version = "19.1.0";
  }()), fs;
}
var hs, ds;
process.env.NODE_ENV === "production" ? (hs = zs(), ds = Bs()) : (hs = Ns(), ds = Us());
hs.version;
var Gs = hs.renderToString;
hs.renderToStaticMarkup;
ds.renderToReadableStream;
ds.resume && ds.resume;
export {
  Gs as r
};
